unit SystemSettings;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls,
  WEBLib.TMSWEBCustomComponent, WEBLib.TMSWEBStateManager,
  WEBLib.TMSWEBResponsiveManager, WEBLib.ComCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.DBCtrls, Data.DB, WEBLib.DB, XData.Web.Client,
  XData.Web.JsonDataset, XData.Web.Dataset, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, VCL.TMSFNCGridCell,
  VCL.TMSFNCGridOptions, VCL.TMSFNCCustomComponent, VCL.TMSFNCCustomGrid,
  VCL.TMSFNCGridDatabaseAdapter, VCL.TMSFNCCustomControl,
  VCL.TMSFNCCustomScrollControl, VCL.TMSFNCGridData, VCL.TMSFNCGrid,
  WEBLib.Buttons, WEBLib.CheckLst, System.Rtti, VCL.TMSFNCDataGridCell,
  VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase, VCL.TMSFNCDataGridCore,
  VCL.TMSFNCDataGridRenderer, VCL.TMSFNCDataGridDatabaseAdapter,
  VCL.TMSFNCDataGrid, VCL.TMSFNCBitmapContainer;

type
  TfrmSystemSettings = class(TForm)
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebResponsiveManager1: TResponsiveManager;
    wpcSysSetup: TPageControl;
    WebPageControl1Sheet1: TTabSheet;
    WebPageControl1Sheet2: TTabSheet;
    WebPageControl1Sheet3: TTabSheet;
    WebPanel3: TPanel;
    WebResponsiveManager3: TResponsiveManager;
    btnSave: TButton;
    WebButton2: TButton;
    wcCompInfo: TXDataWebClient;
    wdsCompInfo: TXDataWebDataSet;
    wdsCompInfoSSCLoadConLoadDate: TBooleanField;
    wdsCompInfoSSCLoadConOffLoadDate: TBooleanField;
    wdsCompInfoSSCLOADCONRECEIVEDATE: TBooleanField;
    wdsCompInfoSSCLOADCONCOMPLETEDATE: TBooleanField;
    wdsCompInfoSSCLOADCONLOADTIME: TIntegerField;
    wdsCompInfoSSCLOADCONOFFLOADTIME: TIntegerField;
    wdsCompInfoSSCLOADCONRECEIVETIME: TIntegerField;
    wdsCompInfoSSCLOADCONCOMPLETETIME: TIntegerField;
    wdsCompInfoSSCLOADCONLOADDATEC: TIntegerField;
    wdsCompInfoSSCLOADCONOFFLOADDATEC: TIntegerField;
    wdsCompInfoSSCLOADCONRECEIVEDATEC: TIntegerField;
    wdsCompInfoSSCLOADCONCOMPLETEDATEC: TIntegerField;
    wdsCompInfoSSCLOADCONLOADTIMEC: TIntegerField;
    wdsCompInfoSSCLOADCONOFFLOADTIMEC: TIntegerField;
    wdsCompInfoSSCLOADCONRECEIVETIMEC: TIntegerField;
    wdsCompInfoSSCLOADCONCOMPLETETIMEC: TIntegerField;
    wdsCompInfoUSEFINLINKSYSTEM: TBooleanField;
    wdsCompInfoFINLINKSYSTEM: TIntegerField;
    wdsCompInfoAUTOMAILSYSTEM: TBooleanField;
    wdsCompInfoFINDBSETUP: TBlobField;
    wdsCompInfoMAILSERVER: TStringField;
    wdsCompInfoMAILSERVERPORT: TIntegerField;
    wdsCompInfoMAILSERVERAUTH: TBooleanField;
    wdsCompInfoMAILSERVERUSER: TStringField;
    wdsCompInfoMAILSERVERPASS: TStringField;
    wdsCompInfoMAILSERVERSSL: TBooleanField;
    wdsCompInfoMAILSERVERPROTOCOL: TIntegerField;
    wdsCompInfoMAILSERVERSIGNATURE: TBooleanField;
    wdsCompInfoMAILSERVERENCRYPTION: TBooleanField;
    wdsCompInfoMAILSERVERENCODING: TStringField;
    wdsCompInfoDCLPERC: TFloatField;
    wdsCompInfoBANKSTATEMENT: TBooleanField;
    wdsCompInfoSSFLOADCONLOADDATEC: TIntegerField;
    wdsCompInfoSSFLOADCONOFFLOADDATEC: TIntegerField;
    wdsCompInfoSSFLOADCONRECEIVEDATEC: TIntegerField;
    wdsCompInfoSSFLOADCONCOMPLETEDATEC: TIntegerField;
    wdsCompInfoSSFLOADCONLOADTIMEC: TIntegerField;
    wdsCompInfoSSFLOADCONOFFLOADTIMEC: TIntegerField;
    wdsCompInfoSSFLOADCONRECEIVETIMEC: TIntegerField;
    wdsCompInfoSSFLOADCONCOMPLETETIMEC: TIntegerField;
    wdsCompInfoFORCEDIESELDRIVER: TBooleanField;
    wdsCompInfoFORCELOADDRIVER: TBooleanField;
    wdsCompInfoDEFDIESELORDERS: TIntegerField;
    wdsCompInfoDEFLOADORDERS: TIntegerField;
    wdsCompInfoINVOICESYSTEM: TBooleanField;
    wdsCompInfoBTBRANCHCODE: TStringField;
    wdsCompInfoBTACCOUNTNO: TStringField;
    wdsCompInfoTRIPSHEETTYPE: TStringField;
    wdsCompInfoLOADCUSTOMERS: TBooleanField;
    wdsCompInfoFINLINKSYSTEMCOUNT: TIntegerField;
    wdsCompInfoFIN1NAME: TStringField;
    wdsCompInfoFIN2NAME: TStringField;
    wdsCompInfoUSEDOCKETNOINVNO: TBooleanField;
    wdsCompInfoUSEADDINFONONCON: TBooleanField;
    wdsCompInfoSTATEMENTTYPE: TStringField;
    wdsCompInfoSTOCKSTDPERC: TFloatField;
    wdsCompInfoSTOCKDEDPERC: TFloatField;
    wdsCompInfoSTOCKSPEPERC: TFloatField;
    wdsCompInfoEMPADDCOMDESC: TStringField;
    wdsCompInfoNONCONDISPLAYFUEL: TBooleanField;
    wdsCompInfoADD1DESC: TStringField;
    wdsCompInfoADD2DESC: TStringField;
    wdsCompInfoADD3DESC: TStringField;
    wdsCompInfoADD4DESC: TStringField;
    wdsCompInfoADD5DESC: TStringField;
    wdsCompInfoADD6DESC: TStringField;
    wdsCompInfoADD7DESC: TStringField;
    wdsCompInfoPOSTALADDRESS1: TStringField;
    wdsCompInfoPOSTALADDRESS2: TStringField;
    wdsCompInfoPOSTALADDRESS3: TStringField;
    wdsCompInfoPOSTALADDRESS4: TStringField;
    wdsCompInfoPOSTALCODE: TStringField;
    wdsCompInfoUSEMULTICOMPANYINVOICE: TBooleanField;
    wdsCompInfoMISCINVLOADS: TBooleanField;
    wdsCompInfoPRINTTOTALSSEND: TBooleanField;
    wdsCompInfoWEBSERVERADDRESS: TStringField;
    wdsCompInfoWEBSERVERPORT: TIntegerField;
    wdsCompInfoWEBSERVERUSER: TStringField;
    wdsCompInfoWEBSERVERPASSWORD: TStringField;
    wdsCompInfoWEBSERVERSCANAPI: TStringField;
    wdsCompInfoDBSERVERADDRESS: TStringField;
    wdsCompInfoDBSERVERPORT: TIntegerField;
    wdsCompInfoINTERNALADDRESS: TStringField;
    wdsCompInfoINTERNALPORT: TIntegerField;
    wdsCompInfoWEBSERVERDB: TStringField;
    wdsCompInfoWEBSERVERDBUSER: TStringField;
    wdsCompInfoWEBSERVERDBPASS: TStringField;
    wdsCompInfoUNIQUEORDER: TBooleanField;
    wdsCompInfoUNIQUEWAYBILLS: TBooleanField;
    wdsCompInfoUNIQUEWASHBAYDOCKET: TBooleanField;
    wdsCompInfoIMPORTPERIOD: TIntegerField;
    wdsCompInfoIMPORTBATCH: TIntegerField;
    wdsCompInfoPRINTLOADSAVE: TBooleanField;
    wdsCompInfoNOFUTUREINVDATE: TBooleanField;
    wdsCompInfoUNIQUESHORTDESC: TBooleanField;
    wdsCompInfoCUSTMISCTYPE: TStringField;
    wdsCompInfoSUPPMISCTYPE: TStringField;
    wdsCompInfoJOBCARDPREFIX: TStringField;
    wdsCompInfoREQUESTPREFIX: TStringField;
    wdsCompInfoORDERSPREFIX: TStringField;
    wdsCompInfoMISCGLFORCE: TBooleanField;
    wdsCompInfoSUBUNINVSHOW: TBooleanField;
    wdsCompInfoemployeedemerit: TIntegerField;
    wdsCompInfovehicledemerit: TIntegerField;
    wdsCompInfomonitorvehiclechanges: TBooleanField;
    wdsCompInfomonitordieselupfrontcl: TBooleanField;
    wdsCompInfomonitorloadssub: TBooleanField;
    wdsCompInfomonitorcancelloads: TBooleanField;
    wdsCompInfocheckdieselordersdays: TIntegerField;
    wdsCompInfoJobCompType: TStringField;
    wdsCompInfofinesbrnno: TStringField;
    wdsCompInfofinesidno: TStringField;
    wdsCompInfosmsdiesel: TBooleanField;
    wdsCompInfosmsdieselurl: TStringField;
    wdsCompInfosmsdieseluser: TStringField;
    wdsCompInfosmsdieselpassword: TStringField;
    wdsCompInfoINSTRUCTORDER: TStringField;
    wdsCompInfowashbayinvloads: TBooleanField;
    wdsCompInfosubsoverrite: TBooleanField;
    wdsCompInfocommissiontype: TIntegerField;
    wdsCompInfoallowdieselproforma: TBooleanField;
    wdsCompInfoforcescandocs: TBooleanField;
    wdsCompInfoBANKDETAIL5: TStringField;
    wdsCompInfoBANKDETAILS6: TStringField;
    wdsCompInfoBANKDETAILS7: TStringField;
    wdsCompInfoBANKDETAILS8: TStringField;
    wdsCompInfologo: TBlobField;
    wdsCompInfoautocanceldieselorders: TBooleanField;
    wdsCompInfoautocanceldieselordersdays: TIntegerField;
    wdsCompInfosendloadconsprocess: TBooleanField;
    wdsCompInfoloadcoscutoffdate: TBooleanField;
    wdsCompInfodieselcutoffdate: TBooleanField;
    wdsCompInfohidecanceloadsplanning: TBooleanField;
    wdsCompInfoincrementdocketno: TBooleanField;
    wdsCompInfolinklastdriver: TBooleanField;
    wdsCompInfoplanningshortdesc: TBooleanField;
    wdsCompInfoallowreprint: TBooleanField;
    wdsCompInforemovesubinvdocs: TBooleanField;
    wdsCompInfoloadsmustreceived: TBooleanField;
    wdsCompInfofnbcontractid: TStringField;
    wdsCompInfofnbclientid: TStringField;
    wdsCompInfofnbdeblistcount: TIntegerField;
    wdsCompInfofnbcredlistcount: TIntegerField;
    wdsCompInfofnblastdebdate: TDateField;
    wdsCompInfofnblastcreddate: TDateField;
    wdsCompInfofnblastdebamount: TFloatField;
    wdsCompInfofnblastcredamount: TFloatField;
    wdsCompInfofnbclienttype: TIntegerField;
    wdsCompInfolinkloadsvat: TBooleanField;
    wdsCompInfomarkmultiloadready: TBooleanField;
    wdsCompInfobulkdieselinvoices: TBooleanField;
    wdsCompInfoclearbulkinvoices: TBooleanField;
    wdsCompInfogetsageonlinebalance: TBooleanField;
    wdsCompInfousesageonlinebalancefordiesel: TFloatField;
    wdsCompInfoapiserverurl: TStringField;
    wdsCompInfoapiusername: TStringField;
    wdsCompInfoapipassword: TStringField;
    wdsCompInfoapikey: TStringField;
    wdsCompInfofuelconsumptionfullfills: TBooleanField;
    wdsCompInfousenewscan: TBooleanField;
    wdsCompInfobasescanfolder: TStringField;
    wdsCompInfoftpserver: TStringField;
    wdsCompInfoftpport: TSmallintField;
    wdsCompInfoftpuser: TStringField;
    wdsCompInfoftppassword: TStringField;
    wdsCompInfomulticontroller: TBooleanField;
    wdsCompInfolastshiftno: TIntegerField;
    wdsCompInfodieselnonretail: TBooleanField;
    wdsCompInfoemailaddress: TStringField;
    wdsCompInfojobnullqty: TBooleanField;
    wdsCompInfojoborder: TBooleanField;
    wdsCompInfojobcardtype: TStringField;
    wdsCompInfomaintforcegl: TBooleanField;
    wdsCompInfocompemail: TStringField;
    wdsCompInfoerrormails: TStringField;
    dsCompInfo: TDataSource;
    WebPanel8: TPanel;
    WebLabel23: TLabel;
    WebLabel24: TLabel;
    WebDBEdit1: TDBEdit;
    WebDBEdit2: TDBEdit;
    WebDBCheckBox5: TDBCheckBox;
    WebDBCheckBox6: TDBCheckBox;
    WebDBCheckBox7: TDBCheckBox;
    WebDBCheckBox8: TDBCheckBox;
    WebDBCheckBox9: TDBCheckBox;
    WebDBCheckBox10: TDBCheckBox;
    WebDBCheckBox11: TDBCheckBox;
    WebDBCheckBox12: TDBCheckBox;
    WebDBCheckBox13: TDBCheckBox;
    WebDBCheckBox14: TDBCheckBox;
    WebPanel9: TPanel;
    WebLabel21: TLabel;
    WebLabel22: TLabel;
    WebDBEdit3: TDBEdit;
    WebDBEdit4: TDBEdit;
    WebDBCheckBox15: TDBCheckBox;
    WebDBCheckBox16: TDBCheckBox;
    WebDBCheckBox17: TDBCheckBox;
    WebDBCheckBox18: TDBCheckBox;
    WebDBCheckBox19: TDBCheckBox;
    WebDBCheckBox20: TDBCheckBox;
    WebDBCheckBox21: TDBCheckBox;
    WebDBCheckBox22: TDBCheckBox;
    WebDBCheckBox23: TDBCheckBox;
    WebDBCheckBox24: TDBCheckBox;
    WebPanel7: TPanel;
    WebLabel20: TLabel;
    WebDBEdit5: TDBEdit;
    WebDBCheckBox25: TDBCheckBox;
    WebDBCheckBox26: TDBCheckBox;
    WebDBCheckBox27: TDBCheckBox;
    WebDBCheckBox28: TDBCheckBox;
    WebDBCheckBox29: TDBCheckBox;
    WebDBCheckBox30: TDBCheckBox;
    WebDBCheckBox31: TDBCheckBox;
    WebDBCheckBox32: TDBCheckBox;
    WebDBCheckBox33: TDBCheckBox;
    WebDBCheckBox34: TDBCheckBox;
    WebDBCheckBox35: TDBCheckBox;
    WebDBCheckBox36: TDBCheckBox;
    WebDBCheckBox37: TDBCheckBox;
    WebDBCheckBox38: TDBCheckBox;
    WebDBCheckBox39: TDBCheckBox;
    WebPanel10: TPanel;
    WebLabel31: TLabel;
    WebLabel32: TLabel;
    WebLabel33: TLabel;
    WebLabel34: TLabel;
    WebLabel25: TLabel;
    WebDBEdit6: TDBEdit;
    WebDBEdit7: TDBEdit;
    WebDBEdit8: TDBEdit;
    WebDBEdit9: TDBEdit;
    WebDBEdit14: TDBEdit;
    WebPanel11: TPanel;
    WebLabel26: TLabel;
    WebLabel27: TLabel;
    WebLabel28: TLabel;
    WebLabel29: TLabel;
    WebLabel30: TLabel;
    WebDBEdit10: TDBEdit;
    WebDBEdit11: TDBEdit;
    WebDBEdit12: TDBEdit;
    WebDBEdit13: TDBEdit;
    WebDBEdit15: TDBEdit;
    wpNavigator: TPanel;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    WebSpeedButton3: TSpeedButton;
    WebSpeedButton4: TSpeedButton;
    WebSpeedButton5: TSpeedButton;
    wcNumbers: TXDataWebClient;
    wdsNumbers: TXDataWebDataSet;
    dsNumbers: TDataSource;
    WebPanel4: TPanel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    WebLabel7: TLabel;
    WebLabel8: TLabel;
    WebLabel9: TLabel;
    WebLabel10: TLabel;
    WebLabel11: TLabel;
    WebLabel12: TLabel;
    WebLabel13: TLabel;
    WebLabel14: TLabel;
    WebLabel15: TLabel;
    WebLabel16: TLabel;
    WebLabel17: TLabel;
    WebLabel18: TLabel;
    WebDBImageControl1: TDBImageControl;
    edtCompName: TDBEdit;
    edtCompAddress1: TDBEdit;
    edtCompAddress2: TDBEdit;
    edtCompAddress3: TDBEdit;
    edtCompAddress4: TDBEdit;
    edtCompAddressCode: TDBEdit;
    edtPostalCode: TDBEdit;
    edtPostalAddress4: TDBEdit;
    edtPostalAddress3: TDBEdit;
    edtPostalAddress2: TDBEdit;
    edtPostalAddress1: TDBEdit;
    edtTelephone: TDBEdit;
    edtTaxNo: TDBEdit;
    edtLogoPath: TDBEdit;
    edtRegistrationNo: TDBEdit;
    edtVatNo: TDBEdit;
    edtDeliveryNotePrefix: TDBEdit;
    edtCompEmail: TDBEdit;
    edtBankTransferBranchCode: TDBEdit;
    WebPanel5: TPanel;
    WebLabel6: TLabel;
    edtBankDetails1: TDBEdit;
    edtBankDetails2: TDBEdit;
    edtBankDetails3: TDBEdit;
    edtBankDetails4: TDBEdit;
    cbxPrintOnStatement: TDBCheckBox;
    edtBankTransferAccountNo: TDBEdit;
    WebPageControlSheet4: TTabSheet;
    WebPanel15: TPanel;
    WebLabel53: TLabel;
    WebDBEdit16: TDBEdit;
    WebDBCheckBox40: TDBCheckBox;
    dblFinName: TDBLookupComboBox;
    WebPageControl1: TPageControl;
    WebTabSheet4: TTabSheet;
    WebPanel17: TPanel;
    WebLabel35: TLabel;
    WebLabel39: TLabel;
    WebLabel40: TLabel;
    WebLabel41: TLabel;
    WebLabel42: TLabel;
    WebLabel43: TLabel;
    WebLabel44: TLabel;
    WebLabel45: TLabel;
    eServerName: TEdit;
    eDBPath: TEdit;
    eUsername: TEdit;
    ePassword: TEdit;
    ePort: TEdit;
    eProtocol: TComboBox;
    eDriverID: TComboBox;
    WebPanel18: TPanel;
    WebLabel38: TLabel;
    WebLabel46: TLabel;
    WebLabel47: TLabel;
    WebLabel48: TLabel;
    WebLabel49: TLabel;
    WebLabel50: TLabel;
    WebLabel51: TLabel;
    WebLabel52: TLabel;
    eServerName1: TEdit;
    eDBPath1: TEdit;
    eUsername1: TEdit;
    ePassword1: TEdit;
    ePort1: TEdit;
    eProtocol1: TComboBox;
    eDriverID1: TComboBox;
    WebTabSheet5: TTabSheet;
    WebPanel19: TPanel;
    WebLabel57: TLabel;
    WebLabel58: TLabel;
    WebLabel59: TLabel;
    WebLabel60: TLabel;
    WebLabel67: TLabel;
    WebLabel68: TLabel;
    WebPanel20: TPanel;
    chk1: TCheckBox;
    WebGroupBox1: TGroupBox;
    WebLabel61: TLabel;
    WebLabel62: TLabel;
    WebLabel63: TLabel;
    edtSalesVat: TEdit;
    edtExpenseVat: TEdit;
    edtZeroRate: TEdit;
    WebGroupBox2: TGroupBox;
    WebLabel64: TLabel;
    WebLabel65: TLabel;
    WebLabel66: TLabel;
    fin1dieselinv: TEdit;
    fin1maintinv: TEdit;
    fin1tyresinv: TEdit;
    edtsagepartnername: TEdit;
    edt1: TEdit;
    Edit1: TEdit;
    fin1Bank: TEdit;
    fncMasterGrid: TTMSFNCGrid;
    fncTransactionGrid: TTMSFNCGrid;
    WebTabSheet6: TTabSheet;
    WebPanel6: TPanel;
    WebGroupBox3: TGroupBox;
    WebLabel19: TLabel;
    WebLabel54: TLabel;
    WebLabel55: TLabel;
    WebLabel56: TLabel;
    WebLabel69: TLabel;
    WebLabel70: TLabel;
    WebLabel71: TLabel;
    WebLabel72: TLabel;
    WebLabel73: TLabel;
    WebLabel74: TLabel;
    WebLabel75: TLabel;
    Edit16: TEdit;
    Edit4: TEdit;
    Edit5: TEdit;
    Edit15: TEdit;
    Edit3: TEdit;
    Edit17: TEdit;
    Edit18: TEdit;
    Edit19: TEdit;
    Edit20: TEdit;
    Edit21: TEdit;
    edtBankClear: TEdit;
    WebButton5: TButton;
    WebButton6: TButton;
    WebButton7: TButton;
    WebButton8: TButton;
    WebButton9: TButton;
    WebButton10: TButton;
    WebButton11: TButton;
    wdsFinSystem: TXDataWebDataSet;
    dsFinSystem: TDataSource;
    wcFinSystem: TXDataWebClient;
    WebPageControlSheet5: TTabSheet;
    pnlWebServerSettings: TPanel;
    WebDBEdit17: TDBEdit;
    WebDBEdit18: TDBEdit;
    WebDBEdit19: TDBEdit;
    WebDBEdit20: TDBEdit;
    WebDBEdit21: TDBEdit;
    WebDBEdit22: TDBEdit;
    WebDBEdit24: TDBEdit;
    WebDBEdit25: TDBEdit;
    WebDBEdit26: TDBEdit;
    WebDBEdit27: TDBEdit;
    WebDBEdit28: TDBEdit;
    WebPanel12: TPanel;
    WebDBEdit29: TDBEdit;
    WebDBEdit30: TDBEdit;
    WebDBEdit31: TDBEdit;
    WebLabel36: TLabel;
    WebLabel37: TLabel;
    WebLabel76: TLabel;
    WebLabel77: TLabel;
    WebLabel78: TLabel;
    WebLabel79: TLabel;
    WebLabel80: TLabel;
    WebLabel81: TLabel;
    WebLabel82: TLabel;
    WebLabel83: TLabel;
    WebLabel84: TLabel;
    WebLabel85: TLabel;
    WebLabel86: TLabel;
    WebLabel87: TLabel;
    WebLabel88: TLabel;
    Edit2: TEdit;
    wpcSysSetupSheet6: TTabSheet;
    WebPanel21: TPanel;
    dbcbxAutomailig: TDBCheckBox;
    wgbEmailSetup: TGroupBox;
    WebLabel89: TLabel;
    WebLabel90: TLabel;
    WebLabel91: TLabel;
    WebDBEdit23: TDBEdit;
    WebDBEdit32: TDBEdit;
    WebDBLookupComboBox1: TDBLookupComboBox;
    WebDBCheckBox2: TDBCheckBox;
    WebDBCheckBox3: TDBCheckBox;
    wgbAuthentication: TGroupBox;
    WebLabel92: TLabel;
    WebLabel93: TLabel;
    WebDBEdit33: TDBEdit;
    WebDBEdit34: TDBEdit;
    wpcSysSetupSheet7: TTabSheet;
    WebPanel13: TPanel;
    WebSpeedButton8: TSpeedButton;
    WebSpeedButton9: TSpeedButton;
    WebSpeedButton10: TSpeedButton;
    WebSpeedButton11: TSpeedButton;
    WebSpeedButton12: TSpeedButton;
    dsVattable: TDataSource;
    wdsVattable: TXDataWebDataSet;
    wcVattable: TXDataWebClient;
    wdsVattableVATPERC: TFloatField;
    wpcSysSetupSheet8: TTabSheet;
    WebPanel16: TPanel;
    WebPanel22: TPanel;
    WebSpeedButton13: TSpeedButton;
    WebSpeedButton14: TSpeedButton;
    WebSpeedButton15: TSpeedButton;
    WebSpeedButton16: TSpeedButton;
    WebSpeedButton17: TSpeedButton;
    wdsGLA: TXDataWebDataSet;
    dsGLA: TDataSource;
    wcGLA: TXDataWebClient;
    wdsGLAGLCODE: TStringField;
    wdsGLAGLDESCRIPTION: TStringField;
    wdsGLASUSPENDED: TBooleanField;
    wdsGLAbankaccount: TBooleanField;
    wdsGLAbankcard: TBooleanField;
    wpcSysSetupSheet9: TTabSheet;
    WebPanel23: TPanel;
    WebPanel24: TPanel;
    WebSpeedButton20: TSpeedButton;
    WebSpeedButton21: TSpeedButton;
    WebSpeedButton22: TSpeedButton;
    WebSpeedButton23: TSpeedButton;
    WebSpeedButton24: TSpeedButton;
    wpcSysSetupSheet10: TTabSheet;
    WebCheckListBox1: TCheckListBox;
    WebPageControl2: TPageControl;
    WebPageControl2Sheet1: TTabSheet;
    WebPanel32: TPanel;
    WebLabel98: TLabel;
    WebLabel99: TLabel;
    WebLabel100: TLabel;
    WebLabel101: TLabel;
    WebLabel102: TLabel;
    edtTFNUrl: TEdit;
    edtTFNUser: TEdit;
    edtTFNPassword: TEdit;
    edtTFNAPIKey: TEdit;
    edtTFNAccount: TEdit;
    WebPageControl2Sheet2: TTabSheet;
    WebPanel33: TPanel;
    WebLabel97: TLabel;
    WebLabel103: TLabel;
    WebLabel104: TLabel;
    WebLabel105: TLabel;
    WebLabel106: TLabel;
    WebLabel107: TLabel;
    edtFMSUrl: TEdit;
    edtFMSUser: TEdit;
    edtFMSPass: TEdit;
    edtFMSAPIKey: TEdit;
    edtFMSAccount: TEdit;
    Edit22: TEdit;
    WebPageControl2Sheet4: TTabSheet;
    WebPanel35: TPanel;
    WebLabel114: TLabel;
    WebLabel113: TLabel;
    WebLabel112: TLabel;
    edtFuelUUrl: TEdit;
    edtFuelUToken: TEdit;
    edtFuelUPassword: TEdit;
    WebPageControl2Sheet5: TTabSheet;
    WebPanel36: TPanel;
    WebLabel115: TLabel;
    WebLabel116: TLabel;
    WebLabel117: TLabel;
    WebLabel118: TLabel;
    WebLabel119: TLabel;
    edtPremiPointUrl: TEdit;
    edtPremiPointUser: TEdit;
    edtPremiPointPassword: TEdit;
    edtPremiPointKey: TEdit;
    edtPremiPointAccount: TEdit;
    wpcSysSetupSheet11: TTabSheet;
    wpcSysSetupSheet12: TTabSheet;
    WebPanel37: TPanel;
    WebDBRadioGroup1: TDBRadioGroup;
    WebPanel38: TPanel;
    WebLabel120: TLabel;
    WebLabel121: TLabel;
    WebLabel122: TLabel;
    WebLabel123: TLabel;
    WebLabel124: TLabel;
    WebLabel125: TLabel;
    WebLabel126: TLabel;
    WebLabel127: TLabel;
    WebLabel128: TLabel;
    WebLabel129: TLabel;
    WebDBCheckBox1: TDBCheckBox;
    WebDBCheckBox4: TDBCheckBox;
    WebDBCheckBox41: TDBCheckBox;
    WebDBCheckBox42: TDBCheckBox;
    WebDBComboBox1: TDBComboBox;
    WebDBComboBox2: TDBComboBox;
    WebDBComboBox3: TDBComboBox;
    WebDBComboBox4: TDBComboBox;
    WebDBEdit35: TDBEdit;
    WebDBEdit36: TDBEdit;
    WebDBEdit37: TDBEdit;
    WebDBEdit38: TDBEdit;
    WebDBEdit39: TDBEdit;
    WebDBEdit40: TDBEdit;
    wdsSystemLedgerAccounts: TXDataWebDataSet;
    wcSystemLedgerAccounts: TXDataWebClient;
    dsSystemLedgerAccounts: TDataSource;
    wdsSystemLedgerAccountsGLDESCRIPTION: TStringField;
    wdsSystemLedgerAccountsFleetDesc: TStringField;
    wdsSystemLedgerAccountsValueTypesDesc: TStringField;
    wdsSystemLedgerAccountsSystemDesc: TStringField;
    wdsNumbersTranType: TStringField;
    wdsNumbersPrefix: TStringField;
    wdsNumbersDescription: TStringField;
    wdsNumbersSuffix: TIntegerField;
    wdsTFNSubAccountsS1: TXDataWebDataSet;
    dsTFNSubAccountsS1: TDataSource;
    wcTFNSubAccountsS1: TXDataWebClient;
    WebPanel25: TPanel;
    TFNSubAccountsFirst: TSpeedButton;
    TFNSubAccountsPrior: TSpeedButton;
    TFNSubAccountsNext: TSpeedButton;
    WebSpeedButton28: TSpeedButton;
    edtTFNSubAccounts: TEdit;
    wdsTFNSubAccountsS1ApiServerNo: TIntegerField;
    wdsTFNSubAccountsS1SubContractNo: TStringField;
    wdsTFNSubAccountsS1ApiAccountNo: TStringField;
    wdsTFNSubAccountsS1SubsRegNo: TStringField;
    wdsTFNSubAccountsS1CRName: TStringField;
    wcTFNSubAccountsS2: TXDataWebClient;
    wdsTFNSubAccountsS2: TXDataWebDataSet;
    WebPanel26: TPanel;
    WebPanel27: TPanel;
    WebSpeedButton25: TSpeedButton;
    WebSpeedButton26: TSpeedButton;
    WebSpeedButton27: TSpeedButton;
    WebSpeedButton29: TSpeedButton;
    WebSpeedButton30: TSpeedButton;
    WebPanel28: TPanel;
    WebSpeedButton31: TSpeedButton;
    WebSpeedButton32: TSpeedButton;
    WebSpeedButton33: TSpeedButton;
    WebSpeedButton34: TSpeedButton;
    WebSpeedButton35: TSpeedButton;
    sbtnTFNSubAccountsS2First: TSpeedButton;
    sbtnTFNSubAccountsS2prior: TSpeedButton;
    sbtnTFNSubAccountsS2Next: TSpeedButton;
    sbtnTFNSubAccountsS2Last: TSpeedButton;
    edtTFNSubAccountsS2: TEdit;
    wdsTFNSubAccountsS2ApiServerNo: TIntegerField;
    wdsTFNSubAccountsS2SubContractNo: TStringField;
    wdsTFNSubAccountsS2ApiAccountNo: TStringField;
    wdsTFNSubAccountsS2SubsRegNo: TStringField;
    wdsTFNSubAccountsS2CRName: TStringField;
    WebPanel14: TPanel;
    btnVatTableFirst: TSpeedButton;
    btnVattablePrior: TSpeedButton;
    btnVattableNext: TSpeedButton;
    btnVattableLast: TSpeedButton;
    edtVattablePagecount: TEdit;
    wdsVattableAuto: TIntegerField;
    WebPanel29: TPanel;
    edtNumbersPageCount: TEdit;
    sbtnNumbersNext: TSpeedButton;
    sbtnNumbersPrevious: TSpeedButton;
    sbtnNumbersLast: TSpeedButton;
    sbtnNumbersFirst: TSpeedButton;
    wdsSystemLedgerAccountsGLCode: TStringField;
    edtGLAPC: TEdit;
    sbtnGlaFirst: TSpeedButton;
    sbtnGLAPrior: TSpeedButton;
    sbtnGLANext: TSpeedButton;
    sbtnGLALast: TSpeedButton;
    dsTFNSubAccountsS2: TDataSource;
    btnSystemLedgerFirst: TSpeedButton;
    btnSystemLedgerPrior: TSpeedButton;
    btnSystemLedgerNext: TSpeedButton;
    btnSystemLedgerLast: TSpeedButton;
    edtSystemLedger: TEdit;
    wdsSystemLedgerAccountscompanygldetail_Auto: TIntegerField;
    WebDBComboBox5: TDBComboBox;
    WebDBComboBox6: TDBComboBox;
    WebDBComboBox7: TDBComboBox;
    WebDBComboBox8: TDBComboBox;
    wdsFinLinkSystem: TXDataWebDataSet;
    dsFinLinkSystem: TDataSource;
    wcFinLinkSystem: TXDataWebClient;
    wdsFinLinkSystemFinNo: TIntegerField;
    wdsFinLinkSystemFinName: TStringField;
    wdsFinLinkSystemFinActive: TStringField;
    dgNumbers: TTMSFNCDataGrid;
    dbagNumbers: TTMSFNCDataGridDatabaseAdapter;
    msgdlgNumbersDelete: TMessageDlg;
    dgVatSetup: TTMSFNCDataGrid;
    dbagVatSetup: TTMSFNCDataGridDatabaseAdapter;
    msgdlgVattable: TMessageDlg;
    dgGLA: TTMSFNCDataGrid;
    dbagGLA: TTMSFNCDataGridDatabaseAdapter;
    msgdlgGLA: TMessageDlg;
    dgSystemLedger: TTMSFNCDataGrid;
    dbagSystemLedger: TTMSFNCDataGridDatabaseAdapter;
    msgdlgSystemLedger: TMessageDlg;
    dgTFN1: TTMSFNCDataGrid;
    dbagTFNSubaccounts1: TTMSFNCDataGridDatabaseAdapter;
    dgTFNSubAccounts2: TTMSFNCDataGrid;
    dbagTFNSubAccountsS2: TTMSFNCDataGridDatabaseAdapter;
    WebMessageDlg1: TMessageDlg;
    BitmapContainer1: TTMSFNCBitmapContainer;
    wdsVattableSTARTDATE: TStringField;
    wdsVattableENDATE: TStringField;
    wdsTFNSubAccountsS1LastRunDate: TStringField;
    wdsTFNSubAccountsS2LastRunDate: TStringField;
    wdsCompInfoADDRESS1: TStringField;
    wdsCompInfoADDRESS2: TStringField;
    wdsCompInfoADDRESS3: TStringField;
    wdsCompInfoADDRESS4: TStringField;
    wdsCompInfoADDRESSCODE: TStringField;
    wdsCompInfoCOMPANYNAME: TStringField;
    wdsCompInfoCOMPANYFAX: TStringField;
    wdsCompInfoCOMPANYTEL: TStringField;
    wdsCompInfoCOMPANYREG: TStringField;
    wdsCompInfoCOMPANYVAT: TStringField;
    wdsCompInfoLOGOPATH: TStringField;
    wdsCompInfoUSEDIFFCOMP: TBooleanField;
    wdsCompInfoBANKDETAILS1: TStringField;
    wdsCompInfoBANKDETAILS2: TStringField;
    wdsCompInfoBANKDETAILS3: TStringField;
    wdsCompInfoBANKDETAILS4: TStringField;
    wdsCompInfoLOADCONTYPE: TStringField;
    wdsCompInfoLOADCONPREFIX: TStringField;
    wdsCompInfoCompanyCode: TIntegerField;
    wdsCompInfoSSUNIQUECLIENTDOCKET: TBooleanField;
    procedure WebFormShow(Sender: TObject);
    procedure btnSaveClick(Sender: TObject);
    procedure WebSpeedButton7Click(Sender: TObject);
    procedure WebSpeedButton6Click(Sender: TObject);
    procedure tmsGridNumbersCellClick(Sender: TObject; ACol, ARow: Integer);
    procedure sbtnNextVattableClick(Sender: TObject);
    procedure sbtnPreviousVattableClick(Sender: TObject);
    procedure edtVattablePageCountChange(Sender: TObject);
    procedure edtVattablePageCountExit(Sender: TObject);
    procedure WebSpeedButton5Click(Sender: TObject);
    procedure WebSpeedButton3Click(Sender: TObject);
    procedure WebSpeedButton4Click(Sender: TObject);
    procedure WebSpeedButton2Click(Sender: TObject);
    procedure WebSpeedButton1Click(Sender: TObject);
    procedure WebSpeedButton12Click(Sender: TObject);
    procedure WebSpeedButton17Click(Sender: TObject);
    procedure WebSpeedButton24Click(Sender: TObject);
    procedure TFNSubAccountsNextClick(Sender: TObject);
    procedure TFNSubAccountsPriorClick(Sender: TObject);
    procedure TFNSubAccountsFirstClick(Sender: TObject);
    procedure WebSpeedButton28Click(Sender: TObject);
    procedure sbtnTFNSubAccountsS2priorClick(Sender: TObject);
    procedure sbtnTFNSubAccountsS2FirstClick(Sender: TObject);
    procedure sbtnTFNSubAccountsS2NextClick(Sender: TObject);
    procedure sbtnTFNSubAccountsS2LastClick(Sender: TObject);
    procedure WebSpeedButton30Click(Sender: TObject);
    procedure sbtnGLAPriorClick(Sender: TObject);
    procedure sbtnGLANextClick(Sender: TObject);
    procedure sbtnGlaFirstClick(Sender: TObject);
    procedure sbtnGLALastClick(Sender: TObject);
    procedure WebSpeedButton35Click(Sender: TObject);
    procedure btnSystemLedgerNextClick(Sender: TObject);
    procedure btnSystemLedgerPriorClick(Sender: TObject);
    procedure btnSystemLedgerFirstClick(Sender: TObject);
    procedure btnSystemLedgerLastClick(Sender: TObject);
    procedure dgNumbersCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure dgVatSetupCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure dgGLACellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure dgSystemLedgerCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure dgTFN1CellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure dgTFNSubAccounts2CellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure sbtnNumbersNextClick(Sender: TObject);
    procedure sbtnNumbersPreviousClick(Sender: TObject);
    procedure sbtnNumbersLastClick(Sender: TObject);
    procedure sbtnNumbersFirstClick(Sender: TObject);
    procedure dgNumbersGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure dgVatSetupGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure dgGLAGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure dgSystemLedgerGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure dgTFN1GetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure dgTFNSubAccounts2GetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure WebDBCheckBox5Click(Sender: TObject);
    procedure WebDBCheckBox13Click(Sender: TObject);
    procedure WebDBCheckBox12Click(Sender: TObject);
    procedure WebDBCheckBox6Click(Sender: TObject);
    procedure WebDBCheckBox8Click(Sender: TObject);
    procedure WebDBCheckBox11Click(Sender: TObject);
    procedure WebDBCheckBox9Click(Sender: TObject);
    procedure WebDBCheckBox14Click(Sender: TObject);
    procedure WebDBCheckBox10Click(Sender: TObject);
    procedure WebDBCheckBox7Click(Sender: TObject);
    procedure WebDBCheckBox15Click(Sender: TObject);
    procedure WebDBCheckBox16Click(Sender: TObject);
    procedure WebDBCheckBox17Click(Sender: TObject);
    procedure WebDBCheckBox18Click(Sender: TObject);
    procedure WebDBCheckBox19Click(Sender: TObject);
    procedure WebDBCheckBox20Click(Sender: TObject);
    procedure WebDBCheckBox21Click(Sender: TObject);
    procedure WebDBCheckBox22Click(Sender: TObject);
    procedure WebDBCheckBox23Click(Sender: TObject);
    procedure WebDBCheckBox24Click(Sender: TObject);
    procedure WebDBCheckBox25Click(Sender: TObject);
    procedure WebDBCheckBox26Click(Sender: TObject);
    procedure WebDBCheckBox27Click(Sender: TObject);
    procedure WebDBCheckBox28Click(Sender: TObject);
    procedure WebDBCheckBox29Click(Sender: TObject);
    procedure WebDBCheckBox30Click(Sender: TObject);
    procedure WebDBCheckBox31Click(Sender: TObject);
    procedure WebDBCheckBox32Click(Sender: TObject);
    procedure WebDBCheckBox33Click(Sender: TObject);
    procedure WebDBCheckBox34Click(Sender: TObject);
    procedure WebDBCheckBox35Click(Sender: TObject);
    procedure WebDBCheckBox36Click(Sender: TObject);
    procedure WebDBCheckBox37Click(Sender: TObject);
    procedure WebDBCheckBox38Click(Sender: TObject);
    procedure WebDBCheckBox39Click(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure cbxPrintOnStatementClick(Sender: TObject);
    procedure dbcbxAutomailigClick(Sender: TObject);
    procedure WebDBCheckBox2Click(Sender: TObject);
    procedure WebDBCheckBox3Click(Sender: TObject);
    procedure WebDBCheckBox42Click(Sender: TObject);
    procedure WebDBCheckBox1Click(Sender: TObject);
    procedure WebDBCheckBox4Click(Sender: TObject);
    procedure WebDBCheckBox41Click(Sender: TObject);
  private
    { Private declarations }

    iInvoiceNumPC , iInvoiceNumMaxPC ,
    iVattablePC , iVattableMaxPC ,
    iGLAPC, iGLAMaxPC,
    iSLAPC, iSLAMaxPC,
    iTFNSubAccountsS1PC , iTFNSubAccountsMaxS1PC,
    iTFNSubAccountsS2PC , iTFNSubAccountsMaxS2PC : Integer;

    BitMapEdit, BitMapDelete : TTMSFNCBitmap;

    procedure LoadCompInfo;
    procedure LoadInvoiceNumbers;
    procedure LoadFinSystems;
    procedure LoadVattable;
    Procedure LoadGLA;
    Procedure LoadSystemLedgerAccounts;
    procedure LoadTFNSubAccountsS1;
    Procedure LoadTFNSubAccountsS2;


    Function GetCheckBoxState(sGrid : TTMSFNCGrid; ACol, ARow : Integer; var bState: Boolean) : Boolean;
  public
    { Public declarations }

  protected procedure LoadDFMValues; override; end;

var
  frmSystemSettings: TfrmSystemSettings;

implementation

{$R *.dfm}
  uses
    stfmssystem.connection , share.system.classes , share.common,
    SystemSetupVatSetup,SystemInvoiceNumberSetup,SystemGeneralLedgerAccountsSetup, SystemLedgerAccountSetup, SystemTFNSubAccountsSetup, FMSFuelSystemSetup;
{ TfrmSystemSettings }

procedure TfrmSystemSettings.btnSystemLedgerFirstClick(Sender: TObject);
begin
  iSLAPC := 1;
  LoadSystemLedgerAccounts;
end;

procedure TfrmSystemSettings.btnSystemLedgerLastClick(Sender: TObject);
begin
  iSLAPC := iSLAMaxPC;
  LoadSystemLedgerAccounts;
end;

procedure TfrmSystemSettings.btnSystemLedgerNextClick(Sender: TObject);
begin
  if iSLAPC < iSLAMaxPC then
    Begin
      iSLAPC := iSLAPC + 1;
      LoadSystemLedgerAccounts;
    End;
end;

procedure TfrmSystemSettings.btnSystemLedgerPriorClick(Sender: TObject);
begin
  if iSLAPC > 1 then
    Begin
      iSLAPC := iSLAPC - 1;
      LoadSystemLedgerAccounts;
    End;
end;

procedure TfrmSystemSettings.cbxPrintOnStatementClick(Sender: TObject);
begin
    wdsCompInfo.FieldByName('BANKSTATEMENT').AsBoolean := cbxPrintOnStatement.Checked;
end;

procedure TfrmSystemSettings.dgNumbersCellClick(Sender: TObject; AColumn,
  ARow: Integer);
  var
    newform : TfrmSystemInvoiceNumberSetup;
    sTran : String;
  procedure AfterCreate(AForm: TObject);
    begin
      with newform do
        begin
          iState := 2;
          dbagNumbers.SetActiveRecord(ARow);
          sTran := dbagNumbers.FieldAtColumn[0].AsString;
          lblTran.Caption := sTran;
        end;
    end;
  procedure AfterShowModal(AValue: TModalResult);
    begin
      LoadInvoiceNumbers;
    end;
  procedure OnResult(Value : TModalResult);
    begin
      If Value = mrYes then
        Begin
          //wcCompInfo.RawInvoke('IstfmsSystemService.Put_InvoiceNumber_Delete',[tmsGridNumbers.Cells[0,ARow]]);
          //LoadInvoiceNumbers;
        End
      else
        Exit;
    end;
begin
  if AColumn = 4 then
    Begin
      newform := TfrmSystemInvoiceNumberSetup.CreateNew(@AfterCreate);
      newform.Popup := true;
      newform.PopupOpacity := 0.2;
      newform.Showmodal(@AfterShowModal);
    End;

  if AColumn = 5 then
    Begin
      msgdlgNumbersDelete.ShowDialog('Do you want to delete this record?', WEBLib.Dialogs.mtWarning,[mbYes, mbNo], @OnResult);
    End;
end;

procedure TfrmSystemSettings.dgNumbersGetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin
  if ACell.IsBitmapCell and dbagNumbers.IsValidDataCell(ACell.Coordinate) then
    begin
      if ACell.Column = 4 then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[0];
    end;

end;

procedure TfrmSystemSettings.edtVattablePageCountChange(Sender: TObject);
begin
  if (StrToInt(edtVattablePageCount.Text) <= iVattableMaxPC) AND (StrToInt(edtVattablePageCount.Text) > 0) then
    Begin
      iVattablePC := StrToInt(edtVattablePageCount.Text);
    End
  else
    Begin
      iVattablePC := iVattableMaxPC;
      edtVattablePageCount.Text := IntToStr(iVattableMaxPC);
    End;
end;

procedure TfrmSystemSettings.edtVattablePageCountExit(Sender: TObject);
begin
  if (StrToInt(edtVattablePageCount.Text) <= iVattableMaxPC) AND (StrToInt(edtVattablePageCount.Text) > 0) then
    Begin
      iVattablePC := StrToInt(edtVattablePageCount.Text);
      LoadVattable;
    End
  else
    Begin
      iVattablePC := iVattableMaxPC;
      edtVattablePageCount.Text := IntToStr(iVattableMaxPC);
      LoadVattable;
    End;
end;

function TfrmSystemSettings.GetCheckBoxState(sGrid: TTMSFNCGrid; ACol,
  ARow: Integer; var bState: Boolean): Boolean;
begin
  if Assigned(sGrid) then
    begin
      If sGrid.IsCheckBox(ACol,ARow) then
        Begin
           bState := sGrid.CheckBoxState[ACol,ARow];
           Result := True;
        End
      else
        result := False;
    end
  else
    result := False
end;

procedure TfrmSystemSettings.LoadCompInfo;

  procedure OnErrorCompInfo(Error: TXDataClientError);
    begin
      LoadCompInfo;
    end;

  procedure OnResultFinSystems(Response : TXDataClientResponse);
    begin
      wdsFinLinkSystem.Close;
      wdsFinLinkSystem.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsFinLinkSystem.Open;
    end;

  procedure OnResultTFNSubAccountsS2(Response : TXDataClientResponse);
    begin
      wdsTFNSubAccountsS2.Close;
      wdsTFNSubAccountsS2.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsTFNSubAccountsS2.Open;

      wcFinSystem.RawInvoke('IstfmsSystemService.Get_FinLinkSystem_View',[],@OnResultFinSystems,@OnErrorCompInfo);
    end;

  procedure OnResultTFNSubAccountsS2MaxPC(Response : TXDataClientResponse);
    begin
      iTFNSubAccountsMaxS2PC := Integer(TJSObject(Response.Result)['value']);
      edtTFNSubAccountsS2.Text := IntToStr(iTFNSubAccountsS2PC) + ' OF ' + IntToStr(iTFNSubAccountsMaxS2PC);

      wcTFNSubAccountsS2.RawInvoke('IstfmsSystemService.Get_TFNSubAccountsS1_View',[iTFNSubAccountsS2PC,2,'*'],@OnResultTFNSubAccountsS2,@OnErrorCompInfo);
    end;

  procedure OnResultTFNSubAccountsS1(Response : TXDataClientResponse);
    begin
      wdsTFNSubAccountsS1.Close;
      wdsTFNSubAccountsS1.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsTFNSubAccountsS1.Open;

      wcTFNSubAccountsS2.RawInvoke('IstfmsSystemService.Get_TFNSubAccountsS2_PC',[],@OnResultTFNSubAccountsS2MaxPC,@OnErrorCompInfo);
    end;

  procedure OnResultTFNSubAccountsS1MaxPC(Response : TXDataClientResponse);
    begin
      iTFNSubAccountsMaxS1PC := Integer(TJSObject(Response.Result)['value']);
      edtTFNSubAccounts.Text := IntToStr(iTFNSubAccountsS1PC) + ' OF ' + IntToStr(iTFNSubAccountsMaxS1PC);

      wcTFNSubAccountsS1.RawInvoke('IstfmsSystemService.Get_TFNSubAccountsS1_View',[iTFNSubAccountsS1PC,1,'*'],@OnResultTFNSubAccountsS1,@OnErrorCompInfo);
    end;

  procedure OnResultSysGeneralLedgerAccView(Response : TXDataClientResponse);
    begin
      edtSystemLedger.Text := IntToStr(iSLAPC) + ' OF ' + IntToStr(iSLAMaxPC);

      wdsSystemLedgerAccounts.Close;
      wdsSystemLedgerAccounts.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsSystemLedgerAccounts.Open;

      wcTFNSubAccountsS1.RawInvoke('IstfmsSystemService.Get_TFNSubAccountsS1_PC',[],@OnResultTFNSubAccountsS1MaxPC,@OnErrorCompInfo);
    end;

  procedure OnResultSysGeneralLedgerAccMPC(Response : TXDataClientResponse);
    begin
      iSLAMaxPC := Integer(TJSObject(Response.Result)['value']);

      wcSystemLedgerAccounts.RawInvoke('IstfmsSystemService.Get_CompanyGL_View',[iSLAPC,0],@OnResultSysGeneralLedgerAccView,@OnErrorCompInfo);
    end;

  procedure OnResultGLA(Response : TXDataClientResponse);
    begin
      edtGLAPC.Text := IntToStr(iGLAPC) + ' OF ' + IntToStr(iGLAMaxPC);

      wdsGLA.Close;
      wdsGLA.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsGLA.Open;

      wcSystemLedgerAccounts.RawInvoke('IstfmsSystemService.Get_SystemLedegr_MaxPC',[],@OnResultSysGeneralLedgerAccMPC,@OnErrorCompInfo);
    end;

  procedure OnResultMaxPCGLA(Response : TXDataClientResponse);
    begin
      iGLAMaxPC := Integer(TJSObject(Response.Result)['value']);


      wcGLA.RawInvoke('IstfmsSystemService.Get_GLCodes_View',[iGLAPC,'*'],@OnResultGLA,@OnErrorCompInfo);
    end;

  procedure OnResultVattable(Response : TXDataClientResponse);
    begin
      wdsVattable.Close;
      wdsVattable.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsVattable.Open;

      wcGLA.RawInvoke('IstfmsSystemService.Get_GLCodesMaxPageCount',[],@OnResultMaxPCGLA,@OnErrorCompInfo);
    end;

  procedure OnResultMaxPCVattable(Response : TXDataClientResponse);
    begin
      iVattableMaxPC := Integer(TJSObject(Response.Result)['value']);
      edtVattablePagecount.Text := ('1 OF ' + IntToStr(iVattableMaxPC));

      wcVattable.RawInvoke('IstfmsSystemService.Get_Vattable_View',[iVattablePC,0],@OnResultVattable,@OnErrorCompInfo);
    end;

  procedure OnResultNumbers(Response : TXDataClientResponse);
    begin
      edtNumbersPageCount.Text := IntToStr(iInvoiceNumPC) + ' OF ' + IntToStr(iInvoiceNumMaxPC);

      wdsNumbers.Close;
      wdsNumbers.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsNumbers.Open;

      wcVattable.RawInvoke('IstfmsSystemService.Get_Vattable_Pagecount',[],@OnResultMaxPCVattable,@OnErrorCompInfo);
    end;

  procedure OnResultMaxPCInvoiceNum(Response : TXDataClientResponse);
    begin
      iInvoiceNumMaxPC := Integer(TJSObject(Response.Result)['value']);

      wcNumbers.RawInvoke('IstfmsSystemService.Get_InvoiceNumbers_view',[iInvoiceNumPC,'*'],@OnResultNumbers,@OnErrorCompInfo);
    end;


  procedure OnResult(Response : TXDataClientResponse);
    begin

      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadInvoiceNumbers;
        end
      else
        begin

          wdsCompInfo.Close;
          wdsCompInfo.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
          wdsCompInfo.Open;


          console.log(GetJsonFromDataSet(wdsCompInfo));

          if wdsCompInfo.IsEmpty then
            begin
              wdsCompInfo.Insert;
            end
          else
            begin
              wdsCompInfo.Edit;
            end;

            wcNumbers.RawInvoke('IstfmsSystemService.Get_InvoiceNumbers_MaxPageCount',[],@OnResultMaxPCInvoiceNum,@OnErrorCompInfo);
            edtNumbersPageCount.Text := IntToStr(iInvoiceNumPC) + ' OF ' +  IntToStr(iInvoiceNumPC);
        end;

    end;
begin
  wcCompInfo.RawInvoke('IstfmsSystemService.Get_Systemsetup_View',[0,0],@OnResult,@OnErrorCompInfo);
end;

procedure TfrmSystemSettings.LoadFinSystems;

  procedure OnErrorFinSystem(Error: TXDataClientError);
    begin
      LoadFinSystems;
    end;
  procedure OnResultFinSystems(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadInvoiceNumbers;
        end
      else
        begin
          wdsFinSystem.Close;
          wdsFinSystem.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
          wdsFinSystem.Open;
        end;
    end;
begin
  wcFinSystem.RawInvoke('IstfmsSystemService.Get_InvoiceNumbers_view',[0,'*'],@OnResultFinSystems,@OnErrorFinSystem);
end;

procedure TfrmSystemSettings.LoadGLA;
  procedure OnErrorGLA(Error: TXDataClientError);
    begin
      LoadGLA;
    end;

  procedure OnResultGLA(Response : TXDataClientResponse);
    begin
      edtGLAPC.Text := IntToStr(iGLAPC) + ' OF ' + IntToStr(iGLAMaxPC);

      wdsGLA.Close;
      wdsGLA.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsGLA.Open;

    end;

  procedure OnResultMaxPCGLA(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadInvoiceNumbers;
        end
      else
        begin
          iGLAMaxPC := Integer(TJSObject(Response.Result)['value']);

          wcGLA.RawInvoke('IstfmsSystemService.Get_GLCodes_View',[iGLAPC,'*'],@OnResultGLA,@OnErrorGLA);
        end;
    end;
begin
  wcGLA.RawInvoke('IstfmsSystemService.Get_GLCodesMaxPageCount',[],@OnResultMaxPCGLA,@OnErrorGLA);
end;

procedure TfrmSystemSettings.LoadInvoiceNumbers;
  procedure OnErrorMaxNumbers(Error: TXDataClientError);
    begin
      LoadInvoiceNumbers;
    end;

  procedure OnResultNumbers(Response : TXDataClientResponse);
    begin
      edtNumbersPageCount.Text := IntToStr(iInvoiceNumPC) + ' OF ' + IntToStr(iInvoiceNumMaxPC);

      wdsNumbers.Close;
      wdsNumbers.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsNumbers.Open;

      console.log(GetJsonFromDataSet(wdsNumbers));
    end;

  procedure OnResultMaxPCInvoiceNum(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadInvoiceNumbers;
        end
      else
        begin
          iInvoiceNumMaxPC := Integer(TJSObject(Response.Result)['value']);

          wcNumbers.RawInvoke('IstfmsSystemService.Get_InvoiceNumbers_view',[iInvoiceNumPC,'*'],@OnResultNumbers,@OnErrorMaxNumbers);
        end;
    end;
begin
  wcNumbers.RawInvoke('IstfmsSystemService.Get_InvoiceNumbers_MaxPageCount',[],@OnResultMaxPCInvoiceNum,@OnErrorMaxNumbers);
end;

procedure TfrmSystemSettings.LoadSystemLedgerAccounts;

  procedure OnErrorSLA(Error: TXDataClientError);
    begin
      LoadSystemLedgerAccounts;
    end;
  procedure OnResultSysGeneralLedgerAccView(Response : TXDataClientResponse);
    begin
      edtSystemLedger.Text := IntToStr(iSLAPC) + ' OF ' + IntToStr(iSLAMaxPC);

      wdsSystemLedgerAccounts.Close;
      wdsSystemLedgerAccounts.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsSystemLedgerAccounts.Open;
    end;

  procedure OnResultSysGeneralLedgerAccMPC(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadSystemLedgerAccounts;
        end
      else
        begin
          iSLAMaxPC := Integer(TJSObject(Response.Result)['value']);

          wcSystemLedgerAccounts.RawInvoke('IstfmsSystemService.Get_CompanyGL_View',[iSLAPC,0],@OnResultSysGeneralLedgerAccView,@OnErrorSLA);
        end;
    end;
begin
  wcSystemLedgerAccounts.RawInvoke('IstfmsSystemService.Get_SystemLedegr_MaxPC',[],@OnResultSysGeneralLedgerAccMPC,@OnErrorSLA);
end;

procedure TfrmSystemSettings.LoadVattable;

  procedure OnErrorVattable(Error: TXDataClientError);
    begin
      LoadVattable;
    end;
  procedure OnResultVattable(Response : TXDataClientResponse);
    begin
      wdsVattable.Close;
      wdsVattable.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsVattable.Open;
    end;

  procedure OnResultMaxPCVattable(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadVattable;
        end
      else
        begin
          iVattableMaxPC := Integer(TJSObject(Response.Result)['value']);
          edtVattablePagecount.Text := ('1 OF ' + IntToStr(iVattableMaxPC));

          wcVattable.RawInvoke('IstfmsSystemService.Get_Vattable_View',[iVattablePC,0],@OnResultVattable,@OnErrorVattable);
        end;
    end;
begin
  wcVattable.RawInvoke('IstfmsSystemService.Get_Vattable_Pagecount',[],@OnResultMaxPCVattable,@OnErrorVattable);
end;

procedure TfrmSystemSettings.sbtnNextVattableClick(Sender: TObject);
begin
  If iVattablePC < iVattableMaxPC then
    Begin
      Inc(iVattablePC);
      edtVattablePageCount.Text := IntToStr(iVattablePC);
      LoadVattable;
    End;
end;

procedure TfrmSystemSettings.sbtnNumbersFirstClick(Sender: TObject);
begin
  iInvoiceNumPC := 1;
  LoadInvoiceNumbers;
end;

procedure TfrmSystemSettings.sbtnNumbersLastClick(Sender: TObject);
begin
  iInvoiceNumPC := iInvoiceNumMaxPC;
  LoadInvoiceNumbers;
end;

procedure TfrmSystemSettings.sbtnNumbersNextClick(Sender: TObject);
begin
  if iInvoiceNumPC < iInvoiceNumMaxPC then
    Begin
      Inc(iInvoiceNumPC);
      LoadInvoiceNumbers;
    End;

end;

procedure TfrmSystemSettings.sbtnNumbersPreviousClick(Sender: TObject);
begin
  if iInvoiceNumPC > 1 then
    Begin
      iInvoiceNumPC := iInvoiceNumPC-1;
      LoadInvoiceNumbers;
    End;
end;

procedure TfrmSystemSettings.sbtnPreviousVattableClick(Sender: TObject);
begin
  if iVattablePC > 1 then
    Begin
      Dec(iVattablePC);
      LoadVattable;
    End;
end;

procedure TfrmSystemSettings.sbtnTFNSubAccountsS2FirstClick(Sender: TObject);
begin
  iTFNSubAccountsS2PC := 1;
end;

procedure TfrmSystemSettings.sbtnTFNSubAccountsS2LastClick(Sender: TObject);
begin
  iTFNSubAccountsS2PC := iTFNSubAccountsMaxS2PC;
end;

procedure TfrmSystemSettings.sbtnTFNSubAccountsS2NextClick(Sender: TObject);
begin
  if iTFNSubAccountsS2PC < iTFNSubAccountsMaxS2PC then
    Begin
      Inc(iTFNSubAccountsS2PC);
    End;
end;

procedure TfrmSystemSettings.sbtnTFNSubAccountsS2priorClick(Sender: TObject);
begin
  if iTFNSubAccountsS2PC > 1 then
    Begin
      Dec(iTFNSubAccountsS2PC);
    End;
end;

procedure TfrmSystemSettings.TFNSubAccountsFirstClick(Sender: TObject);
begin
  iTFNSubAccountsS1PC := 1;
  LoadVattable;
end;

procedure TfrmSystemSettings.TFNSubAccountsNextClick(Sender: TObject);
begin
  if iTFNSubAccountsS1PC < iTFNSubAccountsMaxS1PC then
    Begin
      Inc(iTFNSubAccountsS1PC);
      LoadVattable;
    End;
end;

procedure TfrmSystemSettings.TFNSubAccountsPriorClick(Sender: TObject);
begin
  if iTFNSubAccountsS1PC > 1 then
    Begin
      Dec(iTFNSubAccountsS1PC);
      LoadVattable;
    End;
end;

procedure TfrmSystemSettings.dgVatSetupCellClick(Sender: TObject; AColumn,
  ARow: Integer);
var
    newform : TfrmSystemVatSetup;

  procedure AfterCreate(AForm: TObject);
    begin
      with newform do
        begin
          iState := 2;
          dbagVatSetup.SetActiveRecord(ARow);
          iAuto := dbagVatSetup.FieldAtColumn[3].AsInteger;
        end;
    end;
  procedure AfterShowModal(AValue: TModalResult);
    begin
      LoadVattable;
    end;

begin
  if AColumn = 4 then
    Begin
      newform := TfrmSystemVatSetup.CreateNew(@AfterCreate);
      newform.Popup := true;
      newform.PopupOpacity := 0.2;
      newform.Showmodal(@AfterShowModal);
    End;
end;

procedure TfrmSystemSettings.dgVatSetupGetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin
  if ACell.IsBitmapCell and dbagVatSetup.IsValidDataCell(ACell.Coordinate) then
    begin
      if ACell.Column = 4 then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[0];

    end;
end;

procedure TfrmSystemSettings.dgTFN1CellClick(Sender: TObject; AColumn,
  ARow: Integer);
var
    newform : TfrmTFNSubAccountsSetup;

  procedure AfterCreate(AForm: TObject);
    begin
      with newform do
        begin
          iState := 2;

          dbagTFNSubaccounts1.SetActiveRecord(ARow);
          sSubcontractorno := dbagTFNSubaccounts1.FieldAtColumn[1].AsString;
          iApiserverno := 1;
        end;
    end;

    procedure AfterShowModal(AValue: TModalResult);
    begin
      LoadTFNSubAccountsS1;
    end;

  procedure OnResult(Value : TModalResult);
    begin
      If Value = mrYes then
        Begin
          wcTFNSubAccountsS1.RawInvoke('IstfmsSystemService.Put_TFNSubAccounts_Delete',[1,dbagTFNSubaccounts1.FieldAtColumn[1].AsString]);

          LoadTFNSubAccountsS1;
        End
      else
        Exit;
  end;

begin
  if AColumn = 6 then
    Begin
      newform := TfrmTFNSubAccountsSetup.CreateNew(@AfterCreate);
      newform.Popup := true;
      newform.PopupOpacity := 0.2;
      newform.Showmodal(@AfterShowModal);

    End;

  if AColumn = 7 then
    Begin
      msgdlgNumbersDelete.ShowDialog('Do you want to delete this record with Sub Contractor No ' + dbagTFNSubaccounts1.FieldAtColumn[1].AsString, WEBLib.Dialogs.mtWarning,[mbYes, mbNo], @OnResult);
    end;
end;

procedure TfrmSystemSettings.dgTFN1GetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin
  if ACell.IsBitmapCell and dbagTFNSubaccounts1.IsValidDataCell(ACell.Coordinate) then
    Begin
      if ACell.Column = 6 then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[0];

      if ACell.Column = 7 then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[1];
    end;
end;

procedure TfrmSystemSettings.dgTFNSubAccounts2CellClick(Sender: TObject; AColumn,
  ARow: Integer);
var
    newform : TfrmFMSFuelSystem;

  procedure AfterCreate(AForm: TObject);
    begin
      with newform do
        begin
          iState := 2;
          dbagTFNSubAccountsS2.SetActiveRecord(ARow);
          sSubcontractorno := dbagTFNSubAccountsS2.FieldAtColumn[1].AsString;
          iApiserverno := 1;
        end;
    end;

    procedure AfterShowModal(AValue: TModalResult);
    begin
      LoadTFNSubAccountsS2;
    end;

  procedure OnResult(Value : TModalResult);
    begin
      If Value = mrYes then
        Begin
          wcTFNSubAccountsS1.RawInvoke('IstfmsSystemService.Put_TFNSubAccounts_Delete',[2,dbagTFNSubAccountsS2.FieldAtColumn[1].AsString]);

          LoadTFNSubAccountsS2;
        End
      else
        Exit;
  end;

begin
  if AColumn = 6 then
    Begin
      newform := TfrmFMSFuelSystem.CreateNew(@AfterCreate);
      newform.Popup := true;
      newform.PopupOpacity := 0.2;
      newform.Showmodal(@AfterShowModal);
    End;

  if AColumn = 7 then
    Begin
      msgdlgNumbersDelete.ShowDialog('Do you want to delete this record with Sub Contractor No ' + dbagTFNSubAccountsS2.FieldAtColumn[1].AsString, WEBLib.Dialogs.mtWarning,[mbYes, mbNo], @OnResult);
    End;
end;

procedure TfrmSystemSettings.dgTFNSubAccounts2GetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin
  if ACell.IsBitmapCell and dbagTFNSubAccountsS2.IsValidDataCell(ACell.Coordinate) then
    begin
      if ACell.Column = 6 then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[0];

      if ACell.Column = 7 then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[1];
    end;
end;

procedure TfrmSystemSettings.dgSystemLedgerCellClick(Sender: TObject; AColumn,
  ARow: Integer);
var
    newform : TfrmSystemLedgerAccountSetup;

  procedure OnSuccess(Response : TXDataClientResponse);
    Begin
      LoadSystemLedgerAccounts;
    End;
  procedure AfterCreate(AForm: TObject);
    begin
      with newform do
        begin
          iState := 2;
          dbagSystemLedger.SetActiveRecord(ARow);
          iAuto := dbagSystemLedger.FieldAtColumn[0].AsInteger;
        end;
    end;
  procedure AfterShowModal(AValue: TModalResult);
    begin
      LoadSystemLedgerAccounts;
    end;
  procedure OnResult(Value : TModalResult);
    begin
      If Value = mrYes then
        Begin
          dbagSystemLedger.SetActiveRecord(ARow);
          wcVattable.RawInvoke('IstfmsSystemService.Put_CompGLDetails_Delete',[dbagSystemLedger.FieldAtColumn[0].AsInteger],@OnSuccess);
        End
      else
        Exit;
    end;

begin
  if AColumn = 6 then
    Begin
      newform := TfrmSystemLedgerAccountSetup.CreateNew(@AfterCreate);
      newform.Popup := true;
      newform.PopupOpacity := 0.2;
      newform.Showmodal(@AfterShowModal);
    End;

  if AColumn = 7 then
    Begin
      msgdlgSystemLedger.ShowDialog('Do you want to delete this record ', WEBLib.Dialogs.mtWarning,[mbYes, mbNo], @OnResult);
    End;
end;

procedure TfrmSystemSettings.dgSystemLedgerGetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin
  if ACell.IsBitmapCell and dbagSystemLedger.IsValidDataCell(ACell.Coordinate) then
    begin
      if ACell.Column = 6 then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[0];

      if ACell.Column = 7 then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[1];

    end;
end;

procedure TfrmSystemSettings.dbcbxAutomailigClick(Sender: TObject);
begin
 wdsCompInfo.FieldByName('AUTOMAILSYSTEM').AsBoolean := dbcbxAutomailig.Checked;
end;

procedure TfrmSystemSettings.dgGLACellClick(Sender: TObject; AColumn,
  ARow: Integer);
var
    newform : TfrmGeneralLedgerAccounts;
    sGLCode : String;
  procedure AfterCreate(AForm: TObject);
    begin
      with newform do
        begin
          iState := 2;
          dbagGLA.SetActiveRecord(Arow);
          sGLCode := dbagGLA.FieldAtColumn[0].AsString;
        end;
    end;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      LoadGLA;
    end;

  procedure OnResult(Value : TModalResult);
    begin
      If Value = mrYes then
        Begin
          dbagGLA.SetActiveRecord(Arow);
          wcGLA.RawInvoke('IstfmsSystemService.Put_GLAccounts_Delete',[dbagGLA.FieldAtColumn[0].AsString]);

          LoadGLA;
        End
      else
        Exit;
  end;
begin
  if AColumn = 5 then
    Begin
      newform := TfrmGeneralLedgerAccounts.CreateNew(@AfterCreate);
      newform.Popup := true;
      newform.PopupOpacity := 0.2;
      newform.Showmodal(@AfterShowModal);
    End;

  if AColumn = 6 then
    Begin
      msgdlgGLA.ShowDialog('Do you want to delete this record with GL Code ' + dbagGLA.FieldAtColumn[0].AsString, WEBLib.Dialogs.mtWarning,[mbYes, mbNo], @OnResult);
    End;
end;

procedure TfrmSystemSettings.dgGLAGetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin
  if ACell.IsBitmapCell and dbagGLA.IsValidDataCell(ACell.Coordinate) then
    begin
      if ACell.Column = 5 then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[0];

      if ACell.Column = 6 then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[1];
    end;
   
end;

procedure TfrmSystemSettings.tmsGridNumbersCellClick(Sender: TObject; ACol,
  ARow: Integer);
  var
    newform : TfrmSystemInvoiceNumberSetup;
    sTran : String;
  procedure AfterCreate(AForm: TObject);
    begin
      with newform do
        begin
          iState := 2;
          dbagNumbers.SetActiveRecord(ARow);
          sTran := dbagNumbers.FieldAtColumn[0].AsString;
          lblTran.Caption := sTran;
        end;
    end;
  procedure AfterShowModal(AValue: TModalResult);
    begin
      LoadInvoiceNumbers;
    end;
  procedure OnResult(Value : TModalResult);
    begin
      If Value = mrYes then
        Begin
          //wcCompInfo.RawInvoke('IstfmsSystemService.Put_InvoiceNumber_Delete',[tmsGridNumbers.Cells[0,ARow]]);
          //LoadInvoiceNumbers;
        End
      else
        Exit;
    end;
begin
  if ACol = 4 then
    Begin
      newform := TfrmSystemInvoiceNumberSetup.CreateNew(@AfterCreate);
      newform.Popup := true;
      newform.PopupOpacity := 0.2;
      newform.Showmodal(@AfterShowModal);
    End;

  if ACol = 5 then
    Begin
      msgdlgNumbersDelete.ShowDialog('Do you want to delete this record?', WEBLib.Dialogs.mtWarning,[mbYes, mbNo], @OnResult);
    End;
end;

procedure TfrmSystemSettings.btnSaveClick(Sender: TObject);
  var
    infolist : TStringlist;
    bState : Boolean;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      ShowMessage('System Setup Successfully saved');
    end;
  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
    end;

begin

   //if dblFinName.ListSource.Dataset.FieldByName(dblFinName.ListField).AsString <> '' then
    //begin


      case dblFinName.ListSource.Dataset.FieldByName(dblFinName.KeyField).AsInteger of

        0:  Begin
              infolist := TStringList.Create;
              infolist.Clear;
              infolist.Add('[MASTER][SERVER]' + eServerName.Text + ';');
              infolist.Add('[MASTER][PATH]' + eDBPath.Text + ';');
              infolist.Add('[MASTER][USER]' + eUsername.Text + ';');
              infolist.Add('[MASTER][PASSWORD]' + ePassword.Text + ';');
              infolist.Add('[MASTER][PROTOCOL]' + eProtocol.Text + ';');
              infolist.Add('[MASTER][DRIVERID]' + eDriverID.Text + ';');
              infolist.Add('[MASTER][PORT]' + ePort.Text + ';');
              infolist.Add('[TRAN][SERVER]' + eServerName1.Text + ';');
              infolist.Add('[TRAN][PATH]' + eDBPath1.Text + ';');
              infolist.Add('[TRAN][USER]' + eUsername1.Text + ';');
              infolist.Add('[TRAN][PASSWORD]' + ePassword1.Text + ';');
              infolist.Add('[TRAN][PROTOCOL]' + eProtocol1.Text + ';');
              infolist.Add('[TRAN][DRIVERID]' + eDriverID1.Text + ';');
              infolist.Add('[TRAN][PORT]' + ePort1.Text + ';');

              wdsCompInfo.FieldByName('FINDBSETUP').AsString := infolist.Text;

              infolist.Free;

            End;
        1..7: Begin
                infolist := TStringList.Create;
                infolist.Clear;

                infolist.Add('[REGNAME][FIN01]' + edtsagepartnername.Text + ';');
                infolist.Add('[AUTHCODE][FIN01]' + edt1.Text + ';');
                infolist.Add('[DATAPATH][FIN01]' + Edit1.Text + ';');

                infolist.Add('[BANK][FIN01]' + fin1Bank.Text + ';');
                infolist.Add('[DIESELINV][FIN01]' + fin1dieselinv.Text + ';');
                infolist.Add('[MAINTINV][FIN01]' + fin1maintinv.Text + ';');
                infolist.Add('[TYRESINV][FIN01]' + fin1tyresinv.Text + ';');
                //infolist.Add('[BANK][FIN02]' + fin2Bank.Text + ';');
                //infolist.Add('[DIESELINV][FIN02]' + fin2dieselinv.Text + ';');
                //infolist.Add('[MAINTINV][FIN02]' + fin2maintinv.Text + ';');
                //infolist.Add('[TYRESINV][FIN02]' + fin2tyresinv.Text + ';');

                if chk1.Checked then
                  infolist.Add('[OFFLINE][FIN01]' + 'Y' + ';')
                else
                  infolist.Add('[OFFLINE][FIN01]' + 'N' + ';');


                infolist.Add('[SALESOWN][FIN01]' + fncMasterGrid.Cells[3,1] + ';');
                if GetCheckBoxState(fncMasterGrid,3,1,bState) then
                  begin
                    if bState then
                      infolist.Add('[SALESFLEETACC][FIN01]' + 'T' + ';')
                    else
                      infolist.Add('[SALESFLEETACC][FIN01]' + 'F' + ';');
                  end;
                if GetCheckBoxState(fncMasterGrid,4,1,bState) then
                  begin
                    if bState then
                      infolist.Add('[SALESCATACC][FIN01]' + 'T' + ';')
                    else
                      infolist.Add('[SALESCATACC][FIN01]' + 'F' + ';');
                  end;
                infolist.Add('[SALESSUBS][FIN01]' + fncMasterGrid.Cells[2,2] + ';');
                if GetCheckBoxState(fncMasterGrid,3,2,bState) then
                  begin
                    if bState then
                      infolist.Add('[SALESSUBSACC][FIN01]' + 'T' + ';')
                    else
                      infolist.Add('[SALESSUBSACC][FIN01]' + 'F' + ';');
                  end;
                if GetCheckBoxState(fncMasterGrid,4,2,bState) then
                  begin
                    if bState then
                      infolist.Add('[SALESSUBSCATACC][FIN01]' + 'T' + ';')
                    else
                      infolist.Add('[SALESSUBSCATACC][FIN01]' + 'F' + ';');
                  end;
                infolist.Add('[SALESDIESEL][FIN01]' + fncMasterGrid.Cells[2,3] + ';');
                infolist.Add('[SALESMAINT][FIN01]' + fncMasterGrid.Cells[2,4] + ';');
                infolist.Add('[SALESTYRES][FIN01]' + fncMasterGrid.Cells[2,5] + ';');
                infolist.Add('[SALESTOLLS][FIN01]' + fncMasterGrid.Cells[2,6] + ';');
                infolist.Add('[SALESWASH][FIN01]' + fncMasterGrid.Cells[2,7]  + ';');
                infolist.Add('[SALESTRUCKSTOP][FIN01]' + fncMasterGrid.Cells[2,8]  + ';');
                infolist.Add('[SALESMISC][FIN01]' + fncMasterGrid.Cells[2,9]  + ';');

                infolist.Add('[EXPSUBS][FIN01]' + fncMasterGrid.Cells[2,1] + ';');
                infolist.Add('[EXPOWNDIESEL][FIN01]' + fncMasterGrid.Cells[2,2] + ';');
                if GetCheckBoxState(fncMasterGrid,3,2,bState) then
                  begin
                    if bState then
                      infolist.Add('[DIESELFLEETACC][FIN01]' + 'T' + ';')
                    else
                      infolist.Add('[DIESELFLEETACC][FIN01]' + 'F' + ';');
                  end;
                if GetCheckBoxState(fncMasterGrid,4,2,bState) then
                  begin
                    if bState then
                      infolist.Add('[DIESELFLEETCAT][FIN01]' + 'T' + ';')
                    else
                      infolist.Add('[DIESELFLEETCAT][FIN01]' + 'F' + ';');
                  end;
                infolist.Add('[EXPSUBSDIESEL][FIN01]' + fncMasterGrid.Cells[2,3] + ';');
                infolist.Add('[EXPOWNMAINT][FIN01]' + fncMasterGrid.Cells[2,4] + ';');
                if GetCheckBoxState(fncMasterGrid,3,4,bState) then
                  begin
                    if bState then
                      infolist.Add('[MAINTFLEETACC][FIN01]' + 'T' + ';')
                    else
                      infolist.Add('[MAINTFLEETACC][FIN01]' + 'F' + ';');
                  end;
                if GetCheckBoxState(fncMasterGrid,4,4,bState) then
                  begin
                    if bState then
                      infolist.Add('[MAINTFLEETCAT][FIN01]' + 'T' + ';')
                    else
                      infolist.Add('[MAINTFLEETCAT][FIN01]' + 'F' + ';');
                  end;
                infolist.Add('[EXPSUBSMAINT][FIN01]' + fncMasterGrid.Cells[2,5] + ';');
                infolist.Add('[EXPOWNTYRES][FIN01]' + fncMasterGrid.Cells[2,6] + ';');
                if GetCheckBoxState(fncMasterGrid,3,6,bState) then
                  begin
                    if bState then
                      infolist.Add('[TYRESFLEETACC][FIN01]' + 'T' + ';')
                    else
                      infolist.Add('[TYRESFLEETACC][FIN01]' + 'F' + ';');
                  end;
                if GetCheckBoxState(fncMasterGrid,4,6,bState) then
                  begin
                    if bState then
                      infolist.Add('[TYRESFLEETCAT][FIN01]' + 'T' + ';')
                    else
                      infolist.Add('[TYRESFLEETCAT][FIN01]' + 'F' + ';');
                  end;
                infolist.Add('[EXPSUBSTYRES][FIN01]' + fncMasterGrid.Cells[2,7] + ';');
                infolist.Add('[EXPOWNTOLLS][FIN01]' + fncMasterGrid.Cells[2,8] + ';');
                if GetCheckBoxState(fncMasterGrid,3,8,bState) then
                  begin
                    if bState then
                      infolist.Add('[TOLLSFLEETACC][FIN01]' + 'T' + ';')
                    else
                      infolist.Add('[TOLLSFLEETACC][FIN01]' + 'F' + ';');
                  end;
                if GetCheckBoxState(fncMasterGrid,4,8,bState) then
                  begin
                    if bState then
                      infolist.Add('[TOLLSFLEETCAT][FIN01]' + 'T' + ';')
                    else
                      infolist.Add('[TOLLSFLEETCAT][FIN01]' + 'F' + ';');
                  end;
                infolist.Add('[EXPSUBSTOLLS][FIN01]' + fncMasterGrid.Cells[2,9] + ';');
                infolist.Add('[EXPOWNWASHB][FIN01]' + fncMasterGrid.Cells[2,10] + ';');
                if GetCheckBoxState(fncMasterGrid,3,10,bState) then
                  begin
                    if bState then
                      infolist.Add('[WASHBFLEETACC][FIN01]' + 'T' + ';')
                    else
                      infolist.Add('[WASHBFLEETACC][FIN01]' + 'F' + ';');
                  end;
                if GetCheckBoxState(fncMasterGrid,4,10,bState) then
                  begin
                    if bState then
                      infolist.Add('[WASHBFLEETCAT][FIN01]' + 'T' + ';')
                    else
                      infolist.Add('[WASHBFLEETCAT][FIN01]' + 'F' + ';');
                  end;
                infolist.Add('[EXPSUBSWASHB][FIN01]' + fncMasterGrid.Cells[2,11] + ';');
                infolist.Add('[EXPOWNTRUCKS][FIN01]' + fncMasterGrid.Cells[2,12] + ';');
                if GetCheckBoxState(fncMasterGrid,3,12,bState) then
                  begin
                    if bState then
                      infolist.Add('[TRUCKSFLEETACC][FIN01]' + 'T' + ';')
                    else
                      infolist.Add('[TRUCKSFLEETACC][FIN01]' + 'F' + ';');
                  end;
                if GetCheckBoxState(fncMasterGrid,4,12,bState) then
                  begin
                    if bState then
                      infolist.Add('[TRUCKSFLEETCAT][FIN01]' + 'T' + ';')
                    else
                      infolist.Add('[TRUCKSFLEETCAT][FIN01]' + 'F' + ';');
                  end;
                infolist.Add('[EXPSUBSTRUCKS][FIN01]' + fncMasterGrid.Cells[2,13] + ';');
                infolist.Add('[EXPOWNMISC][FIN01]' + fncMasterGrid.Cells[2,14] + ';');
                if GetCheckBoxState(fncMasterGrid,3,14,bState) then
                  begin
                    if bState then
                      infolist.Add('[MISCFLEETACC][FIN01]' + 'T' + ';')
                    else
                      infolist.Add('[MISCFLEETACC][FIN01]' + 'F' + ';');
                  end;
                if GetCheckBoxState(fncMasterGrid,4,14,bState) then
                  begin
                    if bState then
                      infolist.Add('[MISCFLEETCAT][FIN01]' + 'T' + ';')
                    else
                      infolist.Add('[MISCFLEETCAT][FIN01]' + 'F' + ';');
                  end;
                infolist.Add('[EXPSUBSMISC][FIN01]' + fncMasterGrid.Cells[2,15] + ';');

                infolist.Add('[SALESVAT][FIN01]' + edtSalesVat.Text + ';');
                infolist.Add('[EXPVAT][FIN01]' + edtExpenseVat.Text + ';');
                infolist.Add('[ZEROVAT][FIN01]' + edtZeroRate.Text + ';');

                //infolist.Add('[REGNAME][FIN02]' + Edit9.Text + ';');
                //infolist.Add('[AUTHCODE][FIN02]' + Edit10.Text + ';');
                //infolist.Add('[DATAPATH][FIN02]' + Edit11.Text + ';');
                //if CheckBox1.Checked then
                //  infolist.Add('[OFFLINE][FIN02]' + 'Y' + ';')
                //else
                //  infolist.Add('[OFFLINE][FIN02]' + 'N' + ';');

                //infolist.Add('[SALESOWN][FIN02]' + sgFin2Sales.Cells[2,1] + ';');
                if GetCheckBoxState(fncTransactionGrid,3,1,bState) then
                  begin
                    if bState then
                      infolist.Add('[SALESFLEETACC][FIN02]' + 'T' + ';')
                    else
                      infolist.Add('[SALESFLEETACC][FIN02]' + 'F' + ';');
                  end;
                if GetCheckBoxState(fncTransactionGrid,4,1,bState) then
                  begin
                    if bState then
                      infolist.Add('[SALESCATACC][FIN02]' + 'T' + ';')
                    else
                      infolist.Add('[SALESCATACC][FIN02]' + 'F' + ';');
                  end;
                //infolist.Add('[SALESSUBS][FIN02]' + sgFin2Sales.Cells[2,2] + ';');
                //infolist.Add('[SALESDIESEL][FIN02]' + sgFin2Sales.Cells[2,3] + ';');
                //infolist.Add('[SALESMAINT][FIN02]' + sgFin2Sales.Cells[2,4] + ';');
                //infolist.Add('[SALESTYRES][FIN02]' + sgFin2Sales.Cells[2,5] + ';');
                //infolist.Add('[SALESTOLLS][FIN02]' + sgFin2Sales.Cells[2,6] + ';');
                //infolist.Add('[SALESWASH][FIN02]' + sgFin2Sales.Cells[2,7]  + ';');
                //infolist.Add('[SALESTRUCKSTOP][FIN02]' + sgFin2Sales.Cells[2,8]  + ';');
                //infolist.Add('[SALESMISC][FIN02]' + sgFin2Sales.Cells[2,9]  + ';');

                infolist.Add('[EXPSUBS][FIN02]' + fncTransactionGrid.Cells[2,1] + ';');
                infolist.Add('[EXPOWNDIESEL][FIN02]' + fncTransactionGrid.Cells[2,2] + ';');
                if GetCheckBoxState(fncTransactionGrid,3,2,bState) then
                  begin
                    if bState then
                      infolist.Add('[DIESELFLEETACC][FIN02]' + 'T' + ';')
                    else
                      infolist.Add('[DIESELFLEETACC][FIN02]' + 'F' + ';');
                  end;
                if GetCheckBoxState(fncTransactionGrid,4,2,bState) then
                  begin
                    if bState then
                      infolist.Add('[DIESELFLEETCAT][FIN02]' + 'T' + ';')
                    else
                      infolist.Add('[DIESELFLEETCAT][FIN02]' + 'F' + ';');
                  end;
                infolist.Add('[EXPSUBSDIESEL][FIN02]' + fncTransactionGrid.Cells[2,3] + ';');
                infolist.Add('[EXPOWNMAINT][FIN02]' + fncTransactionGrid.Cells[2,4] + ';');
                if GetCheckBoxState(fncTransactionGrid,3,4,bState) then
                  begin
                    if bState then
                      infolist.Add('[MAINTFLEETACC][FIN02]' + 'T' + ';')
                    else
                      infolist.Add('[MAINTFLEETACC][FIN02]' + 'F' + ';');
                  end;
                if GetCheckBoxState(fncTransactionGrid,4,4,bState) then
                  begin
                    if bState then
                      infolist.Add('[MAINTFLEETCAT][FIN02]' + 'T' + ';')
                    else
                      infolist.Add('[MAINTFLEETCAT][FIN02]' + 'F' + ';');
                  end;
                infolist.Add('[EXPSUBSMAINT][FIN02]' + fncTransactionGrid.Cells[2,5] + ';');
                infolist.Add('[EXPOWNTYRES][FIN02]' + fncTransactionGrid.Cells[2,6] + ';');
                if GetCheckBoxState(fncTransactionGrid,3,6,bState) then
                  begin
                    if bState then
                      infolist.Add('[TYRESFLEETACC][FIN02]' + 'T' + ';')
                    else
                      infolist.Add('[TYRESFLEETACC][FIN02]' + 'F' + ';');
                  end;
                if GetCheckBoxState(fncTransactionGrid,4,6,bState) then
                  begin
                    if bState then
                      infolist.Add('[TYRESFLEETCAT][FIN02]' + 'T' + ';')
                    else
                      infolist.Add('[TYRESFLEETCAT][FIN02]' + 'F' + ';');
                  end;
                infolist.Add('[EXPSUBSTYRES][FIN02]' + fncTransactionGrid.Cells[2,7] + ';');
                infolist.Add('[EXPOWNTOLLS][FIN02]' + fncTransactionGrid.Cells[2,8] + ';');
                if GetCheckBoxState(fncTransactionGrid,3,8,bState) then
                  begin
                    if bState then
                      infolist.Add('[TOLLSFLEETACC][FIN02]' + 'T' + ';')
                    else
                      infolist.Add('[TOLLSFLEETACC][FIN02]' + 'F' + ';');
                  end;
                if GetCheckBoxState(fncTransactionGrid,4,8,bState) then
                  begin
                    if bState then
                      infolist.Add('[TOLLSFLEETCAT][FIN02]' + 'T' + ';')
                    else
                      infolist.Add('[TOLLSFLEETCAT][FIN02]' + 'F' + ';');
                  end;
                infolist.Add('[EXPSUBSTOLLS][FIN02]' + fncTransactionGrid.Cells[2,9] + ';');
                infolist.Add('[EXPOWNWASHB][FIN02]' + fncTransactionGrid.Cells[2,10] + ';');
                if GetCheckBoxState(fncTransactionGrid,3,10,bState) then
                  begin
                    if bState then
                      infolist.Add('[WASHBFLEETACC][FIN02]' + 'T' + ';')
                    else
                      infolist.Add('[WASHBFLEETACC][FIN02]' + 'F' + ';');
                  end;
                if GetCheckBoxState(fncTransactionGrid,4,10,bState) then
                  begin
                    if bState then
                      infolist.Add('[WASHBFLEETCAT][FIN02]' + 'T' + ';')
                    else
                      infolist.Add('[WASHBFLEETCAT][FIN02]' + 'F' + ';');
                  end;
                infolist.Add('[EXPSUBSWASHB][FIN02]' + fncTransactionGrid.Cells[2,11] + ';');
                infolist.Add('[EXPOWNTRUCKS][FIN02]' + fncTransactionGrid.Cells[2,12] + ';');
                if GetCheckBoxState(fncTransactionGrid,3,12,bState)then
                  begin
                    if bState then
                      infolist.Add('[TRUCKSFLEETACC][FIN02]' + 'T' + ';')
                    else
                      infolist.Add('[TRUCKSFLEETACC][FIN02]' + 'F' + ';');
                  end;
                if GetCheckBoxState(fncTransactionGrid,4,12,bState) then
                  begin
                    if bState then
                      infolist.Add('[TRUCKSFLEETCAT][FIN02]' + 'T' + ';')
                    else
                      infolist.Add('[TRUCKSFLEETCAT][FIN02]' + 'F' + ';');
                  end;
                infolist.Add('[EXPSUBSTRUCKS][FIN02]' + fncTransactionGrid.Cells[2,13] + ';');
                infolist.Add('[EXPOWNMISC][FIN02]' + fncTransactionGrid.Cells[2,14] + ';');
                if GetCheckBoxState(fncTransactionGrid,3,14,bState) then
                  begin
                    if bState then
                      infolist.Add('[MISCFLEETACC][FIN02]' + 'T' + ';')
                    else
                      infolist.Add('[MISCFLEETACC][FIN02]' + 'F' + ';');
                  end;
                if GetCheckBoxState(fncTransactionGrid,4,14,bState) then
                  begin
                    if bState then
                      infolist.Add('[MISCFLEETCAT][FIN02]' + 'T' + ';')
                    else
                      infolist.Add('[MISCFLEETCAT][FIN02]' + 'F' + ';');
                  end;
                infolist.Add('[EXPSUBSMISC][FIN02]' + fncTransactionGrid.Cells[2,15] + ';');

                //infolist.Add('[SALESVAT][FIN02]' + Edit12.Text + ';');
                //infolist.Add('[EXPVAT][FIN02]' + Edit13.Text + ';');
                //infolist.Add('[ZEROVAT][FIN02]' + Edit14.Text + ';');

                wdsCompInfo.Fieldbyname('FINDBSETUP').AsString := infolist.Text;
                infolist.Free;

              End;
          8: begin
                infolist := TStringList.Create;
                infolist.Clear;
                infolist.Add('[LINKURL]' + Edit16.Text + ';');
                infolist.Add('[LINKCOMPANY]' + Edit3.Text + ';');
                infolist.Add('[LINKUSER]' + Edit4.Text + ';');
                infolist.Add('[LINKPASSWORD]' + Edit5.Text + ';');
                infolist.Add('[LINKAPI]' + Edit15.Text + ';');

                infolist.Add('[LINKBANK]' + Edit17.Text + ';');
                infolist.Add('[LINKVAT]' + Edit18.Text + ';');
                infolist.Add('[LINKNVAT]' + Edit19.Text + ';');
                infolist.Add('[LINKDC]' + Edit20.Text + ';');
                infolist.Add('[LINKCC]' + Edit21.Text + ';');
                infolist.Add('[LINKBANKCLEAR]' + edtBankClear.Text + ';');

                wdsCompInfo.Fieldbyname('FINDBSETUP').AsString := infolist.Text;
                infolist.Free;
              end;

      end;//end case


      //if wdsCompInfo.IsEmpty then
          //wcCompInfo.RawInvoke('IstfmsSystemService.Put_SystemSetup_Insert',[GetJsonFromDataSet(wdsCompInfo)],@OnSuccess, @OnError)
        //else
          //Begin
            Console.log(GetJsonFromDataSet(wdsCompInfo));
            wcCompInfo.RawInvoke('IstfmsSystemService.Put_SystemSetuo_Edit',[GetJsonFromDataSet(wdsCompInfo)],@OnSuccess, @OnError);
          //End

    //end;

end;

procedure TfrmSystemSettings.WebButton2Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmSystemSettings.WebDBCheckBox10Click(Sender: TObject);
begin
  if WebDBCheckBox10.Checked then
	  wdsCompInfo.FieldByName('monitorcancelloads').AsBoolean := true
  else
    wdsCompInfo.FieldByName('monitorcancelloads').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox11Click(Sender: TObject);
begin
  if WebDBCheckBox11.Checked then
	  wdsCompInfo.FieldByName('SUBUNINVSHOW').AsBoolean := true
  else
    wdsCompInfo.FieldByName('SUBUNINVSHOW').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox12Click(Sender: TObject);
begin
  if WebDBCheckBox12.Checked then
	  wdsCompInfo.FieldByName('PRINTTOTALSSEND').AsBoolean := true
  else
    wdsCompInfo.FieldByName('PRINTTOTALSSEND').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox13Click(Sender: TObject);
begin
  if WebDBCheckBox13.Checked then
    wdsCompInfo.FieldByName('FORCELOADDRIVER').AsBoolean := true
  else
    wdsCompInfo.FieldByName('FORCELOADDRIVER').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox14Click(Sender: TObject);
begin
  if WebDBCheckBox14.Checked then
	  wdsCompInfo.FieldByName('monitorloadssub').AsBoolean := true
  else
    wdsCompInfo.FieldByName('monitorloadssub').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox15Click(Sender: TObject);
begin
  if WebDBCheckBox15.Checked then
	  wdsCompInfo.FieldByName('LOADCUSTOMERS').AsBoolean := true
  else
    wdsCompInfo.FieldByName('LOADCUSTOMERS').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox16Click(Sender: TObject);
begin
  if WebDBCheckBox16.Checked then
	  wdsCompInfo.FieldByName('USEDOCKETNOINVNO').AsBoolean := true
  else
    wdsCompInfo.FieldByName('USEDOCKETNOINVNO').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox17Click(Sender: TObject);
begin
if WebDBCheckBox17.Checked then
	wdsCompInfo.FieldByName('USEADDINFONONCON').AsBoolean := true
else
    wdsCompInfo.FieldByName('USEADDINFONONCON').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox18Click(Sender: TObject);
begin
	if WebDBCheckBox18.Checked then
		wdsCompInfo.FieldByName('NONCONDISPLAYFUEL').AsBoolean := true
	else
		wdsCompInfo.FieldByName('NONCONDISPLAYFUEL').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox19Click(Sender: TObject);
begin
	if WebDBCheckBox19.Checked then
		wdsCompInfo.FieldByName('UNIQUESHORTDESC').AsBoolean := true
	else
		wdsCompInfo.FieldByName('UNIQUESHORTDESC').AsBoolean := false;

end;

procedure TfrmSystemSettings.WebDBCheckBox1Click(Sender: TObject);
begin
  wdsCompInfo.FieldByName('MISCINVLOADS').AsBoolean := WebDBCheckBox1.Checked;
end;

procedure TfrmSystemSettings.WebDBCheckBox20Click(Sender: TObject);
begin
	if WebDBCheckBox20.Checked then
		wdsCompInfo.FieldByName('washbayinvloads').AsBoolean := true
	else
		wdsCompInfo.FieldByName('washbayinvloads').AsBoolean := false;

end;

procedure TfrmSystemSettings.WebDBCheckBox21Click(Sender: TObject);
begin
	if WebDBCheckBox21.Checked then
		wdsCompInfo.FieldByName('subsoverrite').AsBoolean := true
	else
		wdsCompInfo.FieldByName('subsoverrite').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox22Click(Sender: TObject);
begin
	if WebDBCheckBox22.Checked then
		wdsCompInfo.FieldByName('forcescandocs').AsBoolean := true
	else
		wdsCompInfo.FieldByName('forcescandocs').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox23Click(Sender: TObject);
begin
	if WebDBCheckBox23.Checked then
		wdsCompInfo.FieldByName('linkloadsvat').AsBoolean := true
	else
		wdsCompInfo.FieldByName('linkloadsvat').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox24Click(Sender: TObject);
begin
	if WebDBCheckBox24.Checked then
		wdsCompInfo.FieldByName('UNIQUEWAYBILLS').AsBoolean := true
	else
		wdsCompInfo.FieldByName('UNIQUEWAYBILLS').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox25Click(Sender: TObject);
begin
	if WebDBCheckBox25.Checked then
		wdsCompInfo.FieldByName('allowreprint').AsBoolean := true
	else
		wdsCompInfo.FieldByName('allowreprint').AsBoolean := false;

end;

procedure TfrmSystemSettings.WebDBCheckBox26Click(Sender: TObject);
begin
	if WebDBCheckBox26.Checked then
		wdsCompInfo.FieldByName('allowdieselproforma').AsBoolean := true
	else
		wdsCompInfo.FieldByName('allowdieselproforma').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox27Click(Sender: TObject);
begin
	if WebDBCheckBox27.Checked then
		wdsCompInfo.FieldByName('removesubinvdocs').AsBoolean := true
	else
		wdsCompInfo.FieldByName('removesubinvdocs').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox28Click(Sender: TObject);
begin
	if WebDBCheckBox28.Checked then
		wdsCompInfo.FieldByName('NOFUTUREINVDATE').AsBoolean := true
	else
		wdsCompInfo.FieldByName('NOFUTUREINVDATE').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox29Click(Sender: TObject);
begin
	if WebDBCheckBox29.Checked then
		wdsCompInfo.FieldByName('UNIQUEORDER').AsBoolean := true
	else
		wdsCompInfo.FieldByName('UNIQUEORDER').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox2Click(Sender: TObject);
begin
  wdsCompInfo.FieldByName('MAILSERVERSSL').AsBoolean := WebDBCheckBox2.Checked;
end;

procedure TfrmSystemSettings.WebDBCheckBox30Click(Sender: TObject);
begin
	if WebDBCheckBox30.Checked then
		wdsCompInfo.FieldByName('autocanceldieselorders').AsBoolean := true
	else
		wdsCompInfo.FieldByName('autocanceldieselorders').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox31Click(Sender: TObject);
begin
	if WebDBCheckBox31.Checked then
		wdsCompInfo.FieldByName('loadcoscutoffdate').AsBoolean := true
	else
		wdsCompInfo.FieldByName('loadcoscutoffdate').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox32Click(Sender: TObject);
begin
	if WebDBCheckBox32.Checked then
		wdsCompInfo.FieldByName('dieselcutoffdate').AsBoolean := true
	else
		wdsCompInfo.FieldByName('dieselcutoffdate').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox33Click(Sender: TObject);
begin
	if WebDBCheckBox33.Checked then
		wdsCompInfo.FieldByName('hidecanceloadsplanning').AsBoolean := true
	else
		wdsCompInfo.FieldByName('hidecanceloadsplanning').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox34Click(Sender: TObject);
begin
	if WebDBCheckBox34.Checked then
		wdsCompInfo.FieldByName('sendloadconsprocess').AsBoolean := true
	else
		wdsCompInfo.FieldByName('sendloadconsprocess').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox35Click(Sender: TObject);
begin
	if WebDBCheckBox35.Checked then
		wdsCompInfo.FieldByName('planningshortdesc').AsBoolean := true
	else
		wdsCompInfo.FieldByName('planningshortdesc').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox36Click(Sender: TObject);
begin
	if WebDBCheckBox36.Checked then
		wdsCompInfo.FieldByName('loadsmustreceived').AsBoolean := true
	else
		wdsCompInfo.FieldByName('loadsmustreceived').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox37Click(Sender: TObject);
begin
	if WebDBCheckBox37.Checked then
		wdsCompInfo.FieldByName('markmultiloadready').AsBoolean := true
	else
		wdsCompInfo.FieldByName('markmultiloadready').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox38Click(Sender: TObject);
begin
  wdsCompInfo.FieldByName('SSUNIQUEClientDocket').AsBoolean := WebDBCheckBox38.Checked;
end;

procedure TfrmSystemSettings.WebDBCheckBox39Click(Sender: TObject);
begin
	if WebDBCheckBox39.Checked then
		wdsCompInfo.FieldByName('monitorvehiclechanges').AsBoolean := true
	else
		wdsCompInfo.FieldByName('monitorvehiclechanges').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox3Click(Sender: TObject);
begin
  wdsCompInfo.FieldByName('MAILSERVERAUTH').AsBoolean := WebDBCheckBox3.Checked;
end;

procedure TfrmSystemSettings.WebDBCheckBox41Click(Sender: TObject);
begin
  wdsCompInfo.FieldByName('joborder').AsBoolean := WebDBCheckBox41.Checked;
end;

procedure TfrmSystemSettings.WebDBCheckBox42Click(Sender: TObject);
begin
  wdsCompInfo.FieldByName('MISCGLFORCE').AsBoolean := WebDBCheckBox42.Checked;
end;

procedure TfrmSystemSettings.WebDBCheckBox4Click(Sender: TObject);
begin
  wdsCompInfo.FieldByName('jobnullqty').AsBoolean := WebDBCheckBox4.Checked;
end;

procedure TfrmSystemSettings.WebDBCheckBox5Click(Sender: TObject);
begin
  if WebDBCheckBox5.Checked then
    wdsCompInfo.FieldByName('FORCEDIESELDRIVER').AsBoolean := true
  else
    wdsCompInfo.FieldByName('FORCEDIESELDRIVER').AsBoolean := false;

end;

procedure TfrmSystemSettings.WebDBCheckBox6Click(Sender: TObject);
begin
  if WebDBCheckBox6.Checked then
	  wdsCompInfo.FieldByName('PRINTLOADSAVE').AsBoolean := true
  else
    wdsCompInfo.FieldByName('PRINTLOADSAVE').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox7Click(Sender: TObject);
begin
  if WebDBCheckBox7.Checked then
	  wdsCompInfo.FieldByName('dieselnonretail').AsBoolean := true
  else
    wdsCompInfo.FieldByName('dieselnonretail').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox8Click(Sender: TObject);
begin
  if WebDBCheckBox8.Checked then
	  wdsCompInfo.FieldByName('UNIQUEWASHBAYDOCKET').AsBoolean := true
  else
    wdsCompInfo.FieldByName('UNIQUEWASHBAYDOCKET').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebDBCheckBox9Click(Sender: TObject);
begin
  if WebDBCheckBox9.Checked then
	wdsCompInfo.FieldByName('monitordieselupfrontcl').AsBoolean := true
else
    wdsCompInfo.FieldByName('monitordieselupfrontcl').AsBoolean := false;
end;

procedure TfrmSystemSettings.WebFormShow(Sender: TObject);
begin
  BitMapEdit := TTMSFNCBitmap.Create;
  BitMapDelete := TTMSFNCBitmap.Create;

  iInvoiceNumPC := 1;
  iVattablePC := 1;
  iGLAPC := 1;
  iSLAPC := 1;
  iTFNSubAccountsS1PC := 1;
  iTFNSubAccountsS2PC := 1;

  LoadCompInfo;

end;

procedure TfrmSystemSettings.WebSpeedButton12Click(Sender: TObject);
var
  newform : TfrmSystemVatSetup;

  procedure AfterCreate(AForm: TObject);
    begin
      with newform do
        begin
          iState := 1;
        end;
    end;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      LoadVattable;
    end;

begin
  newform := TfrmSystemVatSetup.CreateNew(@AfterCreate);
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.Showmodal(@AfterShowModal);
end;

procedure TfrmSystemSettings.WebSpeedButton17Click(Sender: TObject);
var
  newform : TfrmGeneralLedgerAccounts;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      LoadGLA;
    end;

  procedure AfterCreate(AForm: TObject);
    begin
      with newform do
        begin
          iState := 1;
        end;
    end;
begin
  newform := TfrmGeneralLedgerAccounts.CreateNew(@AfterCreate);
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.Showmodal(@AfterShowModal);

end;

procedure TfrmSystemSettings.WebSpeedButton1Click(Sender: TObject);
begin
  wdsVattable.First;
end;

procedure TfrmSystemSettings.WebSpeedButton24Click(Sender: TObject);
var
  newform : TfrmSystemLedgerAccountSetup;

  procedure AfterCreate(AForm: TObject);
    begin
      with newform do
        begin
          iState := 1;
        end;
    end;

    procedure AfterShowModal(AValue: TModalResult);
      begin
        LoadSystemLedgerAccounts;
      end;
begin
  newform := TfrmSystemLedgerAccountSetup.CreateNew(@AfterCreate);
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.Showmodal(@AfterShowModal);
end;

procedure TfrmSystemSettings.WebSpeedButton28Click(Sender: TObject);
begin
  iTFNSubAccountsS1PC := iTFNSubAccountsMaxS1PC;
  LoadVattable;
end;

procedure TfrmSystemSettings.WebSpeedButton2Click(Sender: TObject);
begin
  wdsVattable.Prior;
end;

procedure TfrmSystemSettings.WebSpeedButton30Click(Sender: TObject);
var
  newform : TfrmTFNSubAccountsSetup;

  procedure AfterCreate(AForm: TObject);
    begin
      with newform do
        begin
          iState := 1;
        end;
    end;

    procedure AfterShowModal(AValue: TModalResult);
    begin
      LoadTFNSubAccountsS1;
    end;

begin
  newform := TfrmTFNSubAccountsSetup.CreateNew(@AfterCreate);
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.Showmodal(@AfterShowModal);
end;

procedure TfrmSystemSettings.WebSpeedButton35Click(Sender: TObject);
var
  newform : TfrmFMSFuelSystem;

  procedure AfterCreate(AForm: TObject);
    begin
      with newform do
        begin
          iState := 1;
        end;
    end;

    procedure AfterShowModal(AValue: TModalResult);
    begin
      LoadTFNSubAccountsS2;
    end;

begin
  newform := TfrmFMSFuelSystem.CreateNew(@AfterCreate);
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.Showmodal(@AfterShowModal);
end;

procedure TfrmSystemSettings.sbtnGlaFirstClick(Sender: TObject);
begin
  iGLAPC := 1;

  LoadGLA;
end;

procedure TfrmSystemSettings.sbtnGLALastClick(Sender: TObject);
begin
  iGLAPC := iGLAMaxPC;

  LoadGLA;
end;

procedure TfrmSystemSettings.sbtnGLANextClick(Sender: TObject);
begin
  if iGLAPC < iGLAMaxPC then
    Begin
      iGLAPC := iGLAPC+1;
    End;

    LoadGLA;
end;

procedure TfrmSystemSettings.sbtnGLAPriorClick(Sender: TObject);
begin
  if iGLAPC > 1 then
    Begin
      iGLAPC := iGLAPC-1;
    End;

    LoadGLA;
end;

procedure TfrmSystemSettings.WebSpeedButton3Click(Sender: TObject);
begin
  wdsVattable.Next;
end;

procedure TfrmSystemSettings.WebSpeedButton4Click(Sender: TObject);
begin
  wdsVattable.Last;
end;

procedure TfrmSystemSettings.WebSpeedButton5Click(Sender: TObject);
var
  newform : TfrmSystemInvoiceNumberSetup;

  procedure AfterCreate(AForm: TObject);
    begin
      with newform do
        begin
          iState := 1;
        end;
    end;

begin
  newform := TfrmSystemInvoiceNumberSetup.CreateNew(@AfterCreate);
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.Showmodal;
  newform.iState := 1;
end;

procedure TfrmSystemSettings.WebSpeedButton6Click(Sender: TObject);
begin
  if iInvoiceNumPC > 1 then
    Begin
      iInvoiceNumPC := iInvoiceNumPC - 1;
      LoadInvoiceNumbers;
    End;
end;

procedure TfrmSystemSettings.WebSpeedButton7Click(Sender: TObject);
begin
  if iInvoiceNumPC < iInvoiceNumMaxPC then
    Begin
      Inc(iInvoiceNumPC);
      LoadInvoiceNumbers;
    End;
end;

procedure TfrmSystemSettings.LoadTFNSubAccountsS1;

  procedure OnSubAccountsError(Error: TXDataClientError);
    begin
      LoadTFNSubAccountsS1;
    end;

  procedure OnResultTFNSubAccountsS1(Response : TXDataClientResponse);
    begin
      wdsTFNSubAccountsS1.Close;
      wdsTFNSubAccountsS1.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsTFNSubAccountsS1.Open;
    end;

  procedure OnResultS1(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadTFNSubAccountsS1;
        end
      else
        begin
          iTFNSubAccountsMaxS1PC := Integer(TJSObject(Response.Result)['value']);
          edtTFNSubAccounts.Text := IntToStr(iTFNSubAccountsS1PC) + ' OF ' + IntToStr(iTFNSubAccountsMaxS1PC);

          wcTFNSubAccountsS1.RawInvoke('IstfmsSystemService.Get_TFNSubAccountsS1_View',[iTFNSubAccountsS1PC,1,'*'],@OnResultTFNSubAccountsS1,@OnSubAccountsError);
        end;
    end;
begin
  wcTFNSubAccountsS1.RawInvoke('IstfmsSystemService.Get_TFNSubAccountsS1_PC',[],@OnResultS1,@OnSubAccountsError);
end;

procedure TfrmSystemSettings.LoadTFNSubAccountsS2;
  procedure OnFMSError(Error: TXDataClientError);
    begin
      LoadTFNSubAccountsS2;
    end;

  procedure OnResultTFNSubAccounts(Response : TXDataClientResponse);
    begin
      wdsTFNSubAccountsS2.Close;
      wdsTFNSubAccountsS2.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsTFNSubAccountsS2.Open;
    end;

  procedure OnResult(Response : TXDataClientResponse);
    begin

      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadTFNSubAccountsS2;
        end
      else
        begin

          iTFNSubAccountsMaxS2PC := Integer(TJSObject(Response.Result)['value']);
          edtTFNSubAccountsS2.Text := IntToStr(iTFNSubAccountsS2PC) + ' OF ' + IntToStr(iTFNSubAccountsMaxS2PC);

          wcTFNSubAccountsS2.RawInvoke('IstfmsSystemService.Get_Get_TFNSubAccountsS2_View',[iTFNSubAccountsS2PC],@OnResultTFNSubAccounts,@OnFMSError);
        end;
    end;
begin
  wcTFNSubAccountsS2.RawInvoke('IstfmsSystemService.Get_TFNSubAccountsS2_PC',[],@OnResult,@OnFMSError);
end;

procedure TfrmSystemSettings.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebResponsiveManager1 := TResponsiveManager.Create(Self);
  BitmapContainer1 := TTMSFNCBitmapContainer.Create(Self);
  wpcSysSetup := TPageControl.Create(Self);
  WebPageControl1Sheet1 := TTabSheet.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  WebLabel15 := TLabel.Create(Self);
  WebLabel16 := TLabel.Create(Self);
  WebLabel17 := TLabel.Create(Self);
  WebLabel18 := TLabel.Create(Self);
  WebDBImageControl1 := TDBImageControl.Create(Self);
  edtCompName := TDBEdit.Create(Self);
  edtCompAddress1 := TDBEdit.Create(Self);
  edtCompAddress2 := TDBEdit.Create(Self);
  edtCompAddress3 := TDBEdit.Create(Self);
  edtCompAddress4 := TDBEdit.Create(Self);
  edtCompAddressCode := TDBEdit.Create(Self);
  edtPostalCode := TDBEdit.Create(Self);
  edtPostalAddress4 := TDBEdit.Create(Self);
  edtPostalAddress3 := TDBEdit.Create(Self);
  edtPostalAddress2 := TDBEdit.Create(Self);
  edtPostalAddress1 := TDBEdit.Create(Self);
  edtTelephone := TDBEdit.Create(Self);
  edtTaxNo := TDBEdit.Create(Self);
  edtLogoPath := TDBEdit.Create(Self);
  edtRegistrationNo := TDBEdit.Create(Self);
  edtVatNo := TDBEdit.Create(Self);
  edtDeliveryNotePrefix := TDBEdit.Create(Self);
  edtCompEmail := TDBEdit.Create(Self);
  edtBankTransferBranchCode := TDBEdit.Create(Self);
  WebPanel5 := TPanel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  edtBankDetails1 := TDBEdit.Create(Self);
  edtBankDetails2 := TDBEdit.Create(Self);
  edtBankDetails3 := TDBEdit.Create(Self);
  edtBankDetails4 := TDBEdit.Create(Self);
  cbxPrintOnStatement := TDBCheckBox.Create(Self);
  edtBankTransferAccountNo := TDBEdit.Create(Self);
  WebDBComboBox5 := TDBComboBox.Create(Self);
  WebDBComboBox6 := TDBComboBox.Create(Self);
  WebDBComboBox7 := TDBComboBox.Create(Self);
  WebDBComboBox8 := TDBComboBox.Create(Self);
  WebPageControl1Sheet2 := TTabSheet.Create(Self);
  WebResponsiveManager3 := TResponsiveManager.Create(Self);
  WebPanel8 := TPanel.Create(Self);
  WebLabel23 := TLabel.Create(Self);
  WebLabel24 := TLabel.Create(Self);
  WebDBEdit1 := TDBEdit.Create(Self);
  WebDBEdit2 := TDBEdit.Create(Self);
  WebDBCheckBox5 := TDBCheckBox.Create(Self);
  WebDBCheckBox6 := TDBCheckBox.Create(Self);
  WebDBCheckBox7 := TDBCheckBox.Create(Self);
  WebDBCheckBox8 := TDBCheckBox.Create(Self);
  WebDBCheckBox9 := TDBCheckBox.Create(Self);
  WebDBCheckBox10 := TDBCheckBox.Create(Self);
  WebDBCheckBox11 := TDBCheckBox.Create(Self);
  WebDBCheckBox12 := TDBCheckBox.Create(Self);
  WebDBCheckBox13 := TDBCheckBox.Create(Self);
  WebDBCheckBox14 := TDBCheckBox.Create(Self);
  WebPanel9 := TPanel.Create(Self);
  WebLabel21 := TLabel.Create(Self);
  WebLabel22 := TLabel.Create(Self);
  WebDBEdit3 := TDBEdit.Create(Self);
  WebDBEdit4 := TDBEdit.Create(Self);
  WebDBCheckBox15 := TDBCheckBox.Create(Self);
  WebDBCheckBox16 := TDBCheckBox.Create(Self);
  WebDBCheckBox17 := TDBCheckBox.Create(Self);
  WebDBCheckBox18 := TDBCheckBox.Create(Self);
  WebDBCheckBox19 := TDBCheckBox.Create(Self);
  WebDBCheckBox20 := TDBCheckBox.Create(Self);
  WebDBCheckBox21 := TDBCheckBox.Create(Self);
  WebDBCheckBox22 := TDBCheckBox.Create(Self);
  WebDBCheckBox23 := TDBCheckBox.Create(Self);
  WebDBCheckBox24 := TDBCheckBox.Create(Self);
  WebPanel7 := TPanel.Create(Self);
  WebLabel20 := TLabel.Create(Self);
  WebDBEdit5 := TDBEdit.Create(Self);
  WebDBCheckBox25 := TDBCheckBox.Create(Self);
  WebDBCheckBox26 := TDBCheckBox.Create(Self);
  WebDBCheckBox27 := TDBCheckBox.Create(Self);
  WebDBCheckBox28 := TDBCheckBox.Create(Self);
  WebDBCheckBox29 := TDBCheckBox.Create(Self);
  WebDBCheckBox30 := TDBCheckBox.Create(Self);
  WebDBCheckBox31 := TDBCheckBox.Create(Self);
  WebDBCheckBox32 := TDBCheckBox.Create(Self);
  WebDBCheckBox33 := TDBCheckBox.Create(Self);
  WebDBCheckBox34 := TDBCheckBox.Create(Self);
  WebDBCheckBox35 := TDBCheckBox.Create(Self);
  WebDBCheckBox36 := TDBCheckBox.Create(Self);
  WebDBCheckBox37 := TDBCheckBox.Create(Self);
  WebDBCheckBox38 := TDBCheckBox.Create(Self);
  WebDBCheckBox39 := TDBCheckBox.Create(Self);
  WebPanel10 := TPanel.Create(Self);
  WebLabel31 := TLabel.Create(Self);
  WebLabel32 := TLabel.Create(Self);
  WebLabel33 := TLabel.Create(Self);
  WebLabel34 := TLabel.Create(Self);
  WebLabel25 := TLabel.Create(Self);
  WebDBEdit6 := TDBEdit.Create(Self);
  WebDBEdit7 := TDBEdit.Create(Self);
  WebDBEdit8 := TDBEdit.Create(Self);
  WebDBEdit9 := TDBEdit.Create(Self);
  WebDBEdit14 := TDBEdit.Create(Self);
  WebPanel11 := TPanel.Create(Self);
  WebLabel26 := TLabel.Create(Self);
  WebLabel27 := TLabel.Create(Self);
  WebLabel28 := TLabel.Create(Self);
  WebLabel29 := TLabel.Create(Self);
  WebLabel30 := TLabel.Create(Self);
  WebDBEdit10 := TDBEdit.Create(Self);
  WebDBEdit11 := TDBEdit.Create(Self);
  WebDBEdit12 := TDBEdit.Create(Self);
  WebDBEdit13 := TDBEdit.Create(Self);
  WebDBEdit15 := TDBEdit.Create(Self);
  WebPageControl1Sheet3 := TTabSheet.Create(Self);
  wpNavigator := TPanel.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  WebPanel29 := TPanel.Create(Self);
  edtNumbersPageCount := TEdit.Create(Self);
  sbtnNumbersNext := TSpeedButton.Create(Self);
  sbtnNumbersPrevious := TSpeedButton.Create(Self);
  sbtnNumbersLast := TSpeedButton.Create(Self);
  sbtnNumbersFirst := TSpeedButton.Create(Self);
  dgNumbers := TTMSFNCDataGrid.Create(Self);
  dbagNumbers := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  msgdlgNumbersDelete := TMessageDlg.Create(Self);
  WebPageControlSheet4 := TTabSheet.Create(Self);
  WebPanel15 := TPanel.Create(Self);
  WebLabel53 := TLabel.Create(Self);
  WebDBEdit16 := TDBEdit.Create(Self);
  WebDBCheckBox40 := TDBCheckBox.Create(Self);
  dblFinName := TDBLookupComboBox.Create(Self);
  WebPageControl1 := TPageControl.Create(Self);
  WebTabSheet4 := TTabSheet.Create(Self);
  WebPanel17 := TPanel.Create(Self);
  WebLabel35 := TLabel.Create(Self);
  WebLabel39 := TLabel.Create(Self);
  WebLabel40 := TLabel.Create(Self);
  WebLabel41 := TLabel.Create(Self);
  WebLabel42 := TLabel.Create(Self);
  WebLabel43 := TLabel.Create(Self);
  WebLabel44 := TLabel.Create(Self);
  WebLabel45 := TLabel.Create(Self);
  eServerName := TEdit.Create(Self);
  eDBPath := TEdit.Create(Self);
  eUsername := TEdit.Create(Self);
  ePassword := TEdit.Create(Self);
  ePort := TEdit.Create(Self);
  eProtocol := TComboBox.Create(Self);
  eDriverID := TComboBox.Create(Self);
  WebPanel18 := TPanel.Create(Self);
  WebLabel38 := TLabel.Create(Self);
  WebLabel46 := TLabel.Create(Self);
  WebLabel47 := TLabel.Create(Self);
  WebLabel48 := TLabel.Create(Self);
  WebLabel49 := TLabel.Create(Self);
  WebLabel50 := TLabel.Create(Self);
  WebLabel51 := TLabel.Create(Self);
  WebLabel52 := TLabel.Create(Self);
  eServerName1 := TEdit.Create(Self);
  eDBPath1 := TEdit.Create(Self);
  eUsername1 := TEdit.Create(Self);
  ePassword1 := TEdit.Create(Self);
  ePort1 := TEdit.Create(Self);
  eProtocol1 := TComboBox.Create(Self);
  eDriverID1 := TComboBox.Create(Self);
  WebTabSheet5 := TTabSheet.Create(Self);
  WebPanel19 := TPanel.Create(Self);
  WebLabel57 := TLabel.Create(Self);
  WebLabel58 := TLabel.Create(Self);
  WebLabel59 := TLabel.Create(Self);
  WebLabel60 := TLabel.Create(Self);
  WebLabel67 := TLabel.Create(Self);
  WebLabel68 := TLabel.Create(Self);
  WebPanel20 := TPanel.Create(Self);
  chk1 := TCheckBox.Create(Self);
  WebGroupBox1 := TGroupBox.Create(Self);
  WebLabel61 := TLabel.Create(Self);
  WebLabel62 := TLabel.Create(Self);
  WebLabel63 := TLabel.Create(Self);
  edtSalesVat := TEdit.Create(Self);
  edtExpenseVat := TEdit.Create(Self);
  edtZeroRate := TEdit.Create(Self);
  WebGroupBox2 := TGroupBox.Create(Self);
  WebLabel64 := TLabel.Create(Self);
  WebLabel65 := TLabel.Create(Self);
  WebLabel66 := TLabel.Create(Self);
  fin1dieselinv := TEdit.Create(Self);
  fin1maintinv := TEdit.Create(Self);
  fin1tyresinv := TEdit.Create(Self);
  edtsagepartnername := TEdit.Create(Self);
  edt1 := TEdit.Create(Self);
  Edit1 := TEdit.Create(Self);
  fin1Bank := TEdit.Create(Self);
  fncMasterGrid := TTMSFNCGrid.Create(Self);
  fncTransactionGrid := TTMSFNCGrid.Create(Self);
  WebTabSheet6 := TTabSheet.Create(Self);
  WebPanel6 := TPanel.Create(Self);
  WebGroupBox3 := TGroupBox.Create(Self);
  WebLabel19 := TLabel.Create(Self);
  WebLabel54 := TLabel.Create(Self);
  WebLabel55 := TLabel.Create(Self);
  WebLabel56 := TLabel.Create(Self);
  WebLabel69 := TLabel.Create(Self);
  WebLabel70 := TLabel.Create(Self);
  WebLabel71 := TLabel.Create(Self);
  WebLabel72 := TLabel.Create(Self);
  WebLabel73 := TLabel.Create(Self);
  WebLabel74 := TLabel.Create(Self);
  WebLabel75 := TLabel.Create(Self);
  Edit16 := TEdit.Create(Self);
  Edit4 := TEdit.Create(Self);
  Edit5 := TEdit.Create(Self);
  Edit15 := TEdit.Create(Self);
  Edit3 := TEdit.Create(Self);
  Edit17 := TEdit.Create(Self);
  Edit18 := TEdit.Create(Self);
  Edit19 := TEdit.Create(Self);
  Edit20 := TEdit.Create(Self);
  Edit21 := TEdit.Create(Self);
  edtBankClear := TEdit.Create(Self);
  WebButton5 := TButton.Create(Self);
  WebButton6 := TButton.Create(Self);
  WebButton7 := TButton.Create(Self);
  WebButton8 := TButton.Create(Self);
  WebButton9 := TButton.Create(Self);
  WebButton10 := TButton.Create(Self);
  WebButton11 := TButton.Create(Self);
  WebPageControlSheet5 := TTabSheet.Create(Self);
  pnlWebServerSettings := TPanel.Create(Self);
  WebLabel77 := TLabel.Create(Self);
  WebLabel78 := TLabel.Create(Self);
  WebLabel79 := TLabel.Create(Self);
  WebLabel80 := TLabel.Create(Self);
  WebLabel81 := TLabel.Create(Self);
  WebLabel82 := TLabel.Create(Self);
  WebLabel83 := TLabel.Create(Self);
  WebLabel84 := TLabel.Create(Self);
  WebLabel85 := TLabel.Create(Self);
  WebLabel86 := TLabel.Create(Self);
  WebLabel87 := TLabel.Create(Self);
  WebLabel88 := TLabel.Create(Self);
  WebDBEdit17 := TDBEdit.Create(Self);
  WebDBEdit18 := TDBEdit.Create(Self);
  WebDBEdit19 := TDBEdit.Create(Self);
  WebDBEdit20 := TDBEdit.Create(Self);
  WebDBEdit21 := TDBEdit.Create(Self);
  WebDBEdit22 := TDBEdit.Create(Self);
  WebDBEdit24 := TDBEdit.Create(Self);
  WebDBEdit25 := TDBEdit.Create(Self);
  WebDBEdit26 := TDBEdit.Create(Self);
  WebDBEdit27 := TDBEdit.Create(Self);
  WebDBEdit28 := TDBEdit.Create(Self);
  WebPanel12 := TPanel.Create(Self);
  WebLabel36 := TLabel.Create(Self);
  WebLabel37 := TLabel.Create(Self);
  WebLabel76 := TLabel.Create(Self);
  WebDBEdit29 := TDBEdit.Create(Self);
  WebDBEdit30 := TDBEdit.Create(Self);
  WebDBEdit31 := TDBEdit.Create(Self);
  Edit2 := TEdit.Create(Self);
  wpcSysSetupSheet6 := TTabSheet.Create(Self);
  WebPanel21 := TPanel.Create(Self);
  dbcbxAutomailig := TDBCheckBox.Create(Self);
  wgbEmailSetup := TGroupBox.Create(Self);
  WebLabel89 := TLabel.Create(Self);
  WebLabel90 := TLabel.Create(Self);
  WebLabel91 := TLabel.Create(Self);
  WebDBEdit23 := TDBEdit.Create(Self);
  WebDBEdit32 := TDBEdit.Create(Self);
  WebDBLookupComboBox1 := TDBLookupComboBox.Create(Self);
  WebDBCheckBox2 := TDBCheckBox.Create(Self);
  WebDBCheckBox3 := TDBCheckBox.Create(Self);
  wgbAuthentication := TGroupBox.Create(Self);
  WebLabel92 := TLabel.Create(Self);
  WebLabel93 := TLabel.Create(Self);
  WebDBEdit33 := TDBEdit.Create(Self);
  WebDBEdit34 := TDBEdit.Create(Self);
  wpcSysSetupSheet7 := TTabSheet.Create(Self);
  WebPanel13 := TPanel.Create(Self);
  WebSpeedButton8 := TSpeedButton.Create(Self);
  WebSpeedButton9 := TSpeedButton.Create(Self);
  WebSpeedButton10 := TSpeedButton.Create(Self);
  WebSpeedButton11 := TSpeedButton.Create(Self);
  WebSpeedButton12 := TSpeedButton.Create(Self);
  WebPanel14 := TPanel.Create(Self);
  btnVatTableFirst := TSpeedButton.Create(Self);
  btnVattablePrior := TSpeedButton.Create(Self);
  btnVattableNext := TSpeedButton.Create(Self);
  btnVattableLast := TSpeedButton.Create(Self);
  edtVattablePagecount := TEdit.Create(Self);
  dgVatSetup := TTMSFNCDataGrid.Create(Self);
  dbagVatSetup := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  msgdlgVattable := TMessageDlg.Create(Self);
  wpcSysSetupSheet8 := TTabSheet.Create(Self);
  WebPanel16 := TPanel.Create(Self);
  WebSpeedButton13 := TSpeedButton.Create(Self);
  WebSpeedButton14 := TSpeedButton.Create(Self);
  WebSpeedButton15 := TSpeedButton.Create(Self);
  WebSpeedButton16 := TSpeedButton.Create(Self);
  WebSpeedButton17 := TSpeedButton.Create(Self);
  WebPanel22 := TPanel.Create(Self);
  edtGLAPC := TEdit.Create(Self);
  sbtnGlaFirst := TSpeedButton.Create(Self);
  sbtnGLAPrior := TSpeedButton.Create(Self);
  sbtnGLANext := TSpeedButton.Create(Self);
  sbtnGLALast := TSpeedButton.Create(Self);
  dgGLA := TTMSFNCDataGrid.Create(Self);
  dbagGLA := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  msgdlgGLA := TMessageDlg.Create(Self);
  wpcSysSetupSheet9 := TTabSheet.Create(Self);
  WebPanel23 := TPanel.Create(Self);
  WebSpeedButton20 := TSpeedButton.Create(Self);
  WebSpeedButton21 := TSpeedButton.Create(Self);
  WebSpeedButton22 := TSpeedButton.Create(Self);
  WebSpeedButton23 := TSpeedButton.Create(Self);
  WebSpeedButton24 := TSpeedButton.Create(Self);
  WebPanel24 := TPanel.Create(Self);
  btnSystemLedgerFirst := TSpeedButton.Create(Self);
  btnSystemLedgerPrior := TSpeedButton.Create(Self);
  btnSystemLedgerNext := TSpeedButton.Create(Self);
  btnSystemLedgerLast := TSpeedButton.Create(Self);
  edtSystemLedger := TEdit.Create(Self);
  dgSystemLedger := TTMSFNCDataGrid.Create(Self);
  dbagSystemLedger := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  msgdlgSystemLedger := TMessageDlg.Create(Self);
  wpcSysSetupSheet10 := TTabSheet.Create(Self);
  WebCheckListBox1 := TCheckListBox.Create(Self);
  WebPageControl2 := TPageControl.Create(Self);
  WebPageControl2Sheet1 := TTabSheet.Create(Self);
  WebPanel32 := TPanel.Create(Self);
  WebLabel98 := TLabel.Create(Self);
  WebLabel99 := TLabel.Create(Self);
  WebLabel100 := TLabel.Create(Self);
  WebLabel101 := TLabel.Create(Self);
  WebLabel102 := TLabel.Create(Self);
  edtTFNUrl := TEdit.Create(Self);
  edtTFNUser := TEdit.Create(Self);
  edtTFNPassword := TEdit.Create(Self);
  edtTFNAPIKey := TEdit.Create(Self);
  edtTFNAccount := TEdit.Create(Self);
  WebPanel25 := TPanel.Create(Self);
  TFNSubAccountsFirst := TSpeedButton.Create(Self);
  TFNSubAccountsPrior := TSpeedButton.Create(Self);
  TFNSubAccountsNext := TSpeedButton.Create(Self);
  WebSpeedButton28 := TSpeedButton.Create(Self);
  edtTFNSubAccounts := TEdit.Create(Self);
  WebPanel27 := TPanel.Create(Self);
  WebSpeedButton25 := TSpeedButton.Create(Self);
  WebSpeedButton26 := TSpeedButton.Create(Self);
  WebSpeedButton27 := TSpeedButton.Create(Self);
  WebSpeedButton29 := TSpeedButton.Create(Self);
  WebSpeedButton30 := TSpeedButton.Create(Self);
  dgTFN1 := TTMSFNCDataGrid.Create(Self);
  dbagTFNSubaccounts1 := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  WebPageControl2Sheet2 := TTabSheet.Create(Self);
  WebPanel33 := TPanel.Create(Self);
  WebLabel97 := TLabel.Create(Self);
  WebLabel103 := TLabel.Create(Self);
  WebLabel104 := TLabel.Create(Self);
  WebLabel105 := TLabel.Create(Self);
  WebLabel106 := TLabel.Create(Self);
  WebLabel107 := TLabel.Create(Self);
  edtFMSUrl := TEdit.Create(Self);
  edtFMSUser := TEdit.Create(Self);
  edtFMSPass := TEdit.Create(Self);
  edtFMSAPIKey := TEdit.Create(Self);
  edtFMSAccount := TEdit.Create(Self);
  Edit22 := TEdit.Create(Self);
  WebPanel26 := TPanel.Create(Self);
  WebSpeedButton31 := TSpeedButton.Create(Self);
  WebSpeedButton32 := TSpeedButton.Create(Self);
  WebSpeedButton33 := TSpeedButton.Create(Self);
  WebSpeedButton34 := TSpeedButton.Create(Self);
  WebSpeedButton35 := TSpeedButton.Create(Self);
  WebPanel28 := TPanel.Create(Self);
  sbtnTFNSubAccountsS2First := TSpeedButton.Create(Self);
  sbtnTFNSubAccountsS2prior := TSpeedButton.Create(Self);
  sbtnTFNSubAccountsS2Next := TSpeedButton.Create(Self);
  sbtnTFNSubAccountsS2Last := TSpeedButton.Create(Self);
  edtTFNSubAccountsS2 := TEdit.Create(Self);
  dgTFNSubAccounts2 := TTMSFNCDataGrid.Create(Self);
  dbagTFNSubAccountsS2 := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  WebMessageDlg1 := TMessageDlg.Create(Self);
  WebPageControl2Sheet4 := TTabSheet.Create(Self);
  WebPanel35 := TPanel.Create(Self);
  WebLabel114 := TLabel.Create(Self);
  WebLabel113 := TLabel.Create(Self);
  WebLabel112 := TLabel.Create(Self);
  edtFuelUUrl := TEdit.Create(Self);
  edtFuelUToken := TEdit.Create(Self);
  edtFuelUPassword := TEdit.Create(Self);
  WebPageControl2Sheet5 := TTabSheet.Create(Self);
  WebPanel36 := TPanel.Create(Self);
  WebLabel115 := TLabel.Create(Self);
  WebLabel116 := TLabel.Create(Self);
  WebLabel117 := TLabel.Create(Self);
  WebLabel118 := TLabel.Create(Self);
  WebLabel119 := TLabel.Create(Self);
  edtPremiPointUrl := TEdit.Create(Self);
  edtPremiPointUser := TEdit.Create(Self);
  edtPremiPointPassword := TEdit.Create(Self);
  edtPremiPointKey := TEdit.Create(Self);
  edtPremiPointAccount := TEdit.Create(Self);
  wpcSysSetupSheet11 := TTabSheet.Create(Self);
  WebPanel37 := TPanel.Create(Self);
  WebDBRadioGroup1 := TDBRadioGroup.Create(Self);
  wpcSysSetupSheet12 := TTabSheet.Create(Self);
  WebPanel38 := TPanel.Create(Self);
  WebLabel120 := TLabel.Create(Self);
  WebLabel121 := TLabel.Create(Self);
  WebLabel122 := TLabel.Create(Self);
  WebLabel123 := TLabel.Create(Self);
  WebLabel124 := TLabel.Create(Self);
  WebLabel125 := TLabel.Create(Self);
  WebLabel126 := TLabel.Create(Self);
  WebLabel127 := TLabel.Create(Self);
  WebLabel128 := TLabel.Create(Self);
  WebLabel129 := TLabel.Create(Self);
  WebDBCheckBox1 := TDBCheckBox.Create(Self);
  WebDBCheckBox4 := TDBCheckBox.Create(Self);
  WebDBCheckBox41 := TDBCheckBox.Create(Self);
  WebDBCheckBox42 := TDBCheckBox.Create(Self);
  WebDBComboBox1 := TDBComboBox.Create(Self);
  WebDBComboBox2 := TDBComboBox.Create(Self);
  WebDBComboBox3 := TDBComboBox.Create(Self);
  WebDBComboBox4 := TDBComboBox.Create(Self);
  WebDBEdit35 := TDBEdit.Create(Self);
  WebDBEdit36 := TDBEdit.Create(Self);
  WebDBEdit37 := TDBEdit.Create(Self);
  WebDBEdit38 := TDBEdit.Create(Self);
  WebDBEdit39 := TDBEdit.Create(Self);
  WebDBEdit40 := TDBEdit.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  btnSave := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  wcCompInfo := TXDataWebClient.Create(Self);
  wdsCompInfo := TXDataWebDataSet.Create(Self);
  wdsCompInfoSSCLoadConLoadDate := TBooleanField.Create(Self);
  wdsCompInfoSSCLoadConOffLoadDate := TBooleanField.Create(Self);
  wdsCompInfoSSCLOADCONRECEIVEDATE := TBooleanField.Create(Self);
  wdsCompInfoSSCLOADCONCOMPLETEDATE := TBooleanField.Create(Self);
  wdsCompInfoSSCLOADCONLOADTIME := TIntegerField.Create(Self);
  wdsCompInfoSSCLOADCONOFFLOADTIME := TIntegerField.Create(Self);
  wdsCompInfoSSCLOADCONRECEIVETIME := TIntegerField.Create(Self);
  wdsCompInfoSSCLOADCONCOMPLETETIME := TIntegerField.Create(Self);
  wdsCompInfoSSCLOADCONLOADDATEC := TIntegerField.Create(Self);
  wdsCompInfoSSCLOADCONOFFLOADDATEC := TIntegerField.Create(Self);
  wdsCompInfoSSCLOADCONRECEIVEDATEC := TIntegerField.Create(Self);
  wdsCompInfoSSCLOADCONCOMPLETEDATEC := TIntegerField.Create(Self);
  wdsCompInfoSSCLOADCONLOADTIMEC := TIntegerField.Create(Self);
  wdsCompInfoSSCLOADCONOFFLOADTIMEC := TIntegerField.Create(Self);
  wdsCompInfoSSCLOADCONRECEIVETIMEC := TIntegerField.Create(Self);
  wdsCompInfoSSCLOADCONCOMPLETETIMEC := TIntegerField.Create(Self);
  wdsCompInfoUSEFINLINKSYSTEM := TBooleanField.Create(Self);
  wdsCompInfoFINLINKSYSTEM := TIntegerField.Create(Self);
  wdsCompInfoAUTOMAILSYSTEM := TBooleanField.Create(Self);
  wdsCompInfoFINDBSETUP := TBlobField.Create(Self);
  wdsCompInfoMAILSERVER := TStringField.Create(Self);
  wdsCompInfoMAILSERVERPORT := TIntegerField.Create(Self);
  wdsCompInfoMAILSERVERAUTH := TBooleanField.Create(Self);
  wdsCompInfoMAILSERVERUSER := TStringField.Create(Self);
  wdsCompInfoMAILSERVERPASS := TStringField.Create(Self);
  wdsCompInfoMAILSERVERSSL := TBooleanField.Create(Self);
  wdsCompInfoMAILSERVERPROTOCOL := TIntegerField.Create(Self);
  wdsCompInfoMAILSERVERSIGNATURE := TBooleanField.Create(Self);
  wdsCompInfoMAILSERVERENCRYPTION := TBooleanField.Create(Self);
  wdsCompInfoMAILSERVERENCODING := TStringField.Create(Self);
  wdsCompInfoDCLPERC := TFloatField.Create(Self);
  wdsCompInfoBANKSTATEMENT := TBooleanField.Create(Self);
  wdsCompInfoSSFLOADCONLOADDATEC := TIntegerField.Create(Self);
  wdsCompInfoSSFLOADCONOFFLOADDATEC := TIntegerField.Create(Self);
  wdsCompInfoSSFLOADCONRECEIVEDATEC := TIntegerField.Create(Self);
  wdsCompInfoSSFLOADCONCOMPLETEDATEC := TIntegerField.Create(Self);
  wdsCompInfoSSFLOADCONLOADTIMEC := TIntegerField.Create(Self);
  wdsCompInfoSSFLOADCONOFFLOADTIMEC := TIntegerField.Create(Self);
  wdsCompInfoSSFLOADCONRECEIVETIMEC := TIntegerField.Create(Self);
  wdsCompInfoSSFLOADCONCOMPLETETIMEC := TIntegerField.Create(Self);
  wdsCompInfoFORCEDIESELDRIVER := TBooleanField.Create(Self);
  wdsCompInfoFORCELOADDRIVER := TBooleanField.Create(Self);
  wdsCompInfoDEFDIESELORDERS := TIntegerField.Create(Self);
  wdsCompInfoDEFLOADORDERS := TIntegerField.Create(Self);
  wdsCompInfoINVOICESYSTEM := TBooleanField.Create(Self);
  wdsCompInfoBTBRANCHCODE := TStringField.Create(Self);
  wdsCompInfoBTACCOUNTNO := TStringField.Create(Self);
  wdsCompInfoTRIPSHEETTYPE := TStringField.Create(Self);
  wdsCompInfoLOADCUSTOMERS := TBooleanField.Create(Self);
  wdsCompInfoFINLINKSYSTEMCOUNT := TIntegerField.Create(Self);
  wdsCompInfoFIN1NAME := TStringField.Create(Self);
  wdsCompInfoFIN2NAME := TStringField.Create(Self);
  wdsCompInfoUSEDOCKETNOINVNO := TBooleanField.Create(Self);
  wdsCompInfoUSEADDINFONONCON := TBooleanField.Create(Self);
  wdsCompInfoSTATEMENTTYPE := TStringField.Create(Self);
  wdsCompInfoSTOCKSTDPERC := TFloatField.Create(Self);
  wdsCompInfoSTOCKDEDPERC := TFloatField.Create(Self);
  wdsCompInfoSTOCKSPEPERC := TFloatField.Create(Self);
  wdsCompInfoEMPADDCOMDESC := TStringField.Create(Self);
  wdsCompInfoNONCONDISPLAYFUEL := TBooleanField.Create(Self);
  wdsCompInfoADD1DESC := TStringField.Create(Self);
  wdsCompInfoADD2DESC := TStringField.Create(Self);
  wdsCompInfoADD3DESC := TStringField.Create(Self);
  wdsCompInfoADD4DESC := TStringField.Create(Self);
  wdsCompInfoADD5DESC := TStringField.Create(Self);
  wdsCompInfoADD6DESC := TStringField.Create(Self);
  wdsCompInfoADD7DESC := TStringField.Create(Self);
  wdsCompInfoPOSTALADDRESS1 := TStringField.Create(Self);
  wdsCompInfoPOSTALADDRESS2 := TStringField.Create(Self);
  wdsCompInfoPOSTALADDRESS3 := TStringField.Create(Self);
  wdsCompInfoPOSTALADDRESS4 := TStringField.Create(Self);
  wdsCompInfoPOSTALCODE := TStringField.Create(Self);
  wdsCompInfoUSEMULTICOMPANYINVOICE := TBooleanField.Create(Self);
  wdsCompInfoMISCINVLOADS := TBooleanField.Create(Self);
  wdsCompInfoPRINTTOTALSSEND := TBooleanField.Create(Self);
  wdsCompInfoWEBSERVERADDRESS := TStringField.Create(Self);
  wdsCompInfoWEBSERVERPORT := TIntegerField.Create(Self);
  wdsCompInfoWEBSERVERUSER := TStringField.Create(Self);
  wdsCompInfoWEBSERVERPASSWORD := TStringField.Create(Self);
  wdsCompInfoWEBSERVERSCANAPI := TStringField.Create(Self);
  wdsCompInfoDBSERVERADDRESS := TStringField.Create(Self);
  wdsCompInfoDBSERVERPORT := TIntegerField.Create(Self);
  wdsCompInfoINTERNALADDRESS := TStringField.Create(Self);
  wdsCompInfoINTERNALPORT := TIntegerField.Create(Self);
  wdsCompInfoWEBSERVERDB := TStringField.Create(Self);
  wdsCompInfoWEBSERVERDBUSER := TStringField.Create(Self);
  wdsCompInfoWEBSERVERDBPASS := TStringField.Create(Self);
  wdsCompInfoUNIQUEORDER := TBooleanField.Create(Self);
  wdsCompInfoUNIQUEWAYBILLS := TBooleanField.Create(Self);
  wdsCompInfoUNIQUEWASHBAYDOCKET := TBooleanField.Create(Self);
  wdsCompInfoIMPORTPERIOD := TIntegerField.Create(Self);
  wdsCompInfoIMPORTBATCH := TIntegerField.Create(Self);
  wdsCompInfoPRINTLOADSAVE := TBooleanField.Create(Self);
  wdsCompInfoNOFUTUREINVDATE := TBooleanField.Create(Self);
  wdsCompInfoUNIQUESHORTDESC := TBooleanField.Create(Self);
  wdsCompInfoCUSTMISCTYPE := TStringField.Create(Self);
  wdsCompInfoSUPPMISCTYPE := TStringField.Create(Self);
  wdsCompInfoJOBCARDPREFIX := TStringField.Create(Self);
  wdsCompInfoREQUESTPREFIX := TStringField.Create(Self);
  wdsCompInfoORDERSPREFIX := TStringField.Create(Self);
  wdsCompInfoMISCGLFORCE := TBooleanField.Create(Self);
  wdsCompInfoSUBUNINVSHOW := TBooleanField.Create(Self);
  wdsCompInfoemployeedemerit := TIntegerField.Create(Self);
  wdsCompInfovehicledemerit := TIntegerField.Create(Self);
  wdsCompInfomonitorvehiclechanges := TBooleanField.Create(Self);
  wdsCompInfomonitordieselupfrontcl := TBooleanField.Create(Self);
  wdsCompInfomonitorloadssub := TBooleanField.Create(Self);
  wdsCompInfomonitorcancelloads := TBooleanField.Create(Self);
  wdsCompInfocheckdieselordersdays := TIntegerField.Create(Self);
  wdsCompInfoJobCompType := TStringField.Create(Self);
  wdsCompInfofinesbrnno := TStringField.Create(Self);
  wdsCompInfofinesidno := TStringField.Create(Self);
  wdsCompInfosmsdiesel := TBooleanField.Create(Self);
  wdsCompInfosmsdieselurl := TStringField.Create(Self);
  wdsCompInfosmsdieseluser := TStringField.Create(Self);
  wdsCompInfosmsdieselpassword := TStringField.Create(Self);
  wdsCompInfoINSTRUCTORDER := TStringField.Create(Self);
  wdsCompInfowashbayinvloads := TBooleanField.Create(Self);
  wdsCompInfosubsoverrite := TBooleanField.Create(Self);
  wdsCompInfocommissiontype := TIntegerField.Create(Self);
  wdsCompInfoallowdieselproforma := TBooleanField.Create(Self);
  wdsCompInfoforcescandocs := TBooleanField.Create(Self);
  wdsCompInfoBANKDETAIL5 := TStringField.Create(Self);
  wdsCompInfoBANKDETAILS6 := TStringField.Create(Self);
  wdsCompInfoBANKDETAILS7 := TStringField.Create(Self);
  wdsCompInfoBANKDETAILS8 := TStringField.Create(Self);
  wdsCompInfologo := TBlobField.Create(Self);
  wdsCompInfoautocanceldieselorders := TBooleanField.Create(Self);
  wdsCompInfoautocanceldieselordersdays := TIntegerField.Create(Self);
  wdsCompInfosendloadconsprocess := TBooleanField.Create(Self);
  wdsCompInfoloadcoscutoffdate := TBooleanField.Create(Self);
  wdsCompInfodieselcutoffdate := TBooleanField.Create(Self);
  wdsCompInfohidecanceloadsplanning := TBooleanField.Create(Self);
  wdsCompInfoincrementdocketno := TBooleanField.Create(Self);
  wdsCompInfolinklastdriver := TBooleanField.Create(Self);
  wdsCompInfoplanningshortdesc := TBooleanField.Create(Self);
  wdsCompInfoallowreprint := TBooleanField.Create(Self);
  wdsCompInforemovesubinvdocs := TBooleanField.Create(Self);
  wdsCompInfoloadsmustreceived := TBooleanField.Create(Self);
  wdsCompInfofnbcontractid := TStringField.Create(Self);
  wdsCompInfofnbclientid := TStringField.Create(Self);
  wdsCompInfofnbdeblistcount := TIntegerField.Create(Self);
  wdsCompInfofnbcredlistcount := TIntegerField.Create(Self);
  wdsCompInfofnblastdebdate := TDateField.Create(Self);
  wdsCompInfofnblastcreddate := TDateField.Create(Self);
  wdsCompInfofnblastdebamount := TFloatField.Create(Self);
  wdsCompInfofnblastcredamount := TFloatField.Create(Self);
  wdsCompInfofnbclienttype := TIntegerField.Create(Self);
  wdsCompInfolinkloadsvat := TBooleanField.Create(Self);
  wdsCompInfomarkmultiloadready := TBooleanField.Create(Self);
  wdsCompInfobulkdieselinvoices := TBooleanField.Create(Self);
  wdsCompInfoclearbulkinvoices := TBooleanField.Create(Self);
  wdsCompInfogetsageonlinebalance := TBooleanField.Create(Self);
  wdsCompInfousesageonlinebalancefordiesel := TFloatField.Create(Self);
  wdsCompInfoapiserverurl := TStringField.Create(Self);
  wdsCompInfoapiusername := TStringField.Create(Self);
  wdsCompInfoapipassword := TStringField.Create(Self);
  wdsCompInfoapikey := TStringField.Create(Self);
  wdsCompInfofuelconsumptionfullfills := TBooleanField.Create(Self);
  wdsCompInfousenewscan := TBooleanField.Create(Self);
  wdsCompInfobasescanfolder := TStringField.Create(Self);
  wdsCompInfoftpserver := TStringField.Create(Self);
  wdsCompInfoftpport := TSmallintField.Create(Self);
  wdsCompInfoftpuser := TStringField.Create(Self);
  wdsCompInfoftppassword := TStringField.Create(Self);
  wdsCompInfomulticontroller := TBooleanField.Create(Self);
  wdsCompInfolastshiftno := TIntegerField.Create(Self);
  wdsCompInfodieselnonretail := TBooleanField.Create(Self);
  wdsCompInfoemailaddress := TStringField.Create(Self);
  wdsCompInfojobnullqty := TBooleanField.Create(Self);
  wdsCompInfojoborder := TBooleanField.Create(Self);
  wdsCompInfojobcardtype := TStringField.Create(Self);
  wdsCompInfomaintforcegl := TBooleanField.Create(Self);
  wdsCompInfocompemail := TStringField.Create(Self);
  wdsCompInfoerrormails := TStringField.Create(Self);
  wdsCompInfoADDRESS1 := TStringField.Create(Self);
  wdsCompInfoADDRESS2 := TStringField.Create(Self);
  wdsCompInfoADDRESS3 := TStringField.Create(Self);
  wdsCompInfoADDRESS4 := TStringField.Create(Self);
  wdsCompInfoADDRESSCODE := TStringField.Create(Self);
  wdsCompInfoCOMPANYNAME := TStringField.Create(Self);
  wdsCompInfoCOMPANYFAX := TStringField.Create(Self);
  wdsCompInfoCOMPANYTEL := TStringField.Create(Self);
  wdsCompInfoCOMPANYREG := TStringField.Create(Self);
  wdsCompInfoCOMPANYVAT := TStringField.Create(Self);
  wdsCompInfoLOGOPATH := TStringField.Create(Self);
  wdsCompInfoUSEDIFFCOMP := TBooleanField.Create(Self);
  wdsCompInfoBANKDETAILS1 := TStringField.Create(Self);
  wdsCompInfoBANKDETAILS2 := TStringField.Create(Self);
  wdsCompInfoBANKDETAILS3 := TStringField.Create(Self);
  wdsCompInfoBANKDETAILS4 := TStringField.Create(Self);
  wdsCompInfoLOADCONTYPE := TStringField.Create(Self);
  wdsCompInfoLOADCONPREFIX := TStringField.Create(Self);
  wdsCompInfoCompanyCode := TIntegerField.Create(Self);
  wdsCompInfoSSUNIQUECLIENTDOCKET := TBooleanField.Create(Self);
  dsCompInfo := TDataSource.Create(Self);
  wcNumbers := TXDataWebClient.Create(Self);
  wdsNumbers := TXDataWebDataSet.Create(Self);
  wdsNumbersTranType := TStringField.Create(Self);
  wdsNumbersPrefix := TStringField.Create(Self);
  wdsNumbersDescription := TStringField.Create(Self);
  wdsNumbersSuffix := TIntegerField.Create(Self);
  dsNumbers := TDataSource.Create(Self);
  wdsFinSystem := TXDataWebDataSet.Create(Self);
  dsFinSystem := TDataSource.Create(Self);
  wcFinSystem := TXDataWebClient.Create(Self);
  dsVattable := TDataSource.Create(Self);
  wdsVattable := TXDataWebDataSet.Create(Self);
  wdsVattableVATPERC := TFloatField.Create(Self);
  wdsVattableSTARTDATE := TStringField.Create(Self);
  wdsVattableENDATE := TStringField.Create(Self);
  wdsVattableAuto := TIntegerField.Create(Self);
  wcVattable := TXDataWebClient.Create(Self);
  wdsGLA := TXDataWebDataSet.Create(Self);
  wdsGLAGLCODE := TStringField.Create(Self);
  wdsGLAGLDESCRIPTION := TStringField.Create(Self);
  wdsGLASUSPENDED := TBooleanField.Create(Self);
  wdsGLAbankaccount := TBooleanField.Create(Self);
  wdsGLAbankcard := TBooleanField.Create(Self);
  dsGLA := TDataSource.Create(Self);
  wcGLA := TXDataWebClient.Create(Self);
  wdsSystemLedgerAccounts := TXDataWebDataSet.Create(Self);
  wdsSystemLedgerAccountsGLDESCRIPTION := TStringField.Create(Self);
  wdsSystemLedgerAccountsFleetDesc := TStringField.Create(Self);
  wdsSystemLedgerAccountsValueTypesDesc := TStringField.Create(Self);
  wdsSystemLedgerAccountsSystemDesc := TStringField.Create(Self);
  wdsSystemLedgerAccountsGLCode := TStringField.Create(Self);
  wdsSystemLedgerAccountscompanygldetail_Auto := TIntegerField.Create(Self);
  wcSystemLedgerAccounts := TXDataWebClient.Create(Self);
  dsSystemLedgerAccounts := TDataSource.Create(Self);
  wdsTFNSubAccountsS1 := TXDataWebDataSet.Create(Self);
  wdsTFNSubAccountsS1ApiServerNo := TIntegerField.Create(Self);
  wdsTFNSubAccountsS1SubContractNo := TStringField.Create(Self);
  wdsTFNSubAccountsS1ApiAccountNo := TStringField.Create(Self);
  wdsTFNSubAccountsS1LastRunDate := TStringField.Create(Self);
  wdsTFNSubAccountsS1SubsRegNo := TStringField.Create(Self);
  wdsTFNSubAccountsS1CRName := TStringField.Create(Self);
  dsTFNSubAccountsS1 := TDataSource.Create(Self);
  wcTFNSubAccountsS1 := TXDataWebClient.Create(Self);
  wcTFNSubAccountsS2 := TXDataWebClient.Create(Self);
  wdsTFNSubAccountsS2 := TXDataWebDataSet.Create(Self);
  wdsTFNSubAccountsS2ApiServerNo := TIntegerField.Create(Self);
  wdsTFNSubAccountsS2SubContractNo := TStringField.Create(Self);
  wdsTFNSubAccountsS2ApiAccountNo := TStringField.Create(Self);
  wdsTFNSubAccountsS2LastRunDate := TStringField.Create(Self);
  wdsTFNSubAccountsS2SubsRegNo := TStringField.Create(Self);
  wdsTFNSubAccountsS2CRName := TStringField.Create(Self);
  dsTFNSubAccountsS2 := TDataSource.Create(Self);
  wdsFinLinkSystem := TXDataWebDataSet.Create(Self);
  wdsFinLinkSystemFinNo := TIntegerField.Create(Self);
  wdsFinLinkSystemFinName := TStringField.Create(Self);
  wdsFinLinkSystemFinActive := TStringField.Create(Self);
  dsFinLinkSystem := TDataSource.Create(Self);
  wcFinLinkSystem := TXDataWebClient.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebResponsiveManager1.BeforeLoadDFMValues;
  BitmapContainer1.BeforeLoadDFMValues;
  wpcSysSetup.BeforeLoadDFMValues;
  WebPageControl1Sheet1.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  WebLabel17.BeforeLoadDFMValues;
  WebLabel18.BeforeLoadDFMValues;
  WebDBImageControl1.BeforeLoadDFMValues;
  edtCompName.BeforeLoadDFMValues;
  edtCompAddress1.BeforeLoadDFMValues;
  edtCompAddress2.BeforeLoadDFMValues;
  edtCompAddress3.BeforeLoadDFMValues;
  edtCompAddress4.BeforeLoadDFMValues;
  edtCompAddressCode.BeforeLoadDFMValues;
  edtPostalCode.BeforeLoadDFMValues;
  edtPostalAddress4.BeforeLoadDFMValues;
  edtPostalAddress3.BeforeLoadDFMValues;
  edtPostalAddress2.BeforeLoadDFMValues;
  edtPostalAddress1.BeforeLoadDFMValues;
  edtTelephone.BeforeLoadDFMValues;
  edtTaxNo.BeforeLoadDFMValues;
  edtLogoPath.BeforeLoadDFMValues;
  edtRegistrationNo.BeforeLoadDFMValues;
  edtVatNo.BeforeLoadDFMValues;
  edtDeliveryNotePrefix.BeforeLoadDFMValues;
  edtCompEmail.BeforeLoadDFMValues;
  edtBankTransferBranchCode.BeforeLoadDFMValues;
  WebPanel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  edtBankDetails1.BeforeLoadDFMValues;
  edtBankDetails2.BeforeLoadDFMValues;
  edtBankDetails3.BeforeLoadDFMValues;
  edtBankDetails4.BeforeLoadDFMValues;
  cbxPrintOnStatement.BeforeLoadDFMValues;
  edtBankTransferAccountNo.BeforeLoadDFMValues;
  WebDBComboBox5.BeforeLoadDFMValues;
  WebDBComboBox6.BeforeLoadDFMValues;
  WebDBComboBox7.BeforeLoadDFMValues;
  WebDBComboBox8.BeforeLoadDFMValues;
  WebPageControl1Sheet2.BeforeLoadDFMValues;
  WebResponsiveManager3.BeforeLoadDFMValues;
  WebPanel8.BeforeLoadDFMValues;
  WebLabel23.BeforeLoadDFMValues;
  WebLabel24.BeforeLoadDFMValues;
  WebDBEdit1.BeforeLoadDFMValues;
  WebDBEdit2.BeforeLoadDFMValues;
  WebDBCheckBox5.BeforeLoadDFMValues;
  WebDBCheckBox6.BeforeLoadDFMValues;
  WebDBCheckBox7.BeforeLoadDFMValues;
  WebDBCheckBox8.BeforeLoadDFMValues;
  WebDBCheckBox9.BeforeLoadDFMValues;
  WebDBCheckBox10.BeforeLoadDFMValues;
  WebDBCheckBox11.BeforeLoadDFMValues;
  WebDBCheckBox12.BeforeLoadDFMValues;
  WebDBCheckBox13.BeforeLoadDFMValues;
  WebDBCheckBox14.BeforeLoadDFMValues;
  WebPanel9.BeforeLoadDFMValues;
  WebLabel21.BeforeLoadDFMValues;
  WebLabel22.BeforeLoadDFMValues;
  WebDBEdit3.BeforeLoadDFMValues;
  WebDBEdit4.BeforeLoadDFMValues;
  WebDBCheckBox15.BeforeLoadDFMValues;
  WebDBCheckBox16.BeforeLoadDFMValues;
  WebDBCheckBox17.BeforeLoadDFMValues;
  WebDBCheckBox18.BeforeLoadDFMValues;
  WebDBCheckBox19.BeforeLoadDFMValues;
  WebDBCheckBox20.BeforeLoadDFMValues;
  WebDBCheckBox21.BeforeLoadDFMValues;
  WebDBCheckBox22.BeforeLoadDFMValues;
  WebDBCheckBox23.BeforeLoadDFMValues;
  WebDBCheckBox24.BeforeLoadDFMValues;
  WebPanel7.BeforeLoadDFMValues;
  WebLabel20.BeforeLoadDFMValues;
  WebDBEdit5.BeforeLoadDFMValues;
  WebDBCheckBox25.BeforeLoadDFMValues;
  WebDBCheckBox26.BeforeLoadDFMValues;
  WebDBCheckBox27.BeforeLoadDFMValues;
  WebDBCheckBox28.BeforeLoadDFMValues;
  WebDBCheckBox29.BeforeLoadDFMValues;
  WebDBCheckBox30.BeforeLoadDFMValues;
  WebDBCheckBox31.BeforeLoadDFMValues;
  WebDBCheckBox32.BeforeLoadDFMValues;
  WebDBCheckBox33.BeforeLoadDFMValues;
  WebDBCheckBox34.BeforeLoadDFMValues;
  WebDBCheckBox35.BeforeLoadDFMValues;
  WebDBCheckBox36.BeforeLoadDFMValues;
  WebDBCheckBox37.BeforeLoadDFMValues;
  WebDBCheckBox38.BeforeLoadDFMValues;
  WebDBCheckBox39.BeforeLoadDFMValues;
  WebPanel10.BeforeLoadDFMValues;
  WebLabel31.BeforeLoadDFMValues;
  WebLabel32.BeforeLoadDFMValues;
  WebLabel33.BeforeLoadDFMValues;
  WebLabel34.BeforeLoadDFMValues;
  WebLabel25.BeforeLoadDFMValues;
  WebDBEdit6.BeforeLoadDFMValues;
  WebDBEdit7.BeforeLoadDFMValues;
  WebDBEdit8.BeforeLoadDFMValues;
  WebDBEdit9.BeforeLoadDFMValues;
  WebDBEdit14.BeforeLoadDFMValues;
  WebPanel11.BeforeLoadDFMValues;
  WebLabel26.BeforeLoadDFMValues;
  WebLabel27.BeforeLoadDFMValues;
  WebLabel28.BeforeLoadDFMValues;
  WebLabel29.BeforeLoadDFMValues;
  WebLabel30.BeforeLoadDFMValues;
  WebDBEdit10.BeforeLoadDFMValues;
  WebDBEdit11.BeforeLoadDFMValues;
  WebDBEdit12.BeforeLoadDFMValues;
  WebDBEdit13.BeforeLoadDFMValues;
  WebDBEdit15.BeforeLoadDFMValues;
  WebPageControl1Sheet3.BeforeLoadDFMValues;
  wpNavigator.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  WebPanel29.BeforeLoadDFMValues;
  edtNumbersPageCount.BeforeLoadDFMValues;
  sbtnNumbersNext.BeforeLoadDFMValues;
  sbtnNumbersPrevious.BeforeLoadDFMValues;
  sbtnNumbersLast.BeforeLoadDFMValues;
  sbtnNumbersFirst.BeforeLoadDFMValues;
  dgNumbers.BeforeLoadDFMValues;
  dbagNumbers.BeforeLoadDFMValues;
  msgdlgNumbersDelete.BeforeLoadDFMValues;
  WebPageControlSheet4.BeforeLoadDFMValues;
  WebPanel15.BeforeLoadDFMValues;
  WebLabel53.BeforeLoadDFMValues;
  WebDBEdit16.BeforeLoadDFMValues;
  WebDBCheckBox40.BeforeLoadDFMValues;
  dblFinName.BeforeLoadDFMValues;
  WebPageControl1.BeforeLoadDFMValues;
  WebTabSheet4.BeforeLoadDFMValues;
  WebPanel17.BeforeLoadDFMValues;
  WebLabel35.BeforeLoadDFMValues;
  WebLabel39.BeforeLoadDFMValues;
  WebLabel40.BeforeLoadDFMValues;
  WebLabel41.BeforeLoadDFMValues;
  WebLabel42.BeforeLoadDFMValues;
  WebLabel43.BeforeLoadDFMValues;
  WebLabel44.BeforeLoadDFMValues;
  WebLabel45.BeforeLoadDFMValues;
  eServerName.BeforeLoadDFMValues;
  eDBPath.BeforeLoadDFMValues;
  eUsername.BeforeLoadDFMValues;
  ePassword.BeforeLoadDFMValues;
  ePort.BeforeLoadDFMValues;
  eProtocol.BeforeLoadDFMValues;
  eDriverID.BeforeLoadDFMValues;
  WebPanel18.BeforeLoadDFMValues;
  WebLabel38.BeforeLoadDFMValues;
  WebLabel46.BeforeLoadDFMValues;
  WebLabel47.BeforeLoadDFMValues;
  WebLabel48.BeforeLoadDFMValues;
  WebLabel49.BeforeLoadDFMValues;
  WebLabel50.BeforeLoadDFMValues;
  WebLabel51.BeforeLoadDFMValues;
  WebLabel52.BeforeLoadDFMValues;
  eServerName1.BeforeLoadDFMValues;
  eDBPath1.BeforeLoadDFMValues;
  eUsername1.BeforeLoadDFMValues;
  ePassword1.BeforeLoadDFMValues;
  ePort1.BeforeLoadDFMValues;
  eProtocol1.BeforeLoadDFMValues;
  eDriverID1.BeforeLoadDFMValues;
  WebTabSheet5.BeforeLoadDFMValues;
  WebPanel19.BeforeLoadDFMValues;
  WebLabel57.BeforeLoadDFMValues;
  WebLabel58.BeforeLoadDFMValues;
  WebLabel59.BeforeLoadDFMValues;
  WebLabel60.BeforeLoadDFMValues;
  WebLabel67.BeforeLoadDFMValues;
  WebLabel68.BeforeLoadDFMValues;
  WebPanel20.BeforeLoadDFMValues;
  chk1.BeforeLoadDFMValues;
  WebGroupBox1.BeforeLoadDFMValues;
  WebLabel61.BeforeLoadDFMValues;
  WebLabel62.BeforeLoadDFMValues;
  WebLabel63.BeforeLoadDFMValues;
  edtSalesVat.BeforeLoadDFMValues;
  edtExpenseVat.BeforeLoadDFMValues;
  edtZeroRate.BeforeLoadDFMValues;
  WebGroupBox2.BeforeLoadDFMValues;
  WebLabel64.BeforeLoadDFMValues;
  WebLabel65.BeforeLoadDFMValues;
  WebLabel66.BeforeLoadDFMValues;
  fin1dieselinv.BeforeLoadDFMValues;
  fin1maintinv.BeforeLoadDFMValues;
  fin1tyresinv.BeforeLoadDFMValues;
  edtsagepartnername.BeforeLoadDFMValues;
  edt1.BeforeLoadDFMValues;
  Edit1.BeforeLoadDFMValues;
  fin1Bank.BeforeLoadDFMValues;
  fncMasterGrid.BeforeLoadDFMValues;
  fncTransactionGrid.BeforeLoadDFMValues;
  WebTabSheet6.BeforeLoadDFMValues;
  WebPanel6.BeforeLoadDFMValues;
  WebGroupBox3.BeforeLoadDFMValues;
  WebLabel19.BeforeLoadDFMValues;
  WebLabel54.BeforeLoadDFMValues;
  WebLabel55.BeforeLoadDFMValues;
  WebLabel56.BeforeLoadDFMValues;
  WebLabel69.BeforeLoadDFMValues;
  WebLabel70.BeforeLoadDFMValues;
  WebLabel71.BeforeLoadDFMValues;
  WebLabel72.BeforeLoadDFMValues;
  WebLabel73.BeforeLoadDFMValues;
  WebLabel74.BeforeLoadDFMValues;
  WebLabel75.BeforeLoadDFMValues;
  Edit16.BeforeLoadDFMValues;
  Edit4.BeforeLoadDFMValues;
  Edit5.BeforeLoadDFMValues;
  Edit15.BeforeLoadDFMValues;
  Edit3.BeforeLoadDFMValues;
  Edit17.BeforeLoadDFMValues;
  Edit18.BeforeLoadDFMValues;
  Edit19.BeforeLoadDFMValues;
  Edit20.BeforeLoadDFMValues;
  Edit21.BeforeLoadDFMValues;
  edtBankClear.BeforeLoadDFMValues;
  WebButton5.BeforeLoadDFMValues;
  WebButton6.BeforeLoadDFMValues;
  WebButton7.BeforeLoadDFMValues;
  WebButton8.BeforeLoadDFMValues;
  WebButton9.BeforeLoadDFMValues;
  WebButton10.BeforeLoadDFMValues;
  WebButton11.BeforeLoadDFMValues;
  WebPageControlSheet5.BeforeLoadDFMValues;
  pnlWebServerSettings.BeforeLoadDFMValues;
  WebLabel77.BeforeLoadDFMValues;
  WebLabel78.BeforeLoadDFMValues;
  WebLabel79.BeforeLoadDFMValues;
  WebLabel80.BeforeLoadDFMValues;
  WebLabel81.BeforeLoadDFMValues;
  WebLabel82.BeforeLoadDFMValues;
  WebLabel83.BeforeLoadDFMValues;
  WebLabel84.BeforeLoadDFMValues;
  WebLabel85.BeforeLoadDFMValues;
  WebLabel86.BeforeLoadDFMValues;
  WebLabel87.BeforeLoadDFMValues;
  WebLabel88.BeforeLoadDFMValues;
  WebDBEdit17.BeforeLoadDFMValues;
  WebDBEdit18.BeforeLoadDFMValues;
  WebDBEdit19.BeforeLoadDFMValues;
  WebDBEdit20.BeforeLoadDFMValues;
  WebDBEdit21.BeforeLoadDFMValues;
  WebDBEdit22.BeforeLoadDFMValues;
  WebDBEdit24.BeforeLoadDFMValues;
  WebDBEdit25.BeforeLoadDFMValues;
  WebDBEdit26.BeforeLoadDFMValues;
  WebDBEdit27.BeforeLoadDFMValues;
  WebDBEdit28.BeforeLoadDFMValues;
  WebPanel12.BeforeLoadDFMValues;
  WebLabel36.BeforeLoadDFMValues;
  WebLabel37.BeforeLoadDFMValues;
  WebLabel76.BeforeLoadDFMValues;
  WebDBEdit29.BeforeLoadDFMValues;
  WebDBEdit30.BeforeLoadDFMValues;
  WebDBEdit31.BeforeLoadDFMValues;
  Edit2.BeforeLoadDFMValues;
  wpcSysSetupSheet6.BeforeLoadDFMValues;
  WebPanel21.BeforeLoadDFMValues;
  dbcbxAutomailig.BeforeLoadDFMValues;
  wgbEmailSetup.BeforeLoadDFMValues;
  WebLabel89.BeforeLoadDFMValues;
  WebLabel90.BeforeLoadDFMValues;
  WebLabel91.BeforeLoadDFMValues;
  WebDBEdit23.BeforeLoadDFMValues;
  WebDBEdit32.BeforeLoadDFMValues;
  WebDBLookupComboBox1.BeforeLoadDFMValues;
  WebDBCheckBox2.BeforeLoadDFMValues;
  WebDBCheckBox3.BeforeLoadDFMValues;
  wgbAuthentication.BeforeLoadDFMValues;
  WebLabel92.BeforeLoadDFMValues;
  WebLabel93.BeforeLoadDFMValues;
  WebDBEdit33.BeforeLoadDFMValues;
  WebDBEdit34.BeforeLoadDFMValues;
  wpcSysSetupSheet7.BeforeLoadDFMValues;
  WebPanel13.BeforeLoadDFMValues;
  WebSpeedButton8.BeforeLoadDFMValues;
  WebSpeedButton9.BeforeLoadDFMValues;
  WebSpeedButton10.BeforeLoadDFMValues;
  WebSpeedButton11.BeforeLoadDFMValues;
  WebSpeedButton12.BeforeLoadDFMValues;
  WebPanel14.BeforeLoadDFMValues;
  btnVatTableFirst.BeforeLoadDFMValues;
  btnVattablePrior.BeforeLoadDFMValues;
  btnVattableNext.BeforeLoadDFMValues;
  btnVattableLast.BeforeLoadDFMValues;
  edtVattablePagecount.BeforeLoadDFMValues;
  dgVatSetup.BeforeLoadDFMValues;
  dbagVatSetup.BeforeLoadDFMValues;
  msgdlgVattable.BeforeLoadDFMValues;
  wpcSysSetupSheet8.BeforeLoadDFMValues;
  WebPanel16.BeforeLoadDFMValues;
  WebSpeedButton13.BeforeLoadDFMValues;
  WebSpeedButton14.BeforeLoadDFMValues;
  WebSpeedButton15.BeforeLoadDFMValues;
  WebSpeedButton16.BeforeLoadDFMValues;
  WebSpeedButton17.BeforeLoadDFMValues;
  WebPanel22.BeforeLoadDFMValues;
  edtGLAPC.BeforeLoadDFMValues;
  sbtnGlaFirst.BeforeLoadDFMValues;
  sbtnGLAPrior.BeforeLoadDFMValues;
  sbtnGLANext.BeforeLoadDFMValues;
  sbtnGLALast.BeforeLoadDFMValues;
  dgGLA.BeforeLoadDFMValues;
  dbagGLA.BeforeLoadDFMValues;
  msgdlgGLA.BeforeLoadDFMValues;
  wpcSysSetupSheet9.BeforeLoadDFMValues;
  WebPanel23.BeforeLoadDFMValues;
  WebSpeedButton20.BeforeLoadDFMValues;
  WebSpeedButton21.BeforeLoadDFMValues;
  WebSpeedButton22.BeforeLoadDFMValues;
  WebSpeedButton23.BeforeLoadDFMValues;
  WebSpeedButton24.BeforeLoadDFMValues;
  WebPanel24.BeforeLoadDFMValues;
  btnSystemLedgerFirst.BeforeLoadDFMValues;
  btnSystemLedgerPrior.BeforeLoadDFMValues;
  btnSystemLedgerNext.BeforeLoadDFMValues;
  btnSystemLedgerLast.BeforeLoadDFMValues;
  edtSystemLedger.BeforeLoadDFMValues;
  dgSystemLedger.BeforeLoadDFMValues;
  dbagSystemLedger.BeforeLoadDFMValues;
  msgdlgSystemLedger.BeforeLoadDFMValues;
  wpcSysSetupSheet10.BeforeLoadDFMValues;
  WebCheckListBox1.BeforeLoadDFMValues;
  WebPageControl2.BeforeLoadDFMValues;
  WebPageControl2Sheet1.BeforeLoadDFMValues;
  WebPanel32.BeforeLoadDFMValues;
  WebLabel98.BeforeLoadDFMValues;
  WebLabel99.BeforeLoadDFMValues;
  WebLabel100.BeforeLoadDFMValues;
  WebLabel101.BeforeLoadDFMValues;
  WebLabel102.BeforeLoadDFMValues;
  edtTFNUrl.BeforeLoadDFMValues;
  edtTFNUser.BeforeLoadDFMValues;
  edtTFNPassword.BeforeLoadDFMValues;
  edtTFNAPIKey.BeforeLoadDFMValues;
  edtTFNAccount.BeforeLoadDFMValues;
  WebPanel25.BeforeLoadDFMValues;
  TFNSubAccountsFirst.BeforeLoadDFMValues;
  TFNSubAccountsPrior.BeforeLoadDFMValues;
  TFNSubAccountsNext.BeforeLoadDFMValues;
  WebSpeedButton28.BeforeLoadDFMValues;
  edtTFNSubAccounts.BeforeLoadDFMValues;
  WebPanel27.BeforeLoadDFMValues;
  WebSpeedButton25.BeforeLoadDFMValues;
  WebSpeedButton26.BeforeLoadDFMValues;
  WebSpeedButton27.BeforeLoadDFMValues;
  WebSpeedButton29.BeforeLoadDFMValues;
  WebSpeedButton30.BeforeLoadDFMValues;
  dgTFN1.BeforeLoadDFMValues;
  dbagTFNSubaccounts1.BeforeLoadDFMValues;
  WebPageControl2Sheet2.BeforeLoadDFMValues;
  WebPanel33.BeforeLoadDFMValues;
  WebLabel97.BeforeLoadDFMValues;
  WebLabel103.BeforeLoadDFMValues;
  WebLabel104.BeforeLoadDFMValues;
  WebLabel105.BeforeLoadDFMValues;
  WebLabel106.BeforeLoadDFMValues;
  WebLabel107.BeforeLoadDFMValues;
  edtFMSUrl.BeforeLoadDFMValues;
  edtFMSUser.BeforeLoadDFMValues;
  edtFMSPass.BeforeLoadDFMValues;
  edtFMSAPIKey.BeforeLoadDFMValues;
  edtFMSAccount.BeforeLoadDFMValues;
  Edit22.BeforeLoadDFMValues;
  WebPanel26.BeforeLoadDFMValues;
  WebSpeedButton31.BeforeLoadDFMValues;
  WebSpeedButton32.BeforeLoadDFMValues;
  WebSpeedButton33.BeforeLoadDFMValues;
  WebSpeedButton34.BeforeLoadDFMValues;
  WebSpeedButton35.BeforeLoadDFMValues;
  WebPanel28.BeforeLoadDFMValues;
  sbtnTFNSubAccountsS2First.BeforeLoadDFMValues;
  sbtnTFNSubAccountsS2prior.BeforeLoadDFMValues;
  sbtnTFNSubAccountsS2Next.BeforeLoadDFMValues;
  sbtnTFNSubAccountsS2Last.BeforeLoadDFMValues;
  edtTFNSubAccountsS2.BeforeLoadDFMValues;
  dgTFNSubAccounts2.BeforeLoadDFMValues;
  dbagTFNSubAccountsS2.BeforeLoadDFMValues;
  WebMessageDlg1.BeforeLoadDFMValues;
  WebPageControl2Sheet4.BeforeLoadDFMValues;
  WebPanel35.BeforeLoadDFMValues;
  WebLabel114.BeforeLoadDFMValues;
  WebLabel113.BeforeLoadDFMValues;
  WebLabel112.BeforeLoadDFMValues;
  edtFuelUUrl.BeforeLoadDFMValues;
  edtFuelUToken.BeforeLoadDFMValues;
  edtFuelUPassword.BeforeLoadDFMValues;
  WebPageControl2Sheet5.BeforeLoadDFMValues;
  WebPanel36.BeforeLoadDFMValues;
  WebLabel115.BeforeLoadDFMValues;
  WebLabel116.BeforeLoadDFMValues;
  WebLabel117.BeforeLoadDFMValues;
  WebLabel118.BeforeLoadDFMValues;
  WebLabel119.BeforeLoadDFMValues;
  edtPremiPointUrl.BeforeLoadDFMValues;
  edtPremiPointUser.BeforeLoadDFMValues;
  edtPremiPointPassword.BeforeLoadDFMValues;
  edtPremiPointKey.BeforeLoadDFMValues;
  edtPremiPointAccount.BeforeLoadDFMValues;
  wpcSysSetupSheet11.BeforeLoadDFMValues;
  WebPanel37.BeforeLoadDFMValues;
  WebDBRadioGroup1.BeforeLoadDFMValues;
  wpcSysSetupSheet12.BeforeLoadDFMValues;
  WebPanel38.BeforeLoadDFMValues;
  WebLabel120.BeforeLoadDFMValues;
  WebLabel121.BeforeLoadDFMValues;
  WebLabel122.BeforeLoadDFMValues;
  WebLabel123.BeforeLoadDFMValues;
  WebLabel124.BeforeLoadDFMValues;
  WebLabel125.BeforeLoadDFMValues;
  WebLabel126.BeforeLoadDFMValues;
  WebLabel127.BeforeLoadDFMValues;
  WebLabel128.BeforeLoadDFMValues;
  WebLabel129.BeforeLoadDFMValues;
  WebDBCheckBox1.BeforeLoadDFMValues;
  WebDBCheckBox4.BeforeLoadDFMValues;
  WebDBCheckBox41.BeforeLoadDFMValues;
  WebDBCheckBox42.BeforeLoadDFMValues;
  WebDBComboBox1.BeforeLoadDFMValues;
  WebDBComboBox2.BeforeLoadDFMValues;
  WebDBComboBox3.BeforeLoadDFMValues;
  WebDBComboBox4.BeforeLoadDFMValues;
  WebDBEdit35.BeforeLoadDFMValues;
  WebDBEdit36.BeforeLoadDFMValues;
  WebDBEdit37.BeforeLoadDFMValues;
  WebDBEdit38.BeforeLoadDFMValues;
  WebDBEdit39.BeforeLoadDFMValues;
  WebDBEdit40.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  btnSave.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  wcCompInfo.BeforeLoadDFMValues;
  wdsCompInfo.BeforeLoadDFMValues;
  wdsCompInfoSSCLoadConLoadDate.BeforeLoadDFMValues;
  wdsCompInfoSSCLoadConOffLoadDate.BeforeLoadDFMValues;
  wdsCompInfoSSCLOADCONRECEIVEDATE.BeforeLoadDFMValues;
  wdsCompInfoSSCLOADCONCOMPLETEDATE.BeforeLoadDFMValues;
  wdsCompInfoSSCLOADCONLOADTIME.BeforeLoadDFMValues;
  wdsCompInfoSSCLOADCONOFFLOADTIME.BeforeLoadDFMValues;
  wdsCompInfoSSCLOADCONRECEIVETIME.BeforeLoadDFMValues;
  wdsCompInfoSSCLOADCONCOMPLETETIME.BeforeLoadDFMValues;
  wdsCompInfoSSCLOADCONLOADDATEC.BeforeLoadDFMValues;
  wdsCompInfoSSCLOADCONOFFLOADDATEC.BeforeLoadDFMValues;
  wdsCompInfoSSCLOADCONRECEIVEDATEC.BeforeLoadDFMValues;
  wdsCompInfoSSCLOADCONCOMPLETEDATEC.BeforeLoadDFMValues;
  wdsCompInfoSSCLOADCONLOADTIMEC.BeforeLoadDFMValues;
  wdsCompInfoSSCLOADCONOFFLOADTIMEC.BeforeLoadDFMValues;
  wdsCompInfoSSCLOADCONRECEIVETIMEC.BeforeLoadDFMValues;
  wdsCompInfoSSCLOADCONCOMPLETETIMEC.BeforeLoadDFMValues;
  wdsCompInfoUSEFINLINKSYSTEM.BeforeLoadDFMValues;
  wdsCompInfoFINLINKSYSTEM.BeforeLoadDFMValues;
  wdsCompInfoAUTOMAILSYSTEM.BeforeLoadDFMValues;
  wdsCompInfoFINDBSETUP.BeforeLoadDFMValues;
  wdsCompInfoMAILSERVER.BeforeLoadDFMValues;
  wdsCompInfoMAILSERVERPORT.BeforeLoadDFMValues;
  wdsCompInfoMAILSERVERAUTH.BeforeLoadDFMValues;
  wdsCompInfoMAILSERVERUSER.BeforeLoadDFMValues;
  wdsCompInfoMAILSERVERPASS.BeforeLoadDFMValues;
  wdsCompInfoMAILSERVERSSL.BeforeLoadDFMValues;
  wdsCompInfoMAILSERVERPROTOCOL.BeforeLoadDFMValues;
  wdsCompInfoMAILSERVERSIGNATURE.BeforeLoadDFMValues;
  wdsCompInfoMAILSERVERENCRYPTION.BeforeLoadDFMValues;
  wdsCompInfoMAILSERVERENCODING.BeforeLoadDFMValues;
  wdsCompInfoDCLPERC.BeforeLoadDFMValues;
  wdsCompInfoBANKSTATEMENT.BeforeLoadDFMValues;
  wdsCompInfoSSFLOADCONLOADDATEC.BeforeLoadDFMValues;
  wdsCompInfoSSFLOADCONOFFLOADDATEC.BeforeLoadDFMValues;
  wdsCompInfoSSFLOADCONRECEIVEDATEC.BeforeLoadDFMValues;
  wdsCompInfoSSFLOADCONCOMPLETEDATEC.BeforeLoadDFMValues;
  wdsCompInfoSSFLOADCONLOADTIMEC.BeforeLoadDFMValues;
  wdsCompInfoSSFLOADCONOFFLOADTIMEC.BeforeLoadDFMValues;
  wdsCompInfoSSFLOADCONRECEIVETIMEC.BeforeLoadDFMValues;
  wdsCompInfoSSFLOADCONCOMPLETETIMEC.BeforeLoadDFMValues;
  wdsCompInfoFORCEDIESELDRIVER.BeforeLoadDFMValues;
  wdsCompInfoFORCELOADDRIVER.BeforeLoadDFMValues;
  wdsCompInfoDEFDIESELORDERS.BeforeLoadDFMValues;
  wdsCompInfoDEFLOADORDERS.BeforeLoadDFMValues;
  wdsCompInfoINVOICESYSTEM.BeforeLoadDFMValues;
  wdsCompInfoBTBRANCHCODE.BeforeLoadDFMValues;
  wdsCompInfoBTACCOUNTNO.BeforeLoadDFMValues;
  wdsCompInfoTRIPSHEETTYPE.BeforeLoadDFMValues;
  wdsCompInfoLOADCUSTOMERS.BeforeLoadDFMValues;
  wdsCompInfoFINLINKSYSTEMCOUNT.BeforeLoadDFMValues;
  wdsCompInfoFIN1NAME.BeforeLoadDFMValues;
  wdsCompInfoFIN2NAME.BeforeLoadDFMValues;
  wdsCompInfoUSEDOCKETNOINVNO.BeforeLoadDFMValues;
  wdsCompInfoUSEADDINFONONCON.BeforeLoadDFMValues;
  wdsCompInfoSTATEMENTTYPE.BeforeLoadDFMValues;
  wdsCompInfoSTOCKSTDPERC.BeforeLoadDFMValues;
  wdsCompInfoSTOCKDEDPERC.BeforeLoadDFMValues;
  wdsCompInfoSTOCKSPEPERC.BeforeLoadDFMValues;
  wdsCompInfoEMPADDCOMDESC.BeforeLoadDFMValues;
  wdsCompInfoNONCONDISPLAYFUEL.BeforeLoadDFMValues;
  wdsCompInfoADD1DESC.BeforeLoadDFMValues;
  wdsCompInfoADD2DESC.BeforeLoadDFMValues;
  wdsCompInfoADD3DESC.BeforeLoadDFMValues;
  wdsCompInfoADD4DESC.BeforeLoadDFMValues;
  wdsCompInfoADD5DESC.BeforeLoadDFMValues;
  wdsCompInfoADD6DESC.BeforeLoadDFMValues;
  wdsCompInfoADD7DESC.BeforeLoadDFMValues;
  wdsCompInfoPOSTALADDRESS1.BeforeLoadDFMValues;
  wdsCompInfoPOSTALADDRESS2.BeforeLoadDFMValues;
  wdsCompInfoPOSTALADDRESS3.BeforeLoadDFMValues;
  wdsCompInfoPOSTALADDRESS4.BeforeLoadDFMValues;
  wdsCompInfoPOSTALCODE.BeforeLoadDFMValues;
  wdsCompInfoUSEMULTICOMPANYINVOICE.BeforeLoadDFMValues;
  wdsCompInfoMISCINVLOADS.BeforeLoadDFMValues;
  wdsCompInfoPRINTTOTALSSEND.BeforeLoadDFMValues;
  wdsCompInfoWEBSERVERADDRESS.BeforeLoadDFMValues;
  wdsCompInfoWEBSERVERPORT.BeforeLoadDFMValues;
  wdsCompInfoWEBSERVERUSER.BeforeLoadDFMValues;
  wdsCompInfoWEBSERVERPASSWORD.BeforeLoadDFMValues;
  wdsCompInfoWEBSERVERSCANAPI.BeforeLoadDFMValues;
  wdsCompInfoDBSERVERADDRESS.BeforeLoadDFMValues;
  wdsCompInfoDBSERVERPORT.BeforeLoadDFMValues;
  wdsCompInfoINTERNALADDRESS.BeforeLoadDFMValues;
  wdsCompInfoINTERNALPORT.BeforeLoadDFMValues;
  wdsCompInfoWEBSERVERDB.BeforeLoadDFMValues;
  wdsCompInfoWEBSERVERDBUSER.BeforeLoadDFMValues;
  wdsCompInfoWEBSERVERDBPASS.BeforeLoadDFMValues;
  wdsCompInfoUNIQUEORDER.BeforeLoadDFMValues;
  wdsCompInfoUNIQUEWAYBILLS.BeforeLoadDFMValues;
  wdsCompInfoUNIQUEWASHBAYDOCKET.BeforeLoadDFMValues;
  wdsCompInfoIMPORTPERIOD.BeforeLoadDFMValues;
  wdsCompInfoIMPORTBATCH.BeforeLoadDFMValues;
  wdsCompInfoPRINTLOADSAVE.BeforeLoadDFMValues;
  wdsCompInfoNOFUTUREINVDATE.BeforeLoadDFMValues;
  wdsCompInfoUNIQUESHORTDESC.BeforeLoadDFMValues;
  wdsCompInfoCUSTMISCTYPE.BeforeLoadDFMValues;
  wdsCompInfoSUPPMISCTYPE.BeforeLoadDFMValues;
  wdsCompInfoJOBCARDPREFIX.BeforeLoadDFMValues;
  wdsCompInfoREQUESTPREFIX.BeforeLoadDFMValues;
  wdsCompInfoORDERSPREFIX.BeforeLoadDFMValues;
  wdsCompInfoMISCGLFORCE.BeforeLoadDFMValues;
  wdsCompInfoSUBUNINVSHOW.BeforeLoadDFMValues;
  wdsCompInfoemployeedemerit.BeforeLoadDFMValues;
  wdsCompInfovehicledemerit.BeforeLoadDFMValues;
  wdsCompInfomonitorvehiclechanges.BeforeLoadDFMValues;
  wdsCompInfomonitordieselupfrontcl.BeforeLoadDFMValues;
  wdsCompInfomonitorloadssub.BeforeLoadDFMValues;
  wdsCompInfomonitorcancelloads.BeforeLoadDFMValues;
  wdsCompInfocheckdieselordersdays.BeforeLoadDFMValues;
  wdsCompInfoJobCompType.BeforeLoadDFMValues;
  wdsCompInfofinesbrnno.BeforeLoadDFMValues;
  wdsCompInfofinesidno.BeforeLoadDFMValues;
  wdsCompInfosmsdiesel.BeforeLoadDFMValues;
  wdsCompInfosmsdieselurl.BeforeLoadDFMValues;
  wdsCompInfosmsdieseluser.BeforeLoadDFMValues;
  wdsCompInfosmsdieselpassword.BeforeLoadDFMValues;
  wdsCompInfoINSTRUCTORDER.BeforeLoadDFMValues;
  wdsCompInfowashbayinvloads.BeforeLoadDFMValues;
  wdsCompInfosubsoverrite.BeforeLoadDFMValues;
  wdsCompInfocommissiontype.BeforeLoadDFMValues;
  wdsCompInfoallowdieselproforma.BeforeLoadDFMValues;
  wdsCompInfoforcescandocs.BeforeLoadDFMValues;
  wdsCompInfoBANKDETAIL5.BeforeLoadDFMValues;
  wdsCompInfoBANKDETAILS6.BeforeLoadDFMValues;
  wdsCompInfoBANKDETAILS7.BeforeLoadDFMValues;
  wdsCompInfoBANKDETAILS8.BeforeLoadDFMValues;
  wdsCompInfologo.BeforeLoadDFMValues;
  wdsCompInfoautocanceldieselorders.BeforeLoadDFMValues;
  wdsCompInfoautocanceldieselordersdays.BeforeLoadDFMValues;
  wdsCompInfosendloadconsprocess.BeforeLoadDFMValues;
  wdsCompInfoloadcoscutoffdate.BeforeLoadDFMValues;
  wdsCompInfodieselcutoffdate.BeforeLoadDFMValues;
  wdsCompInfohidecanceloadsplanning.BeforeLoadDFMValues;
  wdsCompInfoincrementdocketno.BeforeLoadDFMValues;
  wdsCompInfolinklastdriver.BeforeLoadDFMValues;
  wdsCompInfoplanningshortdesc.BeforeLoadDFMValues;
  wdsCompInfoallowreprint.BeforeLoadDFMValues;
  wdsCompInforemovesubinvdocs.BeforeLoadDFMValues;
  wdsCompInfoloadsmustreceived.BeforeLoadDFMValues;
  wdsCompInfofnbcontractid.BeforeLoadDFMValues;
  wdsCompInfofnbclientid.BeforeLoadDFMValues;
  wdsCompInfofnbdeblistcount.BeforeLoadDFMValues;
  wdsCompInfofnbcredlistcount.BeforeLoadDFMValues;
  wdsCompInfofnblastdebdate.BeforeLoadDFMValues;
  wdsCompInfofnblastcreddate.BeforeLoadDFMValues;
  wdsCompInfofnblastdebamount.BeforeLoadDFMValues;
  wdsCompInfofnblastcredamount.BeforeLoadDFMValues;
  wdsCompInfofnbclienttype.BeforeLoadDFMValues;
  wdsCompInfolinkloadsvat.BeforeLoadDFMValues;
  wdsCompInfomarkmultiloadready.BeforeLoadDFMValues;
  wdsCompInfobulkdieselinvoices.BeforeLoadDFMValues;
  wdsCompInfoclearbulkinvoices.BeforeLoadDFMValues;
  wdsCompInfogetsageonlinebalance.BeforeLoadDFMValues;
  wdsCompInfousesageonlinebalancefordiesel.BeforeLoadDFMValues;
  wdsCompInfoapiserverurl.BeforeLoadDFMValues;
  wdsCompInfoapiusername.BeforeLoadDFMValues;
  wdsCompInfoapipassword.BeforeLoadDFMValues;
  wdsCompInfoapikey.BeforeLoadDFMValues;
  wdsCompInfofuelconsumptionfullfills.BeforeLoadDFMValues;
  wdsCompInfousenewscan.BeforeLoadDFMValues;
  wdsCompInfobasescanfolder.BeforeLoadDFMValues;
  wdsCompInfoftpserver.BeforeLoadDFMValues;
  wdsCompInfoftpport.BeforeLoadDFMValues;
  wdsCompInfoftpuser.BeforeLoadDFMValues;
  wdsCompInfoftppassword.BeforeLoadDFMValues;
  wdsCompInfomulticontroller.BeforeLoadDFMValues;
  wdsCompInfolastshiftno.BeforeLoadDFMValues;
  wdsCompInfodieselnonretail.BeforeLoadDFMValues;
  wdsCompInfoemailaddress.BeforeLoadDFMValues;
  wdsCompInfojobnullqty.BeforeLoadDFMValues;
  wdsCompInfojoborder.BeforeLoadDFMValues;
  wdsCompInfojobcardtype.BeforeLoadDFMValues;
  wdsCompInfomaintforcegl.BeforeLoadDFMValues;
  wdsCompInfocompemail.BeforeLoadDFMValues;
  wdsCompInfoerrormails.BeforeLoadDFMValues;
  wdsCompInfoADDRESS1.BeforeLoadDFMValues;
  wdsCompInfoADDRESS2.BeforeLoadDFMValues;
  wdsCompInfoADDRESS3.BeforeLoadDFMValues;
  wdsCompInfoADDRESS4.BeforeLoadDFMValues;
  wdsCompInfoADDRESSCODE.BeforeLoadDFMValues;
  wdsCompInfoCOMPANYNAME.BeforeLoadDFMValues;
  wdsCompInfoCOMPANYFAX.BeforeLoadDFMValues;
  wdsCompInfoCOMPANYTEL.BeforeLoadDFMValues;
  wdsCompInfoCOMPANYREG.BeforeLoadDFMValues;
  wdsCompInfoCOMPANYVAT.BeforeLoadDFMValues;
  wdsCompInfoLOGOPATH.BeforeLoadDFMValues;
  wdsCompInfoUSEDIFFCOMP.BeforeLoadDFMValues;
  wdsCompInfoBANKDETAILS1.BeforeLoadDFMValues;
  wdsCompInfoBANKDETAILS2.BeforeLoadDFMValues;
  wdsCompInfoBANKDETAILS3.BeforeLoadDFMValues;
  wdsCompInfoBANKDETAILS4.BeforeLoadDFMValues;
  wdsCompInfoLOADCONTYPE.BeforeLoadDFMValues;
  wdsCompInfoLOADCONPREFIX.BeforeLoadDFMValues;
  wdsCompInfoCompanyCode.BeforeLoadDFMValues;
  wdsCompInfoSSUNIQUECLIENTDOCKET.BeforeLoadDFMValues;
  dsCompInfo.BeforeLoadDFMValues;
  wcNumbers.BeforeLoadDFMValues;
  wdsNumbers.BeforeLoadDFMValues;
  wdsNumbersTranType.BeforeLoadDFMValues;
  wdsNumbersPrefix.BeforeLoadDFMValues;
  wdsNumbersDescription.BeforeLoadDFMValues;
  wdsNumbersSuffix.BeforeLoadDFMValues;
  dsNumbers.BeforeLoadDFMValues;
  wdsFinSystem.BeforeLoadDFMValues;
  dsFinSystem.BeforeLoadDFMValues;
  wcFinSystem.BeforeLoadDFMValues;
  dsVattable.BeforeLoadDFMValues;
  wdsVattable.BeforeLoadDFMValues;
  wdsVattableVATPERC.BeforeLoadDFMValues;
  wdsVattableSTARTDATE.BeforeLoadDFMValues;
  wdsVattableENDATE.BeforeLoadDFMValues;
  wdsVattableAuto.BeforeLoadDFMValues;
  wcVattable.BeforeLoadDFMValues;
  wdsGLA.BeforeLoadDFMValues;
  wdsGLAGLCODE.BeforeLoadDFMValues;
  wdsGLAGLDESCRIPTION.BeforeLoadDFMValues;
  wdsGLASUSPENDED.BeforeLoadDFMValues;
  wdsGLAbankaccount.BeforeLoadDFMValues;
  wdsGLAbankcard.BeforeLoadDFMValues;
  dsGLA.BeforeLoadDFMValues;
  wcGLA.BeforeLoadDFMValues;
  wdsSystemLedgerAccounts.BeforeLoadDFMValues;
  wdsSystemLedgerAccountsGLDESCRIPTION.BeforeLoadDFMValues;
  wdsSystemLedgerAccountsFleetDesc.BeforeLoadDFMValues;
  wdsSystemLedgerAccountsValueTypesDesc.BeforeLoadDFMValues;
  wdsSystemLedgerAccountsSystemDesc.BeforeLoadDFMValues;
  wdsSystemLedgerAccountsGLCode.BeforeLoadDFMValues;
  wdsSystemLedgerAccountscompanygldetail_Auto.BeforeLoadDFMValues;
  wcSystemLedgerAccounts.BeforeLoadDFMValues;
  dsSystemLedgerAccounts.BeforeLoadDFMValues;
  wdsTFNSubAccountsS1.BeforeLoadDFMValues;
  wdsTFNSubAccountsS1ApiServerNo.BeforeLoadDFMValues;
  wdsTFNSubAccountsS1SubContractNo.BeforeLoadDFMValues;
  wdsTFNSubAccountsS1ApiAccountNo.BeforeLoadDFMValues;
  wdsTFNSubAccountsS1LastRunDate.BeforeLoadDFMValues;
  wdsTFNSubAccountsS1SubsRegNo.BeforeLoadDFMValues;
  wdsTFNSubAccountsS1CRName.BeforeLoadDFMValues;
  dsTFNSubAccountsS1.BeforeLoadDFMValues;
  wcTFNSubAccountsS1.BeforeLoadDFMValues;
  wcTFNSubAccountsS2.BeforeLoadDFMValues;
  wdsTFNSubAccountsS2.BeforeLoadDFMValues;
  wdsTFNSubAccountsS2ApiServerNo.BeforeLoadDFMValues;
  wdsTFNSubAccountsS2SubContractNo.BeforeLoadDFMValues;
  wdsTFNSubAccountsS2ApiAccountNo.BeforeLoadDFMValues;
  wdsTFNSubAccountsS2LastRunDate.BeforeLoadDFMValues;
  wdsTFNSubAccountsS2SubsRegNo.BeforeLoadDFMValues;
  wdsTFNSubAccountsS2CRName.BeforeLoadDFMValues;
  dsTFNSubAccountsS2.BeforeLoadDFMValues;
  wdsFinLinkSystem.BeforeLoadDFMValues;
  wdsFinLinkSystemFinNo.BeforeLoadDFMValues;
  wdsFinLinkSystemFinName.BeforeLoadDFMValues;
  wdsFinLinkSystemFinActive.BeforeLoadDFMValues;
  dsFinLinkSystem.BeforeLoadDFMValues;
  wcFinLinkSystem.BeforeLoadDFMValues;
  try
    Name := 'frmSystemSettings';
    Width := 1556;
    Height := 750;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 1556;
    WebPanel1.Height := 750;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 1556;
    WebPanel2.Height := 49;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'System Setup';
    WebPanel2.Color := clSilver;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    WebResponsiveManager1.SetParentComponent(WebPanel2);
    WebResponsiveManager1.Name := 'WebResponsiveManager1';
    WebResponsiveManager1.Left := 13;
    WebResponsiveManager1.Top := 12;
    WebResponsiveManager1.Width := 26;
    WebResponsiveManager1.Height := 26;
    WebResponsiveManager1.Visible := True;
    WebResponsiveManager1.Control := Self;
    BitmapContainer1.SetParentComponent(WebPanel2);
    BitmapContainer1.Name := 'BitmapContainer1';
    BitmapContainer1.Left := 1254;
    BitmapContainer1.Top := 3;
    BitmapContainer1.Width := 26;
    BitmapContainer1.Height := 26;
    BitmapContainer1.Visible := True;
    BitmapContainer1.Items.Clear;
    with BitmapContainer1.Items.Add do
    begin
      Bitmap.LoadFromFile('SystemSettings.BitmapContainer1.Items.Bitmap.svg');
      Name := 'edit.svg';
      Tag := 0;
    end;
    with BitmapContainer1.Items.Add do
    begin
      Bitmap.LoadFromFile('SystemSettings.BitmapContainer1.Items.Bitmap_1.svg');
      Name := 'delete.svg';
      Tag := 0;
    end;
    wpcSysSetup.SetParentComponent(WebPanel1);
    wpcSysSetup.Name := 'wpcSysSetup';
    wpcSysSetup.Left := 0;
    wpcSysSetup.Top := 49;
    wpcSysSetup.Width := 1556;
    wpcSysSetup.Height := 649;
    wpcSysSetup.Align := alClient;
    wpcSysSetup.ChildOrder := 1;
    wpcSysSetup.TabIndex := 8;
    wpcSysSetup.TabOrder := 1;
    WebPageControl1Sheet1.SetParentComponent(wpcSysSetup);
    WebPageControl1Sheet1.Name := 'WebPageControl1Sheet1';
    WebPageControl1Sheet1.Left := 0;
    WebPageControl1Sheet1.Top := 20;
    WebPageControl1Sheet1.Width := 1556;
    WebPageControl1Sheet1.Height := 629;
    WebPageControl1Sheet1.Caption := 'Company Information';
    WebPageControl1Sheet1.Color := clSilver;
    WebPanel4.SetParentComponent(WebPageControl1Sheet1);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 0;
    WebPanel4.Top := 0;
    WebPanel4.Width := 1556;
    WebPanel4.Height := 629;
    WebPanel4.Align := alClient;
    WebPanel4.Color := clSilver;
    WebPanel4.TabOrder := 0;
    WebLabel2.SetParentComponent(WebPanel4);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 24;
    WebLabel2.Top := 14;
    WebLabel2.Width := 96;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'Company Name : ';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel4);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 24;
    WebLabel3.Top := 41;
    WebLabel3.Width := 99;
    WebLabel3.Height := 15;
    WebLabel3.Caption := 'Company Adress : ';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel4);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 320;
    WebLabel4.Top := 41;
    WebLabel4.Width := 79;
    WebLabel4.Height := 15;
    WebLabel4.Caption := 'Postal Adress : ';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebPanel4);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 24;
    WebLabel5.Top := 208;
    WebLabel5.Width := 77;
    WebLabel5.Height := 15;
    WebLabel5.Caption := 'Telephone No:';
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(WebPanel4);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 344;
    WebLabel7.Top := 208;
    WebLabel7.Width := 39;
    WebLabel7.Height := 15;
    WebLabel7.Caption := 'Fax No:';
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebLabel8.SetParentComponent(WebPanel4);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 672;
    WebLabel8.Top := 208;
    WebLabel8.Width := 57;
    WebLabel8.Height := 15;
    WebLabel8.Caption := 'Logo Path:';
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebLabel9.SetParentComponent(WebPanel4);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 24;
    WebLabel9.Top := 256;
    WebLabel9.Width := 85;
    WebLabel9.Height := 15;
    WebLabel9.Caption := 'Registration No:';
    WebLabel9.HeightPercent := 100.000000000000000000;
    WebLabel9.WidthPercent := 100.000000000000000000;
    WebLabel10.SetParentComponent(WebPanel4);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 344;
    WebLabel10.Top := 256;
    WebLabel10.Width := 38;
    WebLabel10.Height := 15;
    WebLabel10.Caption := 'Vat No:';
    WebLabel10.HeightPercent := 100.000000000000000000;
    WebLabel10.WidthPercent := 100.000000000000000000;
    WebLabel11.SetParentComponent(WebPanel4);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 672;
    WebLabel11.Top := 256;
    WebLabel11.Width := 106;
    WebLabel11.Height := 15;
    WebLabel11.Caption := 'Delivery Note Prefix:';
    WebLabel11.HeightPercent := 100.000000000000000000;
    WebLabel11.WidthPercent := 100.000000000000000000;
    WebLabel12.SetParentComponent(WebPanel4);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 24;
    WebLabel12.Top := 306;
    WebLabel12.Width := 155;
    WebLabel12.Height := 15;
    WebLabel12.Caption := 'Load Confirmation Template:';
    WebLabel12.HeightPercent := 100.000000000000000000;
    WebLabel12.WidthPercent := 100.000000000000000000;
    WebLabel13.SetParentComponent(WebPanel4);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 344;
    WebLabel13.Top := 306;
    WebLabel13.Width := 101;
    WebLabel13.Height := 15;
    WebLabel13.Caption := 'Tripsheet template:';
    WebLabel13.HeightPercent := 100.000000000000000000;
    WebLabel13.WidthPercent := 100.000000000000000000;
    WebLabel14.SetParentComponent(WebPanel4);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 672;
    WebLabel14.Top := 306;
    WebLabel14.Width := 109;
    WebLabel14.Height := 15;
    WebLabel14.Caption := 'Statement Template:';
    WebLabel14.HeightPercent := 100.000000000000000000;
    WebLabel14.WidthPercent := 100.000000000000000000;
    WebLabel15.SetParentComponent(WebPanel4);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 24;
    WebLabel15.Top := 350;
    WebLabel15.Width := 87;
    WebLabel15.Height := 15;
    WebLabel15.Caption := 'Company Email:';
    WebLabel15.HeightPercent := 100.000000000000000000;
    WebLabel15.WidthPercent := 100.000000000000000000;
    WebLabel16.SetParentComponent(WebPanel4);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 24;
    WebLabel16.Top := 409;
    WebLabel16.Width := 145;
    WebLabel16.Height := 15;
    WebLabel16.Caption := 'Bank Transfer Branch Code:';
    WebLabel16.HeightPercent := 100.000000000000000000;
    WebLabel16.WidthPercent := 100.000000000000000000;
    WebLabel17.SetParentComponent(WebPanel4);
    WebLabel17.Name := 'WebLabel17';
    WebLabel17.Left := 344;
    WebLabel17.Top := 409;
    WebLabel17.Width := 141;
    WebLabel17.Height := 15;
    WebLabel17.Caption := 'Bank Transfer Account No:';
    WebLabel17.HeightPercent := 100.000000000000000000;
    WebLabel17.WidthPercent := 100.000000000000000000;
    WebLabel18.SetParentComponent(WebPanel4);
    WebLabel18.Name := 'WebLabel18';
    WebLabel18.Left := 672;
    WebLabel18.Top := 409;
    WebLabel18.Width := 124;
    WebLabel18.Height := 15;
    WebLabel18.Caption := 'Load Instruction/Order:';
    WebLabel18.HeightPercent := 100.000000000000000000;
    WebLabel18.WidthPercent := 100.000000000000000000;
    WebDBImageControl1.SetParentComponent(WebPanel4);
    WebDBImageControl1.Name := 'WebDBImageControl1';
    WebDBImageControl1.Left := 975;
    WebDBImageControl1.Top := 18;
    WebDBImageControl1.Width := 290;
    WebDBImageControl1.Height := 165;
    WebDBImageControl1.HeightPercent := 100.000000000000000000;
    WebDBImageControl1.WidthPercent := 100.000000000000000000;
    WebDBImageControl1.ChildOrder := 41;
    WebDBImageControl1.DataField := 'logo';
    WebDBImageControl1.DataSource := dsCompInfo;
    edtCompName.SetParentComponent(WebPanel4);
    edtCompName.Name := 'edtCompName';
    edtCompName.Left := 154;
    edtCompName.Top := 13;
    edtCompName.Width := 358;
    edtCompName.Height := 22;
    edtCompName.ChildOrder := 2;
    edtCompName.Color := clWhite;
    edtCompName.HeightPercent := 100.000000000000000000;
    edtCompName.WidthPercent := 100.000000000000000000;
    edtCompName.DataField := 'COMPANYNAME';
    edtCompName.DataSource := dsCompInfo;
    edtCompAddress1.SetParentComponent(WebPanel4);
    edtCompAddress1.Name := 'edtCompAddress1';
    edtCompAddress1.Left := 25;
    edtCompAddress1.Top := 61;
    edtCompAddress1.Width := 192;
    edtCompAddress1.Height := 22;
    edtCompAddress1.ChildOrder := 4;
    edtCompAddress1.HeightPercent := 100.000000000000000000;
    edtCompAddress1.WidthPercent := 100.000000000000000000;
    edtCompAddress1.DataField := 'ADDRESS1';
    edtCompAddress1.DataSource := dsCompInfo;
    edtCompAddress2.SetParentComponent(WebPanel4);
    edtCompAddress2.Name := 'edtCompAddress2';
    edtCompAddress2.Left := 24;
    edtCompAddress2.Top := 86;
    edtCompAddress2.Width := 192;
    edtCompAddress2.Height := 22;
    edtCompAddress2.ChildOrder := 5;
    edtCompAddress2.HeightPercent := 100.000000000000000000;
    edtCompAddress2.WidthPercent := 100.000000000000000000;
    edtCompAddress2.DataField := 'ADDRESS2';
    edtCompAddress2.DataSource := dsCompInfo;
    edtCompAddress3.SetParentComponent(WebPanel4);
    edtCompAddress3.Name := 'edtCompAddress3';
    edtCompAddress3.Left := 24;
    edtCompAddress3.Top := 111;
    edtCompAddress3.Width := 192;
    edtCompAddress3.Height := 22;
    edtCompAddress3.ChildOrder := 6;
    edtCompAddress3.HeightPercent := 100.000000000000000000;
    edtCompAddress3.WidthPercent := 100.000000000000000000;
    edtCompAddress3.DataField := 'ADDRESS3';
    edtCompAddress3.DataSource := dsCompInfo;
    edtCompAddress4.SetParentComponent(WebPanel4);
    edtCompAddress4.Name := 'edtCompAddress4';
    edtCompAddress4.Left := 24;
    edtCompAddress4.Top := 136;
    edtCompAddress4.Width := 192;
    edtCompAddress4.Height := 22;
    edtCompAddress4.ChildOrder := 7;
    edtCompAddress4.HeightPercent := 100.000000000000000000;
    edtCompAddress4.WidthPercent := 100.000000000000000000;
    edtCompAddress4.DataField := 'ADDRESS4';
    edtCompAddress4.DataSource := dsCompInfo;
    edtCompAddressCode.SetParentComponent(WebPanel4);
    edtCompAddressCode.Name := 'edtCompAddressCode';
    edtCompAddressCode.Left := 24;
    edtCompAddressCode.Top := 161;
    edtCompAddressCode.Width := 86;
    edtCompAddressCode.Height := 22;
    edtCompAddressCode.ChildOrder := 8;
    edtCompAddressCode.HeightPercent := 100.000000000000000000;
    edtCompAddressCode.WidthPercent := 100.000000000000000000;
    edtCompAddressCode.DataField := 'ADDRESSCODE';
    edtCompAddressCode.DataSource := dsCompInfo;
    edtPostalCode.SetParentComponent(WebPanel4);
    edtPostalCode.Name := 'edtPostalCode';
    edtPostalCode.Left := 320;
    edtPostalCode.Top := 161;
    edtPostalCode.Width := 86;
    edtPostalCode.Height := 22;
    edtPostalCode.ChildOrder := 8;
    edtPostalCode.HeightPercent := 100.000000000000000000;
    edtPostalCode.WidthPercent := 100.000000000000000000;
    edtPostalCode.DataField := 'POSTALCODE';
    edtPostalCode.DataSource := dsCompInfo;
    edtPostalAddress4.SetParentComponent(WebPanel4);
    edtPostalAddress4.Name := 'edtPostalAddress4';
    edtPostalAddress4.Left := 320;
    edtPostalAddress4.Top := 136;
    edtPostalAddress4.Width := 192;
    edtPostalAddress4.Height := 22;
    edtPostalAddress4.ChildOrder := 7;
    edtPostalAddress4.HeightPercent := 100.000000000000000000;
    edtPostalAddress4.WidthPercent := 100.000000000000000000;
    edtPostalAddress4.DataField := 'POSTALADDRESS4';
    edtPostalAddress4.DataSource := dsCompInfo;
    edtPostalAddress3.SetParentComponent(WebPanel4);
    edtPostalAddress3.Name := 'edtPostalAddress3';
    edtPostalAddress3.Left := 320;
    edtPostalAddress3.Top := 111;
    edtPostalAddress3.Width := 192;
    edtPostalAddress3.Height := 22;
    edtPostalAddress3.ChildOrder := 6;
    edtPostalAddress3.HeightPercent := 100.000000000000000000;
    edtPostalAddress3.WidthPercent := 100.000000000000000000;
    edtPostalAddress3.DataField := 'POSTALADDRESS3';
    edtPostalAddress3.DataSource := dsCompInfo;
    edtPostalAddress2.SetParentComponent(WebPanel4);
    edtPostalAddress2.Name := 'edtPostalAddress2';
    edtPostalAddress2.Left := 320;
    edtPostalAddress2.Top := 86;
    edtPostalAddress2.Width := 192;
    edtPostalAddress2.Height := 22;
    edtPostalAddress2.ChildOrder := 5;
    edtPostalAddress2.HeightPercent := 100.000000000000000000;
    edtPostalAddress2.WidthPercent := 100.000000000000000000;
    edtPostalAddress2.DataField := 'POSTALADDRESS2';
    edtPostalAddress2.DataSource := dsCompInfo;
    edtPostalAddress1.SetParentComponent(WebPanel4);
    edtPostalAddress1.Name := 'edtPostalAddress1';
    edtPostalAddress1.Left := 320;
    edtPostalAddress1.Top := 62;
    edtPostalAddress1.Width := 192;
    edtPostalAddress1.Height := 22;
    edtPostalAddress1.ChildOrder := 4;
    edtPostalAddress1.HeightPercent := 100.000000000000000000;
    edtPostalAddress1.WidthPercent := 100.000000000000000000;
    edtPostalAddress1.DataField := 'POSTALADDRESS1';
    edtPostalAddress1.DataSource := dsCompInfo;
    edtTelephone.SetParentComponent(WebPanel4);
    edtTelephone.Name := 'edtTelephone';
    edtTelephone.Left := 24;
    edtTelephone.Top := 233;
    edtTelephone.Width := 300;
    edtTelephone.Height := 22;
    edtTelephone.ChildOrder := 15;
    edtTelephone.HeightPercent := 100.000000000000000000;
    edtTelephone.WidthPercent := 100.000000000000000000;
    edtTelephone.DataField := 'COMPANYTEL';
    edtTelephone.DataSource := dsCompInfo;
    edtTaxNo.SetParentComponent(WebPanel4);
    edtTaxNo.Name := 'edtTaxNo';
    edtTaxNo.Left := 344;
    edtTaxNo.Top := 233;
    edtTaxNo.Width := 300;
    edtTaxNo.Height := 22;
    edtTaxNo.ChildOrder := 15;
    edtTaxNo.HeightPercent := 100.000000000000000000;
    edtTaxNo.WidthPercent := 100.000000000000000000;
    edtTaxNo.DataField := 'COMPANYFAX';
    edtTaxNo.DataSource := dsCompInfo;
    edtLogoPath.SetParentComponent(WebPanel4);
    edtLogoPath.Name := 'edtLogoPath';
    edtLogoPath.Left := 672;
    edtLogoPath.Top := 233;
    edtLogoPath.Width := 300;
    edtLogoPath.Height := 22;
    edtLogoPath.ChildOrder := 15;
    edtLogoPath.HeightPercent := 100.000000000000000000;
    edtLogoPath.WidthPercent := 100.000000000000000000;
    edtLogoPath.DataField := 'LogoPath';
    edtLogoPath.DataSource := dsCompInfo;
    edtRegistrationNo.SetParentComponent(WebPanel4);
    edtRegistrationNo.Name := 'edtRegistrationNo';
    edtRegistrationNo.Left := 24;
    edtRegistrationNo.Top := 281;
    edtRegistrationNo.Width := 300;
    edtRegistrationNo.Height := 22;
    edtRegistrationNo.ChildOrder := 15;
    edtRegistrationNo.HeightPercent := 100.000000000000000000;
    edtRegistrationNo.WidthPercent := 100.000000000000000000;
    edtRegistrationNo.DataField := 'COMPANYREG';
    edtRegistrationNo.DataSource := dsCompInfo;
    edtVatNo.SetParentComponent(WebPanel4);
    edtVatNo.Name := 'edtVatNo';
    edtVatNo.Left := 344;
    edtVatNo.Top := 281;
    edtVatNo.Width := 300;
    edtVatNo.Height := 22;
    edtVatNo.ChildOrder := 15;
    edtVatNo.HeightPercent := 100.000000000000000000;
    edtVatNo.WidthPercent := 100.000000000000000000;
    edtVatNo.DataField := 'COMPANYVAT';
    edtVatNo.DataSource := dsCompInfo;
    edtDeliveryNotePrefix.SetParentComponent(WebPanel4);
    edtDeliveryNotePrefix.Name := 'edtDeliveryNotePrefix';
    edtDeliveryNotePrefix.Left := 672;
    edtDeliveryNotePrefix.Top := 281;
    edtDeliveryNotePrefix.Width := 300;
    edtDeliveryNotePrefix.Height := 22;
    edtDeliveryNotePrefix.ChildOrder := 15;
    edtDeliveryNotePrefix.HeightPercent := 100.000000000000000000;
    edtDeliveryNotePrefix.WidthPercent := 100.000000000000000000;
    edtDeliveryNotePrefix.DataField := 'LOADCONPREFIX';
    edtDeliveryNotePrefix.DataSource := dsCompInfo;
    edtCompEmail.SetParentComponent(WebPanel4);
    edtCompEmail.Name := 'edtCompEmail';
    edtCompEmail.Left := 24;
    edtCompEmail.Top := 377;
    edtCompEmail.Width := 300;
    edtCompEmail.Height := 22;
    edtCompEmail.ChildOrder := 15;
    edtCompEmail.HeightPercent := 100.000000000000000000;
    edtCompEmail.WidthPercent := 100.000000000000000000;
    edtCompEmail.DataField := 'emailaddress';
    edtCompEmail.DataSource := dsCompInfo;
    edtBankTransferBranchCode.SetParentComponent(WebPanel4);
    edtBankTransferBranchCode.Name := 'edtBankTransferBranchCode';
    edtBankTransferBranchCode.Left := 24;
    edtBankTransferBranchCode.Top := 434;
    edtBankTransferBranchCode.Width := 300;
    edtBankTransferBranchCode.Height := 22;
    edtBankTransferBranchCode.ChildOrder := 15;
    edtBankTransferBranchCode.HeightPercent := 100.000000000000000000;
    edtBankTransferBranchCode.WidthPercent := 100.000000000000000000;
    edtBankTransferBranchCode.DataField := 'BTBRANCHCODE';
    edtBankTransferBranchCode.DataSource := dsCompInfo;
    WebPanel5.SetParentComponent(WebPanel4);
    WebPanel5.Name := 'WebPanel5';
    WebPanel5.Left := 991;
    WebPanel5.Top := 221;
    WebPanel5.Width := 274;
    WebPanel5.Height := 169;
    WebPanel5.BorderStyle := bsNone;
    WebPanel5.ChildOrder := 32;
    WebPanel5.Color := clSilver;
    WebPanel5.TabOrder := 19;
    WebLabel6.SetParentComponent(WebPanel5);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 26;
    WebLabel6.Top := 17;
    WebLabel6.Width := 81;
    WebLabel6.Height := 15;
    WebLabel6.Caption := 'Banking Details';
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.WidthPercent := 100.000000000000000000;
    edtBankDetails1.SetParentComponent(WebPanel5);
    edtBankDetails1.Name := 'edtBankDetails1';
    edtBankDetails1.Left := 23;
    edtBankDetails1.Top := 42;
    edtBankDetails1.Width := 221;
    edtBankDetails1.Height := 22;
    edtBankDetails1.ChildOrder := 23;
    edtBankDetails1.HeightPercent := 100.000000000000000000;
    edtBankDetails1.WidthPercent := 100.000000000000000000;
    edtBankDetails1.DataField := 'BANKDETAILS1';
    edtBankDetails1.DataSource := dsCompInfo;
    edtBankDetails2.SetParentComponent(WebPanel5);
    edtBankDetails2.Name := 'edtBankDetails2';
    edtBankDetails2.Left := 23;
    edtBankDetails2.Top := 68;
    edtBankDetails2.Width := 221;
    edtBankDetails2.Height := 22;
    edtBankDetails2.ChildOrder := 24;
    edtBankDetails2.HeightPercent := 100.000000000000000000;
    edtBankDetails2.WidthPercent := 100.000000000000000000;
    edtBankDetails2.DataField := 'BANKDETAILS2';
    edtBankDetails2.DataSource := dsCompInfo;
    edtBankDetails3.SetParentComponent(WebPanel5);
    edtBankDetails3.Name := 'edtBankDetails3';
    edtBankDetails3.Left := 23;
    edtBankDetails3.Top := 94;
    edtBankDetails3.Width := 221;
    edtBankDetails3.Height := 22;
    edtBankDetails3.ChildOrder := 25;
    edtBankDetails3.HeightPercent := 100.000000000000000000;
    edtBankDetails3.WidthPercent := 100.000000000000000000;
    edtBankDetails3.DataField := 'BANKDETAILS3';
    edtBankDetails3.DataSource := dsCompInfo;
    edtBankDetails4.SetParentComponent(WebPanel5);
    edtBankDetails4.Name := 'edtBankDetails4';
    edtBankDetails4.Left := 23;
    edtBankDetails4.Top := 119;
    edtBankDetails4.Width := 221;
    edtBankDetails4.Height := 22;
    edtBankDetails4.ChildOrder := 27;
    edtBankDetails4.HeightPercent := 100.000000000000000000;
    edtBankDetails4.WidthPercent := 100.000000000000000000;
    edtBankDetails4.DataField := 'BANKDETAILS4';
    edtBankDetails4.DataSource := dsCompInfo;
    cbxPrintOnStatement.SetParentComponent(WebPanel5);
    cbxPrintOnStatement.Name := 'cbxPrintOnStatement';
    cbxPrintOnStatement.Left := 139;
    cbxPrintOnStatement.Top := 18;
    cbxPrintOnStatement.Width := 113;
    cbxPrintOnStatement.Height := 22;
    cbxPrintOnStatement.Caption := 'cbxPrintOnStatement';
    cbxPrintOnStatement.ChildOrder := 30;
    cbxPrintOnStatement.HeightPercent := 100.000000000000000000;
    cbxPrintOnStatement.WidthPercent := 100.000000000000000000;
    SetEvent(cbxPrintOnStatement, Self, 'OnClick', 'cbxPrintOnStatementClick');
    cbxPrintOnStatement.DataField := 'BANKSTATEMENT';
    cbxPrintOnStatement.DataSource := dsCompInfo;
    edtBankTransferAccountNo.SetParentComponent(WebPanel4);
    edtBankTransferAccountNo.Name := 'edtBankTransferAccountNo';
    edtBankTransferAccountNo.Left := 344;
    edtBankTransferAccountNo.Top := 434;
    edtBankTransferAccountNo.Width := 300;
    edtBankTransferAccountNo.Height := 22;
    edtBankTransferAccountNo.ChildOrder := 41;
    edtBankTransferAccountNo.HeightPercent := 100.000000000000000000;
    edtBankTransferAccountNo.WidthPercent := 100.000000000000000000;
    edtBankTransferAccountNo.DataField := 'BTACCOUNTNO';
    edtBankTransferAccountNo.DataSource := dsCompInfo;
    WebDBComboBox5.SetParentComponent(WebPanel4);
    WebDBComboBox5.Name := 'WebDBComboBox5';
    WebDBComboBox5.Left := 23;
    WebDBComboBox5.Top := 324;
    WebDBComboBox5.Width := 145;
    WebDBComboBox5.Height := 23;
    WebDBComboBox5.HeightPercent := 100.000000000000000000;
    WebDBComboBox5.Text := 'WebDBComboBox5';
    WebDBComboBox5.WidthPercent := 100.000000000000000000;
    WebDBComboBox5.ItemIndex := -1;
    WebDBComboBox5.DataField := 'LoadConType';
    WebDBComboBox6.SetParentComponent(WebPanel4);
    WebDBComboBox6.Name := 'WebDBComboBox6';
    WebDBComboBox6.Left := 341;
    WebDBComboBox6.Top := 326;
    WebDBComboBox6.Width := 145;
    WebDBComboBox6.Height := 23;
    WebDBComboBox6.HeightPercent := 100.000000000000000000;
    WebDBComboBox6.Text := 'WebDBComboBox6';
    WebDBComboBox6.WidthPercent := 100.000000000000000000;
    WebDBComboBox6.ItemIndex := -1;
    WebDBComboBox6.DataSource := dsCompInfo;
    WebDBComboBox7.SetParentComponent(WebPanel4);
    WebDBComboBox7.Name := 'WebDBComboBox7';
    WebDBComboBox7.Left := 672;
    WebDBComboBox7.Top := 326;
    WebDBComboBox7.Width := 145;
    WebDBComboBox7.Height := 23;
    WebDBComboBox7.HeightPercent := 100.000000000000000000;
    WebDBComboBox7.Text := 'WebDBComboBox7';
    WebDBComboBox7.WidthPercent := 100.000000000000000000;
    WebDBComboBox7.ItemIndex := -1;
    WebDBComboBox7.DataField := 'STATEMENTTYPE';
    WebDBComboBox8.SetParentComponent(WebPanel4);
    WebDBComboBox8.Name := 'WebDBComboBox8';
    WebDBComboBox8.Left := 673;
    WebDBComboBox8.Top := 435;
    WebDBComboBox8.Width := 145;
    WebDBComboBox8.Height := 23;
    WebDBComboBox8.HeightPercent := 100.000000000000000000;
    WebDBComboBox8.Text := 'WebDBComboBox8';
    WebDBComboBox8.WidthPercent := 100.000000000000000000;
    WebDBComboBox8.ItemIndex := -1;
    WebPageControl1Sheet2.SetParentComponent(wpcSysSetup);
    WebPageControl1Sheet2.Name := 'WebPageControl1Sheet2';
    WebPageControl1Sheet2.Left := 0;
    WebPageControl1Sheet2.Top := 20;
    WebPageControl1Sheet2.Width := 1556;
    WebPageControl1Sheet2.Height := 629;
    WebPageControl1Sheet2.Caption := 'System Settings';
    WebPageControl1Sheet2.ChildOrder := 1;
    WebResponsiveManager3.SetParentComponent(WebPageControl1Sheet2);
    WebResponsiveManager3.Name := 'WebResponsiveManager3';
    WebResponsiveManager3.Left := 1254;
    WebResponsiveManager3.Top := 11;
    WebResponsiveManager3.Width := 26;
    WebResponsiveManager3.Height := 26;
    WebResponsiveManager3.Visible := True;
    WebResponsiveManager3.Control := Self;
    WebPanel8.SetParentComponent(WebPageControl1Sheet2);
    WebPanel8.Name := 'WebPanel8';
    WebPanel8.Left := 3;
    WebPanel8.Top := 5;
    WebPanel8.Width := 396;
    WebPanel8.Height := 261;
    WebPanel8.ChildOrder := 2;
    WebPanel8.Color := clSilver;
    WebPanel8.TabOrder := 1;
    WebLabel23.SetParentComponent(WebPanel8);
    WebLabel23.Name := 'WebLabel23';
    WebLabel23.Left := 5;
    WebLabel23.Top := 214;
    WebLabel23.Width := 192;
    WebLabel23.Height := 15;
    WebLabel23.Caption := 'Aarto Employee Max Report Points : ';
    WebLabel23.HeightPercent := 100.000000000000000000;
    WebLabel23.WidthPercent := 100.000000000000000000;
    WebLabel24.SetParentComponent(WebPanel8);
    WebLabel24.Name := 'WebLabel24';
    WebLabel24.Left := 5;
    WebLabel24.Top := 235;
    WebLabel24.Width := 203;
    WebLabel24.Height := 15;
    WebLabel24.Caption := 'Auto Cancel Diesel Orders After Days : ';
    WebLabel24.HeightPercent := 100.000000000000000000;
    WebLabel24.WidthPercent := 100.000000000000000000;
    WebDBEdit1.SetParentComponent(WebPanel8);
    WebDBEdit1.Name := 'WebDBEdit1';
    WebDBEdit1.Left := 259;
    WebDBEdit1.Top := 214;
    WebDBEdit1.Width := 121;
    WebDBEdit1.Height := 22;
    WebDBEdit1.ChildOrder := 10;
    WebDBEdit1.HeightPercent := 100.000000000000000000;
    WebDBEdit1.WidthPercent := 100.000000000000000000;
    WebDBEdit1.DataField := 'employeedemerit';
    WebDBEdit1.DataSource := dsCompInfo;
    WebDBEdit2.SetParentComponent(WebPanel8);
    WebDBEdit2.Name := 'WebDBEdit2';
    WebDBEdit2.Left := 259;
    WebDBEdit2.Top := 236;
    WebDBEdit2.Width := 121;
    WebDBEdit2.Height := 22;
    WebDBEdit2.ChildOrder := 11;
    WebDBEdit2.HeightPercent := 100.000000000000000000;
    WebDBEdit2.WidthPercent := 100.000000000000000000;
    WebDBEdit2.DataField := 'autocanceldieselordersdays';
    WebDBEdit2.DataSource := dsCompInfo;
    WebDBCheckBox5.SetParentComponent(WebPanel8);
    WebDBCheckBox5.Name := 'WebDBCheckBox5';
    WebDBCheckBox5.Left := 16;
    WebDBCheckBox5.Top := 3;
    WebDBCheckBox5.Width := 169;
    WebDBCheckBox5.Height := 22;
    WebDBCheckBox5.Caption := 'Force Driver on Diesel Order';
    WebDBCheckBox5.ChildOrder := 4;
    WebDBCheckBox5.HeightPercent := 100.000000000000000000;
    WebDBCheckBox5.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox5, Self, 'OnClick', 'WebDBCheckBox5Click');
    WebDBCheckBox5.DataField := 'FORCEDIESELDRIVER';
    WebDBCheckBox5.DataSource := dsCompInfo;
    WebDBCheckBox5.ValueChecked := 'Y';
    WebDBCheckBox5.ValueUnChecked := 'N';
    WebDBCheckBox6.SetParentComponent(WebPanel8);
    WebDBCheckBox6.Name := 'WebDBCheckBox6';
    WebDBCheckBox6.Left := 16;
    WebDBCheckBox6.Top := 63;
    WebDBCheckBox6.Width := 265;
    WebDBCheckBox6.Height := 29;
    WebDBCheckBox6.Caption := 'Print Contract Loadcon After Save';
    WebDBCheckBox6.ChildOrder := 5;
    WebDBCheckBox6.HeightPercent := 100.000000000000000000;
    WebDBCheckBox6.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox6, Self, 'OnClick', 'WebDBCheckBox6Click');
    WebDBCheckBox6.DataField := 'PRINTLOADSAVE';
    WebDBCheckBox6.DataSource := dsCompInfo;
    WebDBCheckBox6.ValueChecked := 'true';
    WebDBCheckBox6.ValueUnChecked := 'flase';
    WebDBCheckBox7.SetParentComponent(WebPanel8);
    WebDBCheckBox7.Name := 'WebDBCheckBox7';
    WebDBCheckBox7.Left := 16;
    WebDBCheckBox7.Top := 175;
    WebDBCheckBox7.Width := 233;
    WebDBCheckBox7.Height := 38;
    WebDBCheckBox7.Caption := 'Diesel Sales - Non Retail Sales';
    WebDBCheckBox7.ChildOrder := 6;
    WebDBCheckBox7.HeightPercent := 100.000000000000000000;
    WebDBCheckBox7.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox7, Self, 'OnClick', 'WebDBCheckBox7Click');
    WebDBCheckBox7.DataField := 'dieselnonretail';
    WebDBCheckBox7.DataSource := dsCompInfo;
    WebDBCheckBox7.ValueChecked := 'true';
    WebDBCheckBox7.ValueUnChecked := 'flase';
    WebDBCheckBox8.SetParentComponent(WebPanel8);
    WebDBCheckBox8.Name := 'WebDBCheckBox8';
    WebDBCheckBox8.Left := 16;
    WebDBCheckBox8.Top := 87;
    WebDBCheckBox8.Width := 281;
    WebDBCheckBox8.Height := 22;
    WebDBCheckBox8.Caption := 'Washbay Docket Must Be Unique';
    WebDBCheckBox8.ChildOrder := 7;
    WebDBCheckBox8.HeightPercent := 100.000000000000000000;
    WebDBCheckBox8.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox8, Self, 'OnClick', 'WebDBCheckBox8Click');
    WebDBCheckBox8.DataField := 'UNIQUEWASHBAYDOCKET';
    WebDBCheckBox8.DataSource := dsCompInfo;
    WebDBCheckBox8.ValueChecked := 'true';
    WebDBCheckBox8.ValueUnChecked := 'flase';
    WebDBCheckBox9.SetParentComponent(WebPanel8);
    WebDBCheckBox9.Name := 'WebDBCheckBox9';
    WebDBCheckBox9.Left := 16;
    WebDBCheckBox9.Top := 127;
    WebDBCheckBox9.Width := 305;
    WebDBCheckBox9.Height := 22;
    WebDBCheckBox9.Caption := 'Monitor Diesel Upfront Credit Limit';
    WebDBCheckBox9.ChildOrder := 8;
    WebDBCheckBox9.HeightPercent := 100.000000000000000000;
    WebDBCheckBox9.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox9, Self, 'OnClick', 'WebDBCheckBox9Click');
    WebDBCheckBox9.DataField := 'monitordieselupfrontcl';
    WebDBCheckBox9.DataSource := dsCompInfo;
    WebDBCheckBox9.ValueChecked := 'true';
    WebDBCheckBox9.ValueUnChecked := 'flase';
    WebDBCheckBox10.SetParentComponent(WebPanel8);
    WebDBCheckBox10.Name := 'WebDBCheckBox10';
    WebDBCheckBox10.Left := 16;
    WebDBCheckBox10.Top := 164;
    WebDBCheckBox10.Width := 265;
    WebDBCheckBox10.Height := 22;
    WebDBCheckBox10.Caption := 'Monitor Loads Cancel Against Diesel Orders';
    WebDBCheckBox10.ChildOrder := 9;
    WebDBCheckBox10.HeightPercent := 100.000000000000000000;
    WebDBCheckBox10.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox10, Self, 'OnClick', 'WebDBCheckBox10Click');
    WebDBCheckBox10.DataField := 'monitorcancelloads';
    WebDBCheckBox10.DataSource := dsCompInfo;
    WebDBCheckBox10.ValueChecked := 'true';
    WebDBCheckBox10.ValueUnChecked := 'flase';
    WebDBCheckBox11.SetParentComponent(WebPanel8);
    WebDBCheckBox11.Name := 'WebDBCheckBox11';
    WebDBCheckBox11.Left := 16;
    WebDBCheckBox11.Top := 108;
    WebDBCheckBox11.Width := 329;
    WebDBCheckBox11.Height := 22;
    WebDBCheckBox11.Caption := 'Shown Un-Invoiced Sub-Contractor Laodcon';
    WebDBCheckBox11.ChildOrder := 10;
    WebDBCheckBox11.HeightPercent := 100.000000000000000000;
    WebDBCheckBox11.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox11, Self, 'OnClick', 'WebDBCheckBox11Click');
    WebDBCheckBox11.DataField := 'SUBUNINVSHOW';
    WebDBCheckBox11.DataSource := dsCompInfo;
    WebDBCheckBox11.ValueChecked := 'true';
    WebDBCheckBox11.ValueUnChecked := 'flase';
    WebDBCheckBox12.SetParentComponent(WebPanel8);
    WebDBCheckBox12.Name := 'WebDBCheckBox12';
    WebDBCheckBox12.Left := 16;
    WebDBCheckBox12.Top := 37;
    WebDBCheckBox12.Width := 225;
    WebDBCheckBox12.Height := 33;
    WebDBCheckBox12.Caption := 'Print Totals On Client Send Report    ';
    WebDBCheckBox12.ChildOrder := 11;
    WebDBCheckBox12.HeightPercent := 100.000000000000000000;
    WebDBCheckBox12.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox12, Self, 'OnClick', 'WebDBCheckBox12Click');
    WebDBCheckBox12.DataField := 'PRINTTOTALSSEND';
    WebDBCheckBox12.DataSource := dsCompInfo;
    WebDBCheckBox12.ValueChecked := 'true';
    WebDBCheckBox12.ValueUnChecked := 'flase';
    WebDBCheckBox13.SetParentComponent(WebPanel8);
    WebDBCheckBox13.Name := 'WebDBCheckBox13';
    WebDBCheckBox13.Left := 16;
    WebDBCheckBox13.Top := 21;
    WebDBCheckBox13.Width := 295;
    WebDBCheckBox13.Height := 22;
    WebDBCheckBox13.Caption := 'Force Driver on Load Confirmation';
    WebDBCheckBox13.ChildOrder := 12;
    WebDBCheckBox13.HeightPercent := 100.000000000000000000;
    WebDBCheckBox13.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox13, Self, 'OnClick', 'WebDBCheckBox13Click');
    WebDBCheckBox13.DataField := 'FORCELOADDRIVER';
    WebDBCheckBox13.DataSource := dsCompInfo;
    WebDBCheckBox13.ValueChecked := 'Y';
    WebDBCheckBox13.ValueUnChecked := 'N';
    WebDBCheckBox14.SetParentComponent(WebPanel8);
    WebDBCheckBox14.Name := 'WebDBCheckBox14';
    WebDBCheckBox14.Left := 16;
    WebDBCheckBox14.Top := 145;
    WebDBCheckBox14.Width := 305;
    WebDBCheckBox14.Height := 22;
    WebDBCheckBox14.Caption := 'Monitor Loads Sub-Contractor Change';
    WebDBCheckBox14.ChildOrder := 13;
    WebDBCheckBox14.HeightPercent := 100.000000000000000000;
    WebDBCheckBox14.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox14, Self, 'OnClick', 'WebDBCheckBox14Click');
    WebDBCheckBox14.DataField := 'monitorloadssub';
    WebDBCheckBox14.DataSource := dsCompInfo;
    WebDBCheckBox14.ValueChecked := 'true';
    WebDBCheckBox14.ValueUnChecked := 'flase';
    WebPanel9.SetParentComponent(WebPageControl1Sheet2);
    WebPanel9.Name := 'WebPanel9';
    WebPanel9.Left := 399;
    WebPanel9.Top := 5;
    WebPanel9.Width := 453;
    WebPanel9.Height := 261;
    WebPanel9.ChildOrder := 3;
    WebPanel9.Color := clSilver;
    WebPanel9.TabOrder := 2;
    WebLabel21.SetParentComponent(WebPanel9);
    WebLabel21.Name := 'WebLabel21';
    WebLabel21.Left := 16;
    WebLabel21.Top := 216;
    WebLabel21.Width := 179;
    WebLabel21.Height := 15;
    WebLabel21.Caption := 'Default Diesel Orders Per Vehicle : ';
    WebLabel21.HeightPercent := 100.000000000000000000;
    WebLabel21.WidthPercent := 100.000000000000000000;
    WebLabel22.SetParentComponent(WebPanel9);
    WebLabel22.Name := 'WebLabel22';
    WebLabel22.Left := 16;
    WebLabel22.Top := 240;
    WebLabel22.Width := 174;
    WebLabel22.Height := 15;
    WebLabel22.Caption := 'Default Load Orders Per Vehicle : ';
    WebLabel22.HeightPercent := 100.000000000000000000;
    WebLabel22.WidthPercent := 100.000000000000000000;
    WebDBEdit3.SetParentComponent(WebPanel9);
    WebDBEdit3.Name := 'WebDBEdit3';
    WebDBEdit3.Left := 241;
    WebDBEdit3.Top := 213;
    WebDBEdit3.Width := 121;
    WebDBEdit3.Height := 22;
    WebDBEdit3.ChildOrder := 10;
    WebDBEdit3.HeightPercent := 100.000000000000000000;
    WebDBEdit3.WidthPercent := 100.000000000000000000;
    WebDBEdit3.DataField := 'DEFDIESELORDERS';
    WebDBEdit3.DataSource := dsCompInfo;
    WebDBEdit4.SetParentComponent(WebPanel9);
    WebDBEdit4.Name := 'WebDBEdit4';
    WebDBEdit4.Left := 241;
    WebDBEdit4.Top := 236;
    WebDBEdit4.Width := 121;
    WebDBEdit4.Height := 22;
    WebDBEdit4.ChildOrder := 11;
    WebDBEdit4.HeightPercent := 100.000000000000000000;
    WebDBEdit4.WidthPercent := 100.000000000000000000;
    WebDBEdit4.DataField := 'DEFLOADORDERS';
    WebDBEdit4.DataSource := dsCompInfo;
    WebDBCheckBox15.SetParentComponent(WebPanel9);
    WebDBCheckBox15.Name := 'WebDBCheckBox15';
    WebDBCheckBox15.Left := 16;
    WebDBCheckBox15.Top := 5;
    WebDBCheckBox15.Width := 329;
    WebDBCheckBox15.Height := 22;
    WebDBCheckBox15.Caption := 'Create loadcons on Customer Selection';
    WebDBCheckBox15.ChildOrder := 4;
    WebDBCheckBox15.HeightPercent := 100.000000000000000000;
    WebDBCheckBox15.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox15, Self, 'OnClick', 'WebDBCheckBox15Click');
    WebDBCheckBox15.DataField := 'LOADCUSTOMERS';
    WebDBCheckBox15.DataSource := dsCompInfo;
    WebDBCheckBox16.SetParentComponent(WebPanel9);
    WebDBCheckBox16.Name := 'WebDBCheckBox16';
    WebDBCheckBox16.Left := 16;
    WebDBCheckBox16.Top := 25;
    WebDBCheckBox16.Width := 313;
    WebDBCheckBox16.Height := 22;
    WebDBCheckBox16.Caption := 'Use Docket Number As Invoice Number';
    WebDBCheckBox16.ChildOrder := 5;
    WebDBCheckBox16.HeightPercent := 100.000000000000000000;
    WebDBCheckBox16.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox16, Self, 'OnClick', 'WebDBCheckBox16Click');
    WebDBCheckBox16.DataField := 'USEDOCKETNOINVNO';
    WebDBCheckBox16.DataSource := dsCompInfo;
    WebDBCheckBox17.SetParentComponent(WebPanel9);
    WebDBCheckBox17.Name := 'WebDBCheckBox17';
    WebDBCheckBox17.Left := 16;
    WebDBCheckBox17.Top := 44;
    WebDBCheckBox17.Width := 337;
    WebDBCheckBox17.Height := 22;
    WebDBCheckBox17.Caption := 'Use Additional Information on Non-contracts';
    WebDBCheckBox17.ChildOrder := 6;
    WebDBCheckBox17.HeightPercent := 100.000000000000000000;
    WebDBCheckBox17.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox17, Self, 'OnClick', 'WebDBCheckBox17Click');
    WebDBCheckBox17.DataField := 'USEADDINFONONCON';
    WebDBCheckBox17.DataSource := dsCompInfo;
    WebDBCheckBox18.SetParentComponent(WebPanel9);
    WebDBCheckBox18.Name := 'WebDBCheckBox18';
    WebDBCheckBox18.Left := 16;
    WebDBCheckBox18.Top := 65;
    WebDBCheckBox18.Width := 281;
    WebDBCheckBox18.Height := 22;
    WebDBCheckBox18.Caption := 'Show Fuel on Non-contracts';
    WebDBCheckBox18.ChildOrder := 7;
    WebDBCheckBox18.HeightPercent := 100.000000000000000000;
    WebDBCheckBox18.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox18, Self, 'OnClick', 'WebDBCheckBox18Click');
    WebDBCheckBox18.DataField := 'NONCONDISPLAYFUEL';
    WebDBCheckBox18.DataSource := dsCompInfo;
    WebDBCheckBox19.SetParentComponent(WebPanel9);
    WebDBCheckBox19.Name := 'WebDBCheckBox19';
    WebDBCheckBox19.Left := 16;
    WebDBCheckBox19.Top := 86;
    WebDBCheckBox19.Width := 321;
    WebDBCheckBox19.Height := 22;
    WebDBCheckBox19.Caption := 'Unique Contract Short Description';
    WebDBCheckBox19.ChildOrder := 8;
    WebDBCheckBox19.HeightPercent := 100.000000000000000000;
    WebDBCheckBox19.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox19, Self, 'OnClick', 'WebDBCheckBox19Click');
    WebDBCheckBox19.DataField := 'UNIQUESHORTDESC';
    WebDBCheckBox19.DataSource := dsCompInfo;
    WebDBCheckBox20.SetParentComponent(WebPanel9);
    WebDBCheckBox20.Name := 'WebDBCheckBox20';
    WebDBCheckBox20.Left := 16;
    WebDBCheckBox20.Top := 107;
    WebDBCheckBox20.Width := 345;
    WebDBCheckBox20.Height := 22;
    WebDBCheckBox20.Caption := 'Washbay Invoices Must Use Loadcon Numbers';
    WebDBCheckBox20.ChildOrder := 9;
    WebDBCheckBox20.HeightPercent := 100.000000000000000000;
    WebDBCheckBox20.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox20, Self, 'OnClick', 'WebDBCheckBox20Click');
    WebDBCheckBox20.DataField := 'washbayinvloads';
    WebDBCheckBox20.DataSource := dsCompInfo;
    WebDBCheckBox21.SetParentComponent(WebPanel9);
    WebDBCheckBox21.Name := 'WebDBCheckBox21';
    WebDBCheckBox21.Left := 16;
    WebDBCheckBox21.Top := 127;
    WebDBCheckBox21.Width := 329;
    WebDBCheckBox21.Height := 22;
    WebDBCheckBox21.Caption := 'Inter Company - Sub-Contractor Overwrite';
    WebDBCheckBox21.ChildOrder := 10;
    WebDBCheckBox21.HeightPercent := 100.000000000000000000;
    WebDBCheckBox21.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox21, Self, 'OnClick', 'WebDBCheckBox21Click');
    WebDBCheckBox21.DataField := 'subsoverrite';
    WebDBCheckBox21.DataSource := dsCompInfo;
    WebDBCheckBox22.SetParentComponent(WebPanel9);
    WebDBCheckBox22.Name := 'WebDBCheckBox22';
    WebDBCheckBox22.Left := 16;
    WebDBCheckBox22.Top := 149;
    WebDBCheckBox22.Width := 329;
    WebDBCheckBox22.Height := 22;
    WebDBCheckBox22.Caption := 'Inter Company - Force Scan Documents ';
    WebDBCheckBox22.ChildOrder := 11;
    WebDBCheckBox22.HeightPercent := 100.000000000000000000;
    WebDBCheckBox22.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox22, Self, 'OnClick', 'WebDBCheckBox22Click');
    WebDBCheckBox22.DataField := 'forcescandocs';
    WebDBCheckBox22.DataSource := dsCompInfo;
    WebDBCheckBox23.SetParentComponent(WebPanel9);
    WebDBCheckBox23.Name := 'WebDBCheckBox23';
    WebDBCheckBox23.Left := 16;
    WebDBCheckBox23.Top := 168;
    WebDBCheckBox23.Width := 393;
    WebDBCheckBox23.Height := 22;
    WebDBCheckBox23.Caption := 'Client Vat and Supplier Vat On Loads Must Be Linked';
    WebDBCheckBox23.ChildOrder := 12;
    WebDBCheckBox23.HeightPercent := 100.000000000000000000;
    WebDBCheckBox23.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox23, Self, 'OnClick', 'WebDBCheckBox23Click');
    WebDBCheckBox23.DataField := 'linkloadsvat';
    WebDBCheckBox23.DataSource := dsCompInfo;
    WebDBCheckBox24.SetParentComponent(WebPanel9);
    WebDBCheckBox24.Name := 'WebDBCheckBox24';
    WebDBCheckBox24.Left := 16;
    WebDBCheckBox24.Top := 190;
    WebDBCheckBox24.Width := 409;
    WebDBCheckBox24.Height := 22;
    WebDBCheckBox24.Caption := 'Client Loading and Off-Loading Waybills Must Be Unique';
    WebDBCheckBox24.ChildOrder := 13;
    WebDBCheckBox24.HeightPercent := 100.000000000000000000;
    WebDBCheckBox24.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox24, Self, 'OnClick', 'WebDBCheckBox24Click');
    WebDBCheckBox24.DataField := 'UNIQUEWAYBILLS';
    WebDBCheckBox24.DataSource := dsCompInfo;
    WebPanel7.SetParentComponent(WebPageControl1Sheet2);
    WebPanel7.Name := 'WebPanel7';
    WebPanel7.Left := 852;
    WebPanel7.Top := 0;
    WebPanel7.Width := 704;
    WebPanel7.Height := 418;
    WebPanel7.ChildOrder := 1;
    WebPanel7.Color := clSilver;
    WebPanel7.TabOrder := 3;
    WebLabel20.SetParentComponent(WebPanel7);
    WebLabel20.Name := 'WebLabel20';
    WebLabel20.Left := 16;
    WebLabel20.Top := 349;
    WebLabel20.Width := 177;
    WebLabel20.Height := 15;
    WebLabel20.Caption := 'Aarto Vehicle Max Report Points : ';
    WebLabel20.HeightPercent := 100.000000000000000000;
    WebLabel20.WidthPercent := 100.000000000000000000;
    WebDBEdit5.SetParentComponent(WebPanel7);
    WebDBEdit5.Name := 'WebDBEdit5';
    WebDBEdit5.Left := 253;
    WebDBEdit5.Top := 352;
    WebDBEdit5.Width := 121;
    WebDBEdit5.Height := 22;
    WebDBEdit5.ChildOrder := 15;
    WebDBEdit5.HeightPercent := 100.000000000000000000;
    WebDBEdit5.WidthPercent := 100.000000000000000000;
    WebDBEdit5.DataField := 'vehicledemerit';
    WebDBEdit5.DataSource := dsCompInfo;
    WebDBCheckBox25.SetParentComponent(WebPanel7);
    WebDBCheckBox25.Name := 'WebDBCheckBox25';
    WebDBCheckBox25.Left := 16;
    WebDBCheckBox25.Top := 26;
    WebDBCheckBox25.Width := 249;
    WebDBCheckBox25.Height := 22;
    WebDBCheckBox25.Caption := 'Allow Original Re-Print Invoices';
    WebDBCheckBox25.ChildOrder := 2;
    WebDBCheckBox25.HeightPercent := 100.000000000000000000;
    WebDBCheckBox25.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox25, Self, 'OnClick', 'WebDBCheckBox25Click');
    WebDBCheckBox25.DataField := 'allowreprint';
    WebDBCheckBox25.DataSource := dsCompInfo;
    WebDBCheckBox26.SetParentComponent(WebPanel7);
    WebDBCheckBox26.Name := 'WebDBCheckBox26';
    WebDBCheckBox26.Left := 16;
    WebDBCheckBox26.Top := 44;
    WebDBCheckBox26.Width := 265;
    WebDBCheckBox26.Height := 22;
    WebDBCheckBox26.Caption := 'Allow Diesel Pro-Forma Invoices';
    WebDBCheckBox26.ChildOrder := 3;
    WebDBCheckBox26.HeightPercent := 100.000000000000000000;
    WebDBCheckBox26.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox26, Self, 'OnClick', 'WebDBCheckBox26Click');
    WebDBCheckBox26.DataField := 'allowdieselproforma';
    WebDBCheckBox26.DataSource := dsCompInfo;
    WebDBCheckBox27.SetParentComponent(WebPanel7);
    WebDBCheckBox27.Name := 'WebDBCheckBox27';
    WebDBCheckBox27.Left := 16;
    WebDBCheckBox27.Top := 63;
    WebDBCheckBox27.Width := 233;
    WebDBCheckBox27.Height := 22;
    WebDBCheckBox27.Caption := 'No Future Date on Invoice';
    WebDBCheckBox27.ChildOrder := 4;
    WebDBCheckBox27.HeightPercent := 100.000000000000000000;
    WebDBCheckBox27.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox27, Self, 'OnClick', 'WebDBCheckBox27Click');
    WebDBCheckBox27.DataField := 'removesubinvdocs';
    WebDBCheckBox27.DataSource := dsCompInfo;
    WebDBCheckBox28.SetParentComponent(WebPanel7);
    WebDBCheckBox28.Name := 'WebDBCheckBox28';
    WebDBCheckBox28.Left := 16;
    WebDBCheckBox28.Top := 83;
    WebDBCheckBox28.Width := 201;
    WebDBCheckBox28.Height := 22;
    WebDBCheckBox28.Caption := 'No Future Date on Invoice';
    WebDBCheckBox28.ChildOrder := 5;
    WebDBCheckBox28.HeightPercent := 100.000000000000000000;
    WebDBCheckBox28.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox28, Self, 'OnClick', 'WebDBCheckBox28Click');
    WebDBCheckBox28.DataField := 'NOFUTUREINVDATE';
    WebDBCheckBox28.DataSource := dsCompInfo;
    WebDBCheckBox29.SetParentComponent(WebPanel7);
    WebDBCheckBox29.Name := 'WebDBCheckBox29';
    WebDBCheckBox29.Left := 16;
    WebDBCheckBox29.Top := 104;
    WebDBCheckBox29.Width := 249;
    WebDBCheckBox29.Height := 22;
    WebDBCheckBox29.Caption := 'Client Order Must Be Unique';
    WebDBCheckBox29.ChildOrder := 6;
    WebDBCheckBox29.HeightPercent := 100.000000000000000000;
    WebDBCheckBox29.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox29, Self, 'OnClick', 'WebDBCheckBox29Click');
    WebDBCheckBox29.DataField := 'UNIQUEORDER';
    WebDBCheckBox29.DataSource := dsCompInfo;
    WebDBCheckBox30.SetParentComponent(WebPanel7);
    WebDBCheckBox30.Name := 'WebDBCheckBox30';
    WebDBCheckBox30.Left := 16;
    WebDBCheckBox30.Top := 124;
    WebDBCheckBox30.Width := 193;
    WebDBCheckBox30.Height := 22;
    WebDBCheckBox30.Caption := 'Auto Cancel Diesel Orders';
    WebDBCheckBox30.ChildOrder := 7;
    WebDBCheckBox30.HeightPercent := 100.000000000000000000;
    WebDBCheckBox30.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox30, Self, 'OnClick', 'WebDBCheckBox30Click');
    WebDBCheckBox30.DataField := 'autocanceldieselorders';
    WebDBCheckBox30.DataSource := dsCompInfo;
    WebDBCheckBox31.SetParentComponent(WebPanel7);
    WebDBCheckBox31.Name := 'WebDBCheckBox31';
    WebDBCheckBox31.Left := 16;
    WebDBCheckBox31.Top := 146;
    WebDBCheckBox31.Width := 201;
    WebDBCheckBox31.Height := 22;
    WebDBCheckBox31.Caption := 'Use Loads Cut Off Date';
    WebDBCheckBox31.ChildOrder := 8;
    WebDBCheckBox31.HeightPercent := 100.000000000000000000;
    WebDBCheckBox31.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox31, Self, 'OnClick', 'WebDBCheckBox31Click');
    WebDBCheckBox31.DataField := 'loadcoscutoffdate';
    WebDBCheckBox31.DataSource := dsCompInfo;
    WebDBCheckBox32.SetParentComponent(WebPanel7);
    WebDBCheckBox32.Name := 'WebDBCheckBox32';
    WebDBCheckBox32.Left := 16;
    WebDBCheckBox32.Top := 167;
    WebDBCheckBox32.Width := 241;
    WebDBCheckBox32.Height := 22;
    WebDBCheckBox32.Caption := 'Use Diesel Cut Off Date';
    WebDBCheckBox32.ChildOrder := 9;
    WebDBCheckBox32.HeightPercent := 100.000000000000000000;
    WebDBCheckBox32.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox32, Self, 'OnClick', 'WebDBCheckBox32Click');
    WebDBCheckBox32.DataField := 'dieselcutoffdate';
    WebDBCheckBox32.DataSource := dsCompInfo;
    WebDBCheckBox33.SetParentComponent(WebPanel7);
    WebDBCheckBox33.Name := 'WebDBCheckBox33';
    WebDBCheckBox33.Left := 16;
    WebDBCheckBox33.Top := 187;
    WebDBCheckBox33.Width := 249;
    WebDBCheckBox33.Height := 22;
    WebDBCheckBox33.Caption := 'Hide Cancel Loads On Planning';
    WebDBCheckBox33.ChildOrder := 10;
    WebDBCheckBox33.HeightPercent := 100.000000000000000000;
    WebDBCheckBox33.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox33, Self, 'OnClick', 'WebDBCheckBox33Click');
    WebDBCheckBox33.DataField := 'hidecanceloadsplanning';
    WebDBCheckBox33.DataSource := dsCompInfo;
    WebDBCheckBox34.SetParentComponent(WebPanel7);
    WebDBCheckBox34.Name := 'WebDBCheckBox34';
    WebDBCheckBox34.Left := 16;
    WebDBCheckBox34.Top := 208;
    WebDBCheckBox34.Width := 313;
    WebDBCheckBox34.Height := 22;
    WebDBCheckBox34.Caption := 'Send Loadcons with Auto E-Mail Process';
    WebDBCheckBox34.ChildOrder := 11;
    WebDBCheckBox34.HeightPercent := 100.000000000000000000;
    WebDBCheckBox34.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox34, Self, 'OnClick', 'WebDBCheckBox34Click');
    WebDBCheckBox34.DataField := 'sendloadconsprocess';
    WebDBCheckBox34.DataSource := dsCompInfo;
    WebDBCheckBox35.SetParentComponent(WebPanel7);
    WebDBCheckBox35.Name := 'WebDBCheckBox35';
    WebDBCheckBox35.Left := 16;
    WebDBCheckBox35.Top := 229;
    WebDBCheckBox35.Width := 233;
    WebDBCheckBox35.Height := 22;
    WebDBCheckBox35.Caption := 'Use Short Desc On Planning';
    WebDBCheckBox35.ChildOrder := 12;
    WebDBCheckBox35.HeightPercent := 100.000000000000000000;
    WebDBCheckBox35.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox35, Self, 'OnClick', 'WebDBCheckBox35Click');
    WebDBCheckBox35.DataField := 'planningshortdesc';
    WebDBCheckBox35.DataSource := dsCompInfo;
    WebDBCheckBox36.SetParentComponent(WebPanel7);
    WebDBCheckBox36.Name := 'WebDBCheckBox36';
    WebDBCheckBox36.Left := 16;
    WebDBCheckBox36.Top := 248;
    WebDBCheckBox36.Width := 185;
    WebDBCheckBox36.Height := 22;
    WebDBCheckBox36.Caption := 'Subs Loads Must Received';
    WebDBCheckBox36.ChildOrder := 13;
    WebDBCheckBox36.HeightPercent := 100.000000000000000000;
    WebDBCheckBox36.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox36, Self, 'OnClick', 'WebDBCheckBox36Click');
    WebDBCheckBox36.DataField := 'loadsmustreceived';
    WebDBCheckBox36.DataSource := dsCompInfo;
    WebDBCheckBox37.SetParentComponent(WebPanel7);
    WebDBCheckBox37.Name := 'WebDBCheckBox37';
    WebDBCheckBox37.Left := 16;
    WebDBCheckBox37.Top := 270;
    WebDBCheckBox37.Width := 313;
    WebDBCheckBox37.Height := 22;
    WebDBCheckBox37.Caption := 'Mark Import Loads As Multi Load Ready';
    WebDBCheckBox37.ChildOrder := 14;
    WebDBCheckBox37.HeightPercent := 100.000000000000000000;
    WebDBCheckBox37.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox37, Self, 'OnClick', 'WebDBCheckBox37Click');
    WebDBCheckBox37.DataField := 'markmultiloadready';
    WebDBCheckBox37.DataSource := dsCompInfo;
    WebDBCheckBox38.SetParentComponent(WebPanel7);
    WebDBCheckBox38.Name := 'WebDBCheckBox38';
    WebDBCheckBox38.Left := 16;
    WebDBCheckBox38.Top := 292;
    WebDBCheckBox38.Width := 257;
    WebDBCheckBox38.Height := 22;
    WebDBCheckBox38.Caption := 'Client Docket Must Be Unique';
    WebDBCheckBox38.ChildOrder := 15;
    WebDBCheckBox38.HeightPercent := 100.000000000000000000;
    WebDBCheckBox38.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox38, Self, 'OnClick', 'WebDBCheckBox38Click');
    WebDBCheckBox38.DataField := 'SSUNIQUECLIENTDOCKET';
    WebDBCheckBox38.DataSource := dsCompInfo;
    WebDBCheckBox39.SetParentComponent(WebPanel7);
    WebDBCheckBox39.Name := 'WebDBCheckBox39';
    WebDBCheckBox39.Left := 16;
    WebDBCheckBox39.Top := 314;
    WebDBCheckBox39.Width := 209;
    WebDBCheckBox39.Height := 22;
    WebDBCheckBox39.Caption := 'Monitor Vehicle Changes';
    WebDBCheckBox39.ChildOrder := 16;
    WebDBCheckBox39.HeightPercent := 100.000000000000000000;
    WebDBCheckBox39.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox39, Self, 'OnClick', 'WebDBCheckBox39Click');
    WebDBCheckBox39.DataField := 'monitorvehiclechanges';
    WebDBCheckBox39.DataSource := dsCompInfo;
    WebPanel10.SetParentComponent(WebPageControl1Sheet2);
    WebPanel10.Name := 'WebPanel10';
    WebPanel10.Left := 3;
    WebPanel10.Top := 266;
    WebPanel10.Width := 849;
    WebPanel10.Height := 152;
    WebPanel10.ChildOrder := 4;
    WebPanel10.Color := clSilver;
    WebPanel10.TabOrder := 4;
    WebLabel31.SetParentComponent(WebPanel10);
    WebLabel31.Name := 'WebLabel31';
    WebLabel31.Left := 16;
    WebLabel31.Top := 37;
    WebLabel31.Width := 136;
    WebLabel31.Height := 15;
    WebLabel31.Caption := 'Additional 1 Description : ';
    WebLabel31.HeightPercent := 100.000000000000000000;
    WebLabel31.WidthPercent := 100.000000000000000000;
    WebLabel32.SetParentComponent(WebPanel10);
    WebLabel32.Name := 'WebLabel32';
    WebLabel32.Left := 16;
    WebLabel32.Top := 64;
    WebLabel32.Width := 136;
    WebLabel32.Height := 15;
    WebLabel32.Caption := 'Additional 2 Description : ';
    WebLabel32.HeightPercent := 100.000000000000000000;
    WebLabel32.WidthPercent := 100.000000000000000000;
    WebLabel33.SetParentComponent(WebPanel10);
    WebLabel33.Name := 'WebLabel33';
    WebLabel33.Left := 16;
    WebLabel33.Top := 89;
    WebLabel33.Width := 136;
    WebLabel33.Height := 15;
    WebLabel33.Caption := 'Additional 3 Description : ';
    WebLabel33.HeightPercent := 100.000000000000000000;
    WebLabel33.WidthPercent := 100.000000000000000000;
    WebLabel34.SetParentComponent(WebPanel10);
    WebLabel34.Name := 'WebLabel34';
    WebLabel34.Left := 16;
    WebLabel34.Top := 115;
    WebLabel34.Width := 136;
    WebLabel34.Height := 15;
    WebLabel34.Caption := 'Additional 4 Description : ';
    WebLabel34.HeightPercent := 100.000000000000000000;
    WebLabel34.WidthPercent := 100.000000000000000000;
    WebLabel25.SetParentComponent(WebPanel10);
    WebLabel25.Name := 'WebLabel25';
    WebLabel25.Left := 16;
    WebLabel25.Top := 16;
    WebLabel25.Width := 81;
    WebLabel25.Height := 15;
    WebLabel25.Caption := 'Fines BRN No : ';
    WebLabel25.HeightPercent := 100.000000000000000000;
    WebLabel25.WidthPercent := 100.000000000000000000;
    WebDBEdit6.SetParentComponent(WebPanel10);
    WebDBEdit6.Name := 'WebDBEdit6';
    WebDBEdit6.Left := 200;
    WebDBEdit6.Top := 35;
    WebDBEdit6.Width := 287;
    WebDBEdit6.Height := 22;
    WebDBEdit6.ChildOrder := 5;
    WebDBEdit6.HeightPercent := 100.000000000000000000;
    WebDBEdit6.WidthPercent := 100.000000000000000000;
    WebDBEdit6.DataField := 'ADD1DESC';
    WebDBEdit6.DataSource := dsCompInfo;
    WebDBEdit7.SetParentComponent(WebPanel10);
    WebDBEdit7.Name := 'WebDBEdit7';
    WebDBEdit7.Left := 200;
    WebDBEdit7.Top := 61;
    WebDBEdit7.Width := 287;
    WebDBEdit7.Height := 22;
    WebDBEdit7.ChildOrder := 6;
    WebDBEdit7.HeightPercent := 100.000000000000000000;
    WebDBEdit7.WidthPercent := 100.000000000000000000;
    WebDBEdit7.DataField := 'ADD2DESC';
    WebDBEdit7.DataSource := dsCompInfo;
    WebDBEdit8.SetParentComponent(WebPanel10);
    WebDBEdit8.Name := 'WebDBEdit8';
    WebDBEdit8.Left := 200;
    WebDBEdit8.Top := 86;
    WebDBEdit8.Width := 287;
    WebDBEdit8.Height := 22;
    WebDBEdit8.ChildOrder := 7;
    WebDBEdit8.HeightPercent := 100.000000000000000000;
    WebDBEdit8.WidthPercent := 100.000000000000000000;
    WebDBEdit8.DataField := 'ADD3DESC';
    WebDBEdit8.DataSource := dsCompInfo;
    WebDBEdit9.SetParentComponent(WebPanel10);
    WebDBEdit9.Name := 'WebDBEdit9';
    WebDBEdit9.Left := 200;
    WebDBEdit9.Top := 112;
    WebDBEdit9.Width := 287;
    WebDBEdit9.Height := 22;
    WebDBEdit9.ChildOrder := 8;
    WebDBEdit9.HeightPercent := 100.000000000000000000;
    WebDBEdit9.WidthPercent := 100.000000000000000000;
    WebDBEdit9.DataField := 'ADD4DESC';
    WebDBEdit9.DataSource := dsCompInfo;
    WebDBEdit14.SetParentComponent(WebPanel10);
    WebDBEdit14.Name := 'WebDBEdit14';
    WebDBEdit14.Left := 200;
    WebDBEdit14.Top := 12;
    WebDBEdit14.Width := 127;
    WebDBEdit14.Height := 22;
    WebDBEdit14.ChildOrder := 9;
    WebDBEdit14.HeightPercent := 100.000000000000000000;
    WebDBEdit14.WidthPercent := 100.000000000000000000;
    WebDBEdit14.DataField := 'finesbrnno';
    WebDBEdit14.DataSource := dsCompInfo;
    WebPanel11.SetParentComponent(WebPageControl1Sheet2);
    WebPanel11.Name := 'WebPanel11';
    WebPanel11.Left := 0;
    WebPanel11.Top := 418;
    WebPanel11.Width := 1556;
    WebPanel11.Height := 157;
    WebPanel11.ChildOrder := 5;
    WebPanel11.Color := clSilver;
    WebPanel11.TabOrder := 5;
    WebLabel26.SetParentComponent(WebPanel11);
    WebLabel26.Name := 'WebLabel26';
    WebLabel26.Left := 791;
    WebLabel26.Top := 29;
    WebLabel26.Width := 69;
    WebLabel26.Height := 15;
    WebLabel26.Caption := 'Fines ID No : ';
    WebLabel26.HeightPercent := 100.000000000000000000;
    WebLabel26.WidthPercent := 100.000000000000000000;
    WebLabel27.SetParentComponent(WebPanel11);
    WebLabel27.Name := 'WebLabel27';
    WebLabel27.Left := 299;
    WebLabel27.Top := 23;
    WebLabel27.Width := 136;
    WebLabel27.Height := 15;
    WebLabel27.Caption := 'Additional 5 Description : ';
    WebLabel27.HeightPercent := 100.000000000000000000;
    WebLabel27.WidthPercent := 100.000000000000000000;
    WebLabel28.SetParentComponent(WebPanel11);
    WebLabel28.Name := 'WebLabel28';
    WebLabel28.Left := 299;
    WebLabel28.Top := 47;
    WebLabel28.Width := 136;
    WebLabel28.Height := 15;
    WebLabel28.Caption := 'Additional 6 Description : ';
    WebLabel28.HeightPercent := 100.000000000000000000;
    WebLabel28.WidthPercent := 100.000000000000000000;
    WebLabel29.SetParentComponent(WebPanel11);
    WebLabel29.Name := 'WebLabel29';
    WebLabel29.Left := 299;
    WebLabel29.Top := 71;
    WebLabel29.Width := 136;
    WebLabel29.Height := 15;
    WebLabel29.Caption := 'Additional 7 Description : ';
    WebLabel29.HeightPercent := 100.000000000000000000;
    WebLabel29.WidthPercent := 100.000000000000000000;
    WebLabel30.SetParentComponent(WebPanel11);
    WebLabel30.Name := 'WebLabel30';
    WebLabel30.Left := 791;
    WebLabel30.Top := 56;
    WebLabel30.Width := 203;
    WebLabel30.Height := 15;
    WebLabel30.Caption := 'Sub-Contractor Diesel Credit Limit % : ';
    WebLabel30.HeightPercent := 100.000000000000000000;
    WebLabel30.WidthPercent := 100.000000000000000000;
    WebDBEdit10.SetParentComponent(WebPanel11);
    WebDBEdit10.Name := 'WebDBEdit10';
    WebDBEdit10.Left := 503;
    WebDBEdit10.Top := 20;
    WebDBEdit10.Width := 250;
    WebDBEdit10.Height := 22;
    WebDBEdit10.ChildOrder := 5;
    WebDBEdit10.HeightPercent := 100.000000000000000000;
    WebDBEdit10.WidthPercent := 100.000000000000000000;
    WebDBEdit10.DataField := 'ADD5DESC';
    WebDBEdit10.DataSource := dsCompInfo;
    WebDBEdit11.SetParentComponent(WebPanel11);
    WebDBEdit11.Name := 'WebDBEdit11';
    WebDBEdit11.Left := 503;
    WebDBEdit11.Top := 44;
    WebDBEdit11.Width := 250;
    WebDBEdit11.Height := 22;
    WebDBEdit11.ChildOrder := 6;
    WebDBEdit11.HeightPercent := 100.000000000000000000;
    WebDBEdit11.WidthPercent := 100.000000000000000000;
    WebDBEdit11.DataField := 'ADD6DESC';
    WebDBEdit11.DataSource := dsCompInfo;
    WebDBEdit12.SetParentComponent(WebPanel11);
    WebDBEdit12.Name := 'WebDBEdit12';
    WebDBEdit12.Left := 503;
    WebDBEdit12.Top := 68;
    WebDBEdit12.Width := 250;
    WebDBEdit12.Height := 22;
    WebDBEdit12.ChildOrder := 7;
    WebDBEdit12.HeightPercent := 100.000000000000000000;
    WebDBEdit12.WidthPercent := 100.000000000000000000;
    WebDBEdit12.DataField := 'ADD7DESC';
    WebDBEdit12.DataSource := dsCompInfo;
    WebDBEdit13.SetParentComponent(WebPanel11);
    WebDBEdit13.Name := 'WebDBEdit13';
    WebDBEdit13.Left := 1063;
    WebDBEdit13.Top := 58;
    WebDBEdit13.Width := 125;
    WebDBEdit13.Height := 22;
    WebDBEdit13.ChildOrder := 8;
    WebDBEdit13.HeightPercent := 100.000000000000000000;
    WebDBEdit13.WidthPercent := 100.000000000000000000;
    WebDBEdit13.DataField := 'DCLPERC';
    WebDBEdit13.DataSource := dsCompInfo;
    WebDBEdit15.SetParentComponent(WebPanel11);
    WebDBEdit15.Name := 'WebDBEdit15';
    WebDBEdit15.Left := 888;
    WebDBEdit15.Top := 28;
    WebDBEdit15.Width := 121;
    WebDBEdit15.Height := 22;
    WebDBEdit15.ChildOrder := 9;
    WebDBEdit15.HeightPercent := 100.000000000000000000;
    WebDBEdit15.WidthPercent := 100.000000000000000000;
    WebDBEdit15.DataField := 'finesidno';
    WebDBEdit15.DataSource := dsCompInfo;
    WebPageControl1Sheet3.SetParentComponent(wpcSysSetup);
    WebPageControl1Sheet3.Name := 'WebPageControl1Sheet3';
    WebPageControl1Sheet3.Left := 0;
    WebPageControl1Sheet3.Top := 20;
    WebPageControl1Sheet3.Width := 1556;
    WebPageControl1Sheet3.Height := 629;
    WebPageControl1Sheet3.Caption := 'System Number Setup';
    WebPageControl1Sheet3.ChildOrder := 2;
    wpNavigator.SetParentComponent(WebPageControl1Sheet3);
    wpNavigator.Name := 'wpNavigator';
    wpNavigator.Left := 0;
    wpNavigator.Top := 0;
    wpNavigator.Width := 1556;
    wpNavigator.Height := 65;
    wpNavigator.Align := alTop;
    wpNavigator.TabOrder := 0;
    WebSpeedButton1.SetParentComponent(wpNavigator);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 3;
    WebSpeedButton1.Top := 11;
    WebSpeedButton1.Width := 45;
    WebSpeedButton1.Height := 45;
    WebSpeedButton1.Caption := '<<';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 0;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    WebSpeedButton2.SetParentComponent(wpNavigator);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 54;
    WebSpeedButton2.Top := 11;
    WebSpeedButton2.Width := 45;
    WebSpeedButton2.Height := 45;
    WebSpeedButton2.Caption := '<';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.TabOrder := 1;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    WebSpeedButton3.SetParentComponent(wpNavigator);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 105;
    WebSpeedButton3.Top := 11;
    WebSpeedButton3.Width := 45;
    WebSpeedButton3.Height := 45;
    WebSpeedButton3.Caption := '>';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.TabOrder := 2;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton3, Self, 'OnClick', 'WebSpeedButton3Click');
    WebSpeedButton4.SetParentComponent(wpNavigator);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 156;
    WebSpeedButton4.Top := 11;
    WebSpeedButton4.Width := 45;
    WebSpeedButton4.Height := 45;
    WebSpeedButton4.Caption := '>>';
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.TabOrder := 3;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton4, Self, 'OnClick', 'WebSpeedButton4Click');
    WebSpeedButton5.SetParentComponent(wpNavigator);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 207;
    WebSpeedButton5.Top := 11;
    WebSpeedButton5.Width := 45;
    WebSpeedButton5.Height := 45;
    WebSpeedButton5.Caption := '+';
    WebSpeedButton5.Color := clNone;
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.TabOrder := 4;
    WebSpeedButton5.Visible := False;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton5, Self, 'OnClick', 'WebSpeedButton5Click');
    WebPanel29.SetParentComponent(WebPageControl1Sheet3);
    WebPanel29.Name := 'WebPanel29';
    WebPanel29.Left := 0;
    WebPanel29.Top := 569;
    WebPanel29.Width := 1556;
    WebPanel29.Height := 60;
    WebPanel29.Align := alBottom;
    WebPanel29.ChildOrder := 11;
    WebPanel29.TabOrder := 1;
    edtNumbersPageCount.SetParentComponent(WebPanel29);
    edtNumbersPageCount.Name := 'edtNumbersPageCount';
    edtNumbersPageCount.Left := 63;
    edtNumbersPageCount.Top := 18;
    edtNumbersPageCount.Width := 43;
    edtNumbersPageCount.Height := 24;
    edtNumbersPageCount.ChildOrder := 4;
    edtNumbersPageCount.HeightPercent := 100.000000000000000000;
    edtNumbersPageCount.WidthPercent := 100.000000000000000000;
    sbtnNumbersNext.SetParentComponent(WebPanel29);
    sbtnNumbersNext.Name := 'sbtnNumbersNext';
    sbtnNumbersNext.Left := 106;
    sbtnNumbersNext.Top := 18;
    sbtnNumbersNext.Width := 24;
    sbtnNumbersNext.Height := 24;
    sbtnNumbersNext.Caption := '>';
    sbtnNumbersNext.Color := clNone;
    sbtnNumbersNext.HeightPercent := 100.000000000000000000;
    sbtnNumbersNext.TabOrder := 1;
    sbtnNumbersNext.WidthPercent := 100.000000000000000000;
    SetEvent(sbtnNumbersNext, Self, 'OnClick', 'sbtnNumbersNextClick');
    sbtnNumbersPrevious.SetParentComponent(WebPanel29);
    sbtnNumbersPrevious.Name := 'sbtnNumbersPrevious';
    sbtnNumbersPrevious.Left := 36;
    sbtnNumbersPrevious.Top := 18;
    sbtnNumbersPrevious.Width := 24;
    sbtnNumbersPrevious.Height := 24;
    sbtnNumbersPrevious.Caption := '<';
    sbtnNumbersPrevious.Color := clNone;
    sbtnNumbersPrevious.HeightPercent := 100.000000000000000000;
    sbtnNumbersPrevious.TabOrder := 2;
    sbtnNumbersPrevious.WidthPercent := 100.000000000000000000;
    SetEvent(sbtnNumbersPrevious, Self, 'OnClick', 'sbtnNumbersPreviousClick');
    sbtnNumbersLast.SetParentComponent(WebPanel29);
    sbtnNumbersLast.Name := 'sbtnNumbersLast';
    sbtnNumbersLast.Left := 131;
    sbtnNumbersLast.Top := 18;
    sbtnNumbersLast.Width := 24;
    sbtnNumbersLast.Height := 24;
    sbtnNumbersLast.Caption := '>>';
    sbtnNumbersLast.Color := clNone;
    sbtnNumbersLast.HeightPercent := 100.000000000000000000;
    sbtnNumbersLast.TabOrder := 3;
    sbtnNumbersLast.WidthPercent := 100.000000000000000000;
    SetEvent(sbtnNumbersLast, Self, 'OnClick', 'sbtnNumbersLastClick');
    sbtnNumbersFirst.SetParentComponent(WebPanel29);
    sbtnNumbersFirst.Name := 'sbtnNumbersFirst';
    sbtnNumbersFirst.Left := 12;
    sbtnNumbersFirst.Top := 18;
    sbtnNumbersFirst.Width := 24;
    sbtnNumbersFirst.Height := 24;
    sbtnNumbersFirst.Caption := '<<';
    sbtnNumbersFirst.Color := clNone;
    sbtnNumbersFirst.HeightPercent := 100.000000000000000000;
    sbtnNumbersFirst.TabOrder := 4;
    sbtnNumbersFirst.WidthPercent := 100.000000000000000000;
    SetEvent(sbtnNumbersFirst, Self, 'OnClick', 'sbtnNumbersFirstClick');
    dgNumbers.SetParentComponent(WebPageControl1Sheet3);
    dgNumbers.Name := 'dgNumbers';
    dgNumbers.Left := 0;
    dgNumbers.Top := 65;
    dgNumbers.Width := 1556;
    dgNumbers.Height := 504;
    dgNumbers.Align := alClient;
    dgNumbers.ParentDoubleBuffered := False;
    dgNumbers.DoubleBuffered := True;
    dgNumbers.TabOrder := 2;
    dgNumbers.ShowAcceleratorChar := False;
    dgNumbers.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgNumbers.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgNumbers.Header.VisualGrouping.Layout.Font.Height := -12;
    dgNumbers.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgNumbers.Header.VisualGrouping.Layout.Font.Style := [];
    dgNumbers.Adapter := dbagNumbers;
    dgNumbers.BitmapContainer := BitmapContainer1;
    dgNumbers.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgNumbers.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgNumbers.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgNumbers.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgNumbers.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgNumbers.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgNumbers.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgNumbers.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgNumbers.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgNumbers.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgNumbers.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgNumbers.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgNumbers.CellAppearance.BandLayout.Font.Height := -12;
    dgNumbers.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgNumbers.CellAppearance.BandLayout.Font.Style := [];
    dgNumbers.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgNumbers.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgNumbers.CellAppearance.FixedLayout.Font.Height := -12;
    dgNumbers.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgNumbers.CellAppearance.FixedLayout.Font.Style := [];
    dgNumbers.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgNumbers.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgNumbers.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgNumbers.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgNumbers.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgNumbers.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgNumbers.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgNumbers.CellAppearance.FocusedLayout.Font.Height := -12;
    dgNumbers.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgNumbers.CellAppearance.FocusedLayout.Font.Style := [];
    dgNumbers.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgNumbers.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgNumbers.CellAppearance.GroupLayout.Font.Height := -12;
    dgNumbers.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgNumbers.CellAppearance.GroupLayout.Font.Style := [];
    dgNumbers.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgNumbers.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgNumbers.CellAppearance.NormalLayout.Font.Height := -12;
    dgNumbers.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgNumbers.CellAppearance.NormalLayout.Font.Style := [];
    dgNumbers.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgNumbers.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgNumbers.CellAppearance.SelectedLayout.Font.Height := -12;
    dgNumbers.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgNumbers.CellAppearance.SelectedLayout.Font.Style := [];
    dgNumbers.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgNumbers.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgNumbers.CellAppearance.SummaryLayout.Font.Height := -12;
    dgNumbers.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgNumbers.CellAppearance.SummaryLayout.Font.Style := [];
    dgNumbers.ColumnCount := 6;
    dgNumbers.Columns.Clear;
    with dgNumbers.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Tran Type';
      Width := 100.000000000000000000;
    end;
    with dgNumbers.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Prefix';
    end;
    with dgNumbers.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Description';
      Width := 125.000000000000000000;
    end;
    with dgNumbers.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Suffix';
    end;
    with dgNumbers.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Edit';
      Settings := [gcsType];
    end;
    with dgNumbers.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Delete';
      Width := 0.000000000000000000;
    end;
    dgNumbers.Designer := False;
    dgNumbers.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgNumbers.FilterAppearance.Font.Color := clWindowText;
    dgNumbers.FilterAppearance.Font.Height := -12;
    dgNumbers.FilterAppearance.Font.Name := 'Segoe UI';
    dgNumbers.FilterAppearance.Font.Style := [];
    dgNumbers.Icons.ExpandIcon.LoadFromFile('SystemSettings.WebPageControl1Sheet3.dgNumbers.Icons.ExpandIcon.svg');
    dgNumbers.Icons.CollapseIcon.LoadFromFile('SystemSettings.WebPageControl1Sheet3.dgNumbers.Icons.CollapseIcon.svg');
    dgNumbers.Icons.FilterIcon.LoadFromFile('SystemSettings.WebPageControl1Sheet3.dgNumbers.Icons.FilterIcon.svg');
    dgNumbers.Icons.FilterActiveIcon.LoadFromFile('SystemSettings.WebPageControl1Sheet3.dgNumbers.Icons.FilterActiveIcon.svg');
    dgNumbers.Icons.FilterClearIcon.LoadFromFile('SystemSettings.WebPageControl1Sheet3.dgNumbers.Icons.FilterClearIcon.svg');
    dgNumbers.Icons.FilterTypeIcon.LoadFromFile('SystemSettings.WebPageControl1Sheet3.dgNumbers.Icons.FilterTypeIcon.svg');
    dgNumbers.Icons.SortAscendingIcon.LoadFromFile('SystemSettings.WebPageControl1Sheet3.dgNumbers.Icons.SortAscendingIcon.svg');
    dgNumbers.Icons.SortDescendingIcon.LoadFromFile('SystemSettings.WebPageControl1Sheet3.dgNumbers.Icons.SortDescendingIcon.svg');
    dgNumbers.Icons.CloseIcon.LoadFromFile('SystemSettings.WebPageControl1Sheet3.dgNumbers.Icons.CloseIcon.svg');
    SetEvent(dgNumbers, Self, 'OnCellClick', 'dgNumbersCellClick');
    SetEvent(dgNumbers, Self, 'OnGetCellProperties', 'dgNumbersGetCellProperties');
    dgNumbers.RowCount := 1;
    dbagNumbers.SetParentComponent(dgNumbers);
    dbagNumbers.Name := 'dbagNumbers';
    dbagNumbers.Left := 213;
    dbagNumbers.Top := 39;
    dbagNumbers.Width := 26;
    dbagNumbers.Height := 26;
    dbagNumbers.Visible := True;
    dbagNumbers.Columns.Clear;
    with dbagNumbers.Columns.Add do
    begin
      FieldName := 'TranType';
      Header := 'Tran Type';
      AutoCreated := False;
    end;
    with dbagNumbers.Columns.Add do
    begin
      FieldName := 'Prefix';
      Header := 'Prefix';
      AutoCreated := False;
    end;
    with dbagNumbers.Columns.Add do
    begin
      FieldName := 'Description';
      Header := 'Description';
      AutoCreated := False;
    end;
    with dbagNumbers.Columns.Add do
    begin
      FieldName := 'Suffix';
      Header := 'Suffix';
      AutoCreated := False;
    end;
    with dbagNumbers.Columns.Add do
    begin
      Header := 'Edit';
      AutoCreated := False;
    end;
    with dbagNumbers.Columns.Add do
    begin
      Header := 'Delete';
      AutoCreated := False;
    end;
    dbagNumbers.DataSource := dsNumbers;
    msgdlgNumbersDelete.SetParentComponent(dgNumbers);
    msgdlgNumbersDelete.Name := 'msgdlgNumbersDelete';
    msgdlgNumbersDelete.Left := 313;
    msgdlgNumbersDelete.Top := 55;
    msgdlgNumbersDelete.Width := 24;
    msgdlgNumbersDelete.Height := 24;
    msgdlgNumbersDelete.Buttons := [];
    msgdlgNumbersDelete.Opacity := 0.200000000000000000;
    WebPageControlSheet4.SetParentComponent(wpcSysSetup);
    WebPageControlSheet4.Name := 'WebPageControlSheet4';
    WebPageControlSheet4.Left := 0;
    WebPageControlSheet4.Top := 20;
    WebPageControlSheet4.Width := 1556;
    WebPageControlSheet4.Height := 629;
    WebPageControlSheet4.Caption := 'Financial Connection Setup';
    WebPageControlSheet4.ChildOrder := 3;
    WebPanel15.SetParentComponent(WebPageControlSheet4);
    WebPanel15.Name := 'WebPanel15';
    WebPanel15.Left := 0;
    WebPanel15.Top := 0;
    WebPanel15.Width := 1556;
    WebPanel15.Height := 60;
    WebPanel15.Align := alTop;
    WebPanel15.Color := clSilver;
    WebPanel15.TabOrder := 0;
    WebLabel53.SetParentComponent(WebPanel15);
    WebLabel53.Name := 'WebLabel53';
    WebLabel53.Left := 595;
    WebLabel53.Top := 24;
    WebLabel53.Width := 76;
    WebLabel53.Height := 15;
    WebLabel53.Caption := 'Import Period:';
    WebLabel53.HeightPercent := 100.000000000000000000;
    WebLabel53.WidthPercent := 100.000000000000000000;
    WebDBEdit16.SetParentComponent(WebPanel15);
    WebDBEdit16.Name := 'WebDBEdit16';
    WebDBEdit16.Left := 705;
    WebDBEdit16.Top := 24;
    WebDBEdit16.Width := 121;
    WebDBEdit16.Height := 22;
    WebDBEdit16.ChildOrder := 4;
    WebDBEdit16.HeightPercent := 100.000000000000000000;
    WebDBEdit16.WidthPercent := 100.000000000000000000;
    WebDBEdit16.DataField := 'IMPORTPERIOD';
    WebDBEdit16.DataSource := dsCompInfo;
    WebDBCheckBox40.SetParentComponent(WebPanel15);
    WebDBCheckBox40.Name := 'WebDBCheckBox40';
    WebDBCheckBox40.Left := 25;
    WebDBCheckBox40.Top := 24;
    WebDBCheckBox40.Width := 199;
    WebDBCheckBox40.Height := 22;
    WebDBCheckBox40.Alignment := taLeftJustify;
    WebDBCheckBox40.Caption := 'Link To Financial System:';
    WebDBCheckBox40.ChildOrder := 4;
    WebDBCheckBox40.HeightPercent := 100.000000000000000000;
    WebDBCheckBox40.WidthPercent := 100.000000000000000000;
    WebDBCheckBox40.DataField := 'USEFINLINKSYSTEM';
    WebDBCheckBox40.DataSource := dsCompInfo;
    dblFinName.SetParentComponent(WebPanel15);
    dblFinName.Name := 'dblFinName';
    dblFinName.Left := 255;
    dblFinName.Top := 24;
    dblFinName.Width := 297;
    dblFinName.Height := 22;
    dblFinName.HeightPercent := 100.000000000000000000;
    dblFinName.WidthPercent := 100.000000000000000000;
    dblFinName.DataField := 'FINLINKSYSTEM';
    dblFinName.DataSource := dsCompInfo;
    dblFinName.KeyField := 'FinNo';
    dblFinName.ListField := 'FinName';
    dblFinName.ListSource := dsFinLinkSystem;
    WebPageControl1.SetParentComponent(WebPageControlSheet4);
    WebPageControl1.Name := 'WebPageControl1';
    WebPageControl1.Left := 0;
    WebPageControl1.Top := 60;
    WebPageControl1.Width := 1556;
    WebPageControl1.Height := 569;
    WebPageControl1.Align := alClient;
    WebPageControl1.ChildOrder := 2;
    WebPageControl1.TabIndex := 0;
    WebPageControl1.ShowTabs := False;
    WebPageControl1.TabOrder := 1;
    WebTabSheet4.SetParentComponent(WebPageControl1);
    WebTabSheet4.Name := 'WebTabSheet4';
    WebTabSheet4.Left := 0;
    WebTabSheet4.Top := 20;
    WebTabSheet4.Width := 1556;
    WebTabSheet4.Height := 549;
    WebTabSheet4.Caption := 'WebPageControl1Sheet1';
    WebTabSheet4.ChildOrder := 3;
    WebPanel17.SetParentComponent(WebTabSheet4);
    WebPanel17.Name := 'WebPanel17';
    WebPanel17.Left := 0;
    WebPanel17.Top := 0;
    WebPanel17.Width := 608;
    WebPanel17.Height := 549;
    WebPanel17.Align := alLeft;
    WebPanel17.Color := clSilver;
    WebPanel17.TabOrder := 0;
    WebLabel35.SetParentComponent(WebPanel17);
    WebLabel35.Name := 'WebLabel35';
    WebLabel35.Left := 19;
    WebLabel35.Top := 3;
    WebLabel35.Width := 159;
    WebLabel35.Height := 15;
    WebLabel35.Caption := 'Master Database Connection';
    WebLabel35.Font.Charset := DEFAULT_CHARSET;
    WebLabel35.Font.Color := clWindowText;
    WebLabel35.Font.Height := -12;
    WebLabel35.Font.Name := 'Segoe UI';
    WebLabel35.Font.Style := [fsBold];
    WebLabel35.HeightPercent := 100.000000000000000000;
    WebLabel35.ParentFont := False;
    WebLabel35.WidthPercent := 100.000000000000000000;
    WebLabel39.SetParentComponent(WebPanel17);
    WebLabel39.Name := 'WebLabel39';
    WebLabel39.Left := 25;
    WebLabel39.Top := 45;
    WebLabel39.Width := 88;
    WebLabel39.Height := 15;
    WebLabel39.Caption := 'Server Name / IP';
    WebLabel39.HeightPercent := 100.000000000000000000;
    WebLabel39.WidthPercent := 100.000000000000000000;
    WebLabel40.SetParentComponent(WebPanel17);
    WebLabel40.Name := 'WebLabel40';
    WebLabel40.Left := 25;
    WebLabel40.Top := 107;
    WebLabel40.Width := 75;
    WebLabel40.Height := 15;
    WebLabel40.Caption := 'Database Path';
    WebLabel40.HeightPercent := 100.000000000000000000;
    WebLabel40.WidthPercent := 100.000000000000000000;
    WebLabel41.SetParentComponent(WebPanel17);
    WebLabel41.Name := 'WebLabel41';
    WebLabel41.Left := 25;
    WebLabel41.Top := 169;
    WebLabel41.Width := 53;
    WebLabel41.Height := 15;
    WebLabel41.Caption := 'Username';
    WebLabel41.HeightPercent := 100.000000000000000000;
    WebLabel41.WidthPercent := 100.000000000000000000;
    WebLabel42.SetParentComponent(WebPanel17);
    WebLabel42.Name := 'WebLabel42';
    WebLabel42.Left := 245;
    WebLabel42.Top := 169;
    WebLabel42.Width := 50;
    WebLabel42.Height := 15;
    WebLabel42.Caption := 'Password';
    WebLabel42.HeightPercent := 100.000000000000000000;
    WebLabel42.WidthPercent := 100.000000000000000000;
    WebLabel43.SetParentComponent(WebPanel17);
    WebLabel43.Name := 'WebLabel43';
    WebLabel43.Left := 25;
    WebLabel43.Top := 231;
    WebLabel43.Width := 45;
    WebLabel43.Height := 15;
    WebLabel43.Caption := 'Protocol';
    WebLabel43.HeightPercent := 100.000000000000000000;
    WebLabel43.WidthPercent := 100.000000000000000000;
    WebLabel44.SetParentComponent(WebPanel17);
    WebLabel44.Name := 'WebLabel44';
    WebLabel44.Left := 245;
    WebLabel44.Top := 231;
    WebLabel44.Width := 45;
    WebLabel44.Height := 15;
    WebLabel44.Caption := 'Driver ID';
    WebLabel44.HeightPercent := 100.000000000000000000;
    WebLabel44.WidthPercent := 100.000000000000000000;
    WebLabel45.SetParentComponent(WebPanel17);
    WebLabel45.Name := 'WebLabel45';
    WebLabel45.Left := 24;
    WebLabel45.Top := 293;
    WebLabel45.Width := 22;
    WebLabel45.Height := 15;
    WebLabel45.Caption := 'Port';
    WebLabel45.HeightPercent := 100.000000000000000000;
    WebLabel45.WidthPercent := 100.000000000000000000;
    eServerName.SetParentComponent(WebPanel17);
    eServerName.Name := 'eServerName';
    eServerName.Left := 24;
    eServerName.Top := 62;
    eServerName.Width := 280;
    eServerName.Height := 22;
    eServerName.CharCase := wecUpperCase;
    eServerName.ChildOrder := 8;
    eServerName.HeightPercent := 100.000000000000000000;
    eServerName.WidthPercent := 100.000000000000000000;
    eDBPath.SetParentComponent(WebPanel17);
    eDBPath.Name := 'eDBPath';
    eDBPath.Left := 24;
    eDBPath.Top := 128;
    eDBPath.Width := 421;
    eDBPath.Height := 22;
    eDBPath.CharCase := wecUpperCase;
    eDBPath.ChildOrder := 9;
    eDBPath.HeightPercent := 100.000000000000000000;
    eDBPath.WidthPercent := 100.000000000000000000;
    eUsername.SetParentComponent(WebPanel17);
    eUsername.Name := 'eUsername';
    eUsername.Left := 24;
    eUsername.Top := 187;
    eUsername.Width := 200;
    eUsername.Height := 22;
    eUsername.ChildOrder := 10;
    eUsername.HeightPercent := 100.000000000000000000;
    eUsername.WidthPercent := 100.000000000000000000;
    ePassword.SetParentComponent(WebPanel17);
    ePassword.Name := 'ePassword';
    ePassword.Left := 245;
    ePassword.Top := 187;
    ePassword.Width := 200;
    ePassword.Height := 22;
    ePassword.ChildOrder := 11;
    ePassword.HeightPercent := 100.000000000000000000;
    ePassword.WidthPercent := 100.000000000000000000;
    ePort.SetParentComponent(WebPanel17);
    ePort.Name := 'ePort';
    ePort.Left := 24;
    ePort.Top := 314;
    ePort.Width := 200;
    ePort.Height := 22;
    ePort.ChildOrder := 12;
    ePort.HeightPercent := 100.000000000000000000;
    ePort.WidthPercent := 100.000000000000000000;
    eProtocol.SetParentComponent(WebPanel17);
    eProtocol.Name := 'eProtocol';
    eProtocol.Left := 24;
    eProtocol.Top := 252;
    eProtocol.Width := 200;
    eProtocol.Height := 23;
    eProtocol.HeightPercent := 100.000000000000000000;
    eProtocol.Text := 'eProtocol';
    eProtocol.WidthPercent := 100.000000000000000000;
    eProtocol.ItemIndex := -1;
    eDriverID.SetParentComponent(WebPanel17);
    eDriverID.Name := 'eDriverID';
    eDriverID.Left := 245;
    eDriverID.Top := 252;
    eDriverID.Width := 200;
    eDriverID.Height := 23;
    eDriverID.HeightPercent := 100.000000000000000000;
    eDriverID.Text := 'eDriverID';
    eDriverID.WidthPercent := 100.000000000000000000;
    eDriverID.ItemIndex := -1;
    WebPanel18.SetParentComponent(WebTabSheet4);
    WebPanel18.Name := 'WebPanel18';
    WebPanel18.Left := 608;
    WebPanel18.Top := 0;
    WebPanel18.Width := 948;
    WebPanel18.Height := 549;
    WebPanel18.Align := alClient;
    WebPanel18.ChildOrder := 1;
    WebPanel18.Color := clSilver;
    WebPanel18.TabOrder := 1;
    WebLabel38.SetParentComponent(WebPanel18);
    WebLabel38.Name := 'WebLabel38';
    WebLabel38.Left := 12;
    WebLabel38.Top := 3;
    WebLabel38.Width := 183;
    WebLabel38.Height := 15;
    WebLabel38.Caption := 'Transaction Database Connection';
    WebLabel38.Font.Charset := DEFAULT_CHARSET;
    WebLabel38.Font.Color := clWindowText;
    WebLabel38.Font.Height := -12;
    WebLabel38.Font.Name := 'Segoe UI';
    WebLabel38.Font.Style := [fsBold];
    WebLabel38.HeightPercent := 100.000000000000000000;
    WebLabel38.ParentFont := False;
    WebLabel38.WidthPercent := 100.000000000000000000;
    WebLabel46.SetParentComponent(WebPanel18);
    WebLabel46.Name := 'WebLabel46';
    WebLabel46.Left := 28;
    WebLabel46.Top := 45;
    WebLabel46.Width := 88;
    WebLabel46.Height := 15;
    WebLabel46.Caption := 'Server Name / IP';
    WebLabel46.HeightPercent := 100.000000000000000000;
    WebLabel46.WidthPercent := 100.000000000000000000;
    WebLabel47.SetParentComponent(WebPanel18);
    WebLabel47.Name := 'WebLabel47';
    WebLabel47.Left := 28;
    WebLabel47.Top := 107;
    WebLabel47.Width := 75;
    WebLabel47.Height := 15;
    WebLabel47.Caption := 'Database Path';
    WebLabel47.HeightPercent := 100.000000000000000000;
    WebLabel47.WidthPercent := 100.000000000000000000;
    WebLabel48.SetParentComponent(WebPanel18);
    WebLabel48.Name := 'WebLabel48';
    WebLabel48.Left := 28;
    WebLabel48.Top := 166;
    WebLabel48.Width := 53;
    WebLabel48.Height := 15;
    WebLabel48.Caption := 'Username';
    WebLabel48.HeightPercent := 100.000000000000000000;
    WebLabel48.WidthPercent := 100.000000000000000000;
    WebLabel49.SetParentComponent(WebPanel18);
    WebLabel49.Name := 'WebLabel49';
    WebLabel49.Left := 249;
    WebLabel49.Top := 165;
    WebLabel49.Width := 50;
    WebLabel49.Height := 15;
    WebLabel49.Caption := 'Password';
    WebLabel49.HeightPercent := 100.000000000000000000;
    WebLabel49.WidthPercent := 100.000000000000000000;
    WebLabel50.SetParentComponent(WebPanel18);
    WebLabel50.Name := 'WebLabel50';
    WebLabel50.Left := 28;
    WebLabel50.Top := 231;
    WebLabel50.Width := 45;
    WebLabel50.Height := 15;
    WebLabel50.Caption := 'Protocol';
    WebLabel50.HeightPercent := 100.000000000000000000;
    WebLabel50.WidthPercent := 100.000000000000000000;
    WebLabel51.SetParentComponent(WebPanel18);
    WebLabel51.Name := 'WebLabel51';
    WebLabel51.Left := 249;
    WebLabel51.Top := 231;
    WebLabel51.Width := 45;
    WebLabel51.Height := 15;
    WebLabel51.Caption := 'Driver ID';
    WebLabel51.HeightPercent := 100.000000000000000000;
    WebLabel51.WidthPercent := 100.000000000000000000;
    WebLabel52.SetParentComponent(WebPanel18);
    WebLabel52.Name := 'WebLabel52';
    WebLabel52.Left := 28;
    WebLabel52.Top := 293;
    WebLabel52.Width := 22;
    WebLabel52.Height := 15;
    WebLabel52.Caption := 'Port';
    WebLabel52.HeightPercent := 100.000000000000000000;
    WebLabel52.WidthPercent := 100.000000000000000000;
    eServerName1.SetParentComponent(WebPanel18);
    eServerName1.Name := 'eServerName1';
    eServerName1.Left := 28;
    eServerName1.Top := 62;
    eServerName1.Width := 280;
    eServerName1.Height := 22;
    eServerName1.CharCase := wecUpperCase;
    eServerName1.ChildOrder := 8;
    eServerName1.HeightPercent := 100.000000000000000000;
    eServerName1.WidthPercent := 100.000000000000000000;
    eDBPath1.SetParentComponent(WebPanel18);
    eDBPath1.Name := 'eDBPath1';
    eDBPath1.Left := 28;
    eDBPath1.Top := 128;
    eDBPath1.Width := 421;
    eDBPath1.Height := 22;
    eDBPath1.CharCase := wecUpperCase;
    eDBPath1.ChildOrder := 9;
    eDBPath1.HeightPercent := 100.000000000000000000;
    eDBPath1.WidthPercent := 100.000000000000000000;
    eUsername1.SetParentComponent(WebPanel18);
    eUsername1.Name := 'eUsername1';
    eUsername1.Left := 28;
    eUsername1.Top := 187;
    eUsername1.Width := 200;
    eUsername1.Height := 22;
    eUsername1.ChildOrder := 10;
    eUsername1.HeightPercent := 100.000000000000000000;
    eUsername1.WidthPercent := 100.000000000000000000;
    ePassword1.SetParentComponent(WebPanel18);
    ePassword1.Name := 'ePassword1';
    ePassword1.Left := 249;
    ePassword1.Top := 186;
    ePassword1.Width := 200;
    ePassword1.Height := 22;
    ePassword1.ChildOrder := 11;
    ePassword1.HeightPercent := 100.000000000000000000;
    ePassword1.WidthPercent := 100.000000000000000000;
    ePort1.SetParentComponent(WebPanel18);
    ePort1.Name := 'ePort1';
    ePort1.Left := 28;
    ePort1.Top := 314;
    ePort1.Width := 200;
    ePort1.Height := 22;
    ePort1.ChildOrder := 12;
    ePort1.HeightPercent := 100.000000000000000000;
    ePort1.WidthPercent := 100.000000000000000000;
    eProtocol1.SetParentComponent(WebPanel18);
    eProtocol1.Name := 'eProtocol1';
    eProtocol1.Left := 28;
    eProtocol1.Top := 252;
    eProtocol1.Width := 200;
    eProtocol1.Height := 23;
    eProtocol1.HeightPercent := 100.000000000000000000;
    eProtocol1.Text := 'eProtocol1';
    eProtocol1.WidthPercent := 100.000000000000000000;
    eProtocol1.ItemIndex := -1;
    eDriverID1.SetParentComponent(WebPanel18);
    eDriverID1.Name := 'eDriverID1';
    eDriverID1.Left := 249;
    eDriverID1.Top := 252;
    eDriverID1.Width := 200;
    eDriverID1.Height := 23;
    eDriverID1.HeightPercent := 100.000000000000000000;
    eDriverID1.Text := 'eDriverID1';
    eDriverID1.WidthPercent := 100.000000000000000000;
    eDriverID1.ItemIndex := -1;
    WebTabSheet5.SetParentComponent(WebPageControl1);
    WebTabSheet5.Name := 'WebTabSheet5';
    WebTabSheet5.Left := 0;
    WebTabSheet5.Top := 20;
    WebTabSheet5.Width := 1556;
    WebTabSheet5.Height := 549;
    WebTabSheet5.Caption := 'WebPageControl1Sheet2';
    WebTabSheet5.ChildOrder := 1;
    WebPanel19.SetParentComponent(WebTabSheet5);
    WebPanel19.Name := 'WebPanel19';
    WebPanel19.Left := 0;
    WebPanel19.Top := 0;
    WebPanel19.Width := 1556;
    WebPanel19.Height := 549;
    WebPanel19.Align := alClient;
    WebPanel19.Color := clSilver;
    WebPanel19.TabOrder := 0;
    WebLabel57.SetParentComponent(WebPanel19);
    WebLabel57.Name := 'WebLabel57';
    WebLabel57.Left := 48;
    WebLabel57.Top := 64;
    WebLabel57.Width := 159;
    WebLabel57.Height := 15;
    WebLabel57.Caption := 'Sage Partner registered Name:';
    WebLabel57.HeightPercent := 100.000000000000000000;
    WebLabel57.WidthPercent := 100.000000000000000000;
    WebLabel58.SetParentComponent(WebPanel19);
    WebLabel58.Name := 'WebLabel58';
    WebLabel58.Left := 48;
    WebLabel58.Top := 113;
    WebLabel58.Width := 181;
    WebLabel58.Height := 15;
    WebLabel58.Caption := 'Sage Partner Authorisation Code : ';
    WebLabel58.HeightPercent := 100.000000000000000000;
    WebLabel58.WidthPercent := 100.000000000000000000;
    WebLabel59.SetParentComponent(WebPanel19);
    WebLabel59.Name := 'WebLabel59';
    WebLabel59.Left := 48;
    WebLabel59.Top := 161;
    WebLabel59.Width := 60;
    WebLabel59.Height := 15;
    WebLabel59.Caption := 'Data Path : ';
    WebLabel59.HeightPercent := 100.000000000000000000;
    WebLabel59.WidthPercent := 100.000000000000000000;
    WebLabel60.SetParentComponent(WebPanel19);
    WebLabel60.Name := 'WebLabel60';
    WebLabel60.Left := 720;
    WebLabel60.Top := 24;
    WebLabel60.Width := 82;
    WebLabel60.Height := 15;
    WebLabel60.Caption := 'Sales Accounts:';
    WebLabel60.HeightPercent := 100.000000000000000000;
    WebLabel60.WidthPercent := 100.000000000000000000;
    WebLabel67.SetParentComponent(WebPanel19);
    WebLabel67.Name := 'WebLabel67';
    WebLabel67.Left := 48;
    WebLabel67.Top := 215;
    WebLabel67.Width := 77;
    WebLabel67.Height := 15;
    WebLabel67.Caption := 'Bank Account:';
    WebLabel67.HeightPercent := 100.000000000000000000;
    WebLabel67.WidthPercent := 100.000000000000000000;
    WebLabel68.SetParentComponent(WebPanel19);
    WebLabel68.Name := 'WebLabel68';
    WebLabel68.Left := 720;
    WebLabel68.Top := 231;
    WebLabel68.Width := 98;
    WebLabel68.Height := 15;
    WebLabel68.Caption := 'Expense Accounts;';
    WebLabel68.HeightPercent := 100.000000000000000000;
    WebLabel68.WidthPercent := 100.000000000000000000;
    WebPanel20.SetParentComponent(WebPanel19);
    WebPanel20.Name := 'WebPanel20';
    WebPanel20.Left := 5;
    WebPanel20.Top := 5;
    WebPanel20.Width := 97;
    WebPanel20.Height := 36;
    WebPanel20.Caption := 'System 1';
    WebPanel20.ChildOrder := 6;
    WebPanel20.Font.Charset := DEFAULT_CHARSET;
    WebPanel20.Font.Color := clWindowText;
    WebPanel20.Font.Height := -12;
    WebPanel20.Font.Name := 'Segoe UI';
    WebPanel20.Font.Style := [fsBold];
    WebPanel20.ParentFont := False;
    WebPanel20.TabOrder := 0;
    chk1.SetParentComponent(WebPanel19);
    chk1.Name := 'chk1';
    chk1.Left := 387;
    chk1.Top := 76;
    chk1.Width := 139;
    chk1.Height := 22;
    chk1.Alignment := taLeftJustify;
    chk1.Caption := 'Use Sage Offline:';
    chk1.ChildOrder := 5;
    chk1.HeightPercent := 100.000000000000000000;
    chk1.WidthPercent := 100.000000000000000000;
    WebGroupBox1.SetParentComponent(WebPanel19);
    WebGroupBox1.Name := 'WebGroupBox1';
    WebGroupBox1.Left := 387;
    WebGroupBox1.Top := 107;
    WebGroupBox1.Width := 270;
    WebGroupBox1.Height := 113;
    WebGroupBox1.BorderColor := clSilver;
    WebGroupBox1.Caption := 'VAT Codes:';
    WebGroupBox1.ChildOrder := 6;
    WebGroupBox1.Color := clSilver;
    WebLabel61.SetParentComponent(WebGroupBox1);
    WebLabel61.Name := 'WebLabel61';
    WebLabel61.Left := 17;
    WebLabel61.Top := 21;
    WebLabel61.Width := 48;
    WebLabel61.Height := 15;
    WebLabel61.Caption := 'Sales Vat:';
    WebLabel61.HeightPercent := 100.000000000000000000;
    WebLabel61.WidthPercent := 100.000000000000000000;
    WebLabel62.SetParentComponent(WebGroupBox1);
    WebLabel62.Name := 'WebLabel62';
    WebLabel62.Left := 17;
    WebLabel62.Top := 50;
    WebLabel62.Width := 64;
    WebLabel62.Height := 15;
    WebLabel62.Caption := 'Expense Vat:';
    WebLabel62.HeightPercent := 100.000000000000000000;
    WebLabel62.WidthPercent := 100.000000000000000000;
    WebLabel63.SetParentComponent(WebGroupBox1);
    WebLabel63.Name := 'WebLabel63';
    WebLabel63.Left := 17;
    WebLabel63.Top := 80;
    WebLabel63.Width := 53;
    WebLabel63.Height := 15;
    WebLabel63.Caption := 'Zero Rate:';
    WebLabel63.HeightPercent := 100.000000000000000000;
    WebLabel63.WidthPercent := 100.000000000000000000;
    edtSalesVat.SetParentComponent(WebGroupBox1);
    edtSalesVat.Name := 'edtSalesVat';
    edtSalesVat.Left := 105;
    edtSalesVat.Top := 18;
    edtSalesVat.Width := 150;
    edtSalesVat.Height := 22;
    edtSalesVat.ChildOrder := 3;
    edtSalesVat.HeightPercent := 100.000000000000000000;
    edtSalesVat.WidthPercent := 100.000000000000000000;
    edtExpenseVat.SetParentComponent(WebGroupBox1);
    edtExpenseVat.Name := 'edtExpenseVat';
    edtExpenseVat.Left := 105;
    edtExpenseVat.Top := 47;
    edtExpenseVat.Width := 150;
    edtExpenseVat.Height := 22;
    edtExpenseVat.ChildOrder := 4;
    edtExpenseVat.HeightPercent := 100.000000000000000000;
    edtExpenseVat.WidthPercent := 100.000000000000000000;
    edtZeroRate.SetParentComponent(WebGroupBox1);
    edtZeroRate.Name := 'edtZeroRate';
    edtZeroRate.Left := 105;
    edtZeroRate.Top := 77;
    edtZeroRate.Width := 150;
    edtZeroRate.Height := 22;
    edtZeroRate.ChildOrder := 5;
    edtZeroRate.HeightPercent := 100.000000000000000000;
    edtZeroRate.WidthPercent := 100.000000000000000000;
    WebGroupBox2.SetParentComponent(WebPanel19);
    WebGroupBox2.Name := 'WebGroupBox2';
    WebGroupBox2.Left := 387;
    WebGroupBox2.Top := 234;
    WebGroupBox2.Width := 270;
    WebGroupBox2.Height := 113;
    WebGroupBox2.BorderColor := clSilver;
    WebGroupBox2.Caption := 'Inventory:';
    WebGroupBox2.ChildOrder := 7;
    WebGroupBox2.Color := clSilver;
    WebLabel64.SetParentComponent(WebGroupBox2);
    WebLabel64.Name := 'WebLabel64';
    WebLabel64.Left := 12;
    WebLabel64.Top := 21;
    WebLabel64.Width := 34;
    WebLabel64.Height := 15;
    WebLabel64.Caption := 'Diesel:';
    WebLabel64.HeightPercent := 100.000000000000000000;
    WebLabel64.WidthPercent := 100.000000000000000000;
    WebLabel65.SetParentComponent(WebGroupBox2);
    WebLabel65.Name := 'WebLabel65';
    WebLabel65.Left := 12;
    WebLabel65.Top := 50;
    WebLabel65.Width := 72;
    WebLabel65.Height := 15;
    WebLabel65.Caption := 'Maintenance:';
    WebLabel65.HeightPercent := 100.000000000000000000;
    WebLabel65.WidthPercent := 100.000000000000000000;
    WebLabel66.SetParentComponent(WebGroupBox2);
    WebLabel66.Name := 'WebLabel66';
    WebLabel66.Left := 12;
    WebLabel66.Top := 80;
    WebLabel66.Width := 30;
    WebLabel66.Height := 15;
    WebLabel66.Caption := 'Tyres:';
    WebLabel66.HeightPercent := 100.000000000000000000;
    WebLabel66.WidthPercent := 100.000000000000000000;
    fin1dieselinv.SetParentComponent(WebGroupBox2);
    fin1dieselinv.Name := 'fin1dieselinv';
    fin1dieselinv.Left := 105;
    fin1dieselinv.Top := 18;
    fin1dieselinv.Width := 150;
    fin1dieselinv.Height := 22;
    fin1dieselinv.ChildOrder := 3;
    fin1dieselinv.HeightPercent := 100.000000000000000000;
    fin1dieselinv.WidthPercent := 100.000000000000000000;
    fin1maintinv.SetParentComponent(WebGroupBox2);
    fin1maintinv.Name := 'fin1maintinv';
    fin1maintinv.Left := 105;
    fin1maintinv.Top := 48;
    fin1maintinv.Width := 150;
    fin1maintinv.Height := 22;
    fin1maintinv.ChildOrder := 4;
    fin1maintinv.HeightPercent := 100.000000000000000000;
    fin1maintinv.WidthPercent := 100.000000000000000000;
    fin1tyresinv.SetParentComponent(WebGroupBox2);
    fin1tyresinv.Name := 'fin1tyresinv';
    fin1tyresinv.Left := 105;
    fin1tyresinv.Top := 81;
    fin1tyresinv.Width := 150;
    fin1tyresinv.Height := 22;
    fin1tyresinv.ChildOrder := 5;
    fin1tyresinv.HeightPercent := 100.000000000000000000;
    fin1tyresinv.WidthPercent := 100.000000000000000000;
    edtsagepartnername.SetParentComponent(WebPanel19);
    edtsagepartnername.Name := 'edtsagepartnername';
    edtsagepartnername.Left := 50;
    edtsagepartnername.Top := 90;
    edtsagepartnername.Width := 280;
    edtsagepartnername.Height := 22;
    edtsagepartnername.ChildOrder := 8;
    edtsagepartnername.HeightPercent := 100.000000000000000000;
    edtsagepartnername.WidthPercent := 100.000000000000000000;
    edt1.SetParentComponent(WebPanel19);
    edt1.Name := 'edt1';
    edt1.Left := 48;
    edt1.Top := 132;
    edt1.Width := 280;
    edt1.Height := 22;
    edt1.ChildOrder := 9;
    edt1.HeightPercent := 100.000000000000000000;
    edt1.WidthPercent := 100.000000000000000000;
    Edit1.SetParentComponent(WebPanel19);
    Edit1.Name := 'Edit1';
    Edit1.Left := 48;
    Edit1.Top := 182;
    Edit1.Width := 280;
    Edit1.Height := 22;
    Edit1.ChildOrder := 10;
    Edit1.HeightPercent := 100.000000000000000000;
    Edit1.WidthPercent := 100.000000000000000000;
    fin1Bank.SetParentComponent(WebPanel19);
    fin1Bank.Name := 'fin1Bank';
    fin1Bank.Left := 48;
    fin1Bank.Top := 237;
    fin1Bank.Width := 121;
    fin1Bank.Height := 22;
    fin1Bank.ChildOrder := 12;
    fin1Bank.HeightPercent := 100.000000000000000000;
    fin1Bank.WidthPercent := 100.000000000000000000;
    fncMasterGrid.SetParentComponent(WebPanel19);
    fncMasterGrid.Name := 'fncMasterGrid';
    fncMasterGrid.Left := 720;
    fncMasterGrid.Top := 45;
    fncMasterGrid.Width := 520;
    fncMasterGrid.Height := 168;
    fncMasterGrid.ParentDoubleBuffered := False;
    fncMasterGrid.DoubleBuffered := True;
    fncMasterGrid.TabOrder := 8;
    fncMasterGrid.DefaultRowHeight := 40.000000000000000000;
    fncMasterGrid.FixedColumns := 0;
    fncMasterGrid.ColumnCount := 4;
    fncMasterGrid.Options.Bands.Enabled := True;
    fncMasterGrid.Options.Editing.CalcFormat := '%g';
    fncMasterGrid.Options.Grouping.CalcFormat := '%g';
    fncMasterGrid.Options.Grouping.GroupCountFormat := '(%d)';
    fncMasterGrid.Options.IO.XMLEncoding := 'ISO-8859-1';
    fncMasterGrid.Options.Mouse.ClickMargin := 0;
    fncMasterGrid.Options.Mouse.ColumnSizeMargin := 6;
    fncMasterGrid.Options.Mouse.RowSizeMargin := 6;
    fncMasterGrid.Columns.Clear;
    with fncMasterGrid.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 70.000000000000000000;
    end;
    with fncMasterGrid.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 250.000000000000000000;
    end;
    with fncMasterGrid.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 100.000000000000000000;
    end;
    with fncMasterGrid.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 100.000000000000000000;
    end;
    with fncMasterGrid.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 90.000000000000000000;
    end;
    fncMasterGrid.DefaultFont.Charset := DEFAULT_CHARSET;
    fncMasterGrid.DefaultFont.Color := clWindowText;
    fncMasterGrid.DefaultFont.Height := -11;
    fncMasterGrid.DefaultFont.Name := 'Segoe UI';
    fncMasterGrid.DefaultFont.Style := [];
    fncMasterGrid.TopRow := 1;
    fncMasterGrid.Appearance.FixedLayout.Fill.Color := 16380654;
    fncMasterGrid.Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    fncMasterGrid.Appearance.FixedLayout.Font.Color := 4539717;
    fncMasterGrid.Appearance.FixedLayout.Font.Height := -13;
    fncMasterGrid.Appearance.FixedLayout.Font.Name := 'Segoe UI';
    fncMasterGrid.Appearance.FixedLayout.Font.Style := [fsBold];
    fncMasterGrid.Appearance.NormalLayout.Fill.Color := 16578806;
    fncMasterGrid.Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    fncMasterGrid.Appearance.NormalLayout.Font.Color := 8026746;
    fncMasterGrid.Appearance.NormalLayout.Font.Height := -11;
    fncMasterGrid.Appearance.NormalLayout.Font.Name := 'Segoe UI';
    fncMasterGrid.Appearance.NormalLayout.Font.Style := [];
    fncMasterGrid.Appearance.GroupLayout.Fill.Color := 12817262;
    fncMasterGrid.Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    fncMasterGrid.Appearance.GroupLayout.Font.Color := clBlack;
    fncMasterGrid.Appearance.GroupLayout.Font.Height := -11;
    fncMasterGrid.Appearance.GroupLayout.Font.Name := 'Segoe UI';
    fncMasterGrid.Appearance.GroupLayout.Font.Style := [];
    fncMasterGrid.Appearance.SummaryLayout.Fill.Color := 14009785;
    fncMasterGrid.Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    fncMasterGrid.Appearance.SummaryLayout.Font.Color := clBlack;
    fncMasterGrid.Appearance.SummaryLayout.Font.Height := -11;
    fncMasterGrid.Appearance.SummaryLayout.Font.Name := 'Segoe UI';
    fncMasterGrid.Appearance.SummaryLayout.Font.Style := [];
    fncMasterGrid.Appearance.SelectedLayout.Fill.Color := 16441019;
    fncMasterGrid.Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    fncMasterGrid.Appearance.SelectedLayout.Font.Color := 4539717;
    fncMasterGrid.Appearance.SelectedLayout.Font.Height := -11;
    fncMasterGrid.Appearance.SelectedLayout.Font.Name := 'Segoe UI';
    fncMasterGrid.Appearance.SelectedLayout.Font.Style := [];
    fncMasterGrid.Appearance.FocusedLayout.Fill.Color := 16039284;
    fncMasterGrid.Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    fncMasterGrid.Appearance.FocusedLayout.Font.Color := 4539717;
    fncMasterGrid.Appearance.FocusedLayout.Font.Height := -11;
    fncMasterGrid.Appearance.FocusedLayout.Font.Name := 'Segoe UI';
    fncMasterGrid.Appearance.FocusedLayout.Font.Style := [];
    fncMasterGrid.Appearance.FixedSelectedLayout.Fill.Color := clLightsteelblue;
    fncMasterGrid.Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    fncMasterGrid.Appearance.FixedSelectedLayout.Font.Color := clBlack;
    fncMasterGrid.Appearance.FixedSelectedLayout.Font.Height := -11;
    fncMasterGrid.Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    fncMasterGrid.Appearance.FixedSelectedLayout.Font.Style := [];
    fncMasterGrid.Appearance.BandLayout.Fill.Color := 16711679;
    fncMasterGrid.Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    fncMasterGrid.Appearance.BandLayout.Font.Color := 8026746;
    fncMasterGrid.Appearance.BandLayout.Font.Height := -11;
    fncMasterGrid.Appearance.BandLayout.Font.Name := 'Segoe UI';
    fncMasterGrid.Appearance.BandLayout.Font.Style := [];
    fncMasterGrid.Appearance.ProgressLayout.Format := '%.0f%%';
    fncMasterGrid.LeftCol := 0;
    fncMasterGrid.ScrollMode := scmItemScrolling;
    fncMasterGrid.DesignTimeSampleData := True;
    fncTransactionGrid.SetParentComponent(WebPanel19);
    fncTransactionGrid.Name := 'fncTransactionGrid';
    fncTransactionGrid.Left := 720;
    fncTransactionGrid.Top := 252;
    fncTransactionGrid.Width := 520;
    fncTransactionGrid.Height := 176;
    fncTransactionGrid.ParentDoubleBuffered := False;
    fncTransactionGrid.DoubleBuffered := True;
    fncTransactionGrid.TabOrder := 9;
    fncTransactionGrid.DefaultRowHeight := 40.000000000000000000;
    fncTransactionGrid.FixedColumns := 0;
    fncTransactionGrid.ColumnCount := 4;
    fncTransactionGrid.Options.Bands.Enabled := True;
    fncTransactionGrid.Options.Editing.CalcFormat := '%g';
    fncTransactionGrid.Options.Grouping.CalcFormat := '%g';
    fncTransactionGrid.Options.Grouping.GroupCountFormat := '(%d)';
    fncTransactionGrid.Options.IO.XMLEncoding := 'ISO-8859-1';
    fncTransactionGrid.Options.Mouse.ClickMargin := 0;
    fncTransactionGrid.Options.Mouse.ColumnSizeMargin := 6;
    fncTransactionGrid.Options.Mouse.RowSizeMargin := 6;
    fncTransactionGrid.Columns.Clear;
    with fncTransactionGrid.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 70.000000000000000000;
    end;
    with fncTransactionGrid.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 250.000000000000000000;
    end;
    with fncTransactionGrid.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 100.000000000000000000;
    end;
    with fncTransactionGrid.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 100.000000000000000000;
    end;
    with fncTransactionGrid.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 90.000000000000000000;
    end;
    fncTransactionGrid.DefaultFont.Charset := DEFAULT_CHARSET;
    fncTransactionGrid.DefaultFont.Color := clWindowText;
    fncTransactionGrid.DefaultFont.Height := -11;
    fncTransactionGrid.DefaultFont.Name := 'Segoe UI';
    fncTransactionGrid.DefaultFont.Style := [];
    fncTransactionGrid.TopRow := 1;
    fncTransactionGrid.Appearance.FixedLayout.Fill.Color := 16380654;
    fncTransactionGrid.Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    fncTransactionGrid.Appearance.FixedLayout.Font.Color := 4539717;
    fncTransactionGrid.Appearance.FixedLayout.Font.Height := -13;
    fncTransactionGrid.Appearance.FixedLayout.Font.Name := 'Segoe UI';
    fncTransactionGrid.Appearance.FixedLayout.Font.Style := [fsBold];
    fncTransactionGrid.Appearance.NormalLayout.Fill.Color := 16578806;
    fncTransactionGrid.Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    fncTransactionGrid.Appearance.NormalLayout.Font.Color := 8026746;
    fncTransactionGrid.Appearance.NormalLayout.Font.Height := -11;
    fncTransactionGrid.Appearance.NormalLayout.Font.Name := 'Segoe UI';
    fncTransactionGrid.Appearance.NormalLayout.Font.Style := [];
    fncTransactionGrid.Appearance.GroupLayout.Fill.Color := 12817262;
    fncTransactionGrid.Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    fncTransactionGrid.Appearance.GroupLayout.Font.Color := clBlack;
    fncTransactionGrid.Appearance.GroupLayout.Font.Height := -11;
    fncTransactionGrid.Appearance.GroupLayout.Font.Name := 'Segoe UI';
    fncTransactionGrid.Appearance.GroupLayout.Font.Style := [];
    fncTransactionGrid.Appearance.SummaryLayout.Fill.Color := 14009785;
    fncTransactionGrid.Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    fncTransactionGrid.Appearance.SummaryLayout.Font.Color := clBlack;
    fncTransactionGrid.Appearance.SummaryLayout.Font.Height := -11;
    fncTransactionGrid.Appearance.SummaryLayout.Font.Name := 'Segoe UI';
    fncTransactionGrid.Appearance.SummaryLayout.Font.Style := [];
    fncTransactionGrid.Appearance.SelectedLayout.Fill.Color := 16441019;
    fncTransactionGrid.Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    fncTransactionGrid.Appearance.SelectedLayout.Font.Color := 4539717;
    fncTransactionGrid.Appearance.SelectedLayout.Font.Height := -11;
    fncTransactionGrid.Appearance.SelectedLayout.Font.Name := 'Segoe UI';
    fncTransactionGrid.Appearance.SelectedLayout.Font.Style := [];
    fncTransactionGrid.Appearance.FocusedLayout.Fill.Color := 16039284;
    fncTransactionGrid.Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    fncTransactionGrid.Appearance.FocusedLayout.Font.Color := 4539717;
    fncTransactionGrid.Appearance.FocusedLayout.Font.Height := -11;
    fncTransactionGrid.Appearance.FocusedLayout.Font.Name := 'Segoe UI';
    fncTransactionGrid.Appearance.FocusedLayout.Font.Style := [];
    fncTransactionGrid.Appearance.FixedSelectedLayout.Fill.Color := clLightsteelblue;
    fncTransactionGrid.Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    fncTransactionGrid.Appearance.FixedSelectedLayout.Font.Color := clBlack;
    fncTransactionGrid.Appearance.FixedSelectedLayout.Font.Height := -11;
    fncTransactionGrid.Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    fncTransactionGrid.Appearance.FixedSelectedLayout.Font.Style := [];
    fncTransactionGrid.Appearance.BandLayout.Fill.Color := 16711679;
    fncTransactionGrid.Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    fncTransactionGrid.Appearance.BandLayout.Font.Color := 8026746;
    fncTransactionGrid.Appearance.BandLayout.Font.Height := -11;
    fncTransactionGrid.Appearance.BandLayout.Font.Name := 'Segoe UI';
    fncTransactionGrid.Appearance.BandLayout.Font.Style := [];
    fncTransactionGrid.Appearance.ProgressLayout.Format := '%.0f%%';
    fncTransactionGrid.LeftCol := 0;
    fncTransactionGrid.ScrollMode := scmItemScrolling;
    fncTransactionGrid.DesignTimeSampleData := True;
    WebTabSheet6.SetParentComponent(WebPageControl1);
    WebTabSheet6.Name := 'WebTabSheet6';
    WebTabSheet6.Left := 0;
    WebTabSheet6.Top := 20;
    WebTabSheet6.Width := 1556;
    WebTabSheet6.Height := 549;
    WebTabSheet6.Caption := 'WebTabSheet3';
    WebTabSheet6.ChildOrder := 2;
    WebPanel6.SetParentComponent(WebTabSheet6);
    WebPanel6.Name := 'WebPanel6';
    WebPanel6.Left := 0;
    WebPanel6.Top := 0;
    WebPanel6.Width := 1556;
    WebPanel6.Height := 549;
    WebPanel6.Align := alClient;
    WebPanel6.Color := clSilver;
    WebPanel6.TabOrder := 0;
    WebGroupBox3.SetParentComponent(WebPanel6);
    WebGroupBox3.Name := 'WebGroupBox3';
    WebGroupBox3.Left := 52;
    WebGroupBox3.Top := 42;
    WebGroupBox3.Width := 1165;
    WebGroupBox3.Height := 365;
    WebGroupBox3.BorderColor := clSilver;
    WebGroupBox3.Color := clSilver;
    WebLabel19.SetParentComponent(WebGroupBox3);
    WebLabel19.Name := 'WebLabel19';
    WebLabel19.Left := 191;
    WebLabel19.Top := 46;
    WebLabel19.Width := 51;
    WebLabel19.Height := 15;
    WebLabel19.Caption := 'Url Path : ';
    WebLabel19.HeightPercent := 100.000000000000000000;
    WebLabel19.WidthPercent := 100.000000000000000000;
    WebLabel54.SetParentComponent(WebGroupBox3);
    WebLabel54.Name := 'WebLabel54';
    WebLabel54.Left := 175;
    WebLabel54.Top := 100;
    WebLabel54.Width := 67;
    WebLabel54.Height := 15;
    WebLabel54.Caption := 'User Name : ';
    WebLabel54.HeightPercent := 100.000000000000000000;
    WebLabel54.WidthPercent := 100.000000000000000000;
    WebLabel55.SetParentComponent(WebGroupBox3);
    WebLabel55.Name := 'WebLabel55';
    WebLabel55.Left := 188;
    WebLabel55.Top := 155;
    WebLabel55.Width := 59;
    WebLabel55.Height := 15;
    WebLabel55.Caption := 'Password : ';
    WebLabel55.HeightPercent := 100.000000000000000000;
    WebLabel55.WidthPercent := 100.000000000000000000;
    WebLabel56.SetParentComponent(WebGroupBox3);
    WebLabel56.Name := 'WebLabel56';
    WebLabel56.Left := 199;
    WebLabel56.Top := 201;
    WebLabel56.Width := 49;
    WebLabel56.Height := 15;
    WebLabel56.Caption := 'API Key : ';
    WebLabel56.HeightPercent := 100.000000000000000000;
    WebLabel56.WidthPercent := 100.000000000000000000;
    WebLabel69.SetParentComponent(WebGroupBox3);
    WebLabel69.Name := 'WebLabel69';
    WebLabel69.Left := 162;
    WebLabel69.Top := 256;
    WebLabel69.Width := 77;
    WebLabel69.Height := 15;
    WebLabel69.Caption := 'Company No :';
    WebLabel69.HeightPercent := 100.000000000000000000;
    WebLabel69.WidthPercent := 100.000000000000000000;
    WebLabel70.SetParentComponent(WebGroupBox3);
    WebLabel70.Name := 'WebLabel70';
    WebLabel70.Left := 668;
    WebLabel70.Top := 90;
    WebLabel70.Width := 83;
    WebLabel70.Height := 15;
    WebLabel70.Caption := 'Bank Account : ';
    WebLabel70.HeightPercent := 100.000000000000000000;
    WebLabel70.WidthPercent := 100.000000000000000000;
    WebLabel71.SetParentComponent(WebGroupBox3);
    WebLabel71.Name := 'WebLabel71';
    WebLabel71.Left := 704;
    WebLabel71.Top := 123;
    WebLabel71.Width := 53;
    WebLabel71.Height := 15;
    WebLabel71.Caption := 'Vat Type : ';
    WebLabel71.HeightPercent := 100.000000000000000000;
    WebLabel71.WidthPercent := 100.000000000000000000;
    WebLabel72.SetParentComponent(WebGroupBox3);
    WebLabel72.Name := 'WebLabel72';
    WebLabel72.Left := 667;
    WebLabel72.Top := 156;
    WebLabel72.Width := 80;
    WebLabel72.Height := 15;
    WebLabel72.Caption := 'Zero Vat Type : ';
    WebLabel72.HeightPercent := 100.000000000000000000;
    WebLabel72.WidthPercent := 100.000000000000000000;
    WebLabel73.SetParentComponent(WebGroupBox3);
    WebLabel73.Name := 'WebLabel73';
    WebLabel73.Left := 591;
    WebLabel73.Top := 183;
    WebLabel73.Width := 141;
    WebLabel73.Height := 15;
    WebLabel73.Caption := 'Debtors Control Account : ';
    WebLabel73.HeightPercent := 100.000000000000000000;
    WebLabel73.WidthPercent := 100.000000000000000000;
    WebLabel74.SetParentComponent(WebGroupBox3);
    WebLabel74.Name := 'WebLabel74';
    WebLabel74.Left := 582;
    WebLabel74.Top := 214;
    WebLabel74.Width := 148;
    WebLabel74.Height := 15;
    WebLabel74.Caption := 'Creditors Control Account : ';
    WebLabel74.HeightPercent := 100.000000000000000000;
    WebLabel74.WidthPercent := 100.000000000000000000;
    WebLabel75.SetParentComponent(WebGroupBox3);
    WebLabel75.Name := 'WebLabel75';
    WebLabel75.Left := 657;
    WebLabel75.Top := 245;
    WebLabel75.Width := 90;
    WebLabel75.Height := 15;
    WebLabel75.Caption := 'Bank Clearance : ';
    WebLabel75.HeightPercent := 100.000000000000000000;
    WebLabel75.WidthPercent := 100.000000000000000000;
    Edit16.SetParentComponent(WebGroupBox3);
    Edit16.Name := 'Edit16';
    Edit16.Left := 272;
    Edit16.Top := 43;
    Edit16.Width := 472;
    Edit16.Height := 22;
    Edit16.ChildOrder := 11;
    Edit16.HeightPercent := 100.000000000000000000;
    Edit16.WidthPercent := 100.000000000000000000;
    Edit4.SetParentComponent(WebGroupBox3);
    Edit4.Name := 'Edit4';
    Edit4.Left := 272;
    Edit4.Top := 97;
    Edit4.Width := 234;
    Edit4.Height := 22;
    Edit4.ChildOrder := 12;
    Edit4.HeightPercent := 100.000000000000000000;
    Edit4.WidthPercent := 100.000000000000000000;
    Edit5.SetParentComponent(WebGroupBox3);
    Edit5.Name := 'Edit5';
    Edit5.Left := 272;
    Edit5.Top := 152;
    Edit5.Width := 161;
    Edit5.Height := 22;
    Edit5.ChildOrder := 13;
    Edit5.HeightPercent := 100.000000000000000000;
    Edit5.WidthPercent := 100.000000000000000000;
    Edit15.SetParentComponent(WebGroupBox3);
    Edit15.Name := 'Edit15';
    Edit15.Left := 272;
    Edit15.Top := 200;
    Edit15.Width := 234;
    Edit15.Height := 22;
    Edit15.ChildOrder := 14;
    Edit15.HeightPercent := 100.000000000000000000;
    Edit15.WidthPercent := 100.000000000000000000;
    Edit3.SetParentComponent(WebGroupBox3);
    Edit3.Name := 'Edit3';
    Edit3.Left := 272;
    Edit3.Top := 253;
    Edit3.Width := 144;
    Edit3.Height := 22;
    Edit3.ChildOrder := 15;
    Edit3.HeightPercent := 100.000000000000000000;
    Edit3.WidthPercent := 100.000000000000000000;
    Edit17.SetParentComponent(WebGroupBox3);
    Edit17.Name := 'Edit17';
    Edit17.Left := 780;
    Edit17.Top := 84;
    Edit17.Width := 121;
    Edit17.Height := 22;
    Edit17.ChildOrder := 16;
    Edit17.HeightPercent := 100.000000000000000000;
    Edit17.WidthPercent := 100.000000000000000000;
    Edit18.SetParentComponent(WebGroupBox3);
    Edit18.Name := 'Edit18';
    Edit18.Left := 780;
    Edit18.Top := 119;
    Edit18.Width := 121;
    Edit18.Height := 22;
    Edit18.ChildOrder := 17;
    Edit18.HeightPercent := 100.000000000000000000;
    Edit18.WidthPercent := 100.000000000000000000;
    Edit19.SetParentComponent(WebGroupBox3);
    Edit19.Name := 'Edit19';
    Edit19.Left := 780;
    Edit19.Top := 153;
    Edit19.Width := 121;
    Edit19.Height := 22;
    Edit19.ChildOrder := 18;
    Edit19.HeightPercent := 100.000000000000000000;
    Edit19.WidthPercent := 100.000000000000000000;
    Edit20.SetParentComponent(WebGroupBox3);
    Edit20.Name := 'Edit20';
    Edit20.Left := 780;
    Edit20.Top := 187;
    Edit20.Width := 121;
    Edit20.Height := 22;
    Edit20.ChildOrder := 19;
    Edit20.HeightPercent := 100.000000000000000000;
    Edit20.WidthPercent := 100.000000000000000000;
    Edit21.SetParentComponent(WebGroupBox3);
    Edit21.Name := 'Edit21';
    Edit21.Left := 780;
    Edit21.Top := 217;
    Edit21.Width := 121;
    Edit21.Height := 22;
    Edit21.ChildOrder := 20;
    Edit21.HeightPercent := 100.000000000000000000;
    Edit21.WidthPercent := 100.000000000000000000;
    edtBankClear.SetParentComponent(WebGroupBox3);
    edtBankClear.Name := 'edtBankClear';
    edtBankClear.Left := 780;
    edtBankClear.Top := 248;
    edtBankClear.Width := 121;
    edtBankClear.Height := 22;
    edtBankClear.ChildOrder := 21;
    edtBankClear.HeightPercent := 100.000000000000000000;
    edtBankClear.WidthPercent := 100.000000000000000000;
    WebButton5.SetParentComponent(WebGroupBox3);
    WebButton5.Name := 'WebButton5';
    WebButton5.Left := 426;
    WebButton5.Top := 252;
    WebButton5.Width := 25;
    WebButton5.Height := 25;
    WebButton5.Caption := '...';
    WebButton5.ChildOrder := 22;
    WebButton5.HeightPercent := 100.000000000000000000;
    WebButton5.WidthPercent := 100.000000000000000000;
    WebButton6.SetParentComponent(WebGroupBox3);
    WebButton6.Name := 'WebButton6';
    WebButton6.Left := 907;
    WebButton6.Top := 82;
    WebButton6.Width := 25;
    WebButton6.Height := 25;
    WebButton6.Caption := '...';
    WebButton6.ChildOrder := 23;
    WebButton6.HeightPercent := 100.000000000000000000;
    WebButton6.WidthPercent := 100.000000000000000000;
    WebButton7.SetParentComponent(WebGroupBox3);
    WebButton7.Name := 'WebButton7';
    WebButton7.Left := 907;
    WebButton7.Top := 117;
    WebButton7.Width := 25;
    WebButton7.Height := 25;
    WebButton7.Caption := '...';
    WebButton7.ChildOrder := 24;
    WebButton7.HeightPercent := 100.000000000000000000;
    WebButton7.WidthPercent := 100.000000000000000000;
    WebButton8.SetParentComponent(WebGroupBox3);
    WebButton8.Name := 'WebButton8';
    WebButton8.Left := 907;
    WebButton8.Top := 153;
    WebButton8.Width := 25;
    WebButton8.Height := 25;
    WebButton8.Caption := '...';
    WebButton8.ChildOrder := 25;
    WebButton8.HeightPercent := 100.000000000000000000;
    WebButton8.WidthPercent := 100.000000000000000000;
    WebButton9.SetParentComponent(WebGroupBox3);
    WebButton9.Name := 'WebButton9';
    WebButton9.Left := 907;
    WebButton9.Top := 185;
    WebButton9.Width := 25;
    WebButton9.Height := 25;
    WebButton9.Caption := '...';
    WebButton9.ChildOrder := 26;
    WebButton9.HeightPercent := 100.000000000000000000;
    WebButton9.WidthPercent := 100.000000000000000000;
    WebButton10.SetParentComponent(WebGroupBox3);
    WebButton10.Name := 'WebButton10';
    WebButton10.Left := 907;
    WebButton10.Top := 215;
    WebButton10.Width := 25;
    WebButton10.Height := 25;
    WebButton10.Caption := '...';
    WebButton10.ChildOrder := 27;
    WebButton10.HeightPercent := 100.000000000000000000;
    WebButton10.WidthPercent := 100.000000000000000000;
    WebButton11.SetParentComponent(WebGroupBox3);
    WebButton11.Name := 'WebButton11';
    WebButton11.Left := 907;
    WebButton11.Top := 247;
    WebButton11.Width := 25;
    WebButton11.Height := 25;
    WebButton11.Caption := '...';
    WebButton11.ChildOrder := 28;
    WebButton11.HeightPercent := 100.000000000000000000;
    WebButton11.WidthPercent := 100.000000000000000000;
    WebPageControlSheet5.SetParentComponent(wpcSysSetup);
    WebPageControlSheet5.Name := 'WebPageControlSheet5';
    WebPageControlSheet5.Left := 0;
    WebPageControlSheet5.Top := 20;
    WebPageControlSheet5.Width := 1556;
    WebPageControlSheet5.Height := 629;
    WebPageControlSheet5.Caption := 'Web Server Settings';
    WebPageControlSheet5.ChildOrder := 4;
    pnlWebServerSettings.SetParentComponent(WebPageControlSheet5);
    pnlWebServerSettings.Name := 'pnlWebServerSettings';
    pnlWebServerSettings.Left := 0;
    pnlWebServerSettings.Top := 0;
    pnlWebServerSettings.Width := 1556;
    pnlWebServerSettings.Height := 629;
    pnlWebServerSettings.Align := alClient;
    pnlWebServerSettings.Color := clSilver;
    pnlWebServerSettings.TabOrder := 0;
    WebLabel77.SetParentComponent(pnlWebServerSettings);
    WebLabel77.Name := 'WebLabel77';
    WebLabel77.Left := 709;
    WebLabel77.Top := 171;
    WebLabel77.Width := 86;
    WebLabel77.Height := 15;
    WebLabel77.Caption := 'API Server URL : ';
    WebLabel77.HeightPercent := 100.000000000000000000;
    WebLabel77.WidthPercent := 100.000000000000000000;
    WebLabel78.SetParentComponent(pnlWebServerSettings);
    WebLabel78.Name := 'WebLabel78';
    WebLabel78.Left := 709;
    WebLabel78.Top := 201;
    WebLabel78.Width := 110;
    WebLabel78.Height := 15;
    WebLabel78.Caption := 'API Server Account : ';
    WebLabel78.HeightPercent := 100.000000000000000000;
    WebLabel78.WidthPercent := 100.000000000000000000;
    WebLabel79.SetParentComponent(pnlWebServerSettings);
    WebLabel79.Name := 'WebLabel79';
    WebLabel79.Left := 709;
    WebLabel79.Top := 235;
    WebLabel79.Width := 118;
    WebLabel79.Height := 15;
    WebLabel79.Caption := 'API Server Username : ';
    WebLabel79.HeightPercent := 100.000000000000000000;
    WebLabel79.WidthPercent := 100.000000000000000000;
    WebLabel80.SetParentComponent(pnlWebServerSettings);
    WebLabel80.Name := 'WebLabel80';
    WebLabel80.Left := 709;
    WebLabel80.Top := 266;
    WebLabel80.Width := 115;
    WebLabel80.Height := 15;
    WebLabel80.Caption := 'API Server Password : ';
    WebLabel80.HeightPercent := 100.000000000000000000;
    WebLabel80.WidthPercent := 100.000000000000000000;
    WebLabel81.SetParentComponent(pnlWebServerSettings);
    WebLabel81.Name := 'WebLabel81';
    WebLabel81.Left := 709;
    WebLabel81.Top := 299;
    WebLabel81.Width := 84;
    WebLabel81.Height := 15;
    WebLabel81.Caption := 'API Server Key : ';
    WebLabel81.HeightPercent := 100.000000000000000000;
    WebLabel81.WidthPercent := 100.000000000000000000;
    WebLabel82.SetParentComponent(pnlWebServerSettings);
    WebLabel82.Name := 'WebLabel82';
    WebLabel82.Left := 105;
    WebLabel82.Top := 170;
    WebLabel82.Width := 92;
    WebLabel82.Height := 15;
    WebLabel82.Caption := 'Database Server : ';
    WebLabel82.HeightPercent := 100.000000000000000000;
    WebLabel82.WidthPercent := 100.000000000000000000;
    WebLabel83.SetParentComponent(pnlWebServerSettings);
    WebLabel83.Name := 'WebLabel83';
    WebLabel83.Left := 105;
    WebLabel83.Top := 203;
    WebLabel83.Width := 82;
    WebLabel83.Height := 15;
    WebLabel83.Caption := 'Database Port : ';
    WebLabel83.HeightPercent := 100.000000000000000000;
    WebLabel83.WidthPercent := 100.000000000000000000;
    WebLabel84.SetParentComponent(pnlWebServerSettings);
    WebLabel84.Name := 'WebLabel84';
    WebLabel84.Left := 105;
    WebLabel84.Top := 236;
    WebLabel84.Width := 57;
    WebLabel84.Height := 15;
    WebLabel84.Caption := 'Database : ';
    WebLabel84.HeightPercent := 100.000000000000000000;
    WebLabel84.WidthPercent := 100.000000000000000000;
    WebLabel85.SetParentComponent(pnlWebServerSettings);
    WebLabel85.Name := 'WebLabel85';
    WebLabel85.Left := 105;
    WebLabel85.Top := 267;
    WebLabel85.Width := 83;
    WebLabel85.Height := 15;
    WebLabel85.Caption := 'Database User : ';
    WebLabel85.HeightPercent := 100.000000000000000000;
    WebLabel85.WidthPercent := 100.000000000000000000;
    WebLabel86.SetParentComponent(pnlWebServerSettings);
    WebLabel86.Name := 'WebLabel86';
    WebLabel86.Left := 106;
    WebLabel86.Top := 299;
    WebLabel86.Width := 110;
    WebLabel86.Height := 15;
    WebLabel86.Caption := 'Database Password : ';
    WebLabel86.HeightPercent := 100.000000000000000000;
    WebLabel86.WidthPercent := 100.000000000000000000;
    WebLabel87.SetParentComponent(pnlWebServerSettings);
    WebLabel87.Name := 'WebLabel87';
    WebLabel87.Left := 105;
    WebLabel87.Top := 35;
    WebLabel87.Width := 113;
    WebLabel87.Height := 15;
    WebLabel87.Caption := 'Web Server Address : ';
    WebLabel87.HeightPercent := 100.000000000000000000;
    WebLabel87.WidthPercent := 100.000000000000000000;
    WebLabel88.SetParentComponent(pnlWebServerSettings);
    WebLabel88.Name := 'WebLabel88';
    WebLabel88.Left := 105;
    WebLabel88.Top := 71;
    WebLabel88.Width := 93;
    WebLabel88.Height := 15;
    WebLabel88.Caption := 'Web Server Port : ';
    WebLabel88.HeightPercent := 100.000000000000000000;
    WebLabel88.WidthPercent := 100.000000000000000000;
    WebDBEdit17.SetParentComponent(pnlWebServerSettings);
    WebDBEdit17.Name := 'WebDBEdit17';
    WebDBEdit17.Left := 240;
    WebDBEdit17.Top := 32;
    WebDBEdit17.Width := 272;
    WebDBEdit17.Height := 22;
    WebDBEdit17.HeightPercent := 100.000000000000000000;
    WebDBEdit17.WidthPercent := 100.000000000000000000;
    WebDBEdit17.DataField := 'WEBSERVERADDRESS';
    WebDBEdit17.DataSource := dsCompInfo;
    WebDBEdit18.SetParentComponent(pnlWebServerSettings);
    WebDBEdit18.Name := 'WebDBEdit18';
    WebDBEdit18.Left := 240;
    WebDBEdit18.Top := 64;
    WebDBEdit18.Width := 121;
    WebDBEdit18.Height := 22;
    WebDBEdit18.ChildOrder := 1;
    WebDBEdit18.HeightPercent := 100.000000000000000000;
    WebDBEdit18.WidthPercent := 100.000000000000000000;
    WebDBEdit18.DataField := 'WEBSERVERPORT';
    WebDBEdit18.DataSource := dsCompInfo;
    WebDBEdit19.SetParentComponent(pnlWebServerSettings);
    WebDBEdit19.Name := 'WebDBEdit19';
    WebDBEdit19.Left := 240;
    WebDBEdit19.Top := 168;
    WebDBEdit19.Width := 272;
    WebDBEdit19.Height := 22;
    WebDBEdit19.ChildOrder := 2;
    WebDBEdit19.HeightPercent := 100.000000000000000000;
    WebDBEdit19.WidthPercent := 100.000000000000000000;
    WebDBEdit19.DataField := 'DBSERVERADDRESS';
    WebDBEdit19.DataSource := dsCompInfo;
    WebDBEdit20.SetParentComponent(pnlWebServerSettings);
    WebDBEdit20.Name := 'WebDBEdit20';
    WebDBEdit20.Left := 240;
    WebDBEdit20.Top := 200;
    WebDBEdit20.Width := 121;
    WebDBEdit20.Height := 22;
    WebDBEdit20.ChildOrder := 3;
    WebDBEdit20.HeightPercent := 100.000000000000000000;
    WebDBEdit20.WidthPercent := 100.000000000000000000;
    WebDBEdit20.DataField := 'DBSERVERPORT';
    WebDBEdit20.DataSource := dsCompInfo;
    WebDBEdit21.SetParentComponent(pnlWebServerSettings);
    WebDBEdit21.Name := 'WebDBEdit21';
    WebDBEdit21.Left := 240;
    WebDBEdit21.Top := 232;
    WebDBEdit21.Width := 205;
    WebDBEdit21.Height := 22;
    WebDBEdit21.ChildOrder := 4;
    WebDBEdit21.HeightPercent := 100.000000000000000000;
    WebDBEdit21.WidthPercent := 100.000000000000000000;
    WebDBEdit21.DataField := 'WEBSERVERDB';
    WebDBEdit21.DataSource := dsCompInfo;
    WebDBEdit22.SetParentComponent(pnlWebServerSettings);
    WebDBEdit22.Name := 'WebDBEdit22';
    WebDBEdit22.Left := 240;
    WebDBEdit22.Top := 264;
    WebDBEdit22.Width := 169;
    WebDBEdit22.Height := 22;
    WebDBEdit22.ChildOrder := 5;
    WebDBEdit22.HeightPercent := 100.000000000000000000;
    WebDBEdit22.WidthPercent := 100.000000000000000000;
    WebDBEdit22.DataField := 'WEBSERVERDBUSER';
    WebDBEdit22.DataSource := dsCompInfo;
    WebDBEdit24.SetParentComponent(pnlWebServerSettings);
    WebDBEdit24.Name := 'WebDBEdit24';
    WebDBEdit24.Left := 848;
    WebDBEdit24.Top := 168;
    WebDBEdit24.Width := 369;
    WebDBEdit24.Height := 22;
    WebDBEdit24.ChildOrder := 7;
    WebDBEdit24.HeightPercent := 100.000000000000000000;
    WebDBEdit24.WidthPercent := 100.000000000000000000;
    WebDBEdit24.DataField := 'apiserverurl';
    WebDBEdit24.DataSource := dsCompInfo;
    WebDBEdit25.SetParentComponent(pnlWebServerSettings);
    WebDBEdit25.Name := 'WebDBEdit25';
    WebDBEdit25.Left := 848;
    WebDBEdit25.Top := 200;
    WebDBEdit25.Width := 177;
    WebDBEdit25.Height := 22;
    WebDBEdit25.ChildOrder := 8;
    WebDBEdit25.HeightPercent := 100.000000000000000000;
    WebDBEdit25.WidthPercent := 100.000000000000000000;
    WebDBEdit25.DataField := 'smsdieselpassword';
    WebDBEdit25.DataSource := dsCompInfo;
    WebDBEdit26.SetParentComponent(pnlWebServerSettings);
    WebDBEdit26.Name := 'WebDBEdit26';
    WebDBEdit26.Left := 848;
    WebDBEdit26.Top := 233;
    WebDBEdit26.Width := 265;
    WebDBEdit26.Height := 22;
    WebDBEdit26.ChildOrder := 9;
    WebDBEdit26.HeightPercent := 100.000000000000000000;
    WebDBEdit26.WidthPercent := 100.000000000000000000;
    WebDBEdit26.DataField := 'apiusername';
    WebDBEdit26.DataSource := dsCompInfo;
    WebDBEdit27.SetParentComponent(pnlWebServerSettings);
    WebDBEdit27.Name := 'WebDBEdit27';
    WebDBEdit27.Left := 848;
    WebDBEdit27.Top := 264;
    WebDBEdit27.Width := 177;
    WebDBEdit27.Height := 22;
    WebDBEdit27.ChildOrder := 10;
    WebDBEdit27.HeightPercent := 100.000000000000000000;
    WebDBEdit27.WidthPercent := 100.000000000000000000;
    WebDBEdit27.DataField := 'apipassword';
    WebDBEdit27.DataSource := dsCompInfo;
    WebDBEdit28.SetParentComponent(pnlWebServerSettings);
    WebDBEdit28.Name := 'WebDBEdit28';
    WebDBEdit28.Left := 848;
    WebDBEdit28.Top := 296;
    WebDBEdit28.Width := 177;
    WebDBEdit28.Height := 22;
    WebDBEdit28.ChildOrder := 11;
    WebDBEdit28.HeightPercent := 100.000000000000000000;
    WebDBEdit28.WidthPercent := 100.000000000000000000;
    WebDBEdit28.DataField := 'apikey';
    WebDBEdit28.DataSource := dsCompInfo;
    WebPanel12.SetParentComponent(pnlWebServerSettings);
    WebPanel12.Name := 'WebPanel12';
    WebPanel12.Left := 231;
    WebPanel12.Top := 430;
    WebPanel12.Width := 706;
    WebPanel12.Height := 60;
    WebPanel12.BorderColor := clWhite;
    WebPanel12.ChildOrder := 12;
    WebPanel12.TabOrder := 11;
    WebLabel36.SetParentComponent(WebPanel12);
    WebLabel36.Name := 'WebLabel36';
    WebLabel36.Left := 529;
    WebLabel36.Top := 5;
    WebLabel36.Width := 53;
    WebLabel36.Height := 15;
    WebLabel36.Caption := 'Password:';
    WebLabel36.HeightPercent := 100.000000000000000000;
    WebLabel36.WidthPercent := 100.000000000000000000;
    WebLabel37.SetParentComponent(WebPanel12);
    WebLabel37.Name := 'WebLabel37';
    WebLabel37.Left := 312;
    WebLabel37.Top := 5;
    WebLabel37.Width := 61;
    WebLabel37.Height := 15;
    WebLabel37.Caption := 'User Name:';
    WebLabel37.HeightPercent := 100.000000000000000000;
    WebLabel37.WidthPercent := 100.000000000000000000;
    WebLabel76.SetParentComponent(WebPanel12);
    WebLabel76.Name := 'WebLabel76';
    WebLabel76.Left := 14;
    WebLabel76.Top := 5;
    WebLabel76.Width := 71;
    WebLabel76.Height := 15;
    WebLabel76.Caption := 'SMS API URL:';
    WebLabel76.HeightPercent := 100.000000000000000000;
    WebLabel76.WidthPercent := 100.000000000000000000;
    WebDBEdit29.SetParentComponent(WebPanel12);
    WebDBEdit29.Name := 'WebDBEdit29';
    WebDBEdit29.Left := 14;
    WebDBEdit29.Top := 26;
    WebDBEdit29.Width := 292;
    WebDBEdit29.Height := 22;
    WebDBEdit29.HeightPercent := 100.000000000000000000;
    WebDBEdit29.WidthPercent := 100.000000000000000000;
    WebDBEdit29.DataField := 'smsdieselurl';
    WebDBEdit29.DataSource := dsCompInfo;
    WebDBEdit30.SetParentComponent(WebPanel12);
    WebDBEdit30.Name := 'WebDBEdit30';
    WebDBEdit30.Left := 312;
    WebDBEdit30.Top := 26;
    WebDBEdit30.Width := 211;
    WebDBEdit30.Height := 22;
    WebDBEdit30.ChildOrder := 1;
    WebDBEdit30.HeightPercent := 100.000000000000000000;
    WebDBEdit30.WidthPercent := 100.000000000000000000;
    WebDBEdit30.DataField := 'smsdieseluser';
    WebDBEdit30.DataSource := dsCompInfo;
    WebDBEdit31.SetParentComponent(WebPanel12);
    WebDBEdit31.Name := 'WebDBEdit31';
    WebDBEdit31.Left := 529;
    WebDBEdit31.Top := 26;
    WebDBEdit31.Width := 160;
    WebDBEdit31.Height := 22;
    WebDBEdit31.ChildOrder := 2;
    WebDBEdit31.HeightPercent := 100.000000000000000000;
    WebDBEdit31.WidthPercent := 100.000000000000000000;
    WebDBEdit31.DataField := 'smsdieselpassword';
    WebDBEdit31.DataSource := dsCompInfo;
    Edit2.SetParentComponent(pnlWebServerSettings);
    Edit2.Name := 'Edit2';
    Edit2.Left := 240;
    Edit2.Top := 298;
    Edit2.Width := 121;
    Edit2.Height := 22;
    Edit2.ChildOrder := 24;
    Edit2.HeightPercent := 100.000000000000000000;
    Edit2.WidthPercent := 100.000000000000000000;
    wpcSysSetupSheet6.SetParentComponent(wpcSysSetup);
    wpcSysSetupSheet6.Name := 'wpcSysSetupSheet6';
    wpcSysSetupSheet6.Left := 0;
    wpcSysSetupSheet6.Top := 20;
    wpcSysSetupSheet6.Width := 1556;
    wpcSysSetupSheet6.Height := 629;
    wpcSysSetupSheet6.Caption := 'Email Server Settings';
    wpcSysSetupSheet6.ChildOrder := 5;
    WebPanel21.SetParentComponent(wpcSysSetupSheet6);
    WebPanel21.Name := 'WebPanel21';
    WebPanel21.Left := 0;
    WebPanel21.Top := 0;
    WebPanel21.Width := 1556;
    WebPanel21.Height := 629;
    WebPanel21.Align := alClient;
    WebPanel21.Color := clSilver;
    WebPanel21.TabOrder := 0;
    dbcbxAutomailig.SetParentComponent(WebPanel21);
    dbcbxAutomailig.Name := 'dbcbxAutomailig';
    dbcbxAutomailig.Left := 91;
    dbcbxAutomailig.Top := 92;
    dbcbxAutomailig.Width := 143;
    dbcbxAutomailig.Height := 22;
    dbcbxAutomailig.Caption := 'dbcbxAutomailig';
    dbcbxAutomailig.HeightPercent := 100.000000000000000000;
    dbcbxAutomailig.WidthPercent := 100.000000000000000000;
    SetEvent(dbcbxAutomailig, Self, 'OnClick', 'dbcbxAutomailigClick');
    dbcbxAutomailig.DataField := 'AUTOMAILSYSTEM';
    dbcbxAutomailig.DataSource := dsCompInfo;
    wgbEmailSetup.SetParentComponent(WebPanel21);
    wgbEmailSetup.Name := 'wgbEmailSetup';
    wgbEmailSetup.Left := 68;
    wgbEmailSetup.Top := 120;
    wgbEmailSetup.Width := 400;
    wgbEmailSetup.Height := 209;
    wgbEmailSetup.BorderColor := clSilver;
    wgbEmailSetup.Caption := 'E-mail Server Setup';
    wgbEmailSetup.ChildOrder := 1;
    wgbEmailSetup.Color := clSilver;
    WebLabel89.SetParentComponent(wgbEmailSetup);
    WebLabel89.Name := 'WebLabel89';
    WebLabel89.Left := 28;
    WebLabel89.Top := 39;
    WebLabel89.Width := 86;
    WebLabel89.Height := 15;
    WebLabel89.Caption := 'Server Address : ';
    WebLabel89.HeightPercent := 100.000000000000000000;
    WebLabel89.WidthPercent := 100.000000000000000000;
    WebLabel90.SetParentComponent(wgbEmailSetup);
    WebLabel90.Name := 'WebLabel90';
    WebLabel90.Left := 256;
    WebLabel90.Top := 40;
    WebLabel90.Width := 66;
    WebLabel90.Height := 15;
    WebLabel90.Caption := 'Server Port : ';
    WebLabel90.HeightPercent := 100.000000000000000000;
    WebLabel90.WidthPercent := 100.000000000000000000;
    WebLabel91.SetParentComponent(wgbEmailSetup);
    WebLabel91.Name := 'WebLabel91';
    WebLabel91.Left := 29;
    WebLabel91.Top := 92;
    WebLabel91.Width := 106;
    WebLabel91.Height := 15;
    WebLabel91.Caption := 'E-Mail Server Type : ';
    WebLabel91.HeightPercent := 100.000000000000000000;
    WebLabel91.WidthPercent := 100.000000000000000000;
    WebDBEdit23.SetParentComponent(wgbEmailSetup);
    WebDBEdit23.Name := 'WebDBEdit23';
    WebDBEdit23.Left := 23;
    WebDBEdit23.Top := 60;
    WebDBEdit23.Width := 213;
    WebDBEdit23.Height := 22;
    WebDBEdit23.ChildOrder := 3;
    WebDBEdit23.HeightPercent := 100.000000000000000000;
    WebDBEdit23.WidthPercent := 100.000000000000000000;
    WebDBEdit23.DataField := 'MAILSERVER';
    WebDBEdit23.DataSource := dsCompInfo;
    WebDBEdit32.SetParentComponent(wgbEmailSetup);
    WebDBEdit32.Name := 'WebDBEdit32';
    WebDBEdit32.Left := 256;
    WebDBEdit32.Top := 60;
    WebDBEdit32.Width := 121;
    WebDBEdit32.Height := 22;
    WebDBEdit32.ChildOrder := 1;
    WebDBEdit32.HeightPercent := 100.000000000000000000;
    WebDBEdit32.WidthPercent := 100.000000000000000000;
    WebDBEdit32.DataField := 'MAILSERVERPORT';
    WebDBEdit32.DataSource := dsCompInfo;
    WebDBLookupComboBox1.SetParentComponent(wgbEmailSetup);
    WebDBLookupComboBox1.Name := 'WebDBLookupComboBox1';
    WebDBLookupComboBox1.Left := 23;
    WebDBLookupComboBox1.Top := 115;
    WebDBLookupComboBox1.Width := 264;
    WebDBLookupComboBox1.Height := 22;
    WebDBLookupComboBox1.HeightPercent := 100.000000000000000000;
    WebDBLookupComboBox1.WidthPercent := 100.000000000000000000;
    WebDBLookupComboBox1.DataField := 'MAILSERVERPROTOCOL';
    WebDBLookupComboBox1.DataSource := dsCompInfo;
    WebDBCheckBox2.SetParentComponent(wgbEmailSetup);
    WebDBCheckBox2.Name := 'WebDBCheckBox2';
    WebDBCheckBox2.Left := 40;
    WebDBCheckBox2.Top := 163;
    WebDBCheckBox2.Width := 53;
    WebDBCheckBox2.Height := 22;
    WebDBCheckBox2.Caption := 'SSL';
    WebDBCheckBox2.ChildOrder := 6;
    WebDBCheckBox2.HeightPercent := 100.000000000000000000;
    WebDBCheckBox2.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox2, Self, 'OnClick', 'WebDBCheckBox2Click');
    WebDBCheckBox2.DataField := 'MAILSERVERSSL';
    WebDBCheckBox2.DataSource := dsCompInfo;
    WebDBCheckBox3.SetParentComponent(wgbEmailSetup);
    WebDBCheckBox3.Name := 'WebDBCheckBox3';
    WebDBCheckBox3.Left := 245;
    WebDBCheckBox3.Top := 163;
    WebDBCheckBox3.Width := 124;
    WebDBCheckBox3.Height := 22;
    WebDBCheckBox3.Caption := 'Authentication ';
    WebDBCheckBox3.ChildOrder := 7;
    WebDBCheckBox3.HeightPercent := 100.000000000000000000;
    WebDBCheckBox3.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox3, Self, 'OnClick', 'WebDBCheckBox3Click');
    WebDBCheckBox3.DataField := 'MAILSERVERAUTH';
    WebDBCheckBox3.DataSource := dsCompInfo;
    wgbAuthentication.SetParentComponent(WebPanel21);
    wgbAuthentication.Name := 'wgbAuthentication';
    wgbAuthentication.Left := 518;
    wgbAuthentication.Top := 125;
    wgbAuthentication.Width := 400;
    wgbAuthentication.Height := 132;
    wgbAuthentication.BorderColor := clSilver;
    wgbAuthentication.Caption := 'Authentication Information';
    wgbAuthentication.ChildOrder := 2;
    wgbAuthentication.Color := clSilver;
    WebLabel92.SetParentComponent(wgbAuthentication);
    WebLabel92.Name := 'WebLabel92';
    WebLabel92.Left := 19;
    WebLabel92.Top := 53;
    WebLabel92.Width := 67;
    WebLabel92.Height := 15;
    WebLabel92.Caption := 'User Name : ';
    WebLabel92.HeightPercent := 100.000000000000000000;
    WebLabel92.WidthPercent := 100.000000000000000000;
    WebLabel93.SetParentComponent(wgbAuthentication);
    WebLabel93.Name := 'WebLabel93';
    WebLabel93.Left := 224;
    WebLabel93.Top := 54;
    WebLabel93.Width := 59;
    WebLabel93.Height := 15;
    WebLabel93.Caption := 'Password : ';
    WebLabel93.HeightPercent := 100.000000000000000000;
    WebLabel93.WidthPercent := 100.000000000000000000;
    WebDBEdit33.SetParentComponent(wgbAuthentication);
    WebDBEdit33.Name := 'WebDBEdit33';
    WebDBEdit33.Left := 19;
    WebDBEdit33.Top := 77;
    WebDBEdit33.Width := 150;
    WebDBEdit33.Height := 22;
    WebDBEdit33.ChildOrder := 2;
    WebDBEdit33.HeightPercent := 100.000000000000000000;
    WebDBEdit33.WidthPercent := 100.000000000000000000;
    WebDBEdit33.DataField := 'MAILSERVERUSER';
    WebDBEdit33.DataSource := dsCompInfo;
    WebDBEdit34.SetParentComponent(wgbAuthentication);
    WebDBEdit34.Name := 'WebDBEdit34';
    WebDBEdit34.Left := 224;
    WebDBEdit34.Top := 77;
    WebDBEdit34.Width := 153;
    WebDBEdit34.Height := 22;
    WebDBEdit34.ChildOrder := 1;
    WebDBEdit34.HeightPercent := 100.000000000000000000;
    WebDBEdit34.WidthPercent := 100.000000000000000000;
    WebDBEdit34.DataField := 'MAILSERVERPASS';
    WebDBEdit34.DataSource := dsCompInfo;
    wpcSysSetupSheet7.SetParentComponent(wpcSysSetup);
    wpcSysSetupSheet7.Name := 'wpcSysSetupSheet7';
    wpcSysSetupSheet7.Left := 0;
    wpcSysSetupSheet7.Top := 20;
    wpcSysSetupSheet7.Width := 1556;
    wpcSysSetupSheet7.Height := 629;
    wpcSysSetupSheet7.Caption := 'VAT% Setup';
    wpcSysSetupSheet7.ChildOrder := 6;
    WebPanel13.SetParentComponent(wpcSysSetupSheet7);
    WebPanel13.Name := 'WebPanel13';
    WebPanel13.Left := 0;
    WebPanel13.Top := 0;
    WebPanel13.Width := 1556;
    WebPanel13.Height := 67;
    WebPanel13.Align := alTop;
    WebPanel13.TabOrder := 0;
    WebSpeedButton8.SetParentComponent(WebPanel13);
    WebSpeedButton8.Name := 'WebSpeedButton8';
    WebSpeedButton8.Left := 19;
    WebSpeedButton8.Top := 9;
    WebSpeedButton8.Width := 45;
    WebSpeedButton8.Height := 45;
    WebSpeedButton8.Caption := '<<';
    WebSpeedButton8.Color := clNone;
    WebSpeedButton8.HeightPercent := 100.000000000000000000;
    WebSpeedButton8.TabOrder := 0;
    WebSpeedButton8.WidthPercent := 100.000000000000000000;
    WebSpeedButton9.SetParentComponent(WebPanel13);
    WebSpeedButton9.Name := 'WebSpeedButton9';
    WebSpeedButton9.Left := 70;
    WebSpeedButton9.Top := 9;
    WebSpeedButton9.Width := 45;
    WebSpeedButton9.Height := 45;
    WebSpeedButton9.Caption := '<';
    WebSpeedButton9.Color := clNone;
    WebSpeedButton9.HeightPercent := 100.000000000000000000;
    WebSpeedButton9.TabOrder := 1;
    WebSpeedButton9.WidthPercent := 100.000000000000000000;
    WebSpeedButton10.SetParentComponent(WebPanel13);
    WebSpeedButton10.Name := 'WebSpeedButton10';
    WebSpeedButton10.Left := 121;
    WebSpeedButton10.Top := 9;
    WebSpeedButton10.Width := 45;
    WebSpeedButton10.Height := 45;
    WebSpeedButton10.Caption := '>';
    WebSpeedButton10.Color := clNone;
    WebSpeedButton10.HeightPercent := 100.000000000000000000;
    WebSpeedButton10.TabOrder := 2;
    WebSpeedButton10.WidthPercent := 100.000000000000000000;
    WebSpeedButton11.SetParentComponent(WebPanel13);
    WebSpeedButton11.Name := 'WebSpeedButton11';
    WebSpeedButton11.Left := 172;
    WebSpeedButton11.Top := 10;
    WebSpeedButton11.Width := 45;
    WebSpeedButton11.Height := 45;
    WebSpeedButton11.Caption := '>>';
    WebSpeedButton11.Color := clNone;
    WebSpeedButton11.HeightPercent := 100.000000000000000000;
    WebSpeedButton11.TabOrder := 3;
    WebSpeedButton11.WidthPercent := 100.000000000000000000;
    WebSpeedButton12.SetParentComponent(WebPanel13);
    WebSpeedButton12.Name := 'WebSpeedButton12';
    WebSpeedButton12.Left := 224;
    WebSpeedButton12.Top := 10;
    WebSpeedButton12.Width := 45;
    WebSpeedButton12.Height := 45;
    WebSpeedButton12.Caption := '+';
    WebSpeedButton12.Color := clNone;
    WebSpeedButton12.HeightPercent := 100.000000000000000000;
    WebSpeedButton12.TabOrder := 4;
    WebSpeedButton12.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton12, Self, 'OnClick', 'WebSpeedButton12Click');
    WebPanel14.SetParentComponent(wpcSysSetupSheet7);
    WebPanel14.Name := 'WebPanel14';
    WebPanel14.Left := 0;
    WebPanel14.Top := 569;
    WebPanel14.Width := 1556;
    WebPanel14.Height := 60;
    WebPanel14.Align := alBottom;
    WebPanel14.ChildOrder := 11;
    WebPanel14.TabOrder := 1;
    btnVatTableFirst.SetParentComponent(WebPanel14);
    btnVatTableFirst.Name := 'btnVatTableFirst';
    btnVatTableFirst.Left := 16;
    btnVatTableFirst.Top := 18;
    btnVatTableFirst.Width := 24;
    btnVatTableFirst.Height := 24;
    btnVatTableFirst.Caption := '<<';
    btnVatTableFirst.Color := clNone;
    btnVatTableFirst.HeightPercent := 100.000000000000000000;
    btnVatTableFirst.TabOrder := 0;
    btnVatTableFirst.WidthPercent := 100.000000000000000000;
    SetEvent(btnVatTableFirst, Self, 'OnClick', 'TFNSubAccountsFirstClick');
    btnVattablePrior.SetParentComponent(WebPanel14);
    btnVattablePrior.Name := 'btnVattablePrior';
    btnVattablePrior.Left := 39;
    btnVattablePrior.Top := 18;
    btnVattablePrior.Width := 24;
    btnVattablePrior.Height := 24;
    btnVattablePrior.Caption := '<';
    btnVattablePrior.Color := clNone;
    btnVattablePrior.HeightPercent := 100.000000000000000000;
    btnVattablePrior.TabOrder := 1;
    btnVattablePrior.WidthPercent := 100.000000000000000000;
    SetEvent(btnVattablePrior, Self, 'OnClick', 'TFNSubAccountsPriorClick');
    btnVattableNext.SetParentComponent(WebPanel14);
    btnVattableNext.Name := 'btnVattableNext';
    btnVattableNext.Left := 106;
    btnVattableNext.Top := 18;
    btnVattableNext.Width := 24;
    btnVattableNext.Height := 24;
    btnVattableNext.Caption := '>';
    btnVattableNext.Color := clNone;
    btnVattableNext.HeightPercent := 100.000000000000000000;
    btnVattableNext.TabOrder := 2;
    btnVattableNext.WidthPercent := 100.000000000000000000;
    SetEvent(btnVattableNext, Self, 'OnClick', 'TFNSubAccountsNextClick');
    btnVattableLast.SetParentComponent(WebPanel14);
    btnVattableLast.Name := 'btnVattableLast';
    btnVattableLast.Left := 130;
    btnVattableLast.Top := 18;
    btnVattableLast.Width := 24;
    btnVattableLast.Height := 24;
    btnVattableLast.Caption := '>>';
    btnVattableLast.Color := clNone;
    btnVattableLast.HeightPercent := 100.000000000000000000;
    btnVattableLast.TabOrder := 3;
    btnVattableLast.WidthPercent := 100.000000000000000000;
    SetEvent(btnVattableLast, Self, 'OnClick', 'WebSpeedButton28Click');
    edtVattablePagecount.SetParentComponent(WebPanel14);
    edtVattablePagecount.Name := 'edtVattablePagecount';
    edtVattablePagecount.Left := 63;
    edtVattablePagecount.Top := 18;
    edtVattablePagecount.Width := 43;
    edtVattablePagecount.Height := 24;
    edtVattablePagecount.ChildOrder := 4;
    edtVattablePagecount.HeightPercent := 100.000000000000000000;
    edtVattablePagecount.WidthPercent := 100.000000000000000000;
    dgVatSetup.SetParentComponent(wpcSysSetupSheet7);
    dgVatSetup.Name := 'dgVatSetup';
    dgVatSetup.Left := 0;
    dgVatSetup.Top := 67;
    dgVatSetup.Width := 1556;
    dgVatSetup.Height := 502;
    dgVatSetup.Align := alClient;
    dgVatSetup.ParentDoubleBuffered := False;
    dgVatSetup.DoubleBuffered := True;
    dgVatSetup.TabOrder := 2;
    dgVatSetup.ShowAcceleratorChar := False;
    dgVatSetup.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgVatSetup.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgVatSetup.Header.VisualGrouping.Layout.Font.Height := -12;
    dgVatSetup.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgVatSetup.Header.VisualGrouping.Layout.Font.Style := [];
    dgVatSetup.Adapter := dbagVatSetup;
    dgVatSetup.BitmapContainer := BitmapContainer1;
    dgVatSetup.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgVatSetup.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgVatSetup.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgVatSetup.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgVatSetup.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgVatSetup.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgVatSetup.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgVatSetup.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgVatSetup.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgVatSetup.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgVatSetup.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgVatSetup.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgVatSetup.CellAppearance.BandLayout.Font.Height := -12;
    dgVatSetup.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgVatSetup.CellAppearance.BandLayout.Font.Style := [];
    dgVatSetup.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgVatSetup.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgVatSetup.CellAppearance.FixedLayout.Font.Height := -12;
    dgVatSetup.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgVatSetup.CellAppearance.FixedLayout.Font.Style := [];
    dgVatSetup.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgVatSetup.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgVatSetup.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgVatSetup.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgVatSetup.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgVatSetup.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgVatSetup.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgVatSetup.CellAppearance.FocusedLayout.Font.Height := -12;
    dgVatSetup.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgVatSetup.CellAppearance.FocusedLayout.Font.Style := [];
    dgVatSetup.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgVatSetup.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgVatSetup.CellAppearance.GroupLayout.Font.Height := -12;
    dgVatSetup.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgVatSetup.CellAppearance.GroupLayout.Font.Style := [];
    dgVatSetup.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgVatSetup.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgVatSetup.CellAppearance.NormalLayout.Font.Height := -12;
    dgVatSetup.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgVatSetup.CellAppearance.NormalLayout.Font.Style := [];
    dgVatSetup.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgVatSetup.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgVatSetup.CellAppearance.SelectedLayout.Font.Height := -12;
    dgVatSetup.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgVatSetup.CellAppearance.SelectedLayout.Font.Style := [];
    dgVatSetup.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgVatSetup.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgVatSetup.CellAppearance.SummaryLayout.Font.Height := -12;
    dgVatSetup.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgVatSetup.CellAppearance.SummaryLayout.Font.Style := [];
    dgVatSetup.ColumnCount := 5;
    dgVatSetup.Columns.Clear;
    with dgVatSetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'VATPERC';
    end;
    with dgVatSetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'STARTDATE';
    end;
    with dgVatSetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'ENDATE';
    end;
    with dgVatSetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'Auto';
    end;
    with dgVatSetup.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Edit';
      Settings := [gcsType];
    end;
    dgVatSetup.Designer := False;
    dgVatSetup.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgVatSetup.FilterAppearance.Font.Color := clWindowText;
    dgVatSetup.FilterAppearance.Font.Height := -12;
    dgVatSetup.FilterAppearance.Font.Name := 'Segoe UI';
    dgVatSetup.FilterAppearance.Font.Style := [];
    dgVatSetup.Icons.ExpandIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet7.dgVatSetup.Icons.ExpandIcon.svg');
    dgVatSetup.Icons.CollapseIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet7.dgVatSetup.Icons.CollapseIcon.svg');
    dgVatSetup.Icons.FilterIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet7.dgVatSetup.Icons.FilterIcon.svg');
    dgVatSetup.Icons.FilterActiveIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet7.dgVatSetup.Icons.FilterActiveIcon.svg');
    dgVatSetup.Icons.FilterClearIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet7.dgVatSetup.Icons.FilterClearIcon.svg');
    dgVatSetup.Icons.FilterTypeIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet7.dgVatSetup.Icons.FilterTypeIcon.svg');
    dgVatSetup.Icons.SortAscendingIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet7.dgVatSetup.Icons.SortAscendingIcon.svg');
    dgVatSetup.Icons.SortDescendingIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet7.dgVatSetup.Icons.SortDescendingIcon.svg');
    dgVatSetup.Icons.CloseIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet7.dgVatSetup.Icons.CloseIcon.svg');
    SetEvent(dgVatSetup, Self, 'OnCellClick', 'dgVatSetupCellClick');
    SetEvent(dgVatSetup, Self, 'OnGetCellProperties', 'dgVatSetupGetCellProperties');
    dgVatSetup.RowCount := 1;
    dbagVatSetup.SetParentComponent(dgVatSetup);
    dbagVatSetup.Name := 'dbagVatSetup';
    dbagVatSetup.Left := 203;
    dbagVatSetup.Top := 178;
    dbagVatSetup.Width := 26;
    dbagVatSetup.Height := 26;
    dbagVatSetup.Visible := True;
    dbagVatSetup.AutoCreateColumns := False;
    dbagVatSetup.AutoRemoveColumns := False;
    dbagVatSetup.Columns.Clear;
    with dbagVatSetup.Columns.Add do
    begin
      FieldName := 'VATPERC';
      AutoCreated := False;
    end;
    with dbagVatSetup.Columns.Add do
    begin
      FieldName := 'STARTDATE';
      AutoCreated := False;
    end;
    with dbagVatSetup.Columns.Add do
    begin
      FieldName := 'ENDATE';
      AutoCreated := False;
    end;
    with dbagVatSetup.Columns.Add do
    begin
      FieldName := 'Auto';
      AutoCreated := False;
    end;
    with dbagVatSetup.Columns.Add do
    begin
      Header := 'Edit';
      AutoCreated := False;
    end;
    dbagVatSetup.DataSource := dsVattable;
    msgdlgVattable.SetParentComponent(dgVatSetup);
    msgdlgVattable.Name := 'msgdlgVattable';
    msgdlgVattable.Left := 235;
    msgdlgVattable.Top := 178;
    msgdlgVattable.Width := 24;
    msgdlgVattable.Height := 24;
    msgdlgVattable.Buttons := [];
    msgdlgVattable.Opacity := 0.200000000000000000;
    wpcSysSetupSheet8.SetParentComponent(wpcSysSetup);
    wpcSysSetupSheet8.Name := 'wpcSysSetupSheet8';
    wpcSysSetupSheet8.Left := 0;
    wpcSysSetupSheet8.Top := 20;
    wpcSysSetupSheet8.Width := 1556;
    wpcSysSetupSheet8.Height := 629;
    wpcSysSetupSheet8.Caption := 'General Ledger Accounts';
    wpcSysSetupSheet8.ChildOrder := 7;
    WebPanel16.SetParentComponent(wpcSysSetupSheet8);
    WebPanel16.Name := 'WebPanel16';
    WebPanel16.Left := 0;
    WebPanel16.Top := 0;
    WebPanel16.Width := 1556;
    WebPanel16.Height := 67;
    WebPanel16.Align := alTop;
    WebPanel16.TabOrder := 0;
    WebSpeedButton13.SetParentComponent(WebPanel16);
    WebSpeedButton13.Name := 'WebSpeedButton13';
    WebSpeedButton13.Left := 12;
    WebSpeedButton13.Top := 11;
    WebSpeedButton13.Width := 45;
    WebSpeedButton13.Height := 45;
    WebSpeedButton13.Caption := '<<';
    WebSpeedButton13.Color := clNone;
    WebSpeedButton13.HeightPercent := 100.000000000000000000;
    WebSpeedButton13.TabOrder := 0;
    WebSpeedButton13.WidthPercent := 100.000000000000000000;
    WebSpeedButton14.SetParentComponent(WebPanel16);
    WebSpeedButton14.Name := 'WebSpeedButton14';
    WebSpeedButton14.Left := 70;
    WebSpeedButton14.Top := 11;
    WebSpeedButton14.Width := 45;
    WebSpeedButton14.Height := 45;
    WebSpeedButton14.Caption := '<';
    WebSpeedButton14.Color := clNone;
    WebSpeedButton14.HeightPercent := 100.000000000000000000;
    WebSpeedButton14.TabOrder := 1;
    WebSpeedButton14.WidthPercent := 100.000000000000000000;
    WebSpeedButton15.SetParentComponent(WebPanel16);
    WebSpeedButton15.Name := 'WebSpeedButton15';
    WebSpeedButton15.Left := 129;
    WebSpeedButton15.Top := 11;
    WebSpeedButton15.Width := 45;
    WebSpeedButton15.Height := 45;
    WebSpeedButton15.Caption := '>';
    WebSpeedButton15.Color := clNone;
    WebSpeedButton15.HeightPercent := 100.000000000000000000;
    WebSpeedButton15.TabOrder := 2;
    WebSpeedButton15.WidthPercent := 100.000000000000000000;
    WebSpeedButton16.SetParentComponent(WebPanel16);
    WebSpeedButton16.Name := 'WebSpeedButton16';
    WebSpeedButton16.Left := 189;
    WebSpeedButton16.Top := 11;
    WebSpeedButton16.Width := 45;
    WebSpeedButton16.Height := 45;
    WebSpeedButton16.Caption := '>>';
    WebSpeedButton16.Color := clNone;
    WebSpeedButton16.HeightPercent := 100.000000000000000000;
    WebSpeedButton16.TabOrder := 3;
    WebSpeedButton16.WidthPercent := 100.000000000000000000;
    WebSpeedButton17.SetParentComponent(WebPanel16);
    WebSpeedButton17.Name := 'WebSpeedButton17';
    WebSpeedButton17.Left := 248;
    WebSpeedButton17.Top := 11;
    WebSpeedButton17.Width := 45;
    WebSpeedButton17.Height := 45;
    WebSpeedButton17.Caption := '+';
    WebSpeedButton17.Color := clNone;
    WebSpeedButton17.HeightPercent := 100.000000000000000000;
    WebSpeedButton17.TabOrder := 4;
    WebSpeedButton17.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton17, Self, 'OnClick', 'WebSpeedButton17Click');
    WebPanel22.SetParentComponent(wpcSysSetupSheet8);
    WebPanel22.Name := 'WebPanel22';
    WebPanel22.Left := 0;
    WebPanel22.Top := 588;
    WebPanel22.Width := 1556;
    WebPanel22.Height := 41;
    WebPanel22.Align := alBottom;
    WebPanel22.ChildOrder := 1;
    WebPanel22.TabOrder := 1;
    edtGLAPC.SetParentComponent(WebPanel22);
    edtGLAPC.Name := 'edtGLAPC';
    edtGLAPC.Left := 69;
    edtGLAPC.Top := 6;
    edtGLAPC.Width := 43;
    edtGLAPC.Height := 24;
    edtGLAPC.ChildOrder := 5;
    edtGLAPC.HeightPercent := 100.000000000000000000;
    edtGLAPC.WidthPercent := 100.000000000000000000;
    sbtnGlaFirst.SetParentComponent(WebPanel22);
    sbtnGlaFirst.Name := 'sbtnGlaFirst';
    sbtnGlaFirst.Left := 21;
    sbtnGlaFirst.Top := 6;
    sbtnGlaFirst.Width := 24;
    sbtnGlaFirst.Height := 24;
    sbtnGlaFirst.Caption := '<<';
    sbtnGlaFirst.Color := clNone;
    sbtnGlaFirst.HeightPercent := 100.000000000000000000;
    sbtnGlaFirst.TabOrder := 1;
    sbtnGlaFirst.WidthPercent := 100.000000000000000000;
    SetEvent(sbtnGlaFirst, Self, 'OnClick', 'sbtnGlaFirstClick');
    sbtnGLAPrior.SetParentComponent(WebPanel22);
    sbtnGLAPrior.Name := 'sbtnGLAPrior';
    sbtnGLAPrior.Left := 45;
    sbtnGLAPrior.Top := 6;
    sbtnGLAPrior.Width := 24;
    sbtnGLAPrior.Height := 24;
    sbtnGLAPrior.Caption := '<';
    sbtnGLAPrior.Color := clNone;
    sbtnGLAPrior.HeightPercent := 100.000000000000000000;
    sbtnGLAPrior.TabOrder := 2;
    sbtnGLAPrior.WidthPercent := 100.000000000000000000;
    SetEvent(sbtnGLAPrior, Self, 'OnClick', 'sbtnGLAPriorClick');
    sbtnGLANext.SetParentComponent(WebPanel22);
    sbtnGLANext.Name := 'sbtnGLANext';
    sbtnGLANext.Left := 112;
    sbtnGLANext.Top := 6;
    sbtnGLANext.Width := 24;
    sbtnGLANext.Height := 24;
    sbtnGLANext.Caption := '>';
    sbtnGLANext.Color := clNone;
    sbtnGLANext.HeightPercent := 100.000000000000000000;
    sbtnGLANext.TabOrder := 3;
    sbtnGLANext.WidthPercent := 100.000000000000000000;
    SetEvent(sbtnGLANext, Self, 'OnClick', 'sbtnGLANextClick');
    sbtnGLALast.SetParentComponent(WebPanel22);
    sbtnGLALast.Name := 'sbtnGLALast';
    sbtnGLALast.Left := 136;
    sbtnGLALast.Top := 6;
    sbtnGLALast.Width := 24;
    sbtnGLALast.Height := 24;
    sbtnGLALast.Caption := '>>';
    sbtnGLALast.Color := clNone;
    sbtnGLALast.HeightPercent := 100.000000000000000000;
    sbtnGLALast.TabOrder := 4;
    sbtnGLALast.WidthPercent := 100.000000000000000000;
    SetEvent(sbtnGLALast, Self, 'OnClick', 'sbtnGLALastClick');
    dgGLA.SetParentComponent(wpcSysSetupSheet8);
    dgGLA.Name := 'dgGLA';
    dgGLA.Left := 0;
    dgGLA.Top := 67;
    dgGLA.Width := 1556;
    dgGLA.Height := 521;
    dgGLA.Align := alClient;
    dgGLA.ParentDoubleBuffered := False;
    dgGLA.DoubleBuffered := True;
    dgGLA.TabOrder := 2;
    dgGLA.ShowAcceleratorChar := False;
    dgGLA.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgGLA.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgGLA.Header.VisualGrouping.Layout.Font.Height := -12;
    dgGLA.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgGLA.Header.VisualGrouping.Layout.Font.Style := [];
    dgGLA.Adapter := dbagGLA;
    dgGLA.BitmapContainer := BitmapContainer1;
    dgGLA.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgGLA.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgGLA.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgGLA.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgGLA.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgGLA.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgGLA.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgGLA.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgGLA.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgGLA.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgGLA.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgGLA.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgGLA.CellAppearance.BandLayout.Font.Height := -12;
    dgGLA.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgGLA.CellAppearance.BandLayout.Font.Style := [];
    dgGLA.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgGLA.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgGLA.CellAppearance.FixedLayout.Font.Height := -12;
    dgGLA.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgGLA.CellAppearance.FixedLayout.Font.Style := [];
    dgGLA.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgGLA.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgGLA.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgGLA.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgGLA.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgGLA.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgGLA.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgGLA.CellAppearance.FocusedLayout.Font.Height := -12;
    dgGLA.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgGLA.CellAppearance.FocusedLayout.Font.Style := [];
    dgGLA.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgGLA.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgGLA.CellAppearance.GroupLayout.Font.Height := -12;
    dgGLA.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgGLA.CellAppearance.GroupLayout.Font.Style := [];
    dgGLA.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgGLA.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgGLA.CellAppearance.NormalLayout.Font.Height := -12;
    dgGLA.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgGLA.CellAppearance.NormalLayout.Font.Style := [];
    dgGLA.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgGLA.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgGLA.CellAppearance.SelectedLayout.Font.Height := -12;
    dgGLA.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgGLA.CellAppearance.SelectedLayout.Font.Style := [];
    dgGLA.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgGLA.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgGLA.CellAppearance.SummaryLayout.Font.Height := -12;
    dgGLA.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgGLA.CellAppearance.SummaryLayout.Font.Style := [];
    dgGLA.ColumnCount := 7;
    dgGLA.Columns.Clear;
    with dgGLA.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'GLCODE';
      Width := 70.000000000000000000;
    end;
    with dgGLA.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'GLDESCRIPTION';
      Width := 250.000000000000000000;
    end;
    with dgGLA.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'SUSPENDED';
      Width := 100.000000000000000000;
    end;
    with dgGLA.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'bankaccount';
      Width := 100.000000000000000000;
    end;
    with dgGLA.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'bankcard';
    end;
    with dgGLA.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Edit';
      Settings := [gcsType];
    end;
    with dgGLA.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Delete';
      Settings := [gcsType];
    end;
    dgGLA.Designer := False;
    dgGLA.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgGLA.FilterAppearance.Font.Color := clWindowText;
    dgGLA.FilterAppearance.Font.Height := -12;
    dgGLA.FilterAppearance.Font.Name := 'Segoe UI';
    dgGLA.FilterAppearance.Font.Style := [];
    dgGLA.Icons.ExpandIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet8.dgGLA.Icons.ExpandIcon.svg');
    dgGLA.Icons.CollapseIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet8.dgGLA.Icons.CollapseIcon.svg');
    dgGLA.Icons.FilterIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet8.dgGLA.Icons.FilterIcon.svg');
    dgGLA.Icons.FilterActiveIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet8.dgGLA.Icons.FilterActiveIcon.svg');
    dgGLA.Icons.FilterClearIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet8.dgGLA.Icons.FilterClearIcon.svg');
    dgGLA.Icons.FilterTypeIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet8.dgGLA.Icons.FilterTypeIcon.svg');
    dgGLA.Icons.SortAscendingIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet8.dgGLA.Icons.SortAscendingIcon.svg');
    dgGLA.Icons.SortDescendingIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet8.dgGLA.Icons.SortDescendingIcon.svg');
    dgGLA.Icons.CloseIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet8.dgGLA.Icons.CloseIcon.svg');
    SetEvent(dgGLA, Self, 'OnCellClick', 'dgGLACellClick');
    SetEvent(dgGLA, Self, 'OnGetCellProperties', 'dgGLAGetCellProperties');
    dgGLA.RowCount := 1;
    dbagGLA.SetParentComponent(dgGLA);
    dbagGLA.Name := 'dbagGLA';
    dbagGLA.Left := 208;
    dbagGLA.Top := 242;
    dbagGLA.Width := 26;
    dbagGLA.Height := 26;
    dbagGLA.Visible := True;
    dbagGLA.AutoRemoveColumns := False;
    dbagGLA.Columns.Clear;
    with dbagGLA.Columns.Add do
    begin
      FieldName := 'GLCODE';
      AutoCreated := False;
    end;
    with dbagGLA.Columns.Add do
    begin
      FieldName := 'GLDESCRIPTION';
      AutoCreated := False;
    end;
    with dbagGLA.Columns.Add do
    begin
      FieldName := 'SUSPENDED';
      AutoCreated := False;
    end;
    with dbagGLA.Columns.Add do
    begin
      FieldName := 'bankaccount';
      AutoCreated := False;
    end;
    with dbagGLA.Columns.Add do
    begin
      FieldName := 'bankcard';
      AutoCreated := False;
    end;
    with dbagGLA.Columns.Add do
    begin
      Header := 'Edit';
      AutoCreated := False;
    end;
    with dbagGLA.Columns.Add do
    begin
      Header := 'Delete';
      AutoCreated := False;
    end;
    dbagGLA.DataSource := dsGLA;
    msgdlgGLA.SetParentComponent(dgGLA);
    msgdlgGLA.Name := 'msgdlgGLA';
    msgdlgGLA.Left := 258;
    msgdlgGLA.Top := 246;
    msgdlgGLA.Width := 24;
    msgdlgGLA.Height := 24;
    msgdlgGLA.Buttons := [];
    msgdlgGLA.Opacity := 0.200000000000000000;
    wpcSysSetupSheet9.SetParentComponent(wpcSysSetup);
    wpcSysSetupSheet9.Name := 'wpcSysSetupSheet9';
    wpcSysSetupSheet9.Left := 0;
    wpcSysSetupSheet9.Top := 20;
    wpcSysSetupSheet9.Width := 1556;
    wpcSysSetupSheet9.Height := 629;
    wpcSysSetupSheet9.Caption := 'System Ledger Accounts';
    wpcSysSetupSheet9.ChildOrder := 8;
    WebPanel23.SetParentComponent(wpcSysSetupSheet9);
    WebPanel23.Name := 'WebPanel23';
    WebPanel23.Left := 0;
    WebPanel23.Top := 0;
    WebPanel23.Width := 1556;
    WebPanel23.Height := 60;
    WebPanel23.Align := alTop;
    WebPanel23.TabOrder := 0;
    WebSpeedButton20.SetParentComponent(WebPanel23);
    WebSpeedButton20.Name := 'WebSpeedButton20';
    WebSpeedButton20.Left := 10;
    WebSpeedButton20.Top := 7;
    WebSpeedButton20.Width := 45;
    WebSpeedButton20.Height := 45;
    WebSpeedButton20.Caption := '<<';
    WebSpeedButton20.Color := clNone;
    WebSpeedButton20.HeightPercent := 100.000000000000000000;
    WebSpeedButton20.TabOrder := 0;
    WebSpeedButton20.WidthPercent := 100.000000000000000000;
    WebSpeedButton21.SetParentComponent(WebPanel23);
    WebSpeedButton21.Name := 'WebSpeedButton21';
    WebSpeedButton21.Left := 64;
    WebSpeedButton21.Top := 7;
    WebSpeedButton21.Width := 45;
    WebSpeedButton21.Height := 45;
    WebSpeedButton21.Caption := '<';
    WebSpeedButton21.Color := clNone;
    WebSpeedButton21.HeightPercent := 100.000000000000000000;
    WebSpeedButton21.TabOrder := 1;
    WebSpeedButton21.WidthPercent := 100.000000000000000000;
    WebSpeedButton22.SetParentComponent(WebPanel23);
    WebSpeedButton22.Name := 'WebSpeedButton22';
    WebSpeedButton22.Left := 117;
    WebSpeedButton22.Top := 7;
    WebSpeedButton22.Width := 45;
    WebSpeedButton22.Height := 45;
    WebSpeedButton22.Caption := '>';
    WebSpeedButton22.Color := clNone;
    WebSpeedButton22.HeightPercent := 100.000000000000000000;
    WebSpeedButton22.TabOrder := 2;
    WebSpeedButton22.WidthPercent := 100.000000000000000000;
    WebSpeedButton23.SetParentComponent(WebPanel23);
    WebSpeedButton23.Name := 'WebSpeedButton23';
    WebSpeedButton23.Left := 170;
    WebSpeedButton23.Top := 7;
    WebSpeedButton23.Width := 45;
    WebSpeedButton23.Height := 45;
    WebSpeedButton23.Caption := '>>';
    WebSpeedButton23.Color := clNone;
    WebSpeedButton23.HeightPercent := 100.000000000000000000;
    WebSpeedButton23.TabOrder := 3;
    WebSpeedButton23.WidthPercent := 100.000000000000000000;
    WebSpeedButton24.SetParentComponent(WebPanel23);
    WebSpeedButton24.Name := 'WebSpeedButton24';
    WebSpeedButton24.Left := 223;
    WebSpeedButton24.Top := 3;
    WebSpeedButton24.Width := 45;
    WebSpeedButton24.Height := 45;
    WebSpeedButton24.Caption := '+';
    WebSpeedButton24.Color := clNone;
    WebSpeedButton24.HeightPercent := 100.000000000000000000;
    WebSpeedButton24.TabOrder := 4;
    WebSpeedButton24.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton24, Self, 'OnClick', 'WebSpeedButton24Click');
    WebPanel24.SetParentComponent(wpcSysSetupSheet9);
    WebPanel24.Name := 'WebPanel24';
    WebPanel24.Left := 0;
    WebPanel24.Top := 569;
    WebPanel24.Width := 1556;
    WebPanel24.Height := 60;
    WebPanel24.Align := alBottom;
    WebPanel24.ChildOrder := 1;
    WebPanel24.TabOrder := 1;
    btnSystemLedgerFirst.SetParentComponent(WebPanel24);
    btnSystemLedgerFirst.Name := 'btnSystemLedgerFirst';
    btnSystemLedgerFirst.Left := 15;
    btnSystemLedgerFirst.Top := 22;
    btnSystemLedgerFirst.Width := 24;
    btnSystemLedgerFirst.Height := 24;
    btnSystemLedgerFirst.Caption := '<<';
    btnSystemLedgerFirst.Color := clNone;
    btnSystemLedgerFirst.HeightPercent := 100.000000000000000000;
    btnSystemLedgerFirst.TabOrder := 0;
    btnSystemLedgerFirst.WidthPercent := 100.000000000000000000;
    SetEvent(btnSystemLedgerFirst, Self, 'OnClick', 'btnSystemLedgerFirstClick');
    btnSystemLedgerPrior.SetParentComponent(WebPanel24);
    btnSystemLedgerPrior.Name := 'btnSystemLedgerPrior';
    btnSystemLedgerPrior.Left := 38;
    btnSystemLedgerPrior.Top := 22;
    btnSystemLedgerPrior.Width := 24;
    btnSystemLedgerPrior.Height := 24;
    btnSystemLedgerPrior.Caption := '<';
    btnSystemLedgerPrior.Color := clNone;
    btnSystemLedgerPrior.HeightPercent := 100.000000000000000000;
    btnSystemLedgerPrior.TabOrder := 1;
    btnSystemLedgerPrior.WidthPercent := 100.000000000000000000;
    SetEvent(btnSystemLedgerPrior, Self, 'OnClick', 'btnSystemLedgerPriorClick');
    btnSystemLedgerNext.SetParentComponent(WebPanel24);
    btnSystemLedgerNext.Name := 'btnSystemLedgerNext';
    btnSystemLedgerNext.Left := 105;
    btnSystemLedgerNext.Top := 22;
    btnSystemLedgerNext.Width := 24;
    btnSystemLedgerNext.Height := 24;
    btnSystemLedgerNext.Caption := '>';
    btnSystemLedgerNext.Color := clNone;
    btnSystemLedgerNext.HeightPercent := 100.000000000000000000;
    btnSystemLedgerNext.TabOrder := 2;
    btnSystemLedgerNext.WidthPercent := 100.000000000000000000;
    SetEvent(btnSystemLedgerNext, Self, 'OnClick', 'btnSystemLedgerNextClick');
    btnSystemLedgerLast.SetParentComponent(WebPanel24);
    btnSystemLedgerLast.Name := 'btnSystemLedgerLast';
    btnSystemLedgerLast.Left := 129;
    btnSystemLedgerLast.Top := 22;
    btnSystemLedgerLast.Width := 24;
    btnSystemLedgerLast.Height := 24;
    btnSystemLedgerLast.Caption := '>>';
    btnSystemLedgerLast.Color := clNone;
    btnSystemLedgerLast.HeightPercent := 100.000000000000000000;
    btnSystemLedgerLast.TabOrder := 3;
    btnSystemLedgerLast.WidthPercent := 100.000000000000000000;
    SetEvent(btnSystemLedgerLast, Self, 'OnClick', 'btnSystemLedgerLastClick');
    edtSystemLedger.SetParentComponent(WebPanel24);
    edtSystemLedger.Name := 'edtSystemLedger';
    edtSystemLedger.Left := 62;
    edtSystemLedger.Top := 22;
    edtSystemLedger.Width := 43;
    edtSystemLedger.Height := 24;
    edtSystemLedger.ChildOrder := 4;
    edtSystemLedger.HeightPercent := 100.000000000000000000;
    edtSystemLedger.WidthPercent := 100.000000000000000000;
    dgSystemLedger.SetParentComponent(wpcSysSetupSheet9);
    dgSystemLedger.Name := 'dgSystemLedger';
    dgSystemLedger.Left := 0;
    dgSystemLedger.Top := 60;
    dgSystemLedger.Width := 1556;
    dgSystemLedger.Height := 509;
    dgSystemLedger.Align := alClient;
    dgSystemLedger.ParentDoubleBuffered := False;
    dgSystemLedger.DoubleBuffered := True;
    dgSystemLedger.TabOrder := 2;
    dgSystemLedger.ShowAcceleratorChar := False;
    dgSystemLedger.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgSystemLedger.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgSystemLedger.Header.VisualGrouping.Layout.Font.Height := -12;
    dgSystemLedger.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgSystemLedger.Header.VisualGrouping.Layout.Font.Style := [];
    dgSystemLedger.Adapter := dbagSystemLedger;
    dgSystemLedger.BitmapContainer := BitmapContainer1;
    dgSystemLedger.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgSystemLedger.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgSystemLedger.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgSystemLedger.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgSystemLedger.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgSystemLedger.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgSystemLedger.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgSystemLedger.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgSystemLedger.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgSystemLedger.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgSystemLedger.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgSystemLedger.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgSystemLedger.CellAppearance.BandLayout.Font.Height := -12;
    dgSystemLedger.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgSystemLedger.CellAppearance.BandLayout.Font.Style := [];
    dgSystemLedger.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSystemLedger.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgSystemLedger.CellAppearance.FixedLayout.Font.Height := -12;
    dgSystemLedger.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgSystemLedger.CellAppearance.FixedLayout.Font.Style := [];
    dgSystemLedger.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSystemLedger.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgSystemLedger.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgSystemLedger.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgSystemLedger.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgSystemLedger.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSystemLedger.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgSystemLedger.CellAppearance.FocusedLayout.Font.Height := -12;
    dgSystemLedger.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgSystemLedger.CellAppearance.FocusedLayout.Font.Style := [];
    dgSystemLedger.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgSystemLedger.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgSystemLedger.CellAppearance.GroupLayout.Font.Height := -12;
    dgSystemLedger.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgSystemLedger.CellAppearance.GroupLayout.Font.Style := [];
    dgSystemLedger.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgSystemLedger.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgSystemLedger.CellAppearance.NormalLayout.Font.Height := -12;
    dgSystemLedger.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgSystemLedger.CellAppearance.NormalLayout.Font.Style := [];
    dgSystemLedger.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSystemLedger.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgSystemLedger.CellAppearance.SelectedLayout.Font.Height := -12;
    dgSystemLedger.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgSystemLedger.CellAppearance.SelectedLayout.Font.Style := [];
    dgSystemLedger.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgSystemLedger.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgSystemLedger.CellAppearance.SummaryLayout.Font.Height := -12;
    dgSystemLedger.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgSystemLedger.CellAppearance.SummaryLayout.Font.Style := [];
    dgSystemLedger.ColumnCount := 8;
    dgSystemLedger.Columns.Clear;
    with dgSystemLedger.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'companygldetail_Auto';
    end;
    with dgSystemLedger.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'GLCode';
    end;
    with dgSystemLedger.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'GLDESCRIPTION';
    end;
    with dgSystemLedger.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'FleetDesc';
    end;
    with dgSystemLedger.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'ValueTypesDesc';
    end;
    with dgSystemLedger.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'SystemDesc';
    end;
    with dgSystemLedger.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Edit';
      Settings := [gcsType];
    end;
    with dgSystemLedger.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Delete';
      Settings := [gcsType];
    end;
    dgSystemLedger.Designer := False;
    dgSystemLedger.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgSystemLedger.FilterAppearance.Font.Color := clWindowText;
    dgSystemLedger.FilterAppearance.Font.Height := -12;
    dgSystemLedger.FilterAppearance.Font.Name := 'Segoe UI';
    dgSystemLedger.FilterAppearance.Font.Style := [];
    dgSystemLedger.Icons.ExpandIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet9.dgSystemLedger.Icons.ExpandIcon.svg');
    dgSystemLedger.Icons.CollapseIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet9.dgSystemLedger.Icons.CollapseIcon.svg');
    dgSystemLedger.Icons.FilterIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet9.dgSystemLedger.Icons.FilterIcon.svg');
    dgSystemLedger.Icons.FilterActiveIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet9.dgSystemLedger.Icons.FilterActiveIcon.svg');
    dgSystemLedger.Icons.FilterClearIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet9.dgSystemLedger.Icons.FilterClearIcon.svg');
    dgSystemLedger.Icons.FilterTypeIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet9.dgSystemLedger.Icons.FilterTypeIcon.svg');
    dgSystemLedger.Icons.SortAscendingIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet9.dgSystemLedger.Icons.SortAscendingIcon.svg');
    dgSystemLedger.Icons.SortDescendingIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet9.dgSystemLedger.Icons.SortDescendingIcon.svg');
    dgSystemLedger.Icons.CloseIcon.LoadFromFile('SystemSettings.wpcSysSetupSheet9.dgSystemLedger.Icons.CloseIcon.svg');
    SetEvent(dgSystemLedger, Self, 'OnCellClick', 'dgSystemLedgerCellClick');
    SetEvent(dgSystemLedger, Self, 'OnGetCellProperties', 'dgSystemLedgerGetCellProperties');
    dgSystemLedger.RowCount := 1;
    dbagSystemLedger.SetParentComponent(dgSystemLedger);
    dbagSystemLedger.Name := 'dbagSystemLedger';
    dbagSystemLedger.Left := 203;
    dbagSystemLedger.Top := 306;
    dbagSystemLedger.Width := 26;
    dbagSystemLedger.Height := 26;
    dbagSystemLedger.Visible := True;
    dbagSystemLedger.AutoCreateColumns := False;
    dbagSystemLedger.AutoRemoveColumns := False;
    dbagSystemLedger.Columns.Clear;
    with dbagSystemLedger.Columns.Add do
    begin
      FieldName := 'companygldetail_Auto';
      AutoCreated := False;
    end;
    with dbagSystemLedger.Columns.Add do
    begin
      FieldName := 'GLCode';
      AutoCreated := False;
    end;
    with dbagSystemLedger.Columns.Add do
    begin
      FieldName := 'GLDESCRIPTION';
      AutoCreated := False;
    end;
    with dbagSystemLedger.Columns.Add do
    begin
      FieldName := 'FleetDesc';
      AutoCreated := False;
    end;
    with dbagSystemLedger.Columns.Add do
    begin
      FieldName := 'ValueTypesDesc';
      AutoCreated := False;
    end;
    with dbagSystemLedger.Columns.Add do
    begin
      FieldName := 'SystemDesc';
      AutoCreated := False;
    end;
    with dbagSystemLedger.Columns.Add do
    begin
      Header := 'Edit';
      AutoCreated := False;
    end;
    with dbagSystemLedger.Columns.Add do
    begin
      Header := 'Delete';
      AutoCreated := False;
    end;
    dbagSystemLedger.DataSource := dsSystemLedgerAccounts;
    msgdlgSystemLedger.SetParentComponent(dgSystemLedger);
    msgdlgSystemLedger.Name := 'msgdlgSystemLedger';
    msgdlgSystemLedger.Left := 250;
    msgdlgSystemLedger.Top := 306;
    msgdlgSystemLedger.Width := 24;
    msgdlgSystemLedger.Height := 24;
    msgdlgSystemLedger.Buttons := [];
    msgdlgSystemLedger.Opacity := 0.200000000000000000;
    wpcSysSetupSheet10.SetParentComponent(wpcSysSetup);
    wpcSysSetupSheet10.Name := 'wpcSysSetupSheet10';
    wpcSysSetupSheet10.Left := 0;
    wpcSysSetupSheet10.Top := 20;
    wpcSysSetupSheet10.Width := 1556;
    wpcSysSetupSheet10.Height := 629;
    wpcSysSetupSheet10.Caption := 'API Server Setup';
    wpcSysSetupSheet10.ChildOrder := 9;
    WebCheckListBox1.SetParentComponent(wpcSysSetupSheet10);
    WebCheckListBox1.Name := 'WebCheckListBox1';
    WebCheckListBox1.Left := 0;
    WebCheckListBox1.Top := 0;
    WebCheckListBox1.Width := 143;
    WebCheckListBox1.Height := 629;
    WebCheckListBox1.Align := alLeft;
    WebCheckListBox1.HeightPercent := 100.000000000000000000;
    WebCheckListBox1.ItemHeight := 15;
    WebCheckListBox1.Items.BeginUpdate;
    try
      WebCheckListBox1.Items.Clear;
      WebCheckListBox1.Items.Add('Summatech FMS');
      WebCheckListBox1.Items.Add('Truck Fuel Net');
      WebCheckListBox1.Items.Add('FMS Fuel System');
      WebCheckListBox1.Items.Add('Shiptech FMS');
      WebCheckListBox1.Items.Add('FuelU');
      WebCheckListBox1.Items.Add('Premi Points');
    finally
      WebCheckListBox1.Items.EndUpdate;
    end;
    WebCheckListBox1.WidthPercent := 100.000000000000000000;
    WebPageControl2.SetParentComponent(wpcSysSetupSheet10);
    WebPageControl2.Name := 'WebPageControl2';
    WebPageControl2.Left := 143;
    WebPageControl2.Top := 0;
    WebPageControl2.Width := 1413;
    WebPageControl2.Height := 629;
    WebPageControl2.Align := alClient;
    WebPageControl2.ChildOrder := 2;
    WebPageControl2.TabIndex := 0;
    WebPageControl2.TabOrder := 1;
    WebPageControl2Sheet1.SetParentComponent(WebPageControl2);
    WebPageControl2Sheet1.Name := 'WebPageControl2Sheet1';
    WebPageControl2Sheet1.Left := 0;
    WebPageControl2Sheet1.Top := 20;
    WebPageControl2Sheet1.Width := 1413;
    WebPageControl2Sheet1.Height := 609;
    WebPageControl2Sheet1.Caption := 'Truckl Fuel Net';
    WebPageControl2Sheet1.ChildOrder := 3;
    WebPanel32.SetParentComponent(WebPageControl2Sheet1);
    WebPanel32.Name := 'WebPanel32';
    WebPanel32.Left := 0;
    WebPanel32.Top := 0;
    WebPanel32.Width := 1413;
    WebPanel32.Height := 609;
    WebPanel32.Align := alClient;
    WebPanel32.TabOrder := 0;
    WebLabel98.SetParentComponent(WebPanel32);
    WebLabel98.Name := 'WebLabel98';
    WebLabel98.Left := 82;
    WebLabel98.Top := 39;
    WebLabel98.Width := 45;
    WebLabel98.Height := 15;
    WebLabel98.Caption := 'API Url : ';
    WebLabel98.HeightPercent := 100.000000000000000000;
    WebLabel98.WidthPercent := 100.000000000000000000;
    WebLabel99.SetParentComponent(WebPanel32);
    WebLabel99.Name := 'WebLabel99';
    WebLabel99.Left := 82;
    WebLabel99.Top := 84;
    WebLabel99.Width := 88;
    WebLabel99.Height := 15;
    WebLabel99.Caption := 'API User Name : ';
    WebLabel99.HeightPercent := 100.000000000000000000;
    WebLabel99.WidthPercent := 100.000000000000000000;
    WebLabel100.SetParentComponent(WebPanel32);
    WebLabel100.Name := 'WebLabel100';
    WebLabel100.Left := 82;
    WebLabel100.Top := 127;
    WebLabel100.Width := 80;
    WebLabel100.Height := 15;
    WebLabel100.Caption := 'API Password : ';
    WebLabel100.HeightPercent := 100.000000000000000000;
    WebLabel100.WidthPercent := 100.000000000000000000;
    WebLabel101.SetParentComponent(WebPanel32);
    WebLabel101.Name := 'WebLabel101';
    WebLabel101.Left := 82;
    WebLabel101.Top := 167;
    WebLabel101.Width := 43;
    WebLabel101.Height := 15;
    WebLabel101.Caption := 'API Key:';
    WebLabel101.HeightPercent := 100.000000000000000000;
    WebLabel101.WidthPercent := 100.000000000000000000;
    WebLabel102.SetParentComponent(WebPanel32);
    WebLabel102.Name := 'WebLabel102';
    WebLabel102.Left := 82;
    WebLabel102.Top := 203;
    WebLabel102.Width := 79;
    WebLabel102.Height := 15;
    WebLabel102.Caption := 'Link Account : ';
    WebLabel102.HeightPercent := 100.000000000000000000;
    WebLabel102.WidthPercent := 100.000000000000000000;
    edtTFNUrl.SetParentComponent(WebPanel32);
    edtTFNUrl.Name := 'edtTFNUrl';
    edtTFNUrl.Left := 200;
    edtTFNUrl.Top := 38;
    edtTFNUrl.Width := 550;
    edtTFNUrl.Height := 22;
    edtTFNUrl.ChildOrder := 5;
    edtTFNUrl.HeightPercent := 100.000000000000000000;
    edtTFNUrl.WidthPercent := 100.000000000000000000;
    edtTFNUser.SetParentComponent(WebPanel32);
    edtTFNUser.Name := 'edtTFNUser';
    edtTFNUser.Left := 200;
    edtTFNUser.Top := 84;
    edtTFNUser.Width := 250;
    edtTFNUser.Height := 22;
    edtTFNUser.ChildOrder := 1;
    edtTFNUser.HeightPercent := 100.000000000000000000;
    edtTFNUser.WidthPercent := 100.000000000000000000;
    edtTFNPassword.SetParentComponent(WebPanel32);
    edtTFNPassword.Name := 'edtTFNPassword';
    edtTFNPassword.Left := 200;
    edtTFNPassword.Top := 126;
    edtTFNPassword.Width := 250;
    edtTFNPassword.Height := 22;
    edtTFNPassword.ChildOrder := 2;
    edtTFNPassword.HeightPercent := 100.000000000000000000;
    edtTFNPassword.WidthPercent := 100.000000000000000000;
    edtTFNAPIKey.SetParentComponent(WebPanel32);
    edtTFNAPIKey.Name := 'edtTFNAPIKey';
    edtTFNAPIKey.Left := 200;
    edtTFNAPIKey.Top := 165;
    edtTFNAPIKey.Width := 550;
    edtTFNAPIKey.Height := 22;
    edtTFNAPIKey.ChildOrder := 3;
    edtTFNAPIKey.HeightPercent := 100.000000000000000000;
    edtTFNAPIKey.WidthPercent := 100.000000000000000000;
    edtTFNAccount.SetParentComponent(WebPanel32);
    edtTFNAccount.Name := 'edtTFNAccount';
    edtTFNAccount.Left := 200;
    edtTFNAccount.Top := 205;
    edtTFNAccount.Width := 250;
    edtTFNAccount.Height := 22;
    edtTFNAccount.ChildOrder := 4;
    edtTFNAccount.HeightPercent := 100.000000000000000000;
    edtTFNAccount.WidthPercent := 100.000000000000000000;
    WebPanel25.SetParentComponent(WebPanel32);
    WebPanel25.Name := 'WebPanel25';
    WebPanel25.Left := 0;
    WebPanel25.Top := 538;
    WebPanel25.Width := 1417;
    WebPanel25.Height := 68;
    WebPanel25.ChildOrder := 11;
    WebPanel25.TabOrder := 5;
    TFNSubAccountsFirst.SetParentComponent(WebPanel25);
    TFNSubAccountsFirst.Name := 'TFNSubAccountsFirst';
    TFNSubAccountsFirst.Left := 17;
    TFNSubAccountsFirst.Top := 21;
    TFNSubAccountsFirst.Width := 24;
    TFNSubAccountsFirst.Height := 24;
    TFNSubAccountsFirst.Caption := '<<';
    TFNSubAccountsFirst.Color := clNone;
    TFNSubAccountsFirst.HeightPercent := 100.000000000000000000;
    TFNSubAccountsFirst.TabOrder := 0;
    TFNSubAccountsFirst.WidthPercent := 100.000000000000000000;
    SetEvent(TFNSubAccountsFirst, Self, 'OnClick', 'TFNSubAccountsFirstClick');
    TFNSubAccountsPrior.SetParentComponent(WebPanel25);
    TFNSubAccountsPrior.Name := 'TFNSubAccountsPrior';
    TFNSubAccountsPrior.Left := 40;
    TFNSubAccountsPrior.Top := 21;
    TFNSubAccountsPrior.Width := 24;
    TFNSubAccountsPrior.Height := 24;
    TFNSubAccountsPrior.Caption := '<';
    TFNSubAccountsPrior.Color := clNone;
    TFNSubAccountsPrior.HeightPercent := 100.000000000000000000;
    TFNSubAccountsPrior.TabOrder := 1;
    TFNSubAccountsPrior.WidthPercent := 100.000000000000000000;
    SetEvent(TFNSubAccountsPrior, Self, 'OnClick', 'TFNSubAccountsPriorClick');
    TFNSubAccountsNext.SetParentComponent(WebPanel25);
    TFNSubAccountsNext.Name := 'TFNSubAccountsNext';
    TFNSubAccountsNext.Left := 107;
    TFNSubAccountsNext.Top := 21;
    TFNSubAccountsNext.Width := 24;
    TFNSubAccountsNext.Height := 24;
    TFNSubAccountsNext.Caption := '>';
    TFNSubAccountsNext.Color := clNone;
    TFNSubAccountsNext.HeightPercent := 100.000000000000000000;
    TFNSubAccountsNext.TabOrder := 2;
    TFNSubAccountsNext.WidthPercent := 100.000000000000000000;
    SetEvent(TFNSubAccountsNext, Self, 'OnClick', 'TFNSubAccountsNextClick');
    WebSpeedButton28.SetParentComponent(WebPanel25);
    WebSpeedButton28.Name := 'WebSpeedButton28';
    WebSpeedButton28.Left := 131;
    WebSpeedButton28.Top := 21;
    WebSpeedButton28.Width := 24;
    WebSpeedButton28.Height := 24;
    WebSpeedButton28.Caption := '>>';
    WebSpeedButton28.Color := clNone;
    WebSpeedButton28.HeightPercent := 100.000000000000000000;
    WebSpeedButton28.TabOrder := 3;
    WebSpeedButton28.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton28, Self, 'OnClick', 'WebSpeedButton28Click');
    edtTFNSubAccounts.SetParentComponent(WebPanel25);
    edtTFNSubAccounts.Name := 'edtTFNSubAccounts';
    edtTFNSubAccounts.Left := 64;
    edtTFNSubAccounts.Top := 21;
    edtTFNSubAccounts.Width := 43;
    edtTFNSubAccounts.Height := 24;
    edtTFNSubAccounts.ChildOrder := 4;
    edtTFNSubAccounts.HeightPercent := 100.000000000000000000;
    edtTFNSubAccounts.WidthPercent := 100.000000000000000000;
    WebPanel27.SetParentComponent(WebPanel32);
    WebPanel27.Name := 'WebPanel27';
    WebPanel27.Left := 0;
    WebPanel27.Top := 240;
    WebPanel27.Width := 1413;
    WebPanel27.Height := 60;
    WebPanel27.ChildOrder := 12;
    WebPanel27.TabOrder := 6;
    WebSpeedButton25.SetParentComponent(WebPanel27);
    WebSpeedButton25.Name := 'WebSpeedButton25';
    WebSpeedButton25.Left := 9;
    WebSpeedButton25.Top := 8;
    WebSpeedButton25.Width := 45;
    WebSpeedButton25.Height := 45;
    WebSpeedButton25.Caption := '<<';
    WebSpeedButton25.Color := clNone;
    WebSpeedButton25.HeightPercent := 100.000000000000000000;
    WebSpeedButton25.TabOrder := 0;
    WebSpeedButton25.WidthPercent := 100.000000000000000000;
    WebSpeedButton26.SetParentComponent(WebPanel27);
    WebSpeedButton26.Name := 'WebSpeedButton26';
    WebSpeedButton26.Left := 64;
    WebSpeedButton26.Top := 8;
    WebSpeedButton26.Width := 45;
    WebSpeedButton26.Height := 45;
    WebSpeedButton26.Caption := '<';
    WebSpeedButton26.Color := clNone;
    WebSpeedButton26.HeightPercent := 100.000000000000000000;
    WebSpeedButton26.TabOrder := 1;
    WebSpeedButton26.WidthPercent := 100.000000000000000000;
    WebSpeedButton27.SetParentComponent(WebPanel27);
    WebSpeedButton27.Name := 'WebSpeedButton27';
    WebSpeedButton27.Left := 119;
    WebSpeedButton27.Top := 8;
    WebSpeedButton27.Width := 45;
    WebSpeedButton27.Height := 45;
    WebSpeedButton27.Caption := '>';
    WebSpeedButton27.Color := clNone;
    WebSpeedButton27.HeightPercent := 100.000000000000000000;
    WebSpeedButton27.TabOrder := 2;
    WebSpeedButton27.WidthPercent := 100.000000000000000000;
    WebSpeedButton29.SetParentComponent(WebPanel27);
    WebSpeedButton29.Name := 'WebSpeedButton29';
    WebSpeedButton29.Left := 173;
    WebSpeedButton29.Top := 8;
    WebSpeedButton29.Width := 45;
    WebSpeedButton29.Height := 45;
    WebSpeedButton29.Caption := '>>';
    WebSpeedButton29.Color := clNone;
    WebSpeedButton29.HeightPercent := 100.000000000000000000;
    WebSpeedButton29.TabOrder := 3;
    WebSpeedButton29.WidthPercent := 100.000000000000000000;
    WebSpeedButton30.SetParentComponent(WebPanel27);
    WebSpeedButton30.Name := 'WebSpeedButton30';
    WebSpeedButton30.Left := 226;
    WebSpeedButton30.Top := 8;
    WebSpeedButton30.Width := 45;
    WebSpeedButton30.Height := 45;
    WebSpeedButton30.Caption := '+';
    WebSpeedButton30.Color := clNone;
    WebSpeedButton30.HeightPercent := 100.000000000000000000;
    WebSpeedButton30.TabOrder := 4;
    WebSpeedButton30.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton30, Self, 'OnClick', 'WebSpeedButton30Click');
    dgTFN1.SetParentComponent(WebPanel32);
    dgTFN1.Name := 'dgTFN1';
    dgTFN1.Left := 3;
    dgTFN1.Top := 302;
    dgTFN1.Width := 1286;
    dgTFN1.Height := 239;
    dgTFN1.ParentDoubleBuffered := False;
    dgTFN1.DoubleBuffered := True;
    dgTFN1.TabOrder := 7;
    dgTFN1.ShowAcceleratorChar := False;
    dgTFN1.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgTFN1.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgTFN1.Header.VisualGrouping.Layout.Font.Height := -12;
    dgTFN1.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgTFN1.Header.VisualGrouping.Layout.Font.Style := [];
    dgTFN1.Adapter := dbagTFNSubaccounts1;
    dgTFN1.BitmapContainer := BitmapContainer1;
    dgTFN1.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgTFN1.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgTFN1.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgTFN1.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgTFN1.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgTFN1.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgTFN1.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgTFN1.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgTFN1.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgTFN1.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgTFN1.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgTFN1.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgTFN1.CellAppearance.BandLayout.Font.Height := -12;
    dgTFN1.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgTFN1.CellAppearance.BandLayout.Font.Style := [];
    dgTFN1.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgTFN1.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgTFN1.CellAppearance.FixedLayout.Font.Height := -12;
    dgTFN1.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgTFN1.CellAppearance.FixedLayout.Font.Style := [];
    dgTFN1.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgTFN1.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgTFN1.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgTFN1.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgTFN1.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgTFN1.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgTFN1.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgTFN1.CellAppearance.FocusedLayout.Font.Height := -12;
    dgTFN1.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgTFN1.CellAppearance.FocusedLayout.Font.Style := [];
    dgTFN1.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgTFN1.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgTFN1.CellAppearance.GroupLayout.Font.Height := -12;
    dgTFN1.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgTFN1.CellAppearance.GroupLayout.Font.Style := [];
    dgTFN1.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgTFN1.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgTFN1.CellAppearance.NormalLayout.Font.Height := -12;
    dgTFN1.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgTFN1.CellAppearance.NormalLayout.Font.Style := [];
    dgTFN1.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgTFN1.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgTFN1.CellAppearance.SelectedLayout.Font.Height := -12;
    dgTFN1.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgTFN1.CellAppearance.SelectedLayout.Font.Style := [];
    dgTFN1.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgTFN1.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgTFN1.CellAppearance.SummaryLayout.Font.Height := -12;
    dgTFN1.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgTFN1.CellAppearance.SummaryLayout.Font.Style := [];
    dgTFN1.ColumnCount := 8;
    dgTFN1.Columns.Clear;
    with dgTFN1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'ApiServerNo';
    end;
    with dgTFN1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'SubContractNo';
    end;
    with dgTFN1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'ApiAccountNo';
    end;
    with dgTFN1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'LastRunDate';
    end;
    with dgTFN1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'SubsRegNo';
    end;
    with dgTFN1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'CRName';
    end;
    with dgTFN1.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Edit';
      Settings := [gcsType];
    end;
    with dgTFN1.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Delete';
      Settings := [gcsType];
    end;
    dgTFN1.Designer := False;
    dgTFN1.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgTFN1.FilterAppearance.Font.Color := clWindowText;
    dgTFN1.FilterAppearance.Font.Height := -12;
    dgTFN1.FilterAppearance.Font.Name := 'Segoe UI';
    dgTFN1.FilterAppearance.Font.Style := [];
    dgTFN1.Icons.ExpandIcon.LoadFromFile('SystemSettings.WebPanel32.dgTFN1.Icons.ExpandIcon.svg');
    dgTFN1.Icons.CollapseIcon.LoadFromFile('SystemSettings.WebPanel32.dgTFN1.Icons.CollapseIcon.svg');
    dgTFN1.Icons.FilterIcon.LoadFromFile('SystemSettings.WebPanel32.dgTFN1.Icons.FilterIcon.svg');
    dgTFN1.Icons.FilterActiveIcon.LoadFromFile('SystemSettings.WebPanel32.dgTFN1.Icons.FilterActiveIcon.svg');
    dgTFN1.Icons.FilterClearIcon.LoadFromFile('SystemSettings.WebPanel32.dgTFN1.Icons.FilterClearIcon.svg');
    dgTFN1.Icons.FilterTypeIcon.LoadFromFile('SystemSettings.WebPanel32.dgTFN1.Icons.FilterTypeIcon.svg');
    dgTFN1.Icons.SortAscendingIcon.LoadFromFile('SystemSettings.WebPanel32.dgTFN1.Icons.SortAscendingIcon.svg');
    dgTFN1.Icons.SortDescendingIcon.LoadFromFile('SystemSettings.WebPanel32.dgTFN1.Icons.SortDescendingIcon.svg');
    dgTFN1.Icons.CloseIcon.LoadFromFile('SystemSettings.WebPanel32.dgTFN1.Icons.CloseIcon.svg');
    SetEvent(dgTFN1, Self, 'OnCellClick', 'dgTFN1CellClick');
    SetEvent(dgTFN1, Self, 'OnGetCellProperties', 'dgTFN1GetCellProperties');
    dgTFN1.RowCount := 1;
    dbagTFNSubaccounts1.SetParentComponent(dgTFN1);
    dbagTFNSubaccounts1.Name := 'dbagTFNSubaccounts1';
    dbagTFNSubaccounts1.Left := 449;
    dbagTFNSubaccounts1.Top := 48;
    dbagTFNSubaccounts1.Width := 26;
    dbagTFNSubaccounts1.Height := 26;
    dbagTFNSubaccounts1.Visible := True;
    dbagTFNSubaccounts1.AutoCreateColumns := False;
    dbagTFNSubaccounts1.AutoRemoveColumns := False;
    dbagTFNSubaccounts1.Columns.Clear;
    with dbagTFNSubaccounts1.Columns.Add do
    begin
      FieldName := 'ApiServerNo';
      AutoCreated := False;
    end;
    with dbagTFNSubaccounts1.Columns.Add do
    begin
      FieldName := 'SubContractNo';
      AutoCreated := False;
    end;
    with dbagTFNSubaccounts1.Columns.Add do
    begin
      FieldName := 'ApiAccountNo';
      AutoCreated := False;
    end;
    with dbagTFNSubaccounts1.Columns.Add do
    begin
      FieldName := 'LastRunDate';
      AutoCreated := False;
    end;
    with dbagTFNSubaccounts1.Columns.Add do
    begin
      FieldName := 'SubsRegNo';
      AutoCreated := False;
    end;
    with dbagTFNSubaccounts1.Columns.Add do
    begin
      FieldName := 'CRName';
      AutoCreated := False;
    end;
    with dbagTFNSubaccounts1.Columns.Add do
    begin
      Header := 'Edit';
      AutoCreated := False;
    end;
    with dbagTFNSubaccounts1.Columns.Add do
    begin
      Header := 'Delete';
      AutoCreated := False;
    end;
    dbagTFNSubaccounts1.DataSource := dsTFNSubAccountsS1;
    WebPageControl2Sheet2.SetParentComponent(WebPageControl2);
    WebPageControl2Sheet2.Name := 'WebPageControl2Sheet2';
    WebPageControl2Sheet2.Left := 0;
    WebPageControl2Sheet2.Top := 20;
    WebPageControl2Sheet2.Width := 1413;
    WebPageControl2Sheet2.Height := 609;
    WebPageControl2Sheet2.Caption := 'FMS Fuel System';
    WebPageControl2Sheet2.ChildOrder := 1;
    WebPanel33.SetParentComponent(WebPageControl2Sheet2);
    WebPanel33.Name := 'WebPanel33';
    WebPanel33.Left := 0;
    WebPanel33.Top := 0;
    WebPanel33.Width := 1413;
    WebPanel33.Height := 609;
    WebPanel33.Align := alClient;
    WebPanel33.TabOrder := 0;
    WebLabel97.SetParentComponent(WebPanel33);
    WebLabel97.Name := 'WebLabel97';
    WebLabel97.Left := 70;
    WebLabel97.Top := 32;
    WebLabel97.Width := 45;
    WebLabel97.Height := 15;
    WebLabel97.Caption := 'API Url : ';
    WebLabel97.HeightPercent := 100.000000000000000000;
    WebLabel97.WidthPercent := 100.000000000000000000;
    WebLabel103.SetParentComponent(WebPanel33);
    WebLabel103.Name := 'WebLabel103';
    WebLabel103.Left := 70;
    WebLabel103.Top := 66;
    WebLabel103.Width := 88;
    WebLabel103.Height := 15;
    WebLabel103.Caption := 'API User Name : ';
    WebLabel103.HeightPercent := 100.000000000000000000;
    WebLabel103.WidthPercent := 100.000000000000000000;
    WebLabel104.SetParentComponent(WebPanel33);
    WebLabel104.Name := 'WebLabel104';
    WebLabel104.Left := 70;
    WebLabel104.Top := 100;
    WebLabel104.Width := 80;
    WebLabel104.Height := 15;
    WebLabel104.Caption := 'API Password : ';
    WebLabel104.HeightPercent := 100.000000000000000000;
    WebLabel104.WidthPercent := 100.000000000000000000;
    WebLabel105.SetParentComponent(WebPanel33);
    WebLabel105.Name := 'WebLabel105';
    WebLabel105.Left := 70;
    WebLabel105.Top := 135;
    WebLabel105.Width := 40;
    WebLabel105.Height := 15;
    WebLabel105.Caption := 'API Key';
    WebLabel105.HeightPercent := 100.000000000000000000;
    WebLabel105.WidthPercent := 100.000000000000000000;
    WebLabel106.SetParentComponent(WebPanel33);
    WebLabel106.Name := 'WebLabel106';
    WebLabel106.Left := 70;
    WebLabel106.Top := 168;
    WebLabel106.Width := 79;
    WebLabel106.Height := 15;
    WebLabel106.Caption := 'Link Account : ';
    WebLabel106.HeightPercent := 100.000000000000000000;
    WebLabel106.WidthPercent := 100.000000000000000000;
    WebLabel107.SetParentComponent(WebPanel33);
    WebLabel107.Name := 'WebLabel107';
    WebLabel107.Left := 70;
    WebLabel107.Top := 205;
    WebLabel107.Width := 71;
    WebLabel107.Height := 15;
    WebLabel107.Caption := 'Order Prefix : ';
    WebLabel107.HeightPercent := 100.000000000000000000;
    WebLabel107.WidthPercent := 100.000000000000000000;
    edtFMSUrl.SetParentComponent(WebPanel33);
    edtFMSUrl.Name := 'edtFMSUrl';
    edtFMSUrl.Left := 192;
    edtFMSUrl.Top := 32;
    edtFMSUrl.Width := 550;
    edtFMSUrl.Height := 22;
    edtFMSUrl.ChildOrder := 6;
    edtFMSUrl.HeightPercent := 100.000000000000000000;
    edtFMSUrl.WidthPercent := 100.000000000000000000;
    edtFMSUser.SetParentComponent(WebPanel33);
    edtFMSUser.Name := 'edtFMSUser';
    edtFMSUser.Left := 192;
    edtFMSUser.Top := 68;
    edtFMSUser.Width := 250;
    edtFMSUser.Height := 22;
    edtFMSUser.ChildOrder := 1;
    edtFMSUser.HeightPercent := 100.000000000000000000;
    edtFMSUser.WidthPercent := 100.000000000000000000;
    edtFMSPass.SetParentComponent(WebPanel33);
    edtFMSPass.Name := 'edtFMSPass';
    edtFMSPass.Left := 192;
    edtFMSPass.Top := 99;
    edtFMSPass.Width := 250;
    edtFMSPass.Height := 22;
    edtFMSPass.ChildOrder := 2;
    edtFMSPass.HeightPercent := 100.000000000000000000;
    edtFMSPass.WidthPercent := 100.000000000000000000;
    edtFMSAPIKey.SetParentComponent(WebPanel33);
    edtFMSAPIKey.Name := 'edtFMSAPIKey';
    edtFMSAPIKey.Left := 192;
    edtFMSAPIKey.Top := 136;
    edtFMSAPIKey.Width := 550;
    edtFMSAPIKey.Height := 22;
    edtFMSAPIKey.ChildOrder := 3;
    edtFMSAPIKey.HeightPercent := 100.000000000000000000;
    edtFMSAPIKey.WidthPercent := 100.000000000000000000;
    edtFMSAccount.SetParentComponent(WebPanel33);
    edtFMSAccount.Name := 'edtFMSAccount';
    edtFMSAccount.Left := 192;
    edtFMSAccount.Top := 168;
    edtFMSAccount.Width := 250;
    edtFMSAccount.Height := 22;
    edtFMSAccount.ChildOrder := 4;
    edtFMSAccount.HeightPercent := 100.000000000000000000;
    edtFMSAccount.WidthPercent := 100.000000000000000000;
    Edit22.SetParentComponent(WebPanel33);
    Edit22.Name := 'Edit22';
    Edit22.Left := 192;
    Edit22.Top := 203;
    Edit22.Width := 121;
    Edit22.Height := 22;
    Edit22.ChildOrder := 5;
    Edit22.HeightPercent := 100.000000000000000000;
    Edit22.WidthPercent := 100.000000000000000000;
    WebPanel26.SetParentComponent(WebPanel33);
    WebPanel26.Name := 'WebPanel26';
    WebPanel26.Left := 1;
    WebPanel26.Top := 228;
    WebPanel26.Width := 1413;
    WebPanel26.Height := 60;
    WebPanel26.ChildOrder := 13;
    WebPanel26.TabOrder := 6;
    WebSpeedButton31.SetParentComponent(WebPanel26);
    WebSpeedButton31.Name := 'WebSpeedButton31';
    WebSpeedButton31.Left := 6;
    WebSpeedButton31.Top := 9;
    WebSpeedButton31.Width := 45;
    WebSpeedButton31.Height := 45;
    WebSpeedButton31.Caption := '<<';
    WebSpeedButton31.Color := clNone;
    WebSpeedButton31.HeightPercent := 100.000000000000000000;
    WebSpeedButton31.TabOrder := 0;
    WebSpeedButton31.WidthPercent := 100.000000000000000000;
    WebSpeedButton32.SetParentComponent(WebPanel26);
    WebSpeedButton32.Name := 'WebSpeedButton32';
    WebSpeedButton32.Left := 60;
    WebSpeedButton32.Top := 9;
    WebSpeedButton32.Width := 45;
    WebSpeedButton32.Height := 45;
    WebSpeedButton32.Caption := '<';
    WebSpeedButton32.Color := clNone;
    WebSpeedButton32.HeightPercent := 100.000000000000000000;
    WebSpeedButton32.TabOrder := 1;
    WebSpeedButton32.WidthPercent := 100.000000000000000000;
    WebSpeedButton33.SetParentComponent(WebPanel26);
    WebSpeedButton33.Name := 'WebSpeedButton33';
    WebSpeedButton33.Left := 112;
    WebSpeedButton33.Top := 9;
    WebSpeedButton33.Width := 45;
    WebSpeedButton33.Height := 45;
    WebSpeedButton33.Caption := '>';
    WebSpeedButton33.Color := clNone;
    WebSpeedButton33.HeightPercent := 100.000000000000000000;
    WebSpeedButton33.TabOrder := 2;
    WebSpeedButton33.WidthPercent := 100.000000000000000000;
    WebSpeedButton34.SetParentComponent(WebPanel26);
    WebSpeedButton34.Name := 'WebSpeedButton34';
    WebSpeedButton34.Left := 163;
    WebSpeedButton34.Top := 9;
    WebSpeedButton34.Width := 45;
    WebSpeedButton34.Height := 45;
    WebSpeedButton34.Caption := '>>';
    WebSpeedButton34.Color := clNone;
    WebSpeedButton34.HeightPercent := 100.000000000000000000;
    WebSpeedButton34.TabOrder := 3;
    WebSpeedButton34.WidthPercent := 100.000000000000000000;
    WebSpeedButton35.SetParentComponent(WebPanel26);
    WebSpeedButton35.Name := 'WebSpeedButton35';
    WebSpeedButton35.Left := 214;
    WebSpeedButton35.Top := 9;
    WebSpeedButton35.Width := 45;
    WebSpeedButton35.Height := 45;
    WebSpeedButton35.Caption := '+';
    WebSpeedButton35.Color := clNone;
    WebSpeedButton35.HeightPercent := 100.000000000000000000;
    WebSpeedButton35.TabOrder := 4;
    WebSpeedButton35.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton35, Self, 'OnClick', 'WebSpeedButton35Click');
    WebPanel28.SetParentComponent(WebPanel33);
    WebPanel28.Name := 'WebPanel28';
    WebPanel28.Left := 0;
    WebPanel28.Top := 547;
    WebPanel28.Width := 1413;
    WebPanel28.Height := 60;
    WebPanel28.ChildOrder := 14;
    WebPanel28.TabOrder := 7;
    sbtnTFNSubAccountsS2First.SetParentComponent(WebPanel28);
    sbtnTFNSubAccountsS2First.Name := 'sbtnTFNSubAccountsS2First';
    sbtnTFNSubAccountsS2First.Left := 16;
    sbtnTFNSubAccountsS2First.Top := 16;
    sbtnTFNSubAccountsS2First.Width := 24;
    sbtnTFNSubAccountsS2First.Height := 24;
    sbtnTFNSubAccountsS2First.Caption := '<<';
    sbtnTFNSubAccountsS2First.Color := clNone;
    sbtnTFNSubAccountsS2First.HeightPercent := 100.000000000000000000;
    sbtnTFNSubAccountsS2First.TabOrder := 0;
    sbtnTFNSubAccountsS2First.WidthPercent := 100.000000000000000000;
    SetEvent(sbtnTFNSubAccountsS2First, Self, 'OnClick', 'sbtnTFNSubAccountsS2FirstClick');
    sbtnTFNSubAccountsS2prior.SetParentComponent(WebPanel28);
    sbtnTFNSubAccountsS2prior.Name := 'sbtnTFNSubAccountsS2prior';
    sbtnTFNSubAccountsS2prior.Left := 39;
    sbtnTFNSubAccountsS2prior.Top := 16;
    sbtnTFNSubAccountsS2prior.Width := 24;
    sbtnTFNSubAccountsS2prior.Height := 24;
    sbtnTFNSubAccountsS2prior.Caption := '<';
    sbtnTFNSubAccountsS2prior.Color := clNone;
    sbtnTFNSubAccountsS2prior.HeightPercent := 100.000000000000000000;
    sbtnTFNSubAccountsS2prior.TabOrder := 1;
    sbtnTFNSubAccountsS2prior.WidthPercent := 100.000000000000000000;
    SetEvent(sbtnTFNSubAccountsS2prior, Self, 'OnClick', 'sbtnTFNSubAccountsS2priorClick');
    sbtnTFNSubAccountsS2Next.SetParentComponent(WebPanel28);
    sbtnTFNSubAccountsS2Next.Name := 'sbtnTFNSubAccountsS2Next';
    sbtnTFNSubAccountsS2Next.Left := 104;
    sbtnTFNSubAccountsS2Next.Top := 16;
    sbtnTFNSubAccountsS2Next.Width := 24;
    sbtnTFNSubAccountsS2Next.Height := 24;
    sbtnTFNSubAccountsS2Next.Caption := '>';
    sbtnTFNSubAccountsS2Next.Color := clNone;
    sbtnTFNSubAccountsS2Next.HeightPercent := 100.000000000000000000;
    sbtnTFNSubAccountsS2Next.TabOrder := 2;
    sbtnTFNSubAccountsS2Next.WidthPercent := 100.000000000000000000;
    SetEvent(sbtnTFNSubAccountsS2Next, Self, 'OnClick', 'sbtnTFNSubAccountsS2NextClick');
    sbtnTFNSubAccountsS2Last.SetParentComponent(WebPanel28);
    sbtnTFNSubAccountsS2Last.Name := 'sbtnTFNSubAccountsS2Last';
    sbtnTFNSubAccountsS2Last.Left := 127;
    sbtnTFNSubAccountsS2Last.Top := 16;
    sbtnTFNSubAccountsS2Last.Width := 24;
    sbtnTFNSubAccountsS2Last.Height := 24;
    sbtnTFNSubAccountsS2Last.Caption := '>>';
    sbtnTFNSubAccountsS2Last.Color := clNone;
    sbtnTFNSubAccountsS2Last.HeightPercent := 100.000000000000000000;
    sbtnTFNSubAccountsS2Last.TabOrder := 3;
    sbtnTFNSubAccountsS2Last.WidthPercent := 100.000000000000000000;
    SetEvent(sbtnTFNSubAccountsS2Last, Self, 'OnClick', 'sbtnTFNSubAccountsS2LastClick');
    edtTFNSubAccountsS2.SetParentComponent(WebPanel28);
    edtTFNSubAccountsS2.Name := 'edtTFNSubAccountsS2';
    edtTFNSubAccountsS2.Left := 62;
    edtTFNSubAccountsS2.Top := 16;
    edtTFNSubAccountsS2.Width := 43;
    edtTFNSubAccountsS2.Height := 24;
    edtTFNSubAccountsS2.ChildOrder := 4;
    edtTFNSubAccountsS2.HeightPercent := 100.000000000000000000;
    edtTFNSubAccountsS2.WidthPercent := 100.000000000000000000;
    dgTFNSubAccounts2.SetParentComponent(WebPanel33);
    dgTFNSubAccounts2.Name := 'dgTFNSubAccounts2';
    dgTFNSubAccounts2.Left := 3;
    dgTFNSubAccounts2.Top := 290;
    dgTFNSubAccounts2.Width := 1174;
    dgTFNSubAccounts2.Height := 254;
    dgTFNSubAccounts2.ParentDoubleBuffered := False;
    dgTFNSubAccounts2.DoubleBuffered := True;
    dgTFNSubAccounts2.TabOrder := 8;
    dgTFNSubAccounts2.ShowAcceleratorChar := False;
    dgTFNSubAccounts2.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgTFNSubAccounts2.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgTFNSubAccounts2.Header.VisualGrouping.Layout.Font.Height := -12;
    dgTFNSubAccounts2.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgTFNSubAccounts2.Header.VisualGrouping.Layout.Font.Style := [];
    dgTFNSubAccounts2.Adapter := dbagTFNSubAccountsS2;
    dgTFNSubAccounts2.BitmapContainer := BitmapContainer1;
    dgTFNSubAccounts2.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgTFNSubAccounts2.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgTFNSubAccounts2.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgTFNSubAccounts2.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgTFNSubAccounts2.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgTFNSubAccounts2.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgTFNSubAccounts2.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgTFNSubAccounts2.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgTFNSubAccounts2.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgTFNSubAccounts2.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgTFNSubAccounts2.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgTFNSubAccounts2.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgTFNSubAccounts2.CellAppearance.BandLayout.Font.Height := -12;
    dgTFNSubAccounts2.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgTFNSubAccounts2.CellAppearance.BandLayout.Font.Style := [];
    dgTFNSubAccounts2.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgTFNSubAccounts2.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgTFNSubAccounts2.CellAppearance.FixedLayout.Font.Height := -12;
    dgTFNSubAccounts2.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgTFNSubAccounts2.CellAppearance.FixedLayout.Font.Style := [];
    dgTFNSubAccounts2.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgTFNSubAccounts2.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgTFNSubAccounts2.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgTFNSubAccounts2.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgTFNSubAccounts2.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgTFNSubAccounts2.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgTFNSubAccounts2.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgTFNSubAccounts2.CellAppearance.FocusedLayout.Font.Height := -12;
    dgTFNSubAccounts2.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgTFNSubAccounts2.CellAppearance.FocusedLayout.Font.Style := [];
    dgTFNSubAccounts2.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgTFNSubAccounts2.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgTFNSubAccounts2.CellAppearance.GroupLayout.Font.Height := -12;
    dgTFNSubAccounts2.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgTFNSubAccounts2.CellAppearance.GroupLayout.Font.Style := [];
    dgTFNSubAccounts2.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgTFNSubAccounts2.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgTFNSubAccounts2.CellAppearance.NormalLayout.Font.Height := -12;
    dgTFNSubAccounts2.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgTFNSubAccounts2.CellAppearance.NormalLayout.Font.Style := [];
    dgTFNSubAccounts2.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgTFNSubAccounts2.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgTFNSubAccounts2.CellAppearance.SelectedLayout.Font.Height := -12;
    dgTFNSubAccounts2.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgTFNSubAccounts2.CellAppearance.SelectedLayout.Font.Style := [];
    dgTFNSubAccounts2.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgTFNSubAccounts2.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgTFNSubAccounts2.CellAppearance.SummaryLayout.Font.Height := -12;
    dgTFNSubAccounts2.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgTFNSubAccounts2.CellAppearance.SummaryLayout.Font.Style := [];
    dgTFNSubAccounts2.ColumnCount := 8;
    dgTFNSubAccounts2.Columns.Clear;
    with dgTFNSubAccounts2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'ApiServerNo';
      Width := 70.000000000000000000;
    end;
    with dgTFNSubAccounts2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'SubContractNo';
      Width := 250.000000000000000000;
    end;
    with dgTFNSubAccounts2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'ApiAccountNo';
      Width := 100.000000000000000000;
    end;
    with dgTFNSubAccounts2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'LastRunDate';
      Width := 100.000000000000000000;
    end;
    with dgTFNSubAccounts2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'SubsRegNo';
    end;
    with dgTFNSubAccounts2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'CRName';
    end;
    with dgTFNSubAccounts2.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Edit';
      Settings := [gcsType];
    end;
    with dgTFNSubAccounts2.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Delete';
      Settings := [gcsType];
    end;
    dgTFNSubAccounts2.Designer := False;
    dgTFNSubAccounts2.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgTFNSubAccounts2.FilterAppearance.Font.Color := clWindowText;
    dgTFNSubAccounts2.FilterAppearance.Font.Height := -12;
    dgTFNSubAccounts2.FilterAppearance.Font.Name := 'Segoe UI';
    dgTFNSubAccounts2.FilterAppearance.Font.Style := [];
    dgTFNSubAccounts2.Icons.ExpandIcon.LoadFromFile('SystemSettings.WebPanel33.dgTFNSubAccounts2.Icons.ExpandIcon.svg');
    dgTFNSubAccounts2.Icons.CollapseIcon.LoadFromFile('SystemSettings.WebPanel33.dgTFNSubAccounts2.Icons.CollapseIcon.svg');
    dgTFNSubAccounts2.Icons.FilterIcon.LoadFromFile('SystemSettings.WebPanel33.dgTFNSubAccounts2.Icons.FilterIcon.svg');
    dgTFNSubAccounts2.Icons.FilterActiveIcon.LoadFromFile('SystemSettings.WebPanel33.dgTFNSubAccounts2.Icons.FilterActiveIcon.svg');
    dgTFNSubAccounts2.Icons.FilterClearIcon.LoadFromFile('SystemSettings.WebPanel33.dgTFNSubAccounts2.Icons.FilterClearIcon.svg');
    dgTFNSubAccounts2.Icons.FilterTypeIcon.LoadFromFile('SystemSettings.WebPanel33.dgTFNSubAccounts2.Icons.FilterTypeIcon.svg');
    dgTFNSubAccounts2.Icons.SortAscendingIcon.LoadFromFile('SystemSettings.WebPanel33.dgTFNSubAccounts2.Icons.SortAscendingIcon.svg');
    dgTFNSubAccounts2.Icons.SortDescendingIcon.LoadFromFile('SystemSettings.WebPanel33.dgTFNSubAccounts2.Icons.SortDescendingIcon.svg');
    dgTFNSubAccounts2.Icons.CloseIcon.LoadFromFile('SystemSettings.WebPanel33.dgTFNSubAccounts2.Icons.CloseIcon.svg');
    SetEvent(dgTFNSubAccounts2, Self, 'OnCellClick', 'dgTFNSubAccounts2CellClick');
    SetEvent(dgTFNSubAccounts2, Self, 'OnGetCellProperties', 'dgTFNSubAccounts2GetCellProperties');
    dgTFNSubAccounts2.RowCount := 1;
    dbagTFNSubAccountsS2.SetParentComponent(dgTFNSubAccounts2);
    dbagTFNSubAccountsS2.Name := 'dbagTFNSubAccountsS2';
    dbagTFNSubAccountsS2.Left := 430;
    dbagTFNSubAccountsS2.Top := 137;
    dbagTFNSubAccountsS2.Width := 26;
    dbagTFNSubAccountsS2.Height := 26;
    dbagTFNSubAccountsS2.Visible := True;
    dbagTFNSubAccountsS2.AutoCreateColumns := False;
    dbagTFNSubAccountsS2.AutoRemoveColumns := False;
    dbagTFNSubAccountsS2.Columns.Clear;
    with dbagTFNSubAccountsS2.Columns.Add do
    begin
      FieldName := 'ApiServerNo';
      AutoCreated := False;
    end;
    with dbagTFNSubAccountsS2.Columns.Add do
    begin
      FieldName := 'SubContractNo';
      AutoCreated := False;
    end;
    with dbagTFNSubAccountsS2.Columns.Add do
    begin
      FieldName := 'ApiAccountNo';
      AutoCreated := False;
    end;
    with dbagTFNSubAccountsS2.Columns.Add do
    begin
      FieldName := 'LastRunDate';
      AutoCreated := False;
    end;
    with dbagTFNSubAccountsS2.Columns.Add do
    begin
      FieldName := 'SubsRegNo';
      AutoCreated := False;
    end;
    with dbagTFNSubAccountsS2.Columns.Add do
    begin
      FieldName := 'CRName';
      AutoCreated := False;
    end;
    with dbagTFNSubAccountsS2.Columns.Add do
    begin
      Header := 'Edit';
      AutoCreated := False;
    end;
    with dbagTFNSubAccountsS2.Columns.Add do
    begin
      Header := 'Delete';
      AutoCreated := False;
    end;
    dbagTFNSubAccountsS2.DataSource := dsTFNSubAccountsS2;
    WebMessageDlg1.SetParentComponent(dgTFNSubAccounts2);
    WebMessageDlg1.Name := 'WebMessageDlg1';
    WebMessageDlg1.Left := 468;
    WebMessageDlg1.Top := 134;
    WebMessageDlg1.Width := 24;
    WebMessageDlg1.Height := 24;
    WebMessageDlg1.Buttons := [];
    WebMessageDlg1.Opacity := 0.200000000000000000;
    WebPageControl2Sheet4.SetParentComponent(WebPageControl2);
    WebPageControl2Sheet4.Name := 'WebPageControl2Sheet4';
    WebPageControl2Sheet4.Left := 0;
    WebPageControl2Sheet4.Top := 20;
    WebPageControl2Sheet4.Width := 1413;
    WebPageControl2Sheet4.Height := 609;
    WebPageControl2Sheet4.Caption := 'FuelU';
    WebPageControl2Sheet4.ChildOrder := 3;
    WebPanel35.SetParentComponent(WebPageControl2Sheet4);
    WebPanel35.Name := 'WebPanel35';
    WebPanel35.Left := 0;
    WebPanel35.Top := 0;
    WebPanel35.Width := 1413;
    WebPanel35.Height := 609;
    WebPanel35.Align := alClient;
    WebPanel35.ChildOrder := 3;
    WebPanel35.TabOrder := 0;
    WebLabel114.SetParentComponent(WebPanel35);
    WebLabel114.Name := 'WebLabel114';
    WebLabel114.Left := 70;
    WebLabel114.Top := 150;
    WebLabel114.Width := 80;
    WebLabel114.Height := 15;
    WebLabel114.Caption := 'API Password : ';
    WebLabel114.HeightPercent := 100.000000000000000000;
    WebLabel114.WidthPercent := 100.000000000000000000;
    WebLabel113.SetParentComponent(WebPanel35);
    WebLabel113.Name := 'WebLabel113';
    WebLabel113.Left := 70;
    WebLabel113.Top := 99;
    WebLabel113.Width := 62;
    WebLabel113.Height := 15;
    WebLabel113.Caption := 'API Token : ';
    WebLabel113.HeightPercent := 100.000000000000000000;
    WebLabel113.WidthPercent := 100.000000000000000000;
    WebLabel112.SetParentComponent(WebPanel35);
    WebLabel112.Name := 'WebLabel112';
    WebLabel112.Left := 70;
    WebLabel112.Top := 48;
    WebLabel112.Width := 45;
    WebLabel112.Height := 15;
    WebLabel112.Caption := 'API Url : ';
    WebLabel112.HeightPercent := 100.000000000000000000;
    WebLabel112.WidthPercent := 100.000000000000000000;
    edtFuelUUrl.SetParentComponent(WebPanel35);
    edtFuelUUrl.Name := 'edtFuelUUrl';
    edtFuelUUrl.Left := 190;
    edtFuelUUrl.Top := 46;
    edtFuelUUrl.Width := 550;
    edtFuelUUrl.Height := 22;
    edtFuelUUrl.ChildOrder := 3;
    edtFuelUUrl.HeightPercent := 100.000000000000000000;
    edtFuelUUrl.WidthPercent := 100.000000000000000000;
    edtFuelUToken.SetParentComponent(WebPanel35);
    edtFuelUToken.Name := 'edtFuelUToken';
    edtFuelUToken.Left := 190;
    edtFuelUToken.Top := 99;
    edtFuelUToken.Width := 250;
    edtFuelUToken.Height := 22;
    edtFuelUToken.ChildOrder := 4;
    edtFuelUToken.HeightPercent := 100.000000000000000000;
    edtFuelUToken.WidthPercent := 100.000000000000000000;
    edtFuelUPassword.SetParentComponent(WebPanel35);
    edtFuelUPassword.Name := 'edtFuelUPassword';
    edtFuelUPassword.Left := 190;
    edtFuelUPassword.Top := 150;
    edtFuelUPassword.Width := 250;
    edtFuelUPassword.Height := 22;
    edtFuelUPassword.ChildOrder := 5;
    edtFuelUPassword.HeightPercent := 100.000000000000000000;
    edtFuelUPassword.WidthPercent := 100.000000000000000000;
    WebPageControl2Sheet5.SetParentComponent(WebPageControl2);
    WebPageControl2Sheet5.Name := 'WebPageControl2Sheet5';
    WebPageControl2Sheet5.Left := 0;
    WebPageControl2Sheet5.Top := 20;
    WebPageControl2Sheet5.Width := 1413;
    WebPageControl2Sheet5.Height := 609;
    WebPageControl2Sheet5.Caption := 'Premi Points';
    WebPageControl2Sheet5.ChildOrder := 4;
    WebPanel36.SetParentComponent(WebPageControl2Sheet5);
    WebPanel36.Name := 'WebPanel36';
    WebPanel36.Left := 0;
    WebPanel36.Top := 0;
    WebPanel36.Width := 1413;
    WebPanel36.Height := 609;
    WebPanel36.Align := alClient;
    WebPanel36.TabOrder := 0;
    WebLabel115.SetParentComponent(WebPanel36);
    WebLabel115.Name := 'WebLabel115';
    WebLabel115.Left := 70;
    WebLabel115.Top := 42;
    WebLabel115.Width := 45;
    WebLabel115.Height := 15;
    WebLabel115.Caption := 'API Url : ';
    WebLabel115.HeightPercent := 100.000000000000000000;
    WebLabel115.WidthPercent := 100.000000000000000000;
    WebLabel116.SetParentComponent(WebPanel36);
    WebLabel116.Name := 'WebLabel116';
    WebLabel116.Left := 70;
    WebLabel116.Top := 76;
    WebLabel116.Width := 88;
    WebLabel116.Height := 15;
    WebLabel116.Caption := 'API User Name : ';
    WebLabel116.HeightPercent := 100.000000000000000000;
    WebLabel116.WidthPercent := 100.000000000000000000;
    WebLabel117.SetParentComponent(WebPanel36);
    WebLabel117.Name := 'WebLabel117';
    WebLabel117.Left := 70;
    WebLabel117.Top := 110;
    WebLabel117.Width := 80;
    WebLabel117.Height := 15;
    WebLabel117.Caption := 'API Password : ';
    WebLabel117.HeightPercent := 100.000000000000000000;
    WebLabel117.WidthPercent := 100.000000000000000000;
    WebLabel118.SetParentComponent(WebPanel36);
    WebLabel118.Name := 'WebLabel118';
    WebLabel118.Left := 70;
    WebLabel118.Top := 137;
    WebLabel118.Width := 43;
    WebLabel118.Height := 15;
    WebLabel118.Caption := 'API Key:';
    WebLabel118.HeightPercent := 100.000000000000000000;
    WebLabel118.WidthPercent := 100.000000000000000000;
    WebLabel119.SetParentComponent(WebPanel36);
    WebLabel119.Name := 'WebLabel119';
    WebLabel119.Left := 70;
    WebLabel119.Top := 169;
    WebLabel119.Width := 79;
    WebLabel119.Height := 15;
    WebLabel119.Caption := 'Link Account : ';
    WebLabel119.HeightPercent := 100.000000000000000000;
    WebLabel119.WidthPercent := 100.000000000000000000;
    edtPremiPointUrl.SetParentComponent(WebPanel36);
    edtPremiPointUrl.Name := 'edtPremiPointUrl';
    edtPremiPointUrl.Left := 190;
    edtPremiPointUrl.Top := 43;
    edtPremiPointUrl.Width := 550;
    edtPremiPointUrl.Height := 22;
    edtPremiPointUrl.ChildOrder := 1;
    edtPremiPointUrl.HeightPercent := 100.000000000000000000;
    edtPremiPointUrl.WidthPercent := 100.000000000000000000;
    edtPremiPointUser.SetParentComponent(WebPanel36);
    edtPremiPointUser.Name := 'edtPremiPointUser';
    edtPremiPointUser.Left := 192;
    edtPremiPointUser.Top := 76;
    edtPremiPointUser.Width := 250;
    edtPremiPointUser.Height := 22;
    edtPremiPointUser.ChildOrder := 1;
    edtPremiPointUser.HeightPercent := 100.000000000000000000;
    edtPremiPointUser.WidthPercent := 100.000000000000000000;
    edtPremiPointPassword.SetParentComponent(WebPanel36);
    edtPremiPointPassword.Name := 'edtPremiPointPassword';
    edtPremiPointPassword.Left := 192;
    edtPremiPointPassword.Top := 108;
    edtPremiPointPassword.Width := 250;
    edtPremiPointPassword.Height := 22;
    edtPremiPointPassword.ChildOrder := 2;
    edtPremiPointPassword.HeightPercent := 100.000000000000000000;
    edtPremiPointPassword.WidthPercent := 100.000000000000000000;
    edtPremiPointKey.SetParentComponent(WebPanel36);
    edtPremiPointKey.Name := 'edtPremiPointKey';
    edtPremiPointKey.Left := 192;
    edtPremiPointKey.Top := 138;
    edtPremiPointKey.Width := 550;
    edtPremiPointKey.Height := 22;
    edtPremiPointKey.ChildOrder := 3;
    edtPremiPointKey.HeightPercent := 100.000000000000000000;
    edtPremiPointKey.WidthPercent := 100.000000000000000000;
    edtPremiPointAccount.SetParentComponent(WebPanel36);
    edtPremiPointAccount.Name := 'edtPremiPointAccount';
    edtPremiPointAccount.Left := 192;
    edtPremiPointAccount.Top := 170;
    edtPremiPointAccount.Width := 250;
    edtPremiPointAccount.Height := 22;
    edtPremiPointAccount.ChildOrder := 4;
    edtPremiPointAccount.HeightPercent := 100.000000000000000000;
    edtPremiPointAccount.WidthPercent := 100.000000000000000000;
    wpcSysSetupSheet11.SetParentComponent(wpcSysSetup);
    wpcSysSetupSheet11.Name := 'wpcSysSetupSheet11';
    wpcSysSetupSheet11.Left := 0;
    wpcSysSetupSheet11.Top := 20;
    wpcSysSetupSheet11.Width := 1556;
    wpcSysSetupSheet11.Height := 629;
    wpcSysSetupSheet11.Caption := 'Employee Comission Setup';
    wpcSysSetupSheet11.ChildOrder := 10;
    WebPanel37.SetParentComponent(wpcSysSetupSheet11);
    WebPanel37.Name := 'WebPanel37';
    WebPanel37.Left := 0;
    WebPanel37.Top := 0;
    WebPanel37.Width := 1556;
    WebPanel37.Height := 629;
    WebPanel37.Align := alClient;
    WebPanel37.TabOrder := 0;
    WebDBRadioGroup1.SetParentComponent(WebPanel37);
    WebDBRadioGroup1.Name := 'WebDBRadioGroup1';
    WebDBRadioGroup1.Left := 63;
    WebDBRadioGroup1.Top := 58;
    WebDBRadioGroup1.Width := 243;
    WebDBRadioGroup1.Height := 110;
    WebDBRadioGroup1.Caption := 'WebDBRadioGroup1';
    WebDBRadioGroup1.Columns := 1;
    WebDBRadioGroup1.ItemIndex := 0;
    WebDBRadioGroup1.Items.BeginUpdate;
    try
      WebDBRadioGroup1.Items.Clear;
      WebDBRadioGroup1.Items.Add('Based On Total Value');
      WebDBRadioGroup1.Items.Add('Based On Contract Setup');
    finally
      WebDBRadioGroup1.Items.EndUpdate;
    end;
    WebDBRadioGroup1.Role := '';
    WebDBRadioGroup1.TabOrder := 0;
    WebDBRadioGroup1.DataField := 'commissiontype';
    WebDBRadioGroup1.DataSource := dsCompInfo;
    wpcSysSetupSheet12.SetParentComponent(wpcSysSetup);
    wpcSysSetupSheet12.Name := 'wpcSysSetupSheet12';
    wpcSysSetupSheet12.Left := 0;
    wpcSysSetupSheet12.Top := 20;
    wpcSysSetupSheet12.Width := 1556;
    wpcSysSetupSheet12.Height := 629;
    wpcSysSetupSheet12.Caption := 'Maint/Misc System';
    wpcSysSetupSheet12.ChildOrder := 11;
    WebPanel38.SetParentComponent(wpcSysSetupSheet12);
    WebPanel38.Name := 'WebPanel38';
    WebPanel38.Left := 0;
    WebPanel38.Top := 0;
    WebPanel38.Width := 1556;
    WebPanel38.Height := 629;
    WebPanel38.Align := alClient;
    WebPanel38.ChildOrder := 4;
    WebPanel38.TabOrder := 0;
    WebLabel120.SetParentComponent(WebPanel38);
    WebLabel120.Name := 'WebLabel120';
    WebLabel120.Left := 592;
    WebLabel120.Top := 40;
    WebLabel120.Width := 106;
    WebLabel120.Height := 15;
    WebLabel120.Caption := 'Jobcard Completed:';
    WebLabel120.HeightPercent := 100.000000000000000000;
    WebLabel120.WidthPercent := 100.000000000000000000;
    WebLabel121.SetParentComponent(WebPanel38);
    WebLabel121.Name := 'WebLabel121';
    WebLabel121.Left := 592;
    WebLabel121.Top := 70;
    WebLabel121.Width := 114;
    WebLabel121.Height := 15;
    WebLabel121.Caption := 'Custom Misc Invoice:';
    WebLabel121.HeightPercent := 100.000000000000000000;
    WebLabel121.WidthPercent := 100.000000000000000000;
    WebLabel122.SetParentComponent(WebPanel38);
    WebLabel122.Name := 'WebLabel122';
    WebLabel122.Left := 592;
    WebLabel122.Top := 104;
    WebLabel122.Width := 115;
    WebLabel122.Height := 15;
    WebLabel122.Caption := 'Supplier Misc Invoice:';
    WebLabel122.HeightPercent := 100.000000000000000000;
    WebLabel122.WidthPercent := 100.000000000000000000;
    WebLabel123.SetParentComponent(WebPanel38);
    WebLabel123.Name := 'WebLabel123';
    WebLabel123.Left := 592;
    WebLabel123.Top := 138;
    WebLabel123.Width := 92;
    WebLabel123.Height := 15;
    WebLabel123.Caption := 'Jobcard Selection';
    WebLabel123.HeightPercent := 100.000000000000000000;
    WebLabel123.WidthPercent := 100.000000000000000000;
    WebLabel124.SetParentComponent(WebPanel38);
    WebLabel124.Name := 'WebLabel124';
    WebLabel124.Left := 64;
    WebLabel124.Top := 208;
    WebLabel124.Width := 75;
    WebLabel124.Height := 15;
    WebLabel124.Caption := 'Stock STD % : ';
    WebLabel124.HeightPercent := 100.000000000000000000;
    WebLabel124.WidthPercent := 100.000000000000000000;
    WebLabel125.SetParentComponent(WebPanel38);
    WebLabel125.Name := 'WebLabel125';
    WebLabel125.Left := 64;
    WebLabel125.Top := 240;
    WebLabel125.Width := 76;
    WebLabel125.Height := 15;
    WebLabel125.Caption := 'Stock DED % : ';
    WebLabel125.HeightPercent := 100.000000000000000000;
    WebLabel125.WidthPercent := 100.000000000000000000;
    WebLabel126.SetParentComponent(WebPanel38);
    WebLabel126.Name := 'WebLabel126';
    WebLabel126.Left := 64;
    WebLabel126.Top := 272;
    WebLabel126.Width := 73;
    WebLabel126.Height := 15;
    WebLabel126.Caption := 'Stock SPE % : ';
    WebLabel126.HeightPercent := 100.000000000000000000;
    WebLabel126.WidthPercent := 100.000000000000000000;
    WebLabel127.SetParentComponent(WebPanel38);
    WebLabel127.Name := 'WebLabel127';
    WebLabel127.Left := 64;
    WebLabel127.Top := 304;
    WebLabel127.Width := 82;
    WebLabel127.Height := 15;
    WebLabel127.Caption := 'Jobcard Prefix : ';
    WebLabel127.HeightPercent := 100.000000000000000000;
    WebLabel127.WidthPercent := 100.000000000000000000;
    WebLabel128.SetParentComponent(WebPanel38);
    WebLabel128.Name := 'WebLabel128';
    WebLabel128.Left := 64;
    WebLabel128.Top := 336;
    WebLabel128.Width := 83;
    WebLabel128.Height := 15;
    WebLabel128.Caption := 'Request Prefix : ';
    WebLabel128.HeightPercent := 100.000000000000000000;
    WebLabel128.WidthPercent := 100.000000000000000000;
    WebLabel129.SetParentComponent(WebPanel38);
    WebLabel129.Name := 'WebLabel129';
    WebLabel129.Left := 64;
    WebLabel129.Top := 368;
    WebLabel129.Width := 76;
    WebLabel129.Height := 15;
    WebLabel129.Caption := 'Orders Prefix : ';
    WebLabel129.HeightPercent := 100.000000000000000000;
    WebLabel129.WidthPercent := 100.000000000000000000;
    WebDBCheckBox1.SetParentComponent(WebPanel38);
    WebDBCheckBox1.Name := 'WebDBCheckBox1';
    WebDBCheckBox1.Left := 64;
    WebDBCheckBox1.Top := 64;
    WebDBCheckBox1.Width := 381;
    WebDBCheckBox1.Height := 22;
    WebDBCheckBox1.Caption := 'Miscellaneous Invoice Must Use Loadcon Numbers';
    WebDBCheckBox1.ChildOrder := 10;
    WebDBCheckBox1.HeightPercent := 100.000000000000000000;
    WebDBCheckBox1.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox1, Self, 'OnClick', 'WebDBCheckBox1Click');
    WebDBCheckBox1.DataField := 'MISCINVLOADS';
    WebDBCheckBox1.DataSource := dsCompInfo;
    WebDBCheckBox4.SetParentComponent(WebPanel38);
    WebDBCheckBox4.Name := 'WebDBCheckBox4';
    WebDBCheckBox4.Left := 64;
    WebDBCheckBox4.Top := 102;
    WebDBCheckBox4.Width := 240;
    WebDBCheckBox4.Height := 22;
    WebDBCheckBox4.Caption := 'No 0 Qty Stock On Jobcard';
    WebDBCheckBox4.ChildOrder := 1;
    WebDBCheckBox4.HeightPercent := 100.000000000000000000;
    WebDBCheckBox4.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox4, Self, 'OnClick', 'WebDBCheckBox4Click');
    WebDBCheckBox4.DataField := 'jobnullqty';
    WebDBCheckBox4.DataSource := dsCompInfo;
    WebDBCheckBox41.SetParentComponent(WebPanel38);
    WebDBCheckBox41.Name := 'WebDBCheckBox41';
    WebDBCheckBox41.Left := 64;
    WebDBCheckBox41.Top := 139;
    WebDBCheckBox41.Width := 240;
    WebDBCheckBox41.Height := 22;
    WebDBCheckBox41.Caption := 'Pre-Order - JobCard - Order';
    WebDBCheckBox41.ChildOrder := 2;
    WebDBCheckBox41.HeightPercent := 100.000000000000000000;
    WebDBCheckBox41.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox41, Self, 'OnClick', 'WebDBCheckBox41Click');
    WebDBCheckBox41.DataField := 'joborder';
    WebDBCheckBox41.DataSource := dsCompInfo;
    WebDBCheckBox42.SetParentComponent(WebPanel38);
    WebDBCheckBox42.Name := 'WebDBCheckBox42';
    WebDBCheckBox42.Left := 64;
    WebDBCheckBox42.Top := 36;
    WebDBCheckBox42.Width := 170;
    WebDBCheckBox42.Height := 22;
    WebDBCheckBox42.Caption := 'Force Misc GI Code';
    WebDBCheckBox42.ChildOrder := 3;
    WebDBCheckBox42.HeightPercent := 100.000000000000000000;
    WebDBCheckBox42.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox42, Self, 'OnClick', 'WebDBCheckBox42Click');
    WebDBCheckBox42.DataField := 'MISCGLFORCE';
    WebDBCheckBox42.DataSource := dsCompInfo;
    WebDBComboBox1.SetParentComponent(WebPanel38);
    WebDBComboBox1.Name := 'WebDBComboBox1';
    WebDBComboBox1.Left := 744;
    WebDBComboBox1.Top := 35;
    WebDBComboBox1.Width := 145;
    WebDBComboBox1.Height := 23;
    WebDBComboBox1.HeightPercent := 100.000000000000000000;
    WebDBComboBox1.WidthPercent := 100.000000000000000000;
    WebDBComboBox1.ItemIndex := -1;
    WebDBComboBox1.DataField := 'JobCompType';
    WebDBComboBox1.DataSource := dsCompInfo;
    WebDBComboBox2.SetParentComponent(WebPanel38);
    WebDBComboBox2.Name := 'WebDBComboBox2';
    WebDBComboBox2.Left := 744;
    WebDBComboBox2.Top := 69;
    WebDBComboBox2.Width := 145;
    WebDBComboBox2.Height := 23;
    WebDBComboBox2.HeightPercent := 100.000000000000000000;
    WebDBComboBox2.WidthPercent := 100.000000000000000000;
    WebDBComboBox2.ItemIndex := -1;
    WebDBComboBox2.DataField := 'CUSTMISCTYPE';
    WebDBComboBox2.DataSource := dsCompInfo;
    WebDBComboBox3.SetParentComponent(WebPanel38);
    WebDBComboBox3.Name := 'WebDBComboBox3';
    WebDBComboBox3.Left := 744;
    WebDBComboBox3.Top := 104;
    WebDBComboBox3.Width := 145;
    WebDBComboBox3.Height := 23;
    WebDBComboBox3.HeightPercent := 100.000000000000000000;
    WebDBComboBox3.WidthPercent := 100.000000000000000000;
    WebDBComboBox3.ItemIndex := -1;
    WebDBComboBox3.DataField := 'SUPPMISCTYPE';
    WebDBComboBox3.DataSource := dsCompInfo;
    WebDBComboBox4.SetParentComponent(WebPanel38);
    WebDBComboBox4.Name := 'WebDBComboBox4';
    WebDBComboBox4.Left := 744;
    WebDBComboBox4.Top := 139;
    WebDBComboBox4.Width := 145;
    WebDBComboBox4.Height := 23;
    WebDBComboBox4.HeightPercent := 100.000000000000000000;
    WebDBComboBox4.WidthPercent := 100.000000000000000000;
    WebDBComboBox4.ItemIndex := -1;
    WebDBComboBox4.DataField := 'jobcardtype';
    WebDBComboBox4.DataSource := dsCompInfo;
    WebDBEdit35.SetParentComponent(WebPanel38);
    WebDBEdit35.Name := 'WebDBEdit35';
    WebDBEdit35.Left := 174;
    WebDBEdit35.Top := 209;
    WebDBEdit35.Width := 121;
    WebDBEdit35.Height := 22;
    WebDBEdit35.ChildOrder := 18;
    WebDBEdit35.HeightPercent := 100.000000000000000000;
    WebDBEdit35.WidthPercent := 100.000000000000000000;
    WebDBEdit35.DataField := 'STOCKSTDPERC';
    WebDBEdit35.DataSource := dsCompInfo;
    WebDBEdit36.SetParentComponent(WebPanel38);
    WebDBEdit36.Name := 'WebDBEdit36';
    WebDBEdit36.Left := 174;
    WebDBEdit36.Top := 241;
    WebDBEdit36.Width := 121;
    WebDBEdit36.Height := 22;
    WebDBEdit36.ChildOrder := 19;
    WebDBEdit36.HeightPercent := 100.000000000000000000;
    WebDBEdit36.WidthPercent := 100.000000000000000000;
    WebDBEdit36.DataField := 'STOCKDEDPERC';
    WebDBEdit36.DataSource := dsCompInfo;
    WebDBEdit37.SetParentComponent(WebPanel38);
    WebDBEdit37.Name := 'WebDBEdit37';
    WebDBEdit37.Left := 174;
    WebDBEdit37.Top := 273;
    WebDBEdit37.Width := 121;
    WebDBEdit37.Height := 22;
    WebDBEdit37.ChildOrder := 20;
    WebDBEdit37.HeightPercent := 100.000000000000000000;
    WebDBEdit37.WidthPercent := 100.000000000000000000;
    WebDBEdit37.DataField := 'STOCKSPEPERC';
    WebDBEdit37.DataSource := dsCompInfo;
    WebDBEdit38.SetParentComponent(WebPanel38);
    WebDBEdit38.Name := 'WebDBEdit38';
    WebDBEdit38.Left := 175;
    WebDBEdit38.Top := 307;
    WebDBEdit38.Width := 121;
    WebDBEdit38.Height := 22;
    WebDBEdit38.ChildOrder := 21;
    WebDBEdit38.HeightPercent := 100.000000000000000000;
    WebDBEdit38.WidthPercent := 100.000000000000000000;
    WebDBEdit38.DataField := 'JOBCARDPREFIX';
    WebDBEdit38.DataSource := dsCompInfo;
    WebDBEdit39.SetParentComponent(WebPanel38);
    WebDBEdit39.Name := 'WebDBEdit39';
    WebDBEdit39.Left := 174;
    WebDBEdit39.Top := 338;
    WebDBEdit39.Width := 121;
    WebDBEdit39.Height := 22;
    WebDBEdit39.ChildOrder := 22;
    WebDBEdit39.HeightPercent := 100.000000000000000000;
    WebDBEdit39.WidthPercent := 100.000000000000000000;
    WebDBEdit39.DataField := 'REQUESTPREFIX';
    WebDBEdit39.DataSource := dsCompInfo;
    WebDBEdit40.SetParentComponent(WebPanel38);
    WebDBEdit40.Name := 'WebDBEdit40';
    WebDBEdit40.Left := 174;
    WebDBEdit40.Top := 368;
    WebDBEdit40.Width := 121;
    WebDBEdit40.Height := 22;
    WebDBEdit40.ChildOrder := 23;
    WebDBEdit40.HeightPercent := 100.000000000000000000;
    WebDBEdit40.WidthPercent := 100.000000000000000000;
    WebDBEdit40.DataField := 'ORDERSPREFIX';
    WebDBEdit40.DataSource := dsCompInfo;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 698;
    WebPanel3.Width := 1556;
    WebPanel3.Height := 52;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 2;
    WebPanel3.Color := clSilver;
    WebPanel3.TabOrder := 2;
    btnSave.SetParentComponent(WebPanel3);
    btnSave.Name := 'btnSave';
    btnSave.Left := 13;
    btnSave.Top := 14;
    btnSave.Width := 96;
    btnSave.Height := 25;
    btnSave.Caption := 'Save';
    btnSave.Color := clGreenyellow;
    btnSave.HeightPercent := 100.000000000000000000;
    btnSave.WidthPercent := 100.000000000000000000;
    SetEvent(btnSave, Self, 'OnClick', 'btnSaveClick');
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 126;
    WebButton2.Top := 13;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Cancel';
    WebButton2.Color := clRed;
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    wcCompInfo.SetParentComponent(Self);
    wcCompInfo.Name := 'wcCompInfo';
    wcCompInfo.Connection := dmData.dbConnect;
    wcCompInfo.Left := 40;
    wcCompInfo.Top := 121;
    wdsCompInfo.SetParentComponent(Self);
    wdsCompInfo.Name := 'wdsCompInfo';
    wdsCompInfo.Connection := dmData.dbConnect;
    wdsCompInfo.Left := 96;
    wdsCompInfo.Top := 120;
    wdsCompInfoSSCLoadConLoadDate.SetParentComponent(wdsCompInfo);
    wdsCompInfoSSCLoadConLoadDate.Name := 'wdsCompInfoSSCLoadConLoadDate';
    wdsCompInfoSSCLoadConLoadDate.FieldName := 'SSCLoadConLoadDate';
    wdsCompInfoSSCLoadConOffLoadDate.SetParentComponent(wdsCompInfo);
    wdsCompInfoSSCLoadConOffLoadDate.Name := 'wdsCompInfoSSCLoadConOffLoadDate';
    wdsCompInfoSSCLoadConOffLoadDate.FieldName := 'SSCLoadConOffLoadDate';
    wdsCompInfoSSCLOADCONRECEIVEDATE.SetParentComponent(wdsCompInfo);
    wdsCompInfoSSCLOADCONRECEIVEDATE.Name := 'wdsCompInfoSSCLOADCONRECEIVEDATE';
    wdsCompInfoSSCLOADCONRECEIVEDATE.FieldName := 'SSCLOADCONRECEIVEDATE';
    wdsCompInfoSSCLOADCONCOMPLETEDATE.SetParentComponent(wdsCompInfo);
    wdsCompInfoSSCLOADCONCOMPLETEDATE.Name := 'wdsCompInfoSSCLOADCONCOMPLETEDATE';
    wdsCompInfoSSCLOADCONCOMPLETEDATE.FieldName := 'SSCLOADCONCOMPLETEDATE';
    wdsCompInfoSSCLOADCONLOADTIME.SetParentComponent(wdsCompInfo);
    wdsCompInfoSSCLOADCONLOADTIME.Name := 'wdsCompInfoSSCLOADCONLOADTIME';
    wdsCompInfoSSCLOADCONLOADTIME.FieldName := 'SSCLOADCONLOADTIME';
    wdsCompInfoSSCLOADCONOFFLOADTIME.SetParentComponent(wdsCompInfo);
    wdsCompInfoSSCLOADCONOFFLOADTIME.Name := 'wdsCompInfoSSCLOADCONOFFLOADTIME';
    wdsCompInfoSSCLOADCONOFFLOADTIME.FieldName := 'SSCLOADCONOFFLOADTIME';
    wdsCompInfoSSCLOADCONRECEIVETIME.SetParentComponent(wdsCompInfo);
    wdsCompInfoSSCLOADCONRECEIVETIME.Name := 'wdsCompInfoSSCLOADCONRECEIVETIME';
    wdsCompInfoSSCLOADCONRECEIVETIME.FieldName := 'SSCLOADCONRECEIVETIME';
    wdsCompInfoSSCLOADCONCOMPLETETIME.SetParentComponent(wdsCompInfo);
    wdsCompInfoSSCLOADCONCOMPLETETIME.Name := 'wdsCompInfoSSCLOADCONCOMPLETETIME';
    wdsCompInfoSSCLOADCONCOMPLETETIME.FieldName := 'SSCLOADCONCOMPLETETIME';
    wdsCompInfoSSCLOADCONLOADDATEC.SetParentComponent(wdsCompInfo);
    wdsCompInfoSSCLOADCONLOADDATEC.Name := 'wdsCompInfoSSCLOADCONLOADDATEC';
    wdsCompInfoSSCLOADCONLOADDATEC.FieldName := 'SSCLOADCONLOADDATEC';
    wdsCompInfoSSCLOADCONOFFLOADDATEC.SetParentComponent(wdsCompInfo);
    wdsCompInfoSSCLOADCONOFFLOADDATEC.Name := 'wdsCompInfoSSCLOADCONOFFLOADDATEC';
    wdsCompInfoSSCLOADCONOFFLOADDATEC.FieldName := 'SSCLOADCONOFFLOADDATEC';
    wdsCompInfoSSCLOADCONRECEIVEDATEC.SetParentComponent(wdsCompInfo);
    wdsCompInfoSSCLOADCONRECEIVEDATEC.Name := 'wdsCompInfoSSCLOADCONRECEIVEDATEC';
    wdsCompInfoSSCLOADCONRECEIVEDATEC.FieldName := 'SSCLOADCONRECEIVEDATEC';
    wdsCompInfoSSCLOADCONCOMPLETEDATEC.SetParentComponent(wdsCompInfo);
    wdsCompInfoSSCLOADCONCOMPLETEDATEC.Name := 'wdsCompInfoSSCLOADCONCOMPLETEDATEC';
    wdsCompInfoSSCLOADCONCOMPLETEDATEC.FieldName := 'SSCLOADCONCOMPLETEDATEC';
    wdsCompInfoSSCLOADCONLOADTIMEC.SetParentComponent(wdsCompInfo);
    wdsCompInfoSSCLOADCONLOADTIMEC.Name := 'wdsCompInfoSSCLOADCONLOADTIMEC';
    wdsCompInfoSSCLOADCONLOADTIMEC.FieldName := 'SSCLOADCONLOADTIMEC';
    wdsCompInfoSSCLOADCONOFFLOADTIMEC.SetParentComponent(wdsCompInfo);
    wdsCompInfoSSCLOADCONOFFLOADTIMEC.Name := 'wdsCompInfoSSCLOADCONOFFLOADTIMEC';
    wdsCompInfoSSCLOADCONOFFLOADTIMEC.FieldName := 'SSCLOADCONOFFLOADTIMEC';
    wdsCompInfoSSCLOADCONRECEIVETIMEC.SetParentComponent(wdsCompInfo);
    wdsCompInfoSSCLOADCONRECEIVETIMEC.Name := 'wdsCompInfoSSCLOADCONRECEIVETIMEC';
    wdsCompInfoSSCLOADCONRECEIVETIMEC.FieldName := 'SSCLOADCONRECEIVETIMEC';
    wdsCompInfoSSCLOADCONCOMPLETETIMEC.SetParentComponent(wdsCompInfo);
    wdsCompInfoSSCLOADCONCOMPLETETIMEC.Name := 'wdsCompInfoSSCLOADCONCOMPLETETIMEC';
    wdsCompInfoSSCLOADCONCOMPLETETIMEC.FieldName := 'SSCLOADCONCOMPLETETIMEC';
    wdsCompInfoUSEFINLINKSYSTEM.SetParentComponent(wdsCompInfo);
    wdsCompInfoUSEFINLINKSYSTEM.Name := 'wdsCompInfoUSEFINLINKSYSTEM';
    wdsCompInfoUSEFINLINKSYSTEM.FieldName := 'USEFINLINKSYSTEM';
    wdsCompInfoFINLINKSYSTEM.SetParentComponent(wdsCompInfo);
    wdsCompInfoFINLINKSYSTEM.Name := 'wdsCompInfoFINLINKSYSTEM';
    wdsCompInfoFINLINKSYSTEM.FieldName := 'FINLINKSYSTEM';
    wdsCompInfoAUTOMAILSYSTEM.SetParentComponent(wdsCompInfo);
    wdsCompInfoAUTOMAILSYSTEM.Name := 'wdsCompInfoAUTOMAILSYSTEM';
    wdsCompInfoAUTOMAILSYSTEM.FieldName := 'AUTOMAILSYSTEM';
    wdsCompInfoFINDBSETUP.SetParentComponent(wdsCompInfo);
    wdsCompInfoFINDBSETUP.Name := 'wdsCompInfoFINDBSETUP';
    wdsCompInfoFINDBSETUP.FieldName := 'FINDBSETUP';
    wdsCompInfoMAILSERVER.SetParentComponent(wdsCompInfo);
    wdsCompInfoMAILSERVER.Name := 'wdsCompInfoMAILSERVER';
    wdsCompInfoMAILSERVER.FieldName := 'MAILSERVER';
    wdsCompInfoMAILSERVERPORT.SetParentComponent(wdsCompInfo);
    wdsCompInfoMAILSERVERPORT.Name := 'wdsCompInfoMAILSERVERPORT';
    wdsCompInfoMAILSERVERPORT.FieldName := 'MAILSERVERPORT';
    wdsCompInfoMAILSERVERAUTH.SetParentComponent(wdsCompInfo);
    wdsCompInfoMAILSERVERAUTH.Name := 'wdsCompInfoMAILSERVERAUTH';
    wdsCompInfoMAILSERVERAUTH.FieldName := 'MAILSERVERAUTH';
    wdsCompInfoMAILSERVERUSER.SetParentComponent(wdsCompInfo);
    wdsCompInfoMAILSERVERUSER.Name := 'wdsCompInfoMAILSERVERUSER';
    wdsCompInfoMAILSERVERUSER.FieldName := 'MAILSERVERUSER';
    wdsCompInfoMAILSERVERPASS.SetParentComponent(wdsCompInfo);
    wdsCompInfoMAILSERVERPASS.Name := 'wdsCompInfoMAILSERVERPASS';
    wdsCompInfoMAILSERVERPASS.FieldName := 'MAILSERVERPASS';
    wdsCompInfoMAILSERVERSSL.SetParentComponent(wdsCompInfo);
    wdsCompInfoMAILSERVERSSL.Name := 'wdsCompInfoMAILSERVERSSL';
    wdsCompInfoMAILSERVERSSL.FieldName := 'MAILSERVERSSL';
    wdsCompInfoMAILSERVERPROTOCOL.SetParentComponent(wdsCompInfo);
    wdsCompInfoMAILSERVERPROTOCOL.Name := 'wdsCompInfoMAILSERVERPROTOCOL';
    wdsCompInfoMAILSERVERPROTOCOL.FieldName := 'MAILSERVERPROTOCOL';
    wdsCompInfoMAILSERVERSIGNATURE.SetParentComponent(wdsCompInfo);
    wdsCompInfoMAILSERVERSIGNATURE.Name := 'wdsCompInfoMAILSERVERSIGNATURE';
    wdsCompInfoMAILSERVERSIGNATURE.FieldName := 'MAILSERVERSIGNATURE';
    wdsCompInfoMAILSERVERENCRYPTION.SetParentComponent(wdsCompInfo);
    wdsCompInfoMAILSERVERENCRYPTION.Name := 'wdsCompInfoMAILSERVERENCRYPTION';
    wdsCompInfoMAILSERVERENCRYPTION.FieldName := 'MAILSERVERENCRYPTION';
    wdsCompInfoMAILSERVERENCODING.SetParentComponent(wdsCompInfo);
    wdsCompInfoMAILSERVERENCODING.Name := 'wdsCompInfoMAILSERVERENCODING';
    wdsCompInfoMAILSERVERENCODING.FieldName := 'MAILSERVERENCODING';
    wdsCompInfoDCLPERC.SetParentComponent(wdsCompInfo);
    wdsCompInfoDCLPERC.Name := 'wdsCompInfoDCLPERC';
    wdsCompInfoDCLPERC.FieldName := 'DCLPERC';
    wdsCompInfoBANKSTATEMENT.SetParentComponent(wdsCompInfo);
    wdsCompInfoBANKSTATEMENT.Name := 'wdsCompInfoBANKSTATEMENT';
    wdsCompInfoBANKSTATEMENT.FieldName := 'BANKSTATEMENT';
    wdsCompInfoSSFLOADCONLOADDATEC.SetParentComponent(wdsCompInfo);
    wdsCompInfoSSFLOADCONLOADDATEC.Name := 'wdsCompInfoSSFLOADCONLOADDATEC';
    wdsCompInfoSSFLOADCONLOADDATEC.FieldName := 'SSFLOADCONLOADDATEC';
    wdsCompInfoSSFLOADCONOFFLOADDATEC.SetParentComponent(wdsCompInfo);
    wdsCompInfoSSFLOADCONOFFLOADDATEC.Name := 'wdsCompInfoSSFLOADCONOFFLOADDATEC';
    wdsCompInfoSSFLOADCONOFFLOADDATEC.FieldName := 'SSFLOADCONOFFLOADDATEC';
    wdsCompInfoSSFLOADCONRECEIVEDATEC.SetParentComponent(wdsCompInfo);
    wdsCompInfoSSFLOADCONRECEIVEDATEC.Name := 'wdsCompInfoSSFLOADCONRECEIVEDATEC';
    wdsCompInfoSSFLOADCONRECEIVEDATEC.FieldName := 'SSFLOADCONRECEIVEDATEC';
    wdsCompInfoSSFLOADCONCOMPLETEDATEC.SetParentComponent(wdsCompInfo);
    wdsCompInfoSSFLOADCONCOMPLETEDATEC.Name := 'wdsCompInfoSSFLOADCONCOMPLETEDATEC';
    wdsCompInfoSSFLOADCONCOMPLETEDATEC.FieldName := 'SSFLOADCONCOMPLETEDATEC';
    wdsCompInfoSSFLOADCONLOADTIMEC.SetParentComponent(wdsCompInfo);
    wdsCompInfoSSFLOADCONLOADTIMEC.Name := 'wdsCompInfoSSFLOADCONLOADTIMEC';
    wdsCompInfoSSFLOADCONLOADTIMEC.FieldName := 'SSFLOADCONLOADTIMEC';
    wdsCompInfoSSFLOADCONOFFLOADTIMEC.SetParentComponent(wdsCompInfo);
    wdsCompInfoSSFLOADCONOFFLOADTIMEC.Name := 'wdsCompInfoSSFLOADCONOFFLOADTIMEC';
    wdsCompInfoSSFLOADCONOFFLOADTIMEC.FieldName := 'SSFLOADCONOFFLOADTIMEC';
    wdsCompInfoSSFLOADCONRECEIVETIMEC.SetParentComponent(wdsCompInfo);
    wdsCompInfoSSFLOADCONRECEIVETIMEC.Name := 'wdsCompInfoSSFLOADCONRECEIVETIMEC';
    wdsCompInfoSSFLOADCONRECEIVETIMEC.FieldName := 'SSFLOADCONRECEIVETIMEC';
    wdsCompInfoSSFLOADCONCOMPLETETIMEC.SetParentComponent(wdsCompInfo);
    wdsCompInfoSSFLOADCONCOMPLETETIMEC.Name := 'wdsCompInfoSSFLOADCONCOMPLETETIMEC';
    wdsCompInfoSSFLOADCONCOMPLETETIMEC.FieldName := 'SSFLOADCONCOMPLETETIMEC';
    wdsCompInfoFORCEDIESELDRIVER.SetParentComponent(wdsCompInfo);
    wdsCompInfoFORCEDIESELDRIVER.Name := 'wdsCompInfoFORCEDIESELDRIVER';
    wdsCompInfoFORCEDIESELDRIVER.FieldName := 'FORCEDIESELDRIVER';
    wdsCompInfoFORCELOADDRIVER.SetParentComponent(wdsCompInfo);
    wdsCompInfoFORCELOADDRIVER.Name := 'wdsCompInfoFORCELOADDRIVER';
    wdsCompInfoFORCELOADDRIVER.FieldName := 'FORCELOADDRIVER';
    wdsCompInfoDEFDIESELORDERS.SetParentComponent(wdsCompInfo);
    wdsCompInfoDEFDIESELORDERS.Name := 'wdsCompInfoDEFDIESELORDERS';
    wdsCompInfoDEFDIESELORDERS.FieldName := 'DEFDIESELORDERS';
    wdsCompInfoDEFLOADORDERS.SetParentComponent(wdsCompInfo);
    wdsCompInfoDEFLOADORDERS.Name := 'wdsCompInfoDEFLOADORDERS';
    wdsCompInfoDEFLOADORDERS.FieldName := 'DEFLOADORDERS';
    wdsCompInfoINVOICESYSTEM.SetParentComponent(wdsCompInfo);
    wdsCompInfoINVOICESYSTEM.Name := 'wdsCompInfoINVOICESYSTEM';
    wdsCompInfoINVOICESYSTEM.FieldName := 'INVOICESYSTEM';
    wdsCompInfoBTBRANCHCODE.SetParentComponent(wdsCompInfo);
    wdsCompInfoBTBRANCHCODE.Name := 'wdsCompInfoBTBRANCHCODE';
    wdsCompInfoBTBRANCHCODE.FieldName := 'BTBRANCHCODE';
    wdsCompInfoBTACCOUNTNO.SetParentComponent(wdsCompInfo);
    wdsCompInfoBTACCOUNTNO.Name := 'wdsCompInfoBTACCOUNTNO';
    wdsCompInfoBTACCOUNTNO.FieldName := 'BTACCOUNTNO';
    wdsCompInfoTRIPSHEETTYPE.SetParentComponent(wdsCompInfo);
    wdsCompInfoTRIPSHEETTYPE.Name := 'wdsCompInfoTRIPSHEETTYPE';
    wdsCompInfoTRIPSHEETTYPE.FieldName := 'TRIPSHEETTYPE';
    wdsCompInfoLOADCUSTOMERS.SetParentComponent(wdsCompInfo);
    wdsCompInfoLOADCUSTOMERS.Name := 'wdsCompInfoLOADCUSTOMERS';
    wdsCompInfoLOADCUSTOMERS.FieldName := 'LOADCUSTOMERS';
    wdsCompInfoFINLINKSYSTEMCOUNT.SetParentComponent(wdsCompInfo);
    wdsCompInfoFINLINKSYSTEMCOUNT.Name := 'wdsCompInfoFINLINKSYSTEMCOUNT';
    wdsCompInfoFINLINKSYSTEMCOUNT.FieldName := 'FINLINKSYSTEMCOUNT';
    wdsCompInfoFIN1NAME.SetParentComponent(wdsCompInfo);
    wdsCompInfoFIN1NAME.Name := 'wdsCompInfoFIN1NAME';
    wdsCompInfoFIN1NAME.FieldName := 'FIN1NAME';
    wdsCompInfoFIN2NAME.SetParentComponent(wdsCompInfo);
    wdsCompInfoFIN2NAME.Name := 'wdsCompInfoFIN2NAME';
    wdsCompInfoFIN2NAME.FieldName := 'FIN2NAME';
    wdsCompInfoUSEDOCKETNOINVNO.SetParentComponent(wdsCompInfo);
    wdsCompInfoUSEDOCKETNOINVNO.Name := 'wdsCompInfoUSEDOCKETNOINVNO';
    wdsCompInfoUSEDOCKETNOINVNO.FieldName := 'USEDOCKETNOINVNO';
    wdsCompInfoUSEADDINFONONCON.SetParentComponent(wdsCompInfo);
    wdsCompInfoUSEADDINFONONCON.Name := 'wdsCompInfoUSEADDINFONONCON';
    wdsCompInfoUSEADDINFONONCON.FieldName := 'USEADDINFONONCON';
    wdsCompInfoSTATEMENTTYPE.SetParentComponent(wdsCompInfo);
    wdsCompInfoSTATEMENTTYPE.Name := 'wdsCompInfoSTATEMENTTYPE';
    wdsCompInfoSTATEMENTTYPE.FieldName := 'STATEMENTTYPE';
    wdsCompInfoSTOCKSTDPERC.SetParentComponent(wdsCompInfo);
    wdsCompInfoSTOCKSTDPERC.Name := 'wdsCompInfoSTOCKSTDPERC';
    wdsCompInfoSTOCKSTDPERC.FieldName := 'STOCKSTDPERC';
    wdsCompInfoSTOCKDEDPERC.SetParentComponent(wdsCompInfo);
    wdsCompInfoSTOCKDEDPERC.Name := 'wdsCompInfoSTOCKDEDPERC';
    wdsCompInfoSTOCKDEDPERC.FieldName := 'STOCKDEDPERC';
    wdsCompInfoSTOCKSPEPERC.SetParentComponent(wdsCompInfo);
    wdsCompInfoSTOCKSPEPERC.Name := 'wdsCompInfoSTOCKSPEPERC';
    wdsCompInfoSTOCKSPEPERC.FieldName := 'STOCKSPEPERC';
    wdsCompInfoEMPADDCOMDESC.SetParentComponent(wdsCompInfo);
    wdsCompInfoEMPADDCOMDESC.Name := 'wdsCompInfoEMPADDCOMDESC';
    wdsCompInfoEMPADDCOMDESC.FieldName := 'EMPADDCOMDESC';
    wdsCompInfoNONCONDISPLAYFUEL.SetParentComponent(wdsCompInfo);
    wdsCompInfoNONCONDISPLAYFUEL.Name := 'wdsCompInfoNONCONDISPLAYFUEL';
    wdsCompInfoNONCONDISPLAYFUEL.FieldName := 'NONCONDISPLAYFUEL';
    wdsCompInfoADD1DESC.SetParentComponent(wdsCompInfo);
    wdsCompInfoADD1DESC.Name := 'wdsCompInfoADD1DESC';
    wdsCompInfoADD1DESC.FieldName := 'ADD1DESC';
    wdsCompInfoADD2DESC.SetParentComponent(wdsCompInfo);
    wdsCompInfoADD2DESC.Name := 'wdsCompInfoADD2DESC';
    wdsCompInfoADD2DESC.FieldName := 'ADD2DESC';
    wdsCompInfoADD3DESC.SetParentComponent(wdsCompInfo);
    wdsCompInfoADD3DESC.Name := 'wdsCompInfoADD3DESC';
    wdsCompInfoADD3DESC.FieldName := 'ADD3DESC';
    wdsCompInfoADD4DESC.SetParentComponent(wdsCompInfo);
    wdsCompInfoADD4DESC.Name := 'wdsCompInfoADD4DESC';
    wdsCompInfoADD4DESC.FieldName := 'ADD4DESC';
    wdsCompInfoADD5DESC.SetParentComponent(wdsCompInfo);
    wdsCompInfoADD5DESC.Name := 'wdsCompInfoADD5DESC';
    wdsCompInfoADD5DESC.FieldName := 'ADD5DESC';
    wdsCompInfoADD6DESC.SetParentComponent(wdsCompInfo);
    wdsCompInfoADD6DESC.Name := 'wdsCompInfoADD6DESC';
    wdsCompInfoADD6DESC.FieldName := 'ADD6DESC';
    wdsCompInfoADD7DESC.SetParentComponent(wdsCompInfo);
    wdsCompInfoADD7DESC.Name := 'wdsCompInfoADD7DESC';
    wdsCompInfoADD7DESC.FieldName := 'ADD7DESC';
    wdsCompInfoPOSTALADDRESS1.SetParentComponent(wdsCompInfo);
    wdsCompInfoPOSTALADDRESS1.Name := 'wdsCompInfoPOSTALADDRESS1';
    wdsCompInfoPOSTALADDRESS1.FieldName := 'POSTALADDRESS1';
    wdsCompInfoPOSTALADDRESS2.SetParentComponent(wdsCompInfo);
    wdsCompInfoPOSTALADDRESS2.Name := 'wdsCompInfoPOSTALADDRESS2';
    wdsCompInfoPOSTALADDRESS2.FieldName := 'POSTALADDRESS2';
    wdsCompInfoPOSTALADDRESS3.SetParentComponent(wdsCompInfo);
    wdsCompInfoPOSTALADDRESS3.Name := 'wdsCompInfoPOSTALADDRESS3';
    wdsCompInfoPOSTALADDRESS3.FieldName := 'POSTALADDRESS3';
    wdsCompInfoPOSTALADDRESS4.SetParentComponent(wdsCompInfo);
    wdsCompInfoPOSTALADDRESS4.Name := 'wdsCompInfoPOSTALADDRESS4';
    wdsCompInfoPOSTALADDRESS4.FieldName := 'POSTALADDRESS4';
    wdsCompInfoPOSTALCODE.SetParentComponent(wdsCompInfo);
    wdsCompInfoPOSTALCODE.Name := 'wdsCompInfoPOSTALCODE';
    wdsCompInfoPOSTALCODE.FieldName := 'POSTALCODE';
    wdsCompInfoUSEMULTICOMPANYINVOICE.SetParentComponent(wdsCompInfo);
    wdsCompInfoUSEMULTICOMPANYINVOICE.Name := 'wdsCompInfoUSEMULTICOMPANYINVOICE';
    wdsCompInfoUSEMULTICOMPANYINVOICE.FieldName := 'USEMULTICOMPANYINVOICE';
    wdsCompInfoMISCINVLOADS.SetParentComponent(wdsCompInfo);
    wdsCompInfoMISCINVLOADS.Name := 'wdsCompInfoMISCINVLOADS';
    wdsCompInfoMISCINVLOADS.FieldName := 'MISCINVLOADS';
    wdsCompInfoPRINTTOTALSSEND.SetParentComponent(wdsCompInfo);
    wdsCompInfoPRINTTOTALSSEND.Name := 'wdsCompInfoPRINTTOTALSSEND';
    wdsCompInfoPRINTTOTALSSEND.FieldName := 'PRINTTOTALSSEND';
    wdsCompInfoWEBSERVERADDRESS.SetParentComponent(wdsCompInfo);
    wdsCompInfoWEBSERVERADDRESS.Name := 'wdsCompInfoWEBSERVERADDRESS';
    wdsCompInfoWEBSERVERADDRESS.FieldName := 'WEBSERVERADDRESS';
    wdsCompInfoWEBSERVERPORT.SetParentComponent(wdsCompInfo);
    wdsCompInfoWEBSERVERPORT.Name := 'wdsCompInfoWEBSERVERPORT';
    wdsCompInfoWEBSERVERPORT.FieldName := 'WEBSERVERPORT';
    wdsCompInfoWEBSERVERUSER.SetParentComponent(wdsCompInfo);
    wdsCompInfoWEBSERVERUSER.Name := 'wdsCompInfoWEBSERVERUSER';
    wdsCompInfoWEBSERVERUSER.FieldName := 'WEBSERVERUSER';
    wdsCompInfoWEBSERVERPASSWORD.SetParentComponent(wdsCompInfo);
    wdsCompInfoWEBSERVERPASSWORD.Name := 'wdsCompInfoWEBSERVERPASSWORD';
    wdsCompInfoWEBSERVERPASSWORD.FieldName := 'WEBSERVERPASSWORD';
    wdsCompInfoWEBSERVERSCANAPI.SetParentComponent(wdsCompInfo);
    wdsCompInfoWEBSERVERSCANAPI.Name := 'wdsCompInfoWEBSERVERSCANAPI';
    wdsCompInfoWEBSERVERSCANAPI.FieldName := 'WEBSERVERSCANAPI';
    wdsCompInfoDBSERVERADDRESS.SetParentComponent(wdsCompInfo);
    wdsCompInfoDBSERVERADDRESS.Name := 'wdsCompInfoDBSERVERADDRESS';
    wdsCompInfoDBSERVERADDRESS.FieldName := 'DBSERVERADDRESS';
    wdsCompInfoDBSERVERPORT.SetParentComponent(wdsCompInfo);
    wdsCompInfoDBSERVERPORT.Name := 'wdsCompInfoDBSERVERPORT';
    wdsCompInfoDBSERVERPORT.FieldName := 'DBSERVERPORT';
    wdsCompInfoINTERNALADDRESS.SetParentComponent(wdsCompInfo);
    wdsCompInfoINTERNALADDRESS.Name := 'wdsCompInfoINTERNALADDRESS';
    wdsCompInfoINTERNALADDRESS.FieldName := 'INTERNALADDRESS';
    wdsCompInfoINTERNALPORT.SetParentComponent(wdsCompInfo);
    wdsCompInfoINTERNALPORT.Name := 'wdsCompInfoINTERNALPORT';
    wdsCompInfoINTERNALPORT.FieldName := 'INTERNALPORT';
    wdsCompInfoWEBSERVERDB.SetParentComponent(wdsCompInfo);
    wdsCompInfoWEBSERVERDB.Name := 'wdsCompInfoWEBSERVERDB';
    wdsCompInfoWEBSERVERDB.FieldName := 'WEBSERVERDB';
    wdsCompInfoWEBSERVERDBUSER.SetParentComponent(wdsCompInfo);
    wdsCompInfoWEBSERVERDBUSER.Name := 'wdsCompInfoWEBSERVERDBUSER';
    wdsCompInfoWEBSERVERDBUSER.FieldName := 'WEBSERVERDBUSER';
    wdsCompInfoWEBSERVERDBPASS.SetParentComponent(wdsCompInfo);
    wdsCompInfoWEBSERVERDBPASS.Name := 'wdsCompInfoWEBSERVERDBPASS';
    wdsCompInfoWEBSERVERDBPASS.FieldName := 'WEBSERVERDBPASS';
    wdsCompInfoUNIQUEORDER.SetParentComponent(wdsCompInfo);
    wdsCompInfoUNIQUEORDER.Name := 'wdsCompInfoUNIQUEORDER';
    wdsCompInfoUNIQUEORDER.FieldName := 'UNIQUEORDER';
    wdsCompInfoUNIQUEWAYBILLS.SetParentComponent(wdsCompInfo);
    wdsCompInfoUNIQUEWAYBILLS.Name := 'wdsCompInfoUNIQUEWAYBILLS';
    wdsCompInfoUNIQUEWAYBILLS.FieldName := 'UNIQUEWAYBILLS';
    wdsCompInfoUNIQUEWASHBAYDOCKET.SetParentComponent(wdsCompInfo);
    wdsCompInfoUNIQUEWASHBAYDOCKET.Name := 'wdsCompInfoUNIQUEWASHBAYDOCKET';
    wdsCompInfoUNIQUEWASHBAYDOCKET.FieldName := 'UNIQUEWASHBAYDOCKET';
    wdsCompInfoIMPORTPERIOD.SetParentComponent(wdsCompInfo);
    wdsCompInfoIMPORTPERIOD.Name := 'wdsCompInfoIMPORTPERIOD';
    wdsCompInfoIMPORTPERIOD.FieldName := 'IMPORTPERIOD';
    wdsCompInfoIMPORTBATCH.SetParentComponent(wdsCompInfo);
    wdsCompInfoIMPORTBATCH.Name := 'wdsCompInfoIMPORTBATCH';
    wdsCompInfoIMPORTBATCH.FieldName := 'IMPORTBATCH';
    wdsCompInfoPRINTLOADSAVE.SetParentComponent(wdsCompInfo);
    wdsCompInfoPRINTLOADSAVE.Name := 'wdsCompInfoPRINTLOADSAVE';
    wdsCompInfoPRINTLOADSAVE.FieldName := 'PRINTLOADSAVE';
    wdsCompInfoNOFUTUREINVDATE.SetParentComponent(wdsCompInfo);
    wdsCompInfoNOFUTUREINVDATE.Name := 'wdsCompInfoNOFUTUREINVDATE';
    wdsCompInfoNOFUTUREINVDATE.FieldName := 'NOFUTUREINVDATE';
    wdsCompInfoUNIQUESHORTDESC.SetParentComponent(wdsCompInfo);
    wdsCompInfoUNIQUESHORTDESC.Name := 'wdsCompInfoUNIQUESHORTDESC';
    wdsCompInfoUNIQUESHORTDESC.FieldName := 'UNIQUESHORTDESC';
    wdsCompInfoCUSTMISCTYPE.SetParentComponent(wdsCompInfo);
    wdsCompInfoCUSTMISCTYPE.Name := 'wdsCompInfoCUSTMISCTYPE';
    wdsCompInfoCUSTMISCTYPE.FieldName := 'CUSTMISCTYPE';
    wdsCompInfoSUPPMISCTYPE.SetParentComponent(wdsCompInfo);
    wdsCompInfoSUPPMISCTYPE.Name := 'wdsCompInfoSUPPMISCTYPE';
    wdsCompInfoSUPPMISCTYPE.FieldName := 'SUPPMISCTYPE';
    wdsCompInfoJOBCARDPREFIX.SetParentComponent(wdsCompInfo);
    wdsCompInfoJOBCARDPREFIX.Name := 'wdsCompInfoJOBCARDPREFIX';
    wdsCompInfoJOBCARDPREFIX.FieldName := 'JOBCARDPREFIX';
    wdsCompInfoREQUESTPREFIX.SetParentComponent(wdsCompInfo);
    wdsCompInfoREQUESTPREFIX.Name := 'wdsCompInfoREQUESTPREFIX';
    wdsCompInfoREQUESTPREFIX.FieldName := 'REQUESTPREFIX';
    wdsCompInfoORDERSPREFIX.SetParentComponent(wdsCompInfo);
    wdsCompInfoORDERSPREFIX.Name := 'wdsCompInfoORDERSPREFIX';
    wdsCompInfoORDERSPREFIX.FieldName := 'ORDERSPREFIX';
    wdsCompInfoMISCGLFORCE.SetParentComponent(wdsCompInfo);
    wdsCompInfoMISCGLFORCE.Name := 'wdsCompInfoMISCGLFORCE';
    wdsCompInfoMISCGLFORCE.FieldName := 'MISCGLFORCE';
    wdsCompInfoSUBUNINVSHOW.SetParentComponent(wdsCompInfo);
    wdsCompInfoSUBUNINVSHOW.Name := 'wdsCompInfoSUBUNINVSHOW';
    wdsCompInfoSUBUNINVSHOW.FieldName := 'SUBUNINVSHOW';
    wdsCompInfoemployeedemerit.SetParentComponent(wdsCompInfo);
    wdsCompInfoemployeedemerit.Name := 'wdsCompInfoemployeedemerit';
    wdsCompInfoemployeedemerit.FieldName := 'employeedemerit';
    wdsCompInfovehicledemerit.SetParentComponent(wdsCompInfo);
    wdsCompInfovehicledemerit.Name := 'wdsCompInfovehicledemerit';
    wdsCompInfovehicledemerit.FieldName := 'vehicledemerit';
    wdsCompInfomonitorvehiclechanges.SetParentComponent(wdsCompInfo);
    wdsCompInfomonitorvehiclechanges.Name := 'wdsCompInfomonitorvehiclechanges';
    wdsCompInfomonitorvehiclechanges.FieldName := 'monitorvehiclechanges';
    wdsCompInfomonitordieselupfrontcl.SetParentComponent(wdsCompInfo);
    wdsCompInfomonitordieselupfrontcl.Name := 'wdsCompInfomonitordieselupfrontcl';
    wdsCompInfomonitordieselupfrontcl.FieldName := 'monitordieselupfrontcl';
    wdsCompInfomonitorloadssub.SetParentComponent(wdsCompInfo);
    wdsCompInfomonitorloadssub.Name := 'wdsCompInfomonitorloadssub';
    wdsCompInfomonitorloadssub.FieldName := 'monitorloadssub';
    wdsCompInfomonitorcancelloads.SetParentComponent(wdsCompInfo);
    wdsCompInfomonitorcancelloads.Name := 'wdsCompInfomonitorcancelloads';
    wdsCompInfomonitorcancelloads.FieldName := 'monitorcancelloads';
    wdsCompInfocheckdieselordersdays.SetParentComponent(wdsCompInfo);
    wdsCompInfocheckdieselordersdays.Name := 'wdsCompInfocheckdieselordersdays';
    wdsCompInfocheckdieselordersdays.FieldName := 'checkdieselordersdays';
    wdsCompInfoJobCompType.SetParentComponent(wdsCompInfo);
    wdsCompInfoJobCompType.Name := 'wdsCompInfoJobCompType';
    wdsCompInfoJobCompType.FieldName := 'JobCompType';
    wdsCompInfofinesbrnno.SetParentComponent(wdsCompInfo);
    wdsCompInfofinesbrnno.Name := 'wdsCompInfofinesbrnno';
    wdsCompInfofinesbrnno.FieldName := 'finesbrnno';
    wdsCompInfofinesidno.SetParentComponent(wdsCompInfo);
    wdsCompInfofinesidno.Name := 'wdsCompInfofinesidno';
    wdsCompInfofinesidno.FieldName := 'finesidno';
    wdsCompInfosmsdiesel.SetParentComponent(wdsCompInfo);
    wdsCompInfosmsdiesel.Name := 'wdsCompInfosmsdiesel';
    wdsCompInfosmsdiesel.FieldName := 'smsdiesel';
    wdsCompInfosmsdieselurl.SetParentComponent(wdsCompInfo);
    wdsCompInfosmsdieselurl.Name := 'wdsCompInfosmsdieselurl';
    wdsCompInfosmsdieselurl.FieldName := 'smsdieselurl';
    wdsCompInfosmsdieseluser.SetParentComponent(wdsCompInfo);
    wdsCompInfosmsdieseluser.Name := 'wdsCompInfosmsdieseluser';
    wdsCompInfosmsdieseluser.FieldName := 'smsdieseluser';
    wdsCompInfosmsdieselpassword.SetParentComponent(wdsCompInfo);
    wdsCompInfosmsdieselpassword.Name := 'wdsCompInfosmsdieselpassword';
    wdsCompInfosmsdieselpassword.FieldName := 'smsdieselpassword';
    wdsCompInfoINSTRUCTORDER.SetParentComponent(wdsCompInfo);
    wdsCompInfoINSTRUCTORDER.Name := 'wdsCompInfoINSTRUCTORDER';
    wdsCompInfoINSTRUCTORDER.FieldName := 'INSTRUCTORDER';
    wdsCompInfowashbayinvloads.SetParentComponent(wdsCompInfo);
    wdsCompInfowashbayinvloads.Name := 'wdsCompInfowashbayinvloads';
    wdsCompInfowashbayinvloads.FieldName := 'washbayinvloads';
    wdsCompInfosubsoverrite.SetParentComponent(wdsCompInfo);
    wdsCompInfosubsoverrite.Name := 'wdsCompInfosubsoverrite';
    wdsCompInfosubsoverrite.FieldName := 'subsoverrite';
    wdsCompInfocommissiontype.SetParentComponent(wdsCompInfo);
    wdsCompInfocommissiontype.Name := 'wdsCompInfocommissiontype';
    wdsCompInfocommissiontype.FieldName := 'commissiontype';
    wdsCompInfoallowdieselproforma.SetParentComponent(wdsCompInfo);
    wdsCompInfoallowdieselproforma.Name := 'wdsCompInfoallowdieselproforma';
    wdsCompInfoallowdieselproforma.FieldName := 'allowdieselproforma';
    wdsCompInfoforcescandocs.SetParentComponent(wdsCompInfo);
    wdsCompInfoforcescandocs.Name := 'wdsCompInfoforcescandocs';
    wdsCompInfoforcescandocs.FieldName := 'forcescandocs';
    wdsCompInfoBANKDETAIL5.SetParentComponent(wdsCompInfo);
    wdsCompInfoBANKDETAIL5.Name := 'wdsCompInfoBANKDETAIL5';
    wdsCompInfoBANKDETAIL5.FieldName := 'BANKDETAIL5';
    wdsCompInfoBANKDETAILS6.SetParentComponent(wdsCompInfo);
    wdsCompInfoBANKDETAILS6.Name := 'wdsCompInfoBANKDETAILS6';
    wdsCompInfoBANKDETAILS6.FieldName := 'BANKDETAILS6';
    wdsCompInfoBANKDETAILS7.SetParentComponent(wdsCompInfo);
    wdsCompInfoBANKDETAILS7.Name := 'wdsCompInfoBANKDETAILS7';
    wdsCompInfoBANKDETAILS7.FieldName := 'BANKDETAILS7';
    wdsCompInfoBANKDETAILS8.SetParentComponent(wdsCompInfo);
    wdsCompInfoBANKDETAILS8.Name := 'wdsCompInfoBANKDETAILS8';
    wdsCompInfoBANKDETAILS8.FieldName := 'BANKDETAILS8';
    wdsCompInfologo.SetParentComponent(wdsCompInfo);
    wdsCompInfologo.Name := 'wdsCompInfologo';
    wdsCompInfologo.FieldName := 'logo';
    wdsCompInfoautocanceldieselorders.SetParentComponent(wdsCompInfo);
    wdsCompInfoautocanceldieselorders.Name := 'wdsCompInfoautocanceldieselorders';
    wdsCompInfoautocanceldieselorders.FieldName := 'autocanceldieselorders';
    wdsCompInfoautocanceldieselordersdays.SetParentComponent(wdsCompInfo);
    wdsCompInfoautocanceldieselordersdays.Name := 'wdsCompInfoautocanceldieselordersdays';
    wdsCompInfoautocanceldieselordersdays.FieldName := 'autocanceldieselordersdays';
    wdsCompInfosendloadconsprocess.SetParentComponent(wdsCompInfo);
    wdsCompInfosendloadconsprocess.Name := 'wdsCompInfosendloadconsprocess';
    wdsCompInfosendloadconsprocess.FieldName := 'sendloadconsprocess';
    wdsCompInfoloadcoscutoffdate.SetParentComponent(wdsCompInfo);
    wdsCompInfoloadcoscutoffdate.Name := 'wdsCompInfoloadcoscutoffdate';
    wdsCompInfoloadcoscutoffdate.FieldName := 'loadcoscutoffdate';
    wdsCompInfodieselcutoffdate.SetParentComponent(wdsCompInfo);
    wdsCompInfodieselcutoffdate.Name := 'wdsCompInfodieselcutoffdate';
    wdsCompInfodieselcutoffdate.FieldName := 'dieselcutoffdate';
    wdsCompInfohidecanceloadsplanning.SetParentComponent(wdsCompInfo);
    wdsCompInfohidecanceloadsplanning.Name := 'wdsCompInfohidecanceloadsplanning';
    wdsCompInfohidecanceloadsplanning.FieldName := 'hidecanceloadsplanning';
    wdsCompInfoincrementdocketno.SetParentComponent(wdsCompInfo);
    wdsCompInfoincrementdocketno.Name := 'wdsCompInfoincrementdocketno';
    wdsCompInfoincrementdocketno.FieldName := 'incrementdocketno';
    wdsCompInfolinklastdriver.SetParentComponent(wdsCompInfo);
    wdsCompInfolinklastdriver.Name := 'wdsCompInfolinklastdriver';
    wdsCompInfolinklastdriver.FieldName := 'linklastdriver';
    wdsCompInfoplanningshortdesc.SetParentComponent(wdsCompInfo);
    wdsCompInfoplanningshortdesc.Name := 'wdsCompInfoplanningshortdesc';
    wdsCompInfoplanningshortdesc.FieldName := 'planningshortdesc';
    wdsCompInfoallowreprint.SetParentComponent(wdsCompInfo);
    wdsCompInfoallowreprint.Name := 'wdsCompInfoallowreprint';
    wdsCompInfoallowreprint.FieldName := 'allowreprint';
    wdsCompInforemovesubinvdocs.SetParentComponent(wdsCompInfo);
    wdsCompInforemovesubinvdocs.Name := 'wdsCompInforemovesubinvdocs';
    wdsCompInforemovesubinvdocs.FieldName := 'removesubinvdocs';
    wdsCompInfoloadsmustreceived.SetParentComponent(wdsCompInfo);
    wdsCompInfoloadsmustreceived.Name := 'wdsCompInfoloadsmustreceived';
    wdsCompInfoloadsmustreceived.FieldName := 'loadsmustreceived';
    wdsCompInfofnbcontractid.SetParentComponent(wdsCompInfo);
    wdsCompInfofnbcontractid.Name := 'wdsCompInfofnbcontractid';
    wdsCompInfofnbcontractid.FieldName := 'fnbcontractid';
    wdsCompInfofnbclientid.SetParentComponent(wdsCompInfo);
    wdsCompInfofnbclientid.Name := 'wdsCompInfofnbclientid';
    wdsCompInfofnbclientid.FieldName := 'fnbclientid';
    wdsCompInfofnbdeblistcount.SetParentComponent(wdsCompInfo);
    wdsCompInfofnbdeblistcount.Name := 'wdsCompInfofnbdeblistcount';
    wdsCompInfofnbdeblistcount.FieldName := 'fnbdeblistcount';
    wdsCompInfofnbcredlistcount.SetParentComponent(wdsCompInfo);
    wdsCompInfofnbcredlistcount.Name := 'wdsCompInfofnbcredlistcount';
    wdsCompInfofnbcredlistcount.FieldName := 'fnbcredlistcount';
    wdsCompInfofnblastdebdate.SetParentComponent(wdsCompInfo);
    wdsCompInfofnblastdebdate.Name := 'wdsCompInfofnblastdebdate';
    wdsCompInfofnblastdebdate.FieldName := 'fnblastdebdate';
    wdsCompInfofnblastcreddate.SetParentComponent(wdsCompInfo);
    wdsCompInfofnblastcreddate.Name := 'wdsCompInfofnblastcreddate';
    wdsCompInfofnblastcreddate.FieldName := 'fnblastcreddate';
    wdsCompInfofnblastdebamount.SetParentComponent(wdsCompInfo);
    wdsCompInfofnblastdebamount.Name := 'wdsCompInfofnblastdebamount';
    wdsCompInfofnblastdebamount.FieldName := 'fnblastdebamount';
    wdsCompInfofnblastcredamount.SetParentComponent(wdsCompInfo);
    wdsCompInfofnblastcredamount.Name := 'wdsCompInfofnblastcredamount';
    wdsCompInfofnblastcredamount.FieldName := 'fnblastcredamount';
    wdsCompInfofnbclienttype.SetParentComponent(wdsCompInfo);
    wdsCompInfofnbclienttype.Name := 'wdsCompInfofnbclienttype';
    wdsCompInfofnbclienttype.FieldName := 'fnbclienttype';
    wdsCompInfolinkloadsvat.SetParentComponent(wdsCompInfo);
    wdsCompInfolinkloadsvat.Name := 'wdsCompInfolinkloadsvat';
    wdsCompInfolinkloadsvat.FieldName := 'linkloadsvat';
    wdsCompInfomarkmultiloadready.SetParentComponent(wdsCompInfo);
    wdsCompInfomarkmultiloadready.Name := 'wdsCompInfomarkmultiloadready';
    wdsCompInfomarkmultiloadready.FieldName := 'markmultiloadready';
    wdsCompInfobulkdieselinvoices.SetParentComponent(wdsCompInfo);
    wdsCompInfobulkdieselinvoices.Name := 'wdsCompInfobulkdieselinvoices';
    wdsCompInfobulkdieselinvoices.FieldName := 'bulkdieselinvoices';
    wdsCompInfoclearbulkinvoices.SetParentComponent(wdsCompInfo);
    wdsCompInfoclearbulkinvoices.Name := 'wdsCompInfoclearbulkinvoices';
    wdsCompInfoclearbulkinvoices.FieldName := 'clearbulkinvoices';
    wdsCompInfogetsageonlinebalance.SetParentComponent(wdsCompInfo);
    wdsCompInfogetsageonlinebalance.Name := 'wdsCompInfogetsageonlinebalance';
    wdsCompInfogetsageonlinebalance.FieldName := 'getsageonlinebalance';
    wdsCompInfousesageonlinebalancefordiesel.SetParentComponent(wdsCompInfo);
    wdsCompInfousesageonlinebalancefordiesel.Name := 'wdsCompInfousesageonlinebalancefordiesel';
    wdsCompInfousesageonlinebalancefordiesel.FieldName := 'usesageonlinebalancefordiesel';
    wdsCompInfoapiserverurl.SetParentComponent(wdsCompInfo);
    wdsCompInfoapiserverurl.Name := 'wdsCompInfoapiserverurl';
    wdsCompInfoapiserverurl.FieldName := 'apiserverurl';
    wdsCompInfoapiusername.SetParentComponent(wdsCompInfo);
    wdsCompInfoapiusername.Name := 'wdsCompInfoapiusername';
    wdsCompInfoapiusername.FieldName := 'apiusername';
    wdsCompInfoapipassword.SetParentComponent(wdsCompInfo);
    wdsCompInfoapipassword.Name := 'wdsCompInfoapipassword';
    wdsCompInfoapipassword.FieldName := 'apipassword';
    wdsCompInfoapikey.SetParentComponent(wdsCompInfo);
    wdsCompInfoapikey.Name := 'wdsCompInfoapikey';
    wdsCompInfoapikey.FieldName := 'apikey';
    wdsCompInfofuelconsumptionfullfills.SetParentComponent(wdsCompInfo);
    wdsCompInfofuelconsumptionfullfills.Name := 'wdsCompInfofuelconsumptionfullfills';
    wdsCompInfofuelconsumptionfullfills.FieldName := 'fuelconsumptionfullfills';
    wdsCompInfousenewscan.SetParentComponent(wdsCompInfo);
    wdsCompInfousenewscan.Name := 'wdsCompInfousenewscan';
    wdsCompInfousenewscan.FieldName := 'usenewscan';
    wdsCompInfobasescanfolder.SetParentComponent(wdsCompInfo);
    wdsCompInfobasescanfolder.Name := 'wdsCompInfobasescanfolder';
    wdsCompInfobasescanfolder.FieldName := 'basescanfolder';
    wdsCompInfoftpserver.SetParentComponent(wdsCompInfo);
    wdsCompInfoftpserver.Name := 'wdsCompInfoftpserver';
    wdsCompInfoftpserver.FieldName := 'ftpserver';
    wdsCompInfoftpport.SetParentComponent(wdsCompInfo);
    wdsCompInfoftpport.Name := 'wdsCompInfoftpport';
    wdsCompInfoftpport.FieldName := 'ftpport';
    wdsCompInfoftpuser.SetParentComponent(wdsCompInfo);
    wdsCompInfoftpuser.Name := 'wdsCompInfoftpuser';
    wdsCompInfoftpuser.FieldName := 'ftpuser';
    wdsCompInfoftppassword.SetParentComponent(wdsCompInfo);
    wdsCompInfoftppassword.Name := 'wdsCompInfoftppassword';
    wdsCompInfoftppassword.FieldName := 'ftppassword';
    wdsCompInfomulticontroller.SetParentComponent(wdsCompInfo);
    wdsCompInfomulticontroller.Name := 'wdsCompInfomulticontroller';
    wdsCompInfomulticontroller.FieldName := 'multicontroller';
    wdsCompInfolastshiftno.SetParentComponent(wdsCompInfo);
    wdsCompInfolastshiftno.Name := 'wdsCompInfolastshiftno';
    wdsCompInfolastshiftno.FieldName := 'lastshiftno';
    wdsCompInfodieselnonretail.SetParentComponent(wdsCompInfo);
    wdsCompInfodieselnonretail.Name := 'wdsCompInfodieselnonretail';
    wdsCompInfodieselnonretail.FieldName := 'dieselnonretail';
    wdsCompInfoemailaddress.SetParentComponent(wdsCompInfo);
    wdsCompInfoemailaddress.Name := 'wdsCompInfoemailaddress';
    wdsCompInfoemailaddress.FieldName := 'emailaddress';
    wdsCompInfojobnullqty.SetParentComponent(wdsCompInfo);
    wdsCompInfojobnullqty.Name := 'wdsCompInfojobnullqty';
    wdsCompInfojobnullqty.FieldName := 'jobnullqty';
    wdsCompInfojoborder.SetParentComponent(wdsCompInfo);
    wdsCompInfojoborder.Name := 'wdsCompInfojoborder';
    wdsCompInfojoborder.FieldName := 'joborder';
    wdsCompInfojobcardtype.SetParentComponent(wdsCompInfo);
    wdsCompInfojobcardtype.Name := 'wdsCompInfojobcardtype';
    wdsCompInfojobcardtype.FieldName := 'jobcardtype';
    wdsCompInfomaintforcegl.SetParentComponent(wdsCompInfo);
    wdsCompInfomaintforcegl.Name := 'wdsCompInfomaintforcegl';
    wdsCompInfomaintforcegl.FieldName := 'maintforcegl';
    wdsCompInfocompemail.SetParentComponent(wdsCompInfo);
    wdsCompInfocompemail.Name := 'wdsCompInfocompemail';
    wdsCompInfocompemail.FieldName := 'compemail';
    wdsCompInfoerrormails.SetParentComponent(wdsCompInfo);
    wdsCompInfoerrormails.Name := 'wdsCompInfoerrormails';
    wdsCompInfoerrormails.FieldName := 'errormails';
    wdsCompInfoADDRESS1.SetParentComponent(wdsCompInfo);
    wdsCompInfoADDRESS1.Name := 'wdsCompInfoADDRESS1';
    wdsCompInfoADDRESS1.FieldName := 'ADDRESS1';
    wdsCompInfoADDRESS2.SetParentComponent(wdsCompInfo);
    wdsCompInfoADDRESS2.Name := 'wdsCompInfoADDRESS2';
    wdsCompInfoADDRESS2.FieldName := 'ADDRESS2';
    wdsCompInfoADDRESS3.SetParentComponent(wdsCompInfo);
    wdsCompInfoADDRESS3.Name := 'wdsCompInfoADDRESS3';
    wdsCompInfoADDRESS3.FieldName := 'ADDRESS3';
    wdsCompInfoADDRESS4.SetParentComponent(wdsCompInfo);
    wdsCompInfoADDRESS4.Name := 'wdsCompInfoADDRESS4';
    wdsCompInfoADDRESS4.FieldName := 'ADDRESS4';
    wdsCompInfoADDRESSCODE.SetParentComponent(wdsCompInfo);
    wdsCompInfoADDRESSCODE.Name := 'wdsCompInfoADDRESSCODE';
    wdsCompInfoADDRESSCODE.FieldName := 'ADDRESSCODE';
    wdsCompInfoCOMPANYNAME.SetParentComponent(wdsCompInfo);
    wdsCompInfoCOMPANYNAME.Name := 'wdsCompInfoCOMPANYNAME';
    wdsCompInfoCOMPANYNAME.FieldName := 'COMPANYNAME';
    wdsCompInfoCOMPANYFAX.SetParentComponent(wdsCompInfo);
    wdsCompInfoCOMPANYFAX.Name := 'wdsCompInfoCOMPANYFAX';
    wdsCompInfoCOMPANYFAX.FieldName := 'COMPANYFAX';
    wdsCompInfoCOMPANYTEL.SetParentComponent(wdsCompInfo);
    wdsCompInfoCOMPANYTEL.Name := 'wdsCompInfoCOMPANYTEL';
    wdsCompInfoCOMPANYTEL.FieldName := 'COMPANYTEL';
    wdsCompInfoCOMPANYREG.SetParentComponent(wdsCompInfo);
    wdsCompInfoCOMPANYREG.Name := 'wdsCompInfoCOMPANYREG';
    wdsCompInfoCOMPANYREG.FieldName := 'COMPANYREG';
    wdsCompInfoCOMPANYVAT.SetParentComponent(wdsCompInfo);
    wdsCompInfoCOMPANYVAT.Name := 'wdsCompInfoCOMPANYVAT';
    wdsCompInfoCOMPANYVAT.FieldName := 'COMPANYVAT';
    wdsCompInfoLOGOPATH.SetParentComponent(wdsCompInfo);
    wdsCompInfoLOGOPATH.Name := 'wdsCompInfoLOGOPATH';
    wdsCompInfoLOGOPATH.FieldName := 'LOGOPATH';
    wdsCompInfoUSEDIFFCOMP.SetParentComponent(wdsCompInfo);
    wdsCompInfoUSEDIFFCOMP.Name := 'wdsCompInfoUSEDIFFCOMP';
    wdsCompInfoUSEDIFFCOMP.FieldName := 'USEDIFFCOMP';
    wdsCompInfoBANKDETAILS1.SetParentComponent(wdsCompInfo);
    wdsCompInfoBANKDETAILS1.Name := 'wdsCompInfoBANKDETAILS1';
    wdsCompInfoBANKDETAILS1.FieldName := 'BANKDETAILS1';
    wdsCompInfoBANKDETAILS2.SetParentComponent(wdsCompInfo);
    wdsCompInfoBANKDETAILS2.Name := 'wdsCompInfoBANKDETAILS2';
    wdsCompInfoBANKDETAILS2.FieldName := 'BANKDETAILS2';
    wdsCompInfoBANKDETAILS3.SetParentComponent(wdsCompInfo);
    wdsCompInfoBANKDETAILS3.Name := 'wdsCompInfoBANKDETAILS3';
    wdsCompInfoBANKDETAILS3.FieldName := 'BANKDETAILS3';
    wdsCompInfoBANKDETAILS4.SetParentComponent(wdsCompInfo);
    wdsCompInfoBANKDETAILS4.Name := 'wdsCompInfoBANKDETAILS4';
    wdsCompInfoBANKDETAILS4.FieldName := 'BANKDETAILS4';
    wdsCompInfoLOADCONTYPE.SetParentComponent(wdsCompInfo);
    wdsCompInfoLOADCONTYPE.Name := 'wdsCompInfoLOADCONTYPE';
    wdsCompInfoLOADCONTYPE.FieldName := 'LOADCONTYPE';
    wdsCompInfoLOADCONPREFIX.SetParentComponent(wdsCompInfo);
    wdsCompInfoLOADCONPREFIX.Name := 'wdsCompInfoLOADCONPREFIX';
    wdsCompInfoLOADCONPREFIX.FieldName := 'LOADCONPREFIX';
    wdsCompInfoCompanyCode.SetParentComponent(wdsCompInfo);
    wdsCompInfoCompanyCode.Name := 'wdsCompInfoCompanyCode';
    wdsCompInfoCompanyCode.FieldName := 'CompanyCode';
    wdsCompInfoSSUNIQUECLIENTDOCKET.SetParentComponent(wdsCompInfo);
    wdsCompInfoSSUNIQUECLIENTDOCKET.Name := 'wdsCompInfoSSUNIQUECLIENTDOCKET';
    wdsCompInfoSSUNIQUECLIENTDOCKET.FieldName := 'SSUNIQUECLIENTDOCKET';
    dsCompInfo.SetParentComponent(Self);
    dsCompInfo.Name := 'dsCompInfo';
    dsCompInfo.DataSet := wdsCompInfo;
    dsCompInfo.Left := 152;
    dsCompInfo.Top := 120;
    wcNumbers.SetParentComponent(Self);
    wcNumbers.Name := 'wcNumbers';
    wcNumbers.Connection := dmData.dbConnect;
    wcNumbers.Left := 40;
    wcNumbers.Top := 174;
    wdsNumbers.SetParentComponent(Self);
    wdsNumbers.Name := 'wdsNumbers';
    wdsNumbers.Connection := dmData.dbConnect;
    wdsNumbers.Left := 96;
    wdsNumbers.Top := 174;
    wdsNumbersTranType.SetParentComponent(wdsNumbers);
    wdsNumbersTranType.Name := 'wdsNumbersTranType';
    wdsNumbersTranType.FieldName := 'TranType';
    wdsNumbersPrefix.SetParentComponent(wdsNumbers);
    wdsNumbersPrefix.Name := 'wdsNumbersPrefix';
    wdsNumbersPrefix.FieldName := 'Prefix';
    wdsNumbersDescription.SetParentComponent(wdsNumbers);
    wdsNumbersDescription.Name := 'wdsNumbersDescription';
    wdsNumbersDescription.FieldName := 'Description';
    wdsNumbersSuffix.SetParentComponent(wdsNumbers);
    wdsNumbersSuffix.Name := 'wdsNumbersSuffix';
    wdsNumbersSuffix.FieldName := 'Suffix';
    dsNumbers.SetParentComponent(Self);
    dsNumbers.Name := 'dsNumbers';
    dsNumbers.AutoEdit := False;
    dsNumbers.DataSet := wdsNumbers;
    dsNumbers.Left := 152;
    dsNumbers.Top := 174;
    wdsFinSystem.SetParentComponent(Self);
    wdsFinSystem.Name := 'wdsFinSystem';
    wdsFinSystem.Connection := dmData.dbConnect;
    wdsFinSystem.Left := 96;
    wdsFinSystem.Top := 245;
    dsFinSystem.SetParentComponent(Self);
    dsFinSystem.Name := 'dsFinSystem';
    dsFinSystem.Left := 160;
    dsFinSystem.Top := 245;
    wcFinSystem.SetParentComponent(Self);
    wcFinSystem.Name := 'wcFinSystem';
    wcFinSystem.Connection := dmData.dbConnect;
    wcFinSystem.Left := 40;
    wcFinSystem.Top := 245;
    dsVattable.SetParentComponent(Self);
    dsVattable.Name := 'dsVattable';
    dsVattable.DataSet := wdsVattable;
    dsVattable.Left := 160;
    dsVattable.Top := 312;
    wdsVattable.SetParentComponent(Self);
    wdsVattable.Name := 'wdsVattable';
    wdsVattable.Connection := dmData.dbConnect;
    wdsVattable.Left := 96;
    wdsVattable.Top := 312;
    wdsVattableVATPERC.SetParentComponent(wdsVattable);
    wdsVattableVATPERC.Name := 'wdsVattableVATPERC';
    wdsVattableVATPERC.FieldName := 'VATPERC';
    wdsVattableSTARTDATE.SetParentComponent(wdsVattable);
    wdsVattableSTARTDATE.Name := 'wdsVattableSTARTDATE';
    wdsVattableSTARTDATE.FieldName := 'STARTDATE';
    wdsVattableENDATE.SetParentComponent(wdsVattable);
    wdsVattableENDATE.Name := 'wdsVattableENDATE';
    wdsVattableENDATE.FieldName := 'ENDATE';
    wdsVattableAuto.SetParentComponent(wdsVattable);
    wdsVattableAuto.Name := 'wdsVattableAuto';
    wdsVattableAuto.FieldName := 'Auto';
    wcVattable.SetParentComponent(Self);
    wcVattable.Name := 'wcVattable';
    wcVattable.Connection := dmData.dbConnect;
    wcVattable.Left := 40;
    wcVattable.Top := 312;
    wdsGLA.SetParentComponent(Self);
    wdsGLA.Name := 'wdsGLA';
    wdsGLA.Connection := dmData.dbConnect;
    wdsGLA.Left := 96;
    wdsGLA.Top := 376;
    wdsGLAGLCODE.SetParentComponent(wdsGLA);
    wdsGLAGLCODE.Name := 'wdsGLAGLCODE';
    wdsGLAGLCODE.FieldName := 'GLCODE';
    wdsGLAGLDESCRIPTION.SetParentComponent(wdsGLA);
    wdsGLAGLDESCRIPTION.Name := 'wdsGLAGLDESCRIPTION';
    wdsGLAGLDESCRIPTION.FieldName := 'GLDESCRIPTION';
    wdsGLASUSPENDED.SetParentComponent(wdsGLA);
    wdsGLASUSPENDED.Name := 'wdsGLASUSPENDED';
    wdsGLASUSPENDED.FieldName := 'SUSPENDED';
    wdsGLAbankaccount.SetParentComponent(wdsGLA);
    wdsGLAbankaccount.Name := 'wdsGLAbankaccount';
    wdsGLAbankaccount.FieldName := 'bankaccount';
    wdsGLAbankcard.SetParentComponent(wdsGLA);
    wdsGLAbankcard.Name := 'wdsGLAbankcard';
    wdsGLAbankcard.FieldName := 'bankcard';
    dsGLA.SetParentComponent(Self);
    dsGLA.Name := 'dsGLA';
    dsGLA.AutoEdit := False;
    dsGLA.DataSet := wdsGLA;
    dsGLA.Left := 160;
    dsGLA.Top := 376;
    wcGLA.SetParentComponent(Self);
    wcGLA.Name := 'wcGLA';
    wcGLA.Connection := dmData.dbConnect;
    wcGLA.Left := 40;
    wcGLA.Top := 376;
    wdsSystemLedgerAccounts.SetParentComponent(Self);
    wdsSystemLedgerAccounts.Name := 'wdsSystemLedgerAccounts';
    wdsSystemLedgerAccounts.Connection := dmData.dbConnect;
    wdsSystemLedgerAccounts.Left := 96;
    wdsSystemLedgerAccounts.Top := 433;
    wdsSystemLedgerAccountsGLDESCRIPTION.SetParentComponent(wdsSystemLedgerAccounts);
    wdsSystemLedgerAccountsGLDESCRIPTION.Name := 'wdsSystemLedgerAccountsGLDESCRIPTION';
    wdsSystemLedgerAccountsGLDESCRIPTION.FieldName := 'GLDESCRIPTION';
    wdsSystemLedgerAccountsFleetDesc.SetParentComponent(wdsSystemLedgerAccounts);
    wdsSystemLedgerAccountsFleetDesc.Name := 'wdsSystemLedgerAccountsFleetDesc';
    wdsSystemLedgerAccountsFleetDesc.FieldName := 'FleetDesc';
    wdsSystemLedgerAccountsValueTypesDesc.SetParentComponent(wdsSystemLedgerAccounts);
    wdsSystemLedgerAccountsValueTypesDesc.Name := 'wdsSystemLedgerAccountsValueTypesDesc';
    wdsSystemLedgerAccountsValueTypesDesc.FieldName := 'ValueTypesDesc';
    wdsSystemLedgerAccountsSystemDesc.SetParentComponent(wdsSystemLedgerAccounts);
    wdsSystemLedgerAccountsSystemDesc.Name := 'wdsSystemLedgerAccountsSystemDesc';
    wdsSystemLedgerAccountsSystemDesc.FieldName := 'SystemDesc';
    wdsSystemLedgerAccountsGLCode.SetParentComponent(wdsSystemLedgerAccounts);
    wdsSystemLedgerAccountsGLCode.Name := 'wdsSystemLedgerAccountsGLCode';
    wdsSystemLedgerAccountsGLCode.FieldName := 'GLCode';
    wdsSystemLedgerAccountscompanygldetail_Auto.SetParentComponent(wdsSystemLedgerAccounts);
    wdsSystemLedgerAccountscompanygldetail_Auto.Name := 'wdsSystemLedgerAccountscompanygldetail_Auto';
    wdsSystemLedgerAccountscompanygldetail_Auto.FieldName := 'companygldetail_Auto';
    wcSystemLedgerAccounts.SetParentComponent(Self);
    wcSystemLedgerAccounts.Name := 'wcSystemLedgerAccounts';
    wcSystemLedgerAccounts.Connection := dmData.dbConnect;
    wcSystemLedgerAccounts.Left := 40;
    wcSystemLedgerAccounts.Top := 433;
    dsSystemLedgerAccounts.SetParentComponent(Self);
    dsSystemLedgerAccounts.Name := 'dsSystemLedgerAccounts';
    dsSystemLedgerAccounts.AutoEdit := False;
    dsSystemLedgerAccounts.DataSet := wdsSystemLedgerAccounts;
    dsSystemLedgerAccounts.Left := 160;
    dsSystemLedgerAccounts.Top := 433;
    wdsTFNSubAccountsS1.SetParentComponent(Self);
    wdsTFNSubAccountsS1.Name := 'wdsTFNSubAccountsS1';
    wdsTFNSubAccountsS1.Connection := dmData.dbConnect;
    wdsTFNSubAccountsS1.Left := 471;
    wdsTFNSubAccountsS1.Top := 442;
    wdsTFNSubAccountsS1ApiServerNo.SetParentComponent(wdsTFNSubAccountsS1);
    wdsTFNSubAccountsS1ApiServerNo.Name := 'wdsTFNSubAccountsS1ApiServerNo';
    wdsTFNSubAccountsS1ApiServerNo.FieldName := 'ApiServerNo';
    wdsTFNSubAccountsS1SubContractNo.SetParentComponent(wdsTFNSubAccountsS1);
    wdsTFNSubAccountsS1SubContractNo.Name := 'wdsTFNSubAccountsS1SubContractNo';
    wdsTFNSubAccountsS1SubContractNo.FieldName := 'SubContractNo';
    wdsTFNSubAccountsS1ApiAccountNo.SetParentComponent(wdsTFNSubAccountsS1);
    wdsTFNSubAccountsS1ApiAccountNo.Name := 'wdsTFNSubAccountsS1ApiAccountNo';
    wdsTFNSubAccountsS1ApiAccountNo.FieldName := 'ApiAccountNo';
    wdsTFNSubAccountsS1LastRunDate.SetParentComponent(wdsTFNSubAccountsS1);
    wdsTFNSubAccountsS1LastRunDate.Name := 'wdsTFNSubAccountsS1LastRunDate';
    wdsTFNSubAccountsS1LastRunDate.FieldName := 'LastRunDate';
    wdsTFNSubAccountsS1SubsRegNo.SetParentComponent(wdsTFNSubAccountsS1);
    wdsTFNSubAccountsS1SubsRegNo.Name := 'wdsTFNSubAccountsS1SubsRegNo';
    wdsTFNSubAccountsS1SubsRegNo.FieldName := 'SubsRegNo';
    wdsTFNSubAccountsS1CRName.SetParentComponent(wdsTFNSubAccountsS1);
    wdsTFNSubAccountsS1CRName.Name := 'wdsTFNSubAccountsS1CRName';
    wdsTFNSubAccountsS1CRName.FieldName := 'CRName';
    dsTFNSubAccountsS1.SetParentComponent(Self);
    dsTFNSubAccountsS1.Name := 'dsTFNSubAccountsS1';
    dsTFNSubAccountsS1.AutoEdit := False;
    dsTFNSubAccountsS1.DataSet := wdsTFNSubAccountsS1;
    dsTFNSubAccountsS1.Left := 535;
    dsTFNSubAccountsS1.Top := 442;
    wcTFNSubAccountsS1.SetParentComponent(Self);
    wcTFNSubAccountsS1.Name := 'wcTFNSubAccountsS1';
    wcTFNSubAccountsS1.Connection := dmData.dbConnect;
    wcTFNSubAccountsS1.Left := 407;
    wcTFNSubAccountsS1.Top := 442;
    wcTFNSubAccountsS2.SetParentComponent(Self);
    wcTFNSubAccountsS2.Name := 'wcTFNSubAccountsS2';
    wcTFNSubAccountsS2.Connection := dmData.dbConnect;
    wcTFNSubAccountsS2.Left := 407;
    wcTFNSubAccountsS2.Top := 513;
    wdsTFNSubAccountsS2.SetParentComponent(Self);
    wdsTFNSubAccountsS2.Name := 'wdsTFNSubAccountsS2';
    wdsTFNSubAccountsS2.Connection := dmData.dbConnect;
    wdsTFNSubAccountsS2.Left := 471;
    wdsTFNSubAccountsS2.Top := 513;
    wdsTFNSubAccountsS2ApiServerNo.SetParentComponent(wdsTFNSubAccountsS2);
    wdsTFNSubAccountsS2ApiServerNo.Name := 'wdsTFNSubAccountsS2ApiServerNo';
    wdsTFNSubAccountsS2ApiServerNo.FieldName := 'ApiServerNo';
    wdsTFNSubAccountsS2SubContractNo.SetParentComponent(wdsTFNSubAccountsS2);
    wdsTFNSubAccountsS2SubContractNo.Name := 'wdsTFNSubAccountsS2SubContractNo';
    wdsTFNSubAccountsS2SubContractNo.FieldName := 'SubContractNo';
    wdsTFNSubAccountsS2ApiAccountNo.SetParentComponent(wdsTFNSubAccountsS2);
    wdsTFNSubAccountsS2ApiAccountNo.Name := 'wdsTFNSubAccountsS2ApiAccountNo';
    wdsTFNSubAccountsS2ApiAccountNo.FieldName := 'ApiAccountNo';
    wdsTFNSubAccountsS2LastRunDate.SetParentComponent(wdsTFNSubAccountsS2);
    wdsTFNSubAccountsS2LastRunDate.Name := 'wdsTFNSubAccountsS2LastRunDate';
    wdsTFNSubAccountsS2LastRunDate.FieldName := 'LastRunDate';
    wdsTFNSubAccountsS2SubsRegNo.SetParentComponent(wdsTFNSubAccountsS2);
    wdsTFNSubAccountsS2SubsRegNo.Name := 'wdsTFNSubAccountsS2SubsRegNo';
    wdsTFNSubAccountsS2SubsRegNo.FieldName := 'SubsRegNo';
    wdsTFNSubAccountsS2CRName.SetParentComponent(wdsTFNSubAccountsS2);
    wdsTFNSubAccountsS2CRName.Name := 'wdsTFNSubAccountsS2CRName';
    wdsTFNSubAccountsS2CRName.FieldName := 'CRName';
    dsTFNSubAccountsS2.SetParentComponent(Self);
    dsTFNSubAccountsS2.Name := 'dsTFNSubAccountsS2';
    dsTFNSubAccountsS2.AutoEdit := False;
    dsTFNSubAccountsS2.DataSet := wdsTFNSubAccountsS2;
    dsTFNSubAccountsS2.Left := 535;
    dsTFNSubAccountsS2.Top := 513;
    wdsFinLinkSystem.SetParentComponent(Self);
    wdsFinLinkSystem.Name := 'wdsFinLinkSystem';
    wdsFinLinkSystem.Connection := dmData.dbConnect;
    wdsFinLinkSystem.Left := 472;
    wdsFinLinkSystem.Top := 597;
    wdsFinLinkSystemFinNo.SetParentComponent(wdsFinLinkSystem);
    wdsFinLinkSystemFinNo.Name := 'wdsFinLinkSystemFinNo';
    wdsFinLinkSystemFinNo.FieldName := 'FinNo';
    wdsFinLinkSystemFinName.SetParentComponent(wdsFinLinkSystem);
    wdsFinLinkSystemFinName.Name := 'wdsFinLinkSystemFinName';
    wdsFinLinkSystemFinName.FieldName := 'FinName';
    wdsFinLinkSystemFinActive.SetParentComponent(wdsFinLinkSystem);
    wdsFinLinkSystemFinActive.Name := 'wdsFinLinkSystemFinActive';
    wdsFinLinkSystemFinActive.FieldName := 'FinActive';
    dsFinLinkSystem.SetParentComponent(Self);
    dsFinLinkSystem.Name := 'dsFinLinkSystem';
    dsFinLinkSystem.DataSet := wdsFinLinkSystem;
    dsFinLinkSystem.Left := 536;
    dsFinLinkSystem.Top := 597;
    wcFinLinkSystem.SetParentComponent(Self);
    wcFinLinkSystem.Name := 'wcFinLinkSystem';
    wcFinLinkSystem.Connection := dmData.dbConnect;
    wcFinLinkSystem.Left := 408;
    wcFinLinkSystem.Top := 597;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebResponsiveManager1.AfterLoadDFMValues;
    BitmapContainer1.AfterLoadDFMValues;
    wpcSysSetup.AfterLoadDFMValues;
    WebPageControl1Sheet1.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    WebLabel17.AfterLoadDFMValues;
    WebLabel18.AfterLoadDFMValues;
    WebDBImageControl1.AfterLoadDFMValues;
    edtCompName.AfterLoadDFMValues;
    edtCompAddress1.AfterLoadDFMValues;
    edtCompAddress2.AfterLoadDFMValues;
    edtCompAddress3.AfterLoadDFMValues;
    edtCompAddress4.AfterLoadDFMValues;
    edtCompAddressCode.AfterLoadDFMValues;
    edtPostalCode.AfterLoadDFMValues;
    edtPostalAddress4.AfterLoadDFMValues;
    edtPostalAddress3.AfterLoadDFMValues;
    edtPostalAddress2.AfterLoadDFMValues;
    edtPostalAddress1.AfterLoadDFMValues;
    edtTelephone.AfterLoadDFMValues;
    edtTaxNo.AfterLoadDFMValues;
    edtLogoPath.AfterLoadDFMValues;
    edtRegistrationNo.AfterLoadDFMValues;
    edtVatNo.AfterLoadDFMValues;
    edtDeliveryNotePrefix.AfterLoadDFMValues;
    edtCompEmail.AfterLoadDFMValues;
    edtBankTransferBranchCode.AfterLoadDFMValues;
    WebPanel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    edtBankDetails1.AfterLoadDFMValues;
    edtBankDetails2.AfterLoadDFMValues;
    edtBankDetails3.AfterLoadDFMValues;
    edtBankDetails4.AfterLoadDFMValues;
    cbxPrintOnStatement.AfterLoadDFMValues;
    edtBankTransferAccountNo.AfterLoadDFMValues;
    WebDBComboBox5.AfterLoadDFMValues;
    WebDBComboBox6.AfterLoadDFMValues;
    WebDBComboBox7.AfterLoadDFMValues;
    WebDBComboBox8.AfterLoadDFMValues;
    WebPageControl1Sheet2.AfterLoadDFMValues;
    WebResponsiveManager3.AfterLoadDFMValues;
    WebPanel8.AfterLoadDFMValues;
    WebLabel23.AfterLoadDFMValues;
    WebLabel24.AfterLoadDFMValues;
    WebDBEdit1.AfterLoadDFMValues;
    WebDBEdit2.AfterLoadDFMValues;
    WebDBCheckBox5.AfterLoadDFMValues;
    WebDBCheckBox6.AfterLoadDFMValues;
    WebDBCheckBox7.AfterLoadDFMValues;
    WebDBCheckBox8.AfterLoadDFMValues;
    WebDBCheckBox9.AfterLoadDFMValues;
    WebDBCheckBox10.AfterLoadDFMValues;
    WebDBCheckBox11.AfterLoadDFMValues;
    WebDBCheckBox12.AfterLoadDFMValues;
    WebDBCheckBox13.AfterLoadDFMValues;
    WebDBCheckBox14.AfterLoadDFMValues;
    WebPanel9.AfterLoadDFMValues;
    WebLabel21.AfterLoadDFMValues;
    WebLabel22.AfterLoadDFMValues;
    WebDBEdit3.AfterLoadDFMValues;
    WebDBEdit4.AfterLoadDFMValues;
    WebDBCheckBox15.AfterLoadDFMValues;
    WebDBCheckBox16.AfterLoadDFMValues;
    WebDBCheckBox17.AfterLoadDFMValues;
    WebDBCheckBox18.AfterLoadDFMValues;
    WebDBCheckBox19.AfterLoadDFMValues;
    WebDBCheckBox20.AfterLoadDFMValues;
    WebDBCheckBox21.AfterLoadDFMValues;
    WebDBCheckBox22.AfterLoadDFMValues;
    WebDBCheckBox23.AfterLoadDFMValues;
    WebDBCheckBox24.AfterLoadDFMValues;
    WebPanel7.AfterLoadDFMValues;
    WebLabel20.AfterLoadDFMValues;
    WebDBEdit5.AfterLoadDFMValues;
    WebDBCheckBox25.AfterLoadDFMValues;
    WebDBCheckBox26.AfterLoadDFMValues;
    WebDBCheckBox27.AfterLoadDFMValues;
    WebDBCheckBox28.AfterLoadDFMValues;
    WebDBCheckBox29.AfterLoadDFMValues;
    WebDBCheckBox30.AfterLoadDFMValues;
    WebDBCheckBox31.AfterLoadDFMValues;
    WebDBCheckBox32.AfterLoadDFMValues;
    WebDBCheckBox33.AfterLoadDFMValues;
    WebDBCheckBox34.AfterLoadDFMValues;
    WebDBCheckBox35.AfterLoadDFMValues;
    WebDBCheckBox36.AfterLoadDFMValues;
    WebDBCheckBox37.AfterLoadDFMValues;
    WebDBCheckBox38.AfterLoadDFMValues;
    WebDBCheckBox39.AfterLoadDFMValues;
    WebPanel10.AfterLoadDFMValues;
    WebLabel31.AfterLoadDFMValues;
    WebLabel32.AfterLoadDFMValues;
    WebLabel33.AfterLoadDFMValues;
    WebLabel34.AfterLoadDFMValues;
    WebLabel25.AfterLoadDFMValues;
    WebDBEdit6.AfterLoadDFMValues;
    WebDBEdit7.AfterLoadDFMValues;
    WebDBEdit8.AfterLoadDFMValues;
    WebDBEdit9.AfterLoadDFMValues;
    WebDBEdit14.AfterLoadDFMValues;
    WebPanel11.AfterLoadDFMValues;
    WebLabel26.AfterLoadDFMValues;
    WebLabel27.AfterLoadDFMValues;
    WebLabel28.AfterLoadDFMValues;
    WebLabel29.AfterLoadDFMValues;
    WebLabel30.AfterLoadDFMValues;
    WebDBEdit10.AfterLoadDFMValues;
    WebDBEdit11.AfterLoadDFMValues;
    WebDBEdit12.AfterLoadDFMValues;
    WebDBEdit13.AfterLoadDFMValues;
    WebDBEdit15.AfterLoadDFMValues;
    WebPageControl1Sheet3.AfterLoadDFMValues;
    wpNavigator.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    WebPanel29.AfterLoadDFMValues;
    edtNumbersPageCount.AfterLoadDFMValues;
    sbtnNumbersNext.AfterLoadDFMValues;
    sbtnNumbersPrevious.AfterLoadDFMValues;
    sbtnNumbersLast.AfterLoadDFMValues;
    sbtnNumbersFirst.AfterLoadDFMValues;
    dgNumbers.AfterLoadDFMValues;
    dbagNumbers.AfterLoadDFMValues;
    msgdlgNumbersDelete.AfterLoadDFMValues;
    WebPageControlSheet4.AfterLoadDFMValues;
    WebPanel15.AfterLoadDFMValues;
    WebLabel53.AfterLoadDFMValues;
    WebDBEdit16.AfterLoadDFMValues;
    WebDBCheckBox40.AfterLoadDFMValues;
    dblFinName.AfterLoadDFMValues;
    WebPageControl1.AfterLoadDFMValues;
    WebTabSheet4.AfterLoadDFMValues;
    WebPanel17.AfterLoadDFMValues;
    WebLabel35.AfterLoadDFMValues;
    WebLabel39.AfterLoadDFMValues;
    WebLabel40.AfterLoadDFMValues;
    WebLabel41.AfterLoadDFMValues;
    WebLabel42.AfterLoadDFMValues;
    WebLabel43.AfterLoadDFMValues;
    WebLabel44.AfterLoadDFMValues;
    WebLabel45.AfterLoadDFMValues;
    eServerName.AfterLoadDFMValues;
    eDBPath.AfterLoadDFMValues;
    eUsername.AfterLoadDFMValues;
    ePassword.AfterLoadDFMValues;
    ePort.AfterLoadDFMValues;
    eProtocol.AfterLoadDFMValues;
    eDriverID.AfterLoadDFMValues;
    WebPanel18.AfterLoadDFMValues;
    WebLabel38.AfterLoadDFMValues;
    WebLabel46.AfterLoadDFMValues;
    WebLabel47.AfterLoadDFMValues;
    WebLabel48.AfterLoadDFMValues;
    WebLabel49.AfterLoadDFMValues;
    WebLabel50.AfterLoadDFMValues;
    WebLabel51.AfterLoadDFMValues;
    WebLabel52.AfterLoadDFMValues;
    eServerName1.AfterLoadDFMValues;
    eDBPath1.AfterLoadDFMValues;
    eUsername1.AfterLoadDFMValues;
    ePassword1.AfterLoadDFMValues;
    ePort1.AfterLoadDFMValues;
    eProtocol1.AfterLoadDFMValues;
    eDriverID1.AfterLoadDFMValues;
    WebTabSheet5.AfterLoadDFMValues;
    WebPanel19.AfterLoadDFMValues;
    WebLabel57.AfterLoadDFMValues;
    WebLabel58.AfterLoadDFMValues;
    WebLabel59.AfterLoadDFMValues;
    WebLabel60.AfterLoadDFMValues;
    WebLabel67.AfterLoadDFMValues;
    WebLabel68.AfterLoadDFMValues;
    WebPanel20.AfterLoadDFMValues;
    chk1.AfterLoadDFMValues;
    WebGroupBox1.AfterLoadDFMValues;
    WebLabel61.AfterLoadDFMValues;
    WebLabel62.AfterLoadDFMValues;
    WebLabel63.AfterLoadDFMValues;
    edtSalesVat.AfterLoadDFMValues;
    edtExpenseVat.AfterLoadDFMValues;
    edtZeroRate.AfterLoadDFMValues;
    WebGroupBox2.AfterLoadDFMValues;
    WebLabel64.AfterLoadDFMValues;
    WebLabel65.AfterLoadDFMValues;
    WebLabel66.AfterLoadDFMValues;
    fin1dieselinv.AfterLoadDFMValues;
    fin1maintinv.AfterLoadDFMValues;
    fin1tyresinv.AfterLoadDFMValues;
    edtsagepartnername.AfterLoadDFMValues;
    edt1.AfterLoadDFMValues;
    Edit1.AfterLoadDFMValues;
    fin1Bank.AfterLoadDFMValues;
    fncMasterGrid.AfterLoadDFMValues;
    fncTransactionGrid.AfterLoadDFMValues;
    WebTabSheet6.AfterLoadDFMValues;
    WebPanel6.AfterLoadDFMValues;
    WebGroupBox3.AfterLoadDFMValues;
    WebLabel19.AfterLoadDFMValues;
    WebLabel54.AfterLoadDFMValues;
    WebLabel55.AfterLoadDFMValues;
    WebLabel56.AfterLoadDFMValues;
    WebLabel69.AfterLoadDFMValues;
    WebLabel70.AfterLoadDFMValues;
    WebLabel71.AfterLoadDFMValues;
    WebLabel72.AfterLoadDFMValues;
    WebLabel73.AfterLoadDFMValues;
    WebLabel74.AfterLoadDFMValues;
    WebLabel75.AfterLoadDFMValues;
    Edit16.AfterLoadDFMValues;
    Edit4.AfterLoadDFMValues;
    Edit5.AfterLoadDFMValues;
    Edit15.AfterLoadDFMValues;
    Edit3.AfterLoadDFMValues;
    Edit17.AfterLoadDFMValues;
    Edit18.AfterLoadDFMValues;
    Edit19.AfterLoadDFMValues;
    Edit20.AfterLoadDFMValues;
    Edit21.AfterLoadDFMValues;
    edtBankClear.AfterLoadDFMValues;
    WebButton5.AfterLoadDFMValues;
    WebButton6.AfterLoadDFMValues;
    WebButton7.AfterLoadDFMValues;
    WebButton8.AfterLoadDFMValues;
    WebButton9.AfterLoadDFMValues;
    WebButton10.AfterLoadDFMValues;
    WebButton11.AfterLoadDFMValues;
    WebPageControlSheet5.AfterLoadDFMValues;
    pnlWebServerSettings.AfterLoadDFMValues;
    WebLabel77.AfterLoadDFMValues;
    WebLabel78.AfterLoadDFMValues;
    WebLabel79.AfterLoadDFMValues;
    WebLabel80.AfterLoadDFMValues;
    WebLabel81.AfterLoadDFMValues;
    WebLabel82.AfterLoadDFMValues;
    WebLabel83.AfterLoadDFMValues;
    WebLabel84.AfterLoadDFMValues;
    WebLabel85.AfterLoadDFMValues;
    WebLabel86.AfterLoadDFMValues;
    WebLabel87.AfterLoadDFMValues;
    WebLabel88.AfterLoadDFMValues;
    WebDBEdit17.AfterLoadDFMValues;
    WebDBEdit18.AfterLoadDFMValues;
    WebDBEdit19.AfterLoadDFMValues;
    WebDBEdit20.AfterLoadDFMValues;
    WebDBEdit21.AfterLoadDFMValues;
    WebDBEdit22.AfterLoadDFMValues;
    WebDBEdit24.AfterLoadDFMValues;
    WebDBEdit25.AfterLoadDFMValues;
    WebDBEdit26.AfterLoadDFMValues;
    WebDBEdit27.AfterLoadDFMValues;
    WebDBEdit28.AfterLoadDFMValues;
    WebPanel12.AfterLoadDFMValues;
    WebLabel36.AfterLoadDFMValues;
    WebLabel37.AfterLoadDFMValues;
    WebLabel76.AfterLoadDFMValues;
    WebDBEdit29.AfterLoadDFMValues;
    WebDBEdit30.AfterLoadDFMValues;
    WebDBEdit31.AfterLoadDFMValues;
    Edit2.AfterLoadDFMValues;
    wpcSysSetupSheet6.AfterLoadDFMValues;
    WebPanel21.AfterLoadDFMValues;
    dbcbxAutomailig.AfterLoadDFMValues;
    wgbEmailSetup.AfterLoadDFMValues;
    WebLabel89.AfterLoadDFMValues;
    WebLabel90.AfterLoadDFMValues;
    WebLabel91.AfterLoadDFMValues;
    WebDBEdit23.AfterLoadDFMValues;
    WebDBEdit32.AfterLoadDFMValues;
    WebDBLookupComboBox1.AfterLoadDFMValues;
    WebDBCheckBox2.AfterLoadDFMValues;
    WebDBCheckBox3.AfterLoadDFMValues;
    wgbAuthentication.AfterLoadDFMValues;
    WebLabel92.AfterLoadDFMValues;
    WebLabel93.AfterLoadDFMValues;
    WebDBEdit33.AfterLoadDFMValues;
    WebDBEdit34.AfterLoadDFMValues;
    wpcSysSetupSheet7.AfterLoadDFMValues;
    WebPanel13.AfterLoadDFMValues;
    WebSpeedButton8.AfterLoadDFMValues;
    WebSpeedButton9.AfterLoadDFMValues;
    WebSpeedButton10.AfterLoadDFMValues;
    WebSpeedButton11.AfterLoadDFMValues;
    WebSpeedButton12.AfterLoadDFMValues;
    WebPanel14.AfterLoadDFMValues;
    btnVatTableFirst.AfterLoadDFMValues;
    btnVattablePrior.AfterLoadDFMValues;
    btnVattableNext.AfterLoadDFMValues;
    btnVattableLast.AfterLoadDFMValues;
    edtVattablePagecount.AfterLoadDFMValues;
    dgVatSetup.AfterLoadDFMValues;
    dbagVatSetup.AfterLoadDFMValues;
    msgdlgVattable.AfterLoadDFMValues;
    wpcSysSetupSheet8.AfterLoadDFMValues;
    WebPanel16.AfterLoadDFMValues;
    WebSpeedButton13.AfterLoadDFMValues;
    WebSpeedButton14.AfterLoadDFMValues;
    WebSpeedButton15.AfterLoadDFMValues;
    WebSpeedButton16.AfterLoadDFMValues;
    WebSpeedButton17.AfterLoadDFMValues;
    WebPanel22.AfterLoadDFMValues;
    edtGLAPC.AfterLoadDFMValues;
    sbtnGlaFirst.AfterLoadDFMValues;
    sbtnGLAPrior.AfterLoadDFMValues;
    sbtnGLANext.AfterLoadDFMValues;
    sbtnGLALast.AfterLoadDFMValues;
    dgGLA.AfterLoadDFMValues;
    dbagGLA.AfterLoadDFMValues;
    msgdlgGLA.AfterLoadDFMValues;
    wpcSysSetupSheet9.AfterLoadDFMValues;
    WebPanel23.AfterLoadDFMValues;
    WebSpeedButton20.AfterLoadDFMValues;
    WebSpeedButton21.AfterLoadDFMValues;
    WebSpeedButton22.AfterLoadDFMValues;
    WebSpeedButton23.AfterLoadDFMValues;
    WebSpeedButton24.AfterLoadDFMValues;
    WebPanel24.AfterLoadDFMValues;
    btnSystemLedgerFirst.AfterLoadDFMValues;
    btnSystemLedgerPrior.AfterLoadDFMValues;
    btnSystemLedgerNext.AfterLoadDFMValues;
    btnSystemLedgerLast.AfterLoadDFMValues;
    edtSystemLedger.AfterLoadDFMValues;
    dgSystemLedger.AfterLoadDFMValues;
    dbagSystemLedger.AfterLoadDFMValues;
    msgdlgSystemLedger.AfterLoadDFMValues;
    wpcSysSetupSheet10.AfterLoadDFMValues;
    WebCheckListBox1.AfterLoadDFMValues;
    WebPageControl2.AfterLoadDFMValues;
    WebPageControl2Sheet1.AfterLoadDFMValues;
    WebPanel32.AfterLoadDFMValues;
    WebLabel98.AfterLoadDFMValues;
    WebLabel99.AfterLoadDFMValues;
    WebLabel100.AfterLoadDFMValues;
    WebLabel101.AfterLoadDFMValues;
    WebLabel102.AfterLoadDFMValues;
    edtTFNUrl.AfterLoadDFMValues;
    edtTFNUser.AfterLoadDFMValues;
    edtTFNPassword.AfterLoadDFMValues;
    edtTFNAPIKey.AfterLoadDFMValues;
    edtTFNAccount.AfterLoadDFMValues;
    WebPanel25.AfterLoadDFMValues;
    TFNSubAccountsFirst.AfterLoadDFMValues;
    TFNSubAccountsPrior.AfterLoadDFMValues;
    TFNSubAccountsNext.AfterLoadDFMValues;
    WebSpeedButton28.AfterLoadDFMValues;
    edtTFNSubAccounts.AfterLoadDFMValues;
    WebPanel27.AfterLoadDFMValues;
    WebSpeedButton25.AfterLoadDFMValues;
    WebSpeedButton26.AfterLoadDFMValues;
    WebSpeedButton27.AfterLoadDFMValues;
    WebSpeedButton29.AfterLoadDFMValues;
    WebSpeedButton30.AfterLoadDFMValues;
    dgTFN1.AfterLoadDFMValues;
    dbagTFNSubaccounts1.AfterLoadDFMValues;
    WebPageControl2Sheet2.AfterLoadDFMValues;
    WebPanel33.AfterLoadDFMValues;
    WebLabel97.AfterLoadDFMValues;
    WebLabel103.AfterLoadDFMValues;
    WebLabel104.AfterLoadDFMValues;
    WebLabel105.AfterLoadDFMValues;
    WebLabel106.AfterLoadDFMValues;
    WebLabel107.AfterLoadDFMValues;
    edtFMSUrl.AfterLoadDFMValues;
    edtFMSUser.AfterLoadDFMValues;
    edtFMSPass.AfterLoadDFMValues;
    edtFMSAPIKey.AfterLoadDFMValues;
    edtFMSAccount.AfterLoadDFMValues;
    Edit22.AfterLoadDFMValues;
    WebPanel26.AfterLoadDFMValues;
    WebSpeedButton31.AfterLoadDFMValues;
    WebSpeedButton32.AfterLoadDFMValues;
    WebSpeedButton33.AfterLoadDFMValues;
    WebSpeedButton34.AfterLoadDFMValues;
    WebSpeedButton35.AfterLoadDFMValues;
    WebPanel28.AfterLoadDFMValues;
    sbtnTFNSubAccountsS2First.AfterLoadDFMValues;
    sbtnTFNSubAccountsS2prior.AfterLoadDFMValues;
    sbtnTFNSubAccountsS2Next.AfterLoadDFMValues;
    sbtnTFNSubAccountsS2Last.AfterLoadDFMValues;
    edtTFNSubAccountsS2.AfterLoadDFMValues;
    dgTFNSubAccounts2.AfterLoadDFMValues;
    dbagTFNSubAccountsS2.AfterLoadDFMValues;
    WebMessageDlg1.AfterLoadDFMValues;
    WebPageControl2Sheet4.AfterLoadDFMValues;
    WebPanel35.AfterLoadDFMValues;
    WebLabel114.AfterLoadDFMValues;
    WebLabel113.AfterLoadDFMValues;
    WebLabel112.AfterLoadDFMValues;
    edtFuelUUrl.AfterLoadDFMValues;
    edtFuelUToken.AfterLoadDFMValues;
    edtFuelUPassword.AfterLoadDFMValues;
    WebPageControl2Sheet5.AfterLoadDFMValues;
    WebPanel36.AfterLoadDFMValues;
    WebLabel115.AfterLoadDFMValues;
    WebLabel116.AfterLoadDFMValues;
    WebLabel117.AfterLoadDFMValues;
    WebLabel118.AfterLoadDFMValues;
    WebLabel119.AfterLoadDFMValues;
    edtPremiPointUrl.AfterLoadDFMValues;
    edtPremiPointUser.AfterLoadDFMValues;
    edtPremiPointPassword.AfterLoadDFMValues;
    edtPremiPointKey.AfterLoadDFMValues;
    edtPremiPointAccount.AfterLoadDFMValues;
    wpcSysSetupSheet11.AfterLoadDFMValues;
    WebPanel37.AfterLoadDFMValues;
    WebDBRadioGroup1.AfterLoadDFMValues;
    wpcSysSetupSheet12.AfterLoadDFMValues;
    WebPanel38.AfterLoadDFMValues;
    WebLabel120.AfterLoadDFMValues;
    WebLabel121.AfterLoadDFMValues;
    WebLabel122.AfterLoadDFMValues;
    WebLabel123.AfterLoadDFMValues;
    WebLabel124.AfterLoadDFMValues;
    WebLabel125.AfterLoadDFMValues;
    WebLabel126.AfterLoadDFMValues;
    WebLabel127.AfterLoadDFMValues;
    WebLabel128.AfterLoadDFMValues;
    WebLabel129.AfterLoadDFMValues;
    WebDBCheckBox1.AfterLoadDFMValues;
    WebDBCheckBox4.AfterLoadDFMValues;
    WebDBCheckBox41.AfterLoadDFMValues;
    WebDBCheckBox42.AfterLoadDFMValues;
    WebDBComboBox1.AfterLoadDFMValues;
    WebDBComboBox2.AfterLoadDFMValues;
    WebDBComboBox3.AfterLoadDFMValues;
    WebDBComboBox4.AfterLoadDFMValues;
    WebDBEdit35.AfterLoadDFMValues;
    WebDBEdit36.AfterLoadDFMValues;
    WebDBEdit37.AfterLoadDFMValues;
    WebDBEdit38.AfterLoadDFMValues;
    WebDBEdit39.AfterLoadDFMValues;
    WebDBEdit40.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    btnSave.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    wcCompInfo.AfterLoadDFMValues;
    wdsCompInfo.AfterLoadDFMValues;
    wdsCompInfoSSCLoadConLoadDate.AfterLoadDFMValues;
    wdsCompInfoSSCLoadConOffLoadDate.AfterLoadDFMValues;
    wdsCompInfoSSCLOADCONRECEIVEDATE.AfterLoadDFMValues;
    wdsCompInfoSSCLOADCONCOMPLETEDATE.AfterLoadDFMValues;
    wdsCompInfoSSCLOADCONLOADTIME.AfterLoadDFMValues;
    wdsCompInfoSSCLOADCONOFFLOADTIME.AfterLoadDFMValues;
    wdsCompInfoSSCLOADCONRECEIVETIME.AfterLoadDFMValues;
    wdsCompInfoSSCLOADCONCOMPLETETIME.AfterLoadDFMValues;
    wdsCompInfoSSCLOADCONLOADDATEC.AfterLoadDFMValues;
    wdsCompInfoSSCLOADCONOFFLOADDATEC.AfterLoadDFMValues;
    wdsCompInfoSSCLOADCONRECEIVEDATEC.AfterLoadDFMValues;
    wdsCompInfoSSCLOADCONCOMPLETEDATEC.AfterLoadDFMValues;
    wdsCompInfoSSCLOADCONLOADTIMEC.AfterLoadDFMValues;
    wdsCompInfoSSCLOADCONOFFLOADTIMEC.AfterLoadDFMValues;
    wdsCompInfoSSCLOADCONRECEIVETIMEC.AfterLoadDFMValues;
    wdsCompInfoSSCLOADCONCOMPLETETIMEC.AfterLoadDFMValues;
    wdsCompInfoUSEFINLINKSYSTEM.AfterLoadDFMValues;
    wdsCompInfoFINLINKSYSTEM.AfterLoadDFMValues;
    wdsCompInfoAUTOMAILSYSTEM.AfterLoadDFMValues;
    wdsCompInfoFINDBSETUP.AfterLoadDFMValues;
    wdsCompInfoMAILSERVER.AfterLoadDFMValues;
    wdsCompInfoMAILSERVERPORT.AfterLoadDFMValues;
    wdsCompInfoMAILSERVERAUTH.AfterLoadDFMValues;
    wdsCompInfoMAILSERVERUSER.AfterLoadDFMValues;
    wdsCompInfoMAILSERVERPASS.AfterLoadDFMValues;
    wdsCompInfoMAILSERVERSSL.AfterLoadDFMValues;
    wdsCompInfoMAILSERVERPROTOCOL.AfterLoadDFMValues;
    wdsCompInfoMAILSERVERSIGNATURE.AfterLoadDFMValues;
    wdsCompInfoMAILSERVERENCRYPTION.AfterLoadDFMValues;
    wdsCompInfoMAILSERVERENCODING.AfterLoadDFMValues;
    wdsCompInfoDCLPERC.AfterLoadDFMValues;
    wdsCompInfoBANKSTATEMENT.AfterLoadDFMValues;
    wdsCompInfoSSFLOADCONLOADDATEC.AfterLoadDFMValues;
    wdsCompInfoSSFLOADCONOFFLOADDATEC.AfterLoadDFMValues;
    wdsCompInfoSSFLOADCONRECEIVEDATEC.AfterLoadDFMValues;
    wdsCompInfoSSFLOADCONCOMPLETEDATEC.AfterLoadDFMValues;
    wdsCompInfoSSFLOADCONLOADTIMEC.AfterLoadDFMValues;
    wdsCompInfoSSFLOADCONOFFLOADTIMEC.AfterLoadDFMValues;
    wdsCompInfoSSFLOADCONRECEIVETIMEC.AfterLoadDFMValues;
    wdsCompInfoSSFLOADCONCOMPLETETIMEC.AfterLoadDFMValues;
    wdsCompInfoFORCEDIESELDRIVER.AfterLoadDFMValues;
    wdsCompInfoFORCELOADDRIVER.AfterLoadDFMValues;
    wdsCompInfoDEFDIESELORDERS.AfterLoadDFMValues;
    wdsCompInfoDEFLOADORDERS.AfterLoadDFMValues;
    wdsCompInfoINVOICESYSTEM.AfterLoadDFMValues;
    wdsCompInfoBTBRANCHCODE.AfterLoadDFMValues;
    wdsCompInfoBTACCOUNTNO.AfterLoadDFMValues;
    wdsCompInfoTRIPSHEETTYPE.AfterLoadDFMValues;
    wdsCompInfoLOADCUSTOMERS.AfterLoadDFMValues;
    wdsCompInfoFINLINKSYSTEMCOUNT.AfterLoadDFMValues;
    wdsCompInfoFIN1NAME.AfterLoadDFMValues;
    wdsCompInfoFIN2NAME.AfterLoadDFMValues;
    wdsCompInfoUSEDOCKETNOINVNO.AfterLoadDFMValues;
    wdsCompInfoUSEADDINFONONCON.AfterLoadDFMValues;
    wdsCompInfoSTATEMENTTYPE.AfterLoadDFMValues;
    wdsCompInfoSTOCKSTDPERC.AfterLoadDFMValues;
    wdsCompInfoSTOCKDEDPERC.AfterLoadDFMValues;
    wdsCompInfoSTOCKSPEPERC.AfterLoadDFMValues;
    wdsCompInfoEMPADDCOMDESC.AfterLoadDFMValues;
    wdsCompInfoNONCONDISPLAYFUEL.AfterLoadDFMValues;
    wdsCompInfoADD1DESC.AfterLoadDFMValues;
    wdsCompInfoADD2DESC.AfterLoadDFMValues;
    wdsCompInfoADD3DESC.AfterLoadDFMValues;
    wdsCompInfoADD4DESC.AfterLoadDFMValues;
    wdsCompInfoADD5DESC.AfterLoadDFMValues;
    wdsCompInfoADD6DESC.AfterLoadDFMValues;
    wdsCompInfoADD7DESC.AfterLoadDFMValues;
    wdsCompInfoPOSTALADDRESS1.AfterLoadDFMValues;
    wdsCompInfoPOSTALADDRESS2.AfterLoadDFMValues;
    wdsCompInfoPOSTALADDRESS3.AfterLoadDFMValues;
    wdsCompInfoPOSTALADDRESS4.AfterLoadDFMValues;
    wdsCompInfoPOSTALCODE.AfterLoadDFMValues;
    wdsCompInfoUSEMULTICOMPANYINVOICE.AfterLoadDFMValues;
    wdsCompInfoMISCINVLOADS.AfterLoadDFMValues;
    wdsCompInfoPRINTTOTALSSEND.AfterLoadDFMValues;
    wdsCompInfoWEBSERVERADDRESS.AfterLoadDFMValues;
    wdsCompInfoWEBSERVERPORT.AfterLoadDFMValues;
    wdsCompInfoWEBSERVERUSER.AfterLoadDFMValues;
    wdsCompInfoWEBSERVERPASSWORD.AfterLoadDFMValues;
    wdsCompInfoWEBSERVERSCANAPI.AfterLoadDFMValues;
    wdsCompInfoDBSERVERADDRESS.AfterLoadDFMValues;
    wdsCompInfoDBSERVERPORT.AfterLoadDFMValues;
    wdsCompInfoINTERNALADDRESS.AfterLoadDFMValues;
    wdsCompInfoINTERNALPORT.AfterLoadDFMValues;
    wdsCompInfoWEBSERVERDB.AfterLoadDFMValues;
    wdsCompInfoWEBSERVERDBUSER.AfterLoadDFMValues;
    wdsCompInfoWEBSERVERDBPASS.AfterLoadDFMValues;
    wdsCompInfoUNIQUEORDER.AfterLoadDFMValues;
    wdsCompInfoUNIQUEWAYBILLS.AfterLoadDFMValues;
    wdsCompInfoUNIQUEWASHBAYDOCKET.AfterLoadDFMValues;
    wdsCompInfoIMPORTPERIOD.AfterLoadDFMValues;
    wdsCompInfoIMPORTBATCH.AfterLoadDFMValues;
    wdsCompInfoPRINTLOADSAVE.AfterLoadDFMValues;
    wdsCompInfoNOFUTUREINVDATE.AfterLoadDFMValues;
    wdsCompInfoUNIQUESHORTDESC.AfterLoadDFMValues;
    wdsCompInfoCUSTMISCTYPE.AfterLoadDFMValues;
    wdsCompInfoSUPPMISCTYPE.AfterLoadDFMValues;
    wdsCompInfoJOBCARDPREFIX.AfterLoadDFMValues;
    wdsCompInfoREQUESTPREFIX.AfterLoadDFMValues;
    wdsCompInfoORDERSPREFIX.AfterLoadDFMValues;
    wdsCompInfoMISCGLFORCE.AfterLoadDFMValues;
    wdsCompInfoSUBUNINVSHOW.AfterLoadDFMValues;
    wdsCompInfoemployeedemerit.AfterLoadDFMValues;
    wdsCompInfovehicledemerit.AfterLoadDFMValues;
    wdsCompInfomonitorvehiclechanges.AfterLoadDFMValues;
    wdsCompInfomonitordieselupfrontcl.AfterLoadDFMValues;
    wdsCompInfomonitorloadssub.AfterLoadDFMValues;
    wdsCompInfomonitorcancelloads.AfterLoadDFMValues;
    wdsCompInfocheckdieselordersdays.AfterLoadDFMValues;
    wdsCompInfoJobCompType.AfterLoadDFMValues;
    wdsCompInfofinesbrnno.AfterLoadDFMValues;
    wdsCompInfofinesidno.AfterLoadDFMValues;
    wdsCompInfosmsdiesel.AfterLoadDFMValues;
    wdsCompInfosmsdieselurl.AfterLoadDFMValues;
    wdsCompInfosmsdieseluser.AfterLoadDFMValues;
    wdsCompInfosmsdieselpassword.AfterLoadDFMValues;
    wdsCompInfoINSTRUCTORDER.AfterLoadDFMValues;
    wdsCompInfowashbayinvloads.AfterLoadDFMValues;
    wdsCompInfosubsoverrite.AfterLoadDFMValues;
    wdsCompInfocommissiontype.AfterLoadDFMValues;
    wdsCompInfoallowdieselproforma.AfterLoadDFMValues;
    wdsCompInfoforcescandocs.AfterLoadDFMValues;
    wdsCompInfoBANKDETAIL5.AfterLoadDFMValues;
    wdsCompInfoBANKDETAILS6.AfterLoadDFMValues;
    wdsCompInfoBANKDETAILS7.AfterLoadDFMValues;
    wdsCompInfoBANKDETAILS8.AfterLoadDFMValues;
    wdsCompInfologo.AfterLoadDFMValues;
    wdsCompInfoautocanceldieselorders.AfterLoadDFMValues;
    wdsCompInfoautocanceldieselordersdays.AfterLoadDFMValues;
    wdsCompInfosendloadconsprocess.AfterLoadDFMValues;
    wdsCompInfoloadcoscutoffdate.AfterLoadDFMValues;
    wdsCompInfodieselcutoffdate.AfterLoadDFMValues;
    wdsCompInfohidecanceloadsplanning.AfterLoadDFMValues;
    wdsCompInfoincrementdocketno.AfterLoadDFMValues;
    wdsCompInfolinklastdriver.AfterLoadDFMValues;
    wdsCompInfoplanningshortdesc.AfterLoadDFMValues;
    wdsCompInfoallowreprint.AfterLoadDFMValues;
    wdsCompInforemovesubinvdocs.AfterLoadDFMValues;
    wdsCompInfoloadsmustreceived.AfterLoadDFMValues;
    wdsCompInfofnbcontractid.AfterLoadDFMValues;
    wdsCompInfofnbclientid.AfterLoadDFMValues;
    wdsCompInfofnbdeblistcount.AfterLoadDFMValues;
    wdsCompInfofnbcredlistcount.AfterLoadDFMValues;
    wdsCompInfofnblastdebdate.AfterLoadDFMValues;
    wdsCompInfofnblastcreddate.AfterLoadDFMValues;
    wdsCompInfofnblastdebamount.AfterLoadDFMValues;
    wdsCompInfofnblastcredamount.AfterLoadDFMValues;
    wdsCompInfofnbclienttype.AfterLoadDFMValues;
    wdsCompInfolinkloadsvat.AfterLoadDFMValues;
    wdsCompInfomarkmultiloadready.AfterLoadDFMValues;
    wdsCompInfobulkdieselinvoices.AfterLoadDFMValues;
    wdsCompInfoclearbulkinvoices.AfterLoadDFMValues;
    wdsCompInfogetsageonlinebalance.AfterLoadDFMValues;
    wdsCompInfousesageonlinebalancefordiesel.AfterLoadDFMValues;
    wdsCompInfoapiserverurl.AfterLoadDFMValues;
    wdsCompInfoapiusername.AfterLoadDFMValues;
    wdsCompInfoapipassword.AfterLoadDFMValues;
    wdsCompInfoapikey.AfterLoadDFMValues;
    wdsCompInfofuelconsumptionfullfills.AfterLoadDFMValues;
    wdsCompInfousenewscan.AfterLoadDFMValues;
    wdsCompInfobasescanfolder.AfterLoadDFMValues;
    wdsCompInfoftpserver.AfterLoadDFMValues;
    wdsCompInfoftpport.AfterLoadDFMValues;
    wdsCompInfoftpuser.AfterLoadDFMValues;
    wdsCompInfoftppassword.AfterLoadDFMValues;
    wdsCompInfomulticontroller.AfterLoadDFMValues;
    wdsCompInfolastshiftno.AfterLoadDFMValues;
    wdsCompInfodieselnonretail.AfterLoadDFMValues;
    wdsCompInfoemailaddress.AfterLoadDFMValues;
    wdsCompInfojobnullqty.AfterLoadDFMValues;
    wdsCompInfojoborder.AfterLoadDFMValues;
    wdsCompInfojobcardtype.AfterLoadDFMValues;
    wdsCompInfomaintforcegl.AfterLoadDFMValues;
    wdsCompInfocompemail.AfterLoadDFMValues;
    wdsCompInfoerrormails.AfterLoadDFMValues;
    wdsCompInfoADDRESS1.AfterLoadDFMValues;
    wdsCompInfoADDRESS2.AfterLoadDFMValues;
    wdsCompInfoADDRESS3.AfterLoadDFMValues;
    wdsCompInfoADDRESS4.AfterLoadDFMValues;
    wdsCompInfoADDRESSCODE.AfterLoadDFMValues;
    wdsCompInfoCOMPANYNAME.AfterLoadDFMValues;
    wdsCompInfoCOMPANYFAX.AfterLoadDFMValues;
    wdsCompInfoCOMPANYTEL.AfterLoadDFMValues;
    wdsCompInfoCOMPANYREG.AfterLoadDFMValues;
    wdsCompInfoCOMPANYVAT.AfterLoadDFMValues;
    wdsCompInfoLOGOPATH.AfterLoadDFMValues;
    wdsCompInfoUSEDIFFCOMP.AfterLoadDFMValues;
    wdsCompInfoBANKDETAILS1.AfterLoadDFMValues;
    wdsCompInfoBANKDETAILS2.AfterLoadDFMValues;
    wdsCompInfoBANKDETAILS3.AfterLoadDFMValues;
    wdsCompInfoBANKDETAILS4.AfterLoadDFMValues;
    wdsCompInfoLOADCONTYPE.AfterLoadDFMValues;
    wdsCompInfoLOADCONPREFIX.AfterLoadDFMValues;
    wdsCompInfoCompanyCode.AfterLoadDFMValues;
    wdsCompInfoSSUNIQUECLIENTDOCKET.AfterLoadDFMValues;
    dsCompInfo.AfterLoadDFMValues;
    wcNumbers.AfterLoadDFMValues;
    wdsNumbers.AfterLoadDFMValues;
    wdsNumbersTranType.AfterLoadDFMValues;
    wdsNumbersPrefix.AfterLoadDFMValues;
    wdsNumbersDescription.AfterLoadDFMValues;
    wdsNumbersSuffix.AfterLoadDFMValues;
    dsNumbers.AfterLoadDFMValues;
    wdsFinSystem.AfterLoadDFMValues;
    dsFinSystem.AfterLoadDFMValues;
    wcFinSystem.AfterLoadDFMValues;
    dsVattable.AfterLoadDFMValues;
    wdsVattable.AfterLoadDFMValues;
    wdsVattableVATPERC.AfterLoadDFMValues;
    wdsVattableSTARTDATE.AfterLoadDFMValues;
    wdsVattableENDATE.AfterLoadDFMValues;
    wdsVattableAuto.AfterLoadDFMValues;
    wcVattable.AfterLoadDFMValues;
    wdsGLA.AfterLoadDFMValues;
    wdsGLAGLCODE.AfterLoadDFMValues;
    wdsGLAGLDESCRIPTION.AfterLoadDFMValues;
    wdsGLASUSPENDED.AfterLoadDFMValues;
    wdsGLAbankaccount.AfterLoadDFMValues;
    wdsGLAbankcard.AfterLoadDFMValues;
    dsGLA.AfterLoadDFMValues;
    wcGLA.AfterLoadDFMValues;
    wdsSystemLedgerAccounts.AfterLoadDFMValues;
    wdsSystemLedgerAccountsGLDESCRIPTION.AfterLoadDFMValues;
    wdsSystemLedgerAccountsFleetDesc.AfterLoadDFMValues;
    wdsSystemLedgerAccountsValueTypesDesc.AfterLoadDFMValues;
    wdsSystemLedgerAccountsSystemDesc.AfterLoadDFMValues;
    wdsSystemLedgerAccountsGLCode.AfterLoadDFMValues;
    wdsSystemLedgerAccountscompanygldetail_Auto.AfterLoadDFMValues;
    wcSystemLedgerAccounts.AfterLoadDFMValues;
    dsSystemLedgerAccounts.AfterLoadDFMValues;
    wdsTFNSubAccountsS1.AfterLoadDFMValues;
    wdsTFNSubAccountsS1ApiServerNo.AfterLoadDFMValues;
    wdsTFNSubAccountsS1SubContractNo.AfterLoadDFMValues;
    wdsTFNSubAccountsS1ApiAccountNo.AfterLoadDFMValues;
    wdsTFNSubAccountsS1LastRunDate.AfterLoadDFMValues;
    wdsTFNSubAccountsS1SubsRegNo.AfterLoadDFMValues;
    wdsTFNSubAccountsS1CRName.AfterLoadDFMValues;
    dsTFNSubAccountsS1.AfterLoadDFMValues;
    wcTFNSubAccountsS1.AfterLoadDFMValues;
    wcTFNSubAccountsS2.AfterLoadDFMValues;
    wdsTFNSubAccountsS2.AfterLoadDFMValues;
    wdsTFNSubAccountsS2ApiServerNo.AfterLoadDFMValues;
    wdsTFNSubAccountsS2SubContractNo.AfterLoadDFMValues;
    wdsTFNSubAccountsS2ApiAccountNo.AfterLoadDFMValues;
    wdsTFNSubAccountsS2LastRunDate.AfterLoadDFMValues;
    wdsTFNSubAccountsS2SubsRegNo.AfterLoadDFMValues;
    wdsTFNSubAccountsS2CRName.AfterLoadDFMValues;
    dsTFNSubAccountsS2.AfterLoadDFMValues;
    wdsFinLinkSystem.AfterLoadDFMValues;
    wdsFinLinkSystemFinNo.AfterLoadDFMValues;
    wdsFinLinkSystemFinName.AfterLoadDFMValues;
    wdsFinLinkSystemFinActive.AfterLoadDFMValues;
    dsFinLinkSystem.AfterLoadDFMValues;
    wcFinLinkSystem.AfterLoadDFMValues;
  end;
end;

end.
